
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequire49d7"];
var parcelRegister = parcelRequire.register;
parcelRegister("8iNv0", function(module, exports) {

$parcel$defineInteropFlag(module.exports);
$parcel$export(module.exports, "DashboardsDirectory", () => $c2a290c2a368df5f$export$6b6b79c824d04932);
$parcel$export(module.exports, "default", () => $c2a290c2a368df5f$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");
parcelRequire("3avtZ");

var $hVCgF = parcelRequire("hVCgF");

var $hkJNU = parcelRequire("hkJNU");

var $dFtHW = parcelRequire("dFtHW");

var $6UU7v = parcelRequire("6UU7v");

var $9l1y1 = parcelRequire("9l1y1");

var $iEXnd = parcelRequire("iEXnd");

var $koAZ4 = parcelRequire("koAZ4");

var $4EKqI = parcelRequire("4EKqI");

var $eJrcF = parcelRequire("eJrcF");
var $jJaSe = parcelRequire("jJaSe");

var $emZpp = parcelRequire("emZpp");
// eslint-disable-next-line jira/react/no-usage-of-hooks-outside-components
const $c2a290c2a368df5f$var$useDashboardsDirectoryResource = (0, $6UU7v.withSuspense)(()=>(0, $eJrcF.useResource)((0, $9l1y1.dashboardsDirectoryResource)));
const $c2a290c2a368df5f$export$6b6b79c824d04932 = ({ location: location })=>{
    const state = $c2a290c2a368df5f$var$useDashboardsDirectoryResource();
    const tenantContext = (0, $koAZ4.useTenantContext)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $hkJNU.default), {
        location: location
    }, ({ query: query, onQueryChanged: onQueryChanged })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $dFtHW.FavoriteChangeConsumer), null, (favoriteChangeContext)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $4EKqI.default), {
                name: "dashboards-directory"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $emZpp.default), {
                tenantContext: tenantContext,
                prefetchResult: {
                    ...state
                },
                favoriteChangeContext: favoriteChangeContext,
                query: query,
                onQueryChanged: onQueryChanged
            }))));
};
// @ts-expect-error - TS2322 - Type '{ (props: RouteContext & { history: BrowserHistory; }): Element; displayName: string; }' is not assignable to type 'ComponentType<Record<any, any>>'.
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $c2a290c2a368df5f$var$RouterWrapper = (0, $jJaSe.withRouter)($c2a290c2a368df5f$export$6b6b79c824d04932);
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $c2a290c2a368df5f$var$DashboardsDirectoryType = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $iEXnd.MarkProductStart), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $hVCgF.default), {
        appNameSuffixForV2Event: "directory.dashboards",
        appNameForV3OperationalEvent: "dashboardsDirectory"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($c2a290c2a368df5f$var$RouterWrapper, props));
var $c2a290c2a368df5f$export$2e2bcd8739ae039 = $c2a290c2a368df5f$var$DashboardsDirectoryType;

});
parcelRegister("hVCgF", function(module, exports) {
$parcel$export(module.exports, "default", () => $aeb7896d17d4ecc0$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $kGj4V = parcelRequire("kGj4V");
var $kRgKj = parcelRequire("kRgKj");
var $dFqXL = parcelRequire("dFqXL");
const $aeb7896d17d4ecc0$var$fireGasV2AndGasV3Analytics = (appNameSuffixForV2Event, appNameForV3OperationalEvent)=>(analyticsEvent)=>{
        (0, $kRgKj.fireOperationalAnalytics)(analyticsEvent, `${appNameForV3OperationalEvent} pageInitialised`);
    };
const $aeb7896d17d4ecc0$var$PageAppInitialisationAnalytics = ({ appNameSuffixForV2Event: appNameSuffixForV2Event, appNameForV3OperationalEvent: appNameForV3OperationalEvent })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $kGj4V.ContextualAnalyticsData), {
        sourceType: (0, $aa42ce8e355d58fa$export$f636b5b56f1d624a),
        sourceName: ""
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $dFqXL.MountEvent), {
        onMount: $aeb7896d17d4ecc0$var$fireGasV2AndGasV3Analytics(appNameSuffixForV2Event, appNameForV3OperationalEvent)
    }));
var $aeb7896d17d4ecc0$export$2e2bcd8739ae039 = $aeb7896d17d4ecc0$var$PageAppInitialisationAnalytics;

});
// SCREENS
const $aa42ce8e355d58fa$export$f636b5b56f1d624a = 'Screen';
const $aa42ce8e355d58fa$export$9d2de6eebf7462b5 = 'Drawer';
const $aa42ce8e355d58fa$export$1171103ea9083ffa = 'Modal';
const $aa42ce8e355d58fa$export$cae2783c9279926 = 'InlineDialog';
const $aa42ce8e355d58fa$export$d1123261ca8831d2 = 'Dropdown';
const $aa42ce8e355d58fa$export$238d30785c4bca84 = 'Banner';
const $aa42ce8e355d58fa$export$a1562d08625f5d7e = 'UI';
const $aa42ce8e355d58fa$export$947dac6c72b26f81 = 'TRACK';
const $aa42ce8e355d58fa$export$f1d537d508d2945a = 'SCREEN';
const $aa42ce8e355d58fa$export$12346a674644c156 = 'OPERATIONAL';


parcelRegister("hkJNU", function(module, exports) {
$parcel$export(module.exports, "default", () => $74d8b2db3692f9e9$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $97OFh = parcelRequire("97OFh");

var $714QC = parcelRequire("714QC");

var $5XnPB = parcelRequire("5XnPB");

var $13TEf = parcelRequire("13TEf");
const $74d8b2db3692f9e9$var$QueryParamAdapterWithSortingAndFiltering = ({ location: location, children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $97OFh.default), {
        location: location,
        sortFieldToParam: (0, $13TEf.sortFieldToParam),
        sortFieldFromParam: (0, $13TEf.sortFieldFromParam),
        filterFromParams: (0, $5XnPB.filterFromParams),
        filterToParams: (0, $5XnPB.filterToParams),
        defaultQuery: (0, $714QC.initialQuery)
    }, children);
var $74d8b2db3692f9e9$export$2e2bcd8739ae039 = $74d8b2db3692f9e9$var$QueryParamAdapterWithSortingAndFiltering;

});
parcelRegister("97OFh", function(module, exports) {
$parcel$export(module.exports, "default", () => $556c18568dff142c$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $4cuZm = parcelRequire("4cuZm");

var $4l9z6 = parcelRequire("4l9z6");

var $lg6iR = parcelRequire("lg6iR");
const $556c18568dff142c$var$QueryParamAdapter = ({ location: location, children: children, sortFieldFromParam: sortFieldFromParam, filterFromParams: filterFromParams, sortFieldToParam: sortFieldToParam, filterToParams: filterToParams, defaultQuery: defaultQuery })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $4cuZm.default), {
        location: location,
        queryFromUrl: (0, $lg6iR.default)(sortFieldFromParam, filterFromParams),
        queryToUrl: (0, $4l9z6.default)(sortFieldToParam, filterToParams),
        defaultQuery: defaultQuery
    }, children);
var $556c18568dff142c$export$2e2bcd8739ae039 = $556c18568dff142c$var$QueryParamAdapter;

});
parcelRegister("4cuZm", function(module, exports) {
$parcel$export(module.exports, "default", () => $446b3862e19b2a93$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $k4x9q = parcelRequire("k4x9q");

var $12DRg = parcelRequire("12DRg");

var $b5RwB = parcelRequire("b5RwB");

var $lcB5K = parcelRequire("lcB5K");

var $eoPnG = parcelRequire("eoPnG");

var $kuiVs = parcelRequire("kuiVs");
const $446b3862e19b2a93$var$GenericQueryParamAdapter = ({ location: location, children: children, queryToUrl: queryToUrl, queryFromUrl: queryFromUrl, defaultQuery: defaultQuery })=>{
    const toQuery = (search)=>(0, (/*@__PURE__*/$parcel$interopDefault($k4x9q)))((0, $eoPnG.default)(queryFromUrl)((0, (/*@__PURE__*/$parcel$interopDefault($b5RwB))).parse(search)), defaultQuery);
    const replaceUrl = (// @ts-expect-error - TS2304 - Cannot find name 'Href'.
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    replace, query, prevParams)=>replace(`?${(0, (/*@__PURE__*/$parcel$interopDefault($b5RwB))).stringify({
            ...prevParams,
            ...queryToUrl(query)
        })}`, []);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $lcB5K.RouterActions), null, ({ replace: replace })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $kuiVs.AdapterWithState), {
            search: location.search,
            toQuery: (search)=>toQuery(search),
            onChange: false ? (0, (/*@__PURE__*/$parcel$interopDefault($12DRg))) : (query, prevParams)=>replaceUrl(replace, query, prevParams)
        }, children));
};
var $446b3862e19b2a93$export$2e2bcd8739ae039 = $446b3862e19b2a93$var$GenericQueryParamAdapter;

});
parcelRegister("eoPnG", function(module, exports) {
$parcel$export(module.exports, "default", () => $c36cbf0efe48d029$export$2e2bcd8739ae039);

var $eq3Hf = parcelRequire("eq3Hf");

var $huH03 = parcelRequire("huH03");
const $c36cbf0efe48d029$var$fromUrlTransformerFactory = (transformer)=>(0, (/*@__PURE__*/$parcel$interopDefault($eq3Hf)))([
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        (params)=>(0, (/*@__PURE__*/$parcel$interopDefault($huH03)))(params, (p)=>Array.isArray(p) ? p[0] : p),
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        (params)=>transformer(params)
    ]);
var $c36cbf0efe48d029$export$2e2bcd8739ae039 = $c36cbf0efe48d029$var$fromUrlTransformerFactory;

});
parcelRegister("huH03", function(module, exports) {

var $iBJlb = parcelRequire("iBJlb");

var $75Jcs = parcelRequire("75Jcs");

var $1lM9j = parcelRequire("1lM9j");
/**
 * Creates an object with the same keys as `object` and values generated
 * by running each own enumerable string keyed property of `object` thru
 * `iteratee`. The iteratee is invoked with three arguments:
 * (value, key, object).
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Object
 * @param {Object} object The object to iterate over.
 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
 * @returns {Object} Returns the new mapped object.
 * @see _.mapKeys
 * @example
 *
 * var users = {
 *   'fred':    { 'user': 'fred',    'age': 40 },
 *   'pebbles': { 'user': 'pebbles', 'age': 1 }
 * };
 *
 * _.mapValues(users, function(o) { return o.age; });
 * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
 *
 * // The `_.property` iteratee shorthand.
 * _.mapValues(users, 'age');
 * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
 */ function $cbc697e9f663ba19$var$mapValues(object, iteratee) {
    var result = {};
    iteratee = $1lM9j(iteratee, 3);
    $75Jcs(object, function(value, key, object) {
        $iBJlb(result, key, iteratee(value, key, object));
    });
    return result;
}
module.exports = $cbc697e9f663ba19$var$mapValues;

});


parcelRegister("kuiVs", function(module, exports) {
$parcel$export(module.exports, "AdapterWithState", () => $2b09358ce6ec78a3$export$2fcc0cb3ae18b63e);

var $eJOHy = parcelRequire("eJOHy");

var $cSmYj = parcelRequire("cSmYj");

var $b5RwB = parcelRequire("b5RwB");
class $2b09358ce6ec78a3$export$2fcc0cb3ae18b63e extends (0, $eJOHy.Component) {
    static getDerivedStateFromProps(props, state) {
        if (props.search !== state.prevSearch) return {
            query: props.toQuery(props.search),
            prevSearch: props.search
        };
        return null;
    }
    componentDidUpdate(prevProps, prevState) {
        if (!(0, (/*@__PURE__*/$parcel$interopDefault($cSmYj)))(prevState.query, this.state.query)) {
            const prevParams = (0, (/*@__PURE__*/$parcel$interopDefault($b5RwB))).parse(prevState.prevSearch);
            this.props.onChange(this.state.query, prevParams);
        }
    }
    render() {
        return this.props.children({
            query: this.state.query,
            onQueryChanged: this.onQueryChanged
        });
    }
    constructor(...args){
        super(...args), this.state = {
            query: this.props.toQuery(this.props.search),
            prevSearch: this.props.search
        }, this.onQueryChanged = (query)=>{
            this.setState({
                query: query
            });
        };
    }
}

});


parcelRegister("4l9z6", function(module, exports) {
$parcel$export(module.exports, "default", () => $796340d1cc38288a$export$2e2bcd8739ae039);

var $3zv7S = parcelRequire("3zv7S");

var $fFyRs = parcelRequire("fFyRs");
const $796340d1cc38288a$var$toUrlTransformerFactory = (sortFieldTransformer, filterTransformer)=>{
    const valueTransformers = {
        // @ts-expect-error - TS7006 - Parameter 'page' implicitly has an 'any' type.
        page: (page)=>({
                page: (0, $fFyRs.number).stringify(page)
            }),
        // @ts-expect-error - TS7006 - Parameter 'dir' implicitly has an 'any' type.
        sortDirection: (dir)=>({
                sortOrder: (0, $fFyRs.string).stringify(dir)
            }),
        // @ts-expect-error - TS7006 - Parameter 'field' implicitly has an 'any' type.
        sortField: (field)=>({
                sortKey: sortFieldTransformer(field)
            }),
        filter: filterTransformer
    };
    return (query)=>(0, (/*@__PURE__*/$parcel$interopDefault($3zv7S)))(query, (params, value, key)=>// @ts-expect-error - TS7053 - Element implicitly has an 'any' type because expression of type 'string' can't be used to index type '{ page: (page: any) => { page: string; }; sortDirection: (dir: any) => { sortOrder: any; }; sortField: (field: any) => { sortKey: string; }; filter: FilterToParamTransformer<TFilter>; }'. | TS7053 - Element implicitly has an 'any' type because expression of type 'string' can't be used to index type '{ page: (page: any) => { page: string; }; sortDirection: (dir: any) => { sortOrder: any; }; sortField: (field: any) => { sortKey: string; }; filter: FilterToParamTransformer<TFilter>; }'.
            valueTransformers[key] ? {
                ...params,
                ...valueTransformers[key](value)
            } : params, {});
};
var $796340d1cc38288a$export$2e2bcd8739ae039 = $796340d1cc38288a$var$toUrlTransformerFactory;

});
parcelRegister("3zv7S", function(module, exports) {

var $2x6Yt = parcelRequire("2x6Yt");

var $c3u3c = parcelRequire("c3u3c");

var $1lM9j = parcelRequire("1lM9j");

var $aiJg7 = parcelRequire("aiJg7");

var $4sprp = parcelRequire("4sprp");
/**
 * Reduces `collection` to a value which is the accumulated result of running
 * each element in `collection` thru `iteratee`, where each successive
 * invocation is supplied the return value of the previous. If `accumulator`
 * is not given, the first element of `collection` is used as the initial
 * value. The iteratee is invoked with four arguments:
 * (accumulator, value, index|key, collection).
 *
 * Many lodash methods are guarded to work as iteratees for methods like
 * `_.reduce`, `_.reduceRight`, and `_.transform`.
 *
 * The guarded methods are:
 * `assign`, `defaults`, `defaultsDeep`, `includes`, `merge`, `orderBy`,
 * and `sortBy`
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
 * @param {*} [accumulator] The initial value.
 * @returns {*} Returns the accumulated value.
 * @see _.reduceRight
 * @example
 *
 * _.reduce([1, 2], function(sum, n) {
 *   return sum + n;
 * }, 0);
 * // => 3
 *
 * _.reduce({ 'a': 1, 'b': 2, 'c': 1 }, function(result, value, key) {
 *   (result[value] || (result[value] = [])).push(key);
 *   return result;
 * }, {});
 * // => { '1': ['a', 'c'], '2': ['b'] } (iteration order is not guaranteed)
 */ function $299cc8f655bd088e$var$reduce(collection, iteratee, accumulator) {
    var func = $4sprp(collection) ? $2x6Yt : $aiJg7, initAccum = arguments.length < 3;
    return func(collection, $1lM9j(iteratee, 4), accumulator, initAccum, $c3u3c);
}
module.exports = $299cc8f655bd088e$var$reduce;

});
parcelRegister("aiJg7", function(module, exports) {
/**
 * The base implementation of `_.reduce` and `_.reduceRight`, without support
 * for iteratee shorthands, which iterates over `collection` using `eachFunc`.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @param {*} accumulator The initial value.
 * @param {boolean} initAccum Specify using the first or last element of
 *  `collection` as the initial value.
 * @param {Function} eachFunc The function to iterate over `collection`.
 * @returns {*} Returns the accumulated value.
 */ function $77feb151e6770379$var$baseReduce(collection, iteratee, accumulator, initAccum, eachFunc) {
    eachFunc(collection, function(value, index, collection) {
        accumulator = initAccum ? (initAccum = false, value) : iteratee(accumulator, value, index, collection);
    });
    return accumulator;
}
module.exports = $77feb151e6770379$var$baseReduce;

});



parcelRegister("lg6iR", function(module, exports) {
$parcel$export(module.exports, "default", () => $ba0ec9813bfa2405$export$2e2bcd8739ae039);

var $eq3Hf = parcelRequire("eq3Hf");

var $huH03 = parcelRequire("huH03");

var $3zv7S = parcelRequire("3zv7S");

var $2CrAx = parcelRequire("2CrAx");

var $fFyRs = parcelRequire("fFyRs");
const $ba0ec9813bfa2405$var$fromUrlTransformerFactory = (sortFieldTransformer, filterTransformer)=>{
    const transformers = {
        // @ts-expect-error - TS7006 - Parameter 'page' implicitly has an 'any' type.
        page: (page)=>(0, $2CrAx.validatePageNumber)((0, $fFyRs.number).parse(page)) ? {
                page: (0, $fFyRs.number).parse(page)
            } : {},
        // @ts-expect-error - TS7006 - Parameter 'order' implicitly has an 'any' type.
        sortOrder: (order)=>(0, $2CrAx.validateSortDirection)(order) ? {
                sortDirection: order
            } : {},
        // @ts-expect-error - TS7006 - Parameter 'key' implicitly has an 'any' type.
        sortKey: (key)=>sortFieldTransformer(key) ? {
                sortField: sortFieldTransformer(key)
            } : {}
    };
    return (0, (/*@__PURE__*/$parcel$interopDefault($eq3Hf)))([
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        (params)=>(0, (/*@__PURE__*/$parcel$interopDefault($huH03)))(params, (p)=>Array.isArray(p) ? p[0] : p),
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        (params)=>(0, (/*@__PURE__*/$parcel$interopDefault($3zv7S)))(params, (query, value, key)=>// @ts-expect-error - TS7053 - Element implicitly has an 'any' type because expression of type 'string' can't be used to index type '{ page: (page: any) => { page: number; } | { page?: undefined; }; sortOrder: (order: any) => { sortDirection: any; } | { sortDirection?: undefined; }; sortKey: (key: any) => { sortField: TSortField | null; } | { ...; }; }'. | TS7053 - Element implicitly has an 'any' type because expression of type 'string' can't be used to index type '{ page: (page: any) => { page: number; } | { page?: undefined; }; sortOrder: (order: any) => { sortDirection: any; } | { sortDirection?: undefined; }; sortKey: (key: any) => { sortField: TSortField | null; } | { ...; }; }'.
                transformers[key] ? {
                    ...query,
                    ...transformers[key](value)
                } : query, {
                filter: filterTransformer(params)
            })
    ]);
};
var $ba0ec9813bfa2405$export$2e2bcd8739ae039 = $ba0ec9813bfa2405$var$fromUrlTransformerFactory;

});
parcelRegister("2CrAx", function(module, exports) {
$parcel$export(module.exports, "calculateTotalPages", () => $e8881310cdd77edc$export$fba88641b8ab6cd8);
$parcel$export(module.exports, "predictPageToRequestAfterItemDeletion", () => $e8881310cdd77edc$export$3179e82a0f1565e1);
$parcel$export(module.exports, "validatePageNumber", () => $e8881310cdd77edc$export$231cde03e0d8b537);
$parcel$export(module.exports, "validateSortDirection", () => $e8881310cdd77edc$export$407c10b4791d7a16);

const $e8881310cdd77edc$export$fba88641b8ab6cd8 = (totalItems, itemsPerPage)=>Math.max(Math.ceil(totalItems / itemsPerPage), 1);
const $e8881310cdd77edc$export$3179e82a0f1565e1 = (itemsPerPage, totalItems, currentPage = 1, itemsRemoved = 1)=>{
    const maxPossiblePage = $e8881310cdd77edc$export$fba88641b8ab6cd8(totalItems - itemsRemoved, itemsPerPage);
    return currentPage > maxPossiblePage ? maxPossiblePage : currentPage;
};
const $e8881310cdd77edc$export$231cde03e0d8b537 = (input)=>typeof input === 'number' && Number.isInteger(input) && input >= 1;
const $e8881310cdd77edc$export$407c10b4791d7a16 = (input)=>[
        (0, $88c5923de10af20c$export$1dee026a19752d6b),
        (0, $88c5923de10af20c$export$b6abcf7fa1d94f65)
    ].includes(input);

});
const $88c5923de10af20c$export$1dee026a19752d6b = 'ASC';
const $88c5923de10af20c$export$b6abcf7fa1d94f65 = 'DESC';




parcelRegister("714QC", function(module, exports) {
$parcel$export(module.exports, "initialQuery", () => $3d50f2f3055f041c$export$8af7177c92ae79e3);


var $awhT9 = parcelRequire("awhT9");
const $3d50f2f3055f041c$export$8af7177c92ae79e3 = {
    sortField: (0, $awhT9.NAME),
    sortDirection: (0, $88c5923de10af20c$export$1dee026a19752d6b),
    page: 1,
    filter: {
        text: undefined,
        project: undefined,
        group: undefined,
        owner: undefined
    }
};

});
parcelRegister("awhT9", function(module, exports) {
$parcel$export(module.exports, "FAVOURITED", () => $97256a26c42cb455$export$fdb541a0853ce91e);
$parcel$export(module.exports, "NAME", () => $97256a26c42cb455$export$3c5e605ca7ade9f2);
$parcel$export(module.exports, "OWNER", () => $97256a26c42cb455$export$8c6af90262e3c6cd);
$parcel$export(module.exports, "POPULARITY", () => $97256a26c42cb455$export$baf77a5a5061f88f);
$parcel$export(module.exports, "SORT_FIELDS", () => $97256a26c42cb455$export$5866f21b947884b4);
const $97256a26c42cb455$export$fdb541a0853ce91e = 'favourite';
const $97256a26c42cb455$export$3c5e605ca7ade9f2 = 'name';
const $97256a26c42cb455$export$8c6af90262e3c6cd = 'owner';
const $97256a26c42cb455$export$baf77a5a5061f88f = 'popularity';
const $97256a26c42cb455$export$5866f21b947884b4 = {
    [$97256a26c42cb455$export$3c5e605ca7ade9f2]: 'NAME',
    [$97256a26c42cb455$export$8c6af90262e3c6cd]: 'OWNER',
    [$97256a26c42cb455$export$fdb541a0853ce91e]: 'IS_FAVOURITE',
    [$97256a26c42cb455$export$baf77a5a5061f88f]: 'FAVOURITE_COUNT'
};

});


parcelRegister("5XnPB", function(module, exports) {
$parcel$export(module.exports, "filterToParams", () => $0f18717bf9445e4e$export$cb128e46cc7ba0f1);
$parcel$export(module.exports, "filterFromParams", () => $0f18717bf9445e4e$export$f6542f27c27241c6);
const $0f18717bf9445e4e$export$cb128e46cc7ba0f1 = ({ group: group, owner: owner, project: project, text: text } = {})=>({
        name: text || undefined,
        owner: owner && owner.accountId || undefined,
        selectedProject: project && project.value || 'anything',
        selectedGroup: group && group.value || 'anything'
    });
const $0f18717bf9445e4e$var$transformSelectedOwner = (input)=>input ? {
        accountId: input
    } : undefined;
const $0f18717bf9445e4e$var$transformSelectedProject = (input)=>input && input !== 'anything' ? {
        value: input
    } : undefined;
const $0f18717bf9445e4e$var$transformSelectedGroup = (input)=>input && input !== 'anything' ? {
        value: input,
        name: input
    } : undefined;
const $0f18717bf9445e4e$export$f6542f27c27241c6 = (params)=>({
        text: params.name || params.searchName || undefined,
        owner: $0f18717bf9445e4e$var$transformSelectedOwner(params.owner),
        project: $0f18717bf9445e4e$var$transformSelectedProject(params.selectedProject),
        group: $0f18717bf9445e4e$var$transformSelectedGroup(params.selectedGroup)
    });

});

parcelRegister("13TEf", function(module, exports) {
$parcel$export(module.exports, "sortFieldToParam", () => $584e5d02652075a3$export$9a7ae3517c7d79c2);
$parcel$export(module.exports, "sortFieldFromParam", () => $584e5d02652075a3$export$307ee63ec20d9c92);

var $awhT9 = parcelRequire("awhT9");
const $584e5d02652075a3$var$sortFieldMap = {
    [(0, $awhT9.NAME).toLowerCase()]: (0, $awhT9.NAME),
    [(0, $awhT9.OWNER).toLowerCase()]: (0, $awhT9.OWNER),
    [(0, $awhT9.POPULARITY).toLowerCase()]: (0, $awhT9.POPULARITY),
    [(0, $awhT9.FAVOURITED).toLowerCase()]: (0, $awhT9.FAVOURITED)
};
const $584e5d02652075a3$export$9a7ae3517c7d79c2 = (field)=>field.toLowerCase();
const $584e5d02652075a3$export$307ee63ec20d9c92 = (param)=>$584e5d02652075a3$var$sortFieldMap[param] ? $584e5d02652075a3$var$sortFieldMap[param] : null;

});


parcelRegister("6UU7v", function(module, exports) {
$parcel$export(module.exports, "withSuspense", () => $d591853152e8b41d$export$a3bce93d4fb4eda6);
const $d591853152e8b41d$var$isDataEmpty = (data)=>data == null;
function $d591853152e8b41d$export$a3bce93d4fb4eda6(theHook) {
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    return (...args)=>{
        const result = theHook(...args);
        if (!false && $d591853152e8b41d$var$isDataEmpty(result.data) && result.loading) throw result.promise;
        return result;
    };
}

});

parcelRegister("iEXnd", function(module, exports) {
$parcel$export(module.exports, "PRODUCT_START_MARK", () => $528da7e985f30ee4$export$8e54fca0a680fdfd);
$parcel$export(module.exports, "MarkProductStart", () => $528da7e985f30ee4$export$2a999c5f84501025);

var $6uWhG = parcelRequire("6uWhG");
const $528da7e985f30ee4$export$8e54fca0a680fdfd = 'PRODUCT_START';
const $528da7e985f30ee4$export$2a999c5f84501025 = ()=>{
    if (!false) {
        performance.clearMarks($528da7e985f30ee4$export$8e54fca0a680fdfd);
        (0, $6uWhG.setMark)($528da7e985f30ee4$export$8e54fca0a680fdfd);
    }
    return null;
};

});

parcelRegister("emZpp", function(module, exports) {
$parcel$export(module.exports, "default", () => $e30b9beb6a14d47d$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $2QUmO = parcelRequire("2QUmO");

var $cZTMg = parcelRequire("cZTMg");

var $5doBc = parcelRequire("5doBc");
const $e30b9beb6a14d47d$export$3386beb5bc3bfa = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $cZTMg.SubProductUpdater), {
        subProduct: "platform"
    });
var $e30b9beb6a14d47d$export$2e2bcd8739ae039 = (0, $2QUmO.default)((0, $5doBc.default), {
    Updater: $e30b9beb6a14d47d$export$3386beb5bc3bfa
});

});
parcelRegister("5doBc", function(module, exports) {
$parcel$export(module.exports, "default", () => $7b03bb0458b2a895$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $12DRg = parcelRequire("12DRg");

var $fdpHV = parcelRequire("fdpHV");

var $1Rprg = parcelRequire("1Rprg");

var $1qbKn = parcelRequire("1qbKn");

var $3So8J = parcelRequire("3So8J");


var $2vBmG = parcelRequire("2vBmG");

var $jUHqr = parcelRequire("jUHqr");

var $iMFdk = parcelRequire("iMFdk");

var $gWu57 = parcelRequire("gWu57");

var $6fgqt = parcelRequire("6fgqt");
function $7b03bb0458b2a895$var$DashboardsDirectory({ Updater: Updater, tenantContext: tenantContext, prefetchResult: prefetchResult, favoriteChangeContext: favoriteChangeContext, query: query, onQueryChanged: onQueryChanged }) {
    const { locale: locale, atlassianAccountId: atlassianAccountId, xsrfToken: xsrfToken } = tenantContext;
    const { error: prefetchError, loading: loading, data: data } = prefetchResult;
    if (prefetchError && !loading) // @ts-expect-error - TS2322 - Type 'Error | Record<string, any> | (Error & Record<string, any>) | (Record<string, any> & Error)' is not assignable to type 'Error | null'.
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1qbKn.ErrorFlagRenderer), {
        id: "directories-dashboards",
        error: prefetchError
    });
    if (!data) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $iMFdk.DashboardsDirectorySkeleton), null);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $gWu57.PageLayout), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $3So8J.default), {
        id: "unhandled",
        packageName: "jiraSpaAppsDirectoriesDashboards",
        teamName: "keystone"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(Updater, null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1Rprg.default), {
        accountId: atlassianAccountId,
        locale: locale,
        query: query,
        favoriteChangeContext: favoriteChangeContext,
        prefetchedData: data,
        onQueryChanged: onQueryChanged,
        onUnmount: (0, (/*@__PURE__*/$parcel$interopDefault($12DRg))),
        withPageReadyMetrics: false,
        xsrfToken: xsrfToken
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $jUHqr.default), {
        metricKey: "jira.directories.dashboards",
        metric: (0, $6fgqt.dashboardsDirectoryPageLoad),
        isExpectedToHaveSsr: true,
        withMarks: [
            (0, $2vBmG.appBundleReadyMark),
            (0, $2vBmG.prefetchApiReadyMark)
        ]
    })));
}
var $7b03bb0458b2a895$export$2e2bcd8739ae039 = (0, $fdpHV.AnalyticsSource)('dashboards', (0, $aa42ce8e355d58fa$export$f636b5b56f1d624a))($7b03bb0458b2a895$var$DashboardsDirectory);

});
parcelRegister("1Rprg", function(module, exports) {
$parcel$export(module.exports, "default", () => $4f37873e22b83de5$export$2e2bcd8739ae039);

var $eq3Hf = parcelRequire("eq3Hf");

var $giQZR = parcelRequire("giQZR");

var $aQLTb = parcelRequire("aQLTb");

var $9s5bB = parcelRequire("9s5bB");

var $idGBm = parcelRequire("idGBm");

var $8UrZS = parcelRequire("8UrZS");
var $4f37873e22b83de5$export$2e2bcd8739ae039 = (0, (/*@__PURE__*/$parcel$interopDefault($eq3Hf)))((0, $idGBm.injectIntlV2), (0, $giQZR.default)({
    CreateButton: $aQLTb.default,
    DashboardsDirectory: $9s5bB.default
}))((0, $8UrZS.default));

});
parcelRegister("giQZR", function(module, exports) {
$parcel$export(module.exports, "default", () => $388c753b6a91fb19$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");
const $388c753b6a91fb19$var$isEmpty = (s)=>s === undefined || s === null || s === '';
const $388c753b6a91fb19$var$getDisplayName = (x)=>{
    // @ts-expect-error - TS2322 - Type 'string | undefined' is not assignable to type 'string'.
    if (!$388c753b6a91fb19$var$isEmpty(x.displayName)) return x.displayName;
    if (!$388c753b6a91fb19$var$isEmpty(x.name)) return x.name;
    return 'Component';
};
const $388c753b6a91fb19$export$19c55c6cefb3b57 = (defaults)=>(Component)=>{
        const displayName = $388c753b6a91fb19$var$getDisplayName(Component);
        // @ts-expect-error - TS2698 - Spread types may only be created from object types. | TS2698 - Spread types may only be created from object types.
        const WithProps = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(Component, {
                ...defaults,
                ...props
            });
        WithProps.displayName = `WithProps(${displayName})`;
        // @ts-expect-error - TS2322 - Type '{ (props: Partial<A> & B): JSX.Element; displayName: string; }' is not assignable to type 'AbstractComponent<Partial<A> & B, unknown>'.
        return WithProps;
    };
var $388c753b6a91fb19$export$2e2bcd8739ae039 = $388c753b6a91fb19$export$19c55c6cefb3b57;

});

parcelRegister("aQLTb", function(module, exports) {
$parcel$export(module.exports, "default", () => $af4d1e79757bede8$export$2e2bcd8739ae039);
// eslint-disable-next-line jira/restricted/react-component-props

var $eJOHy = parcelRequire("eJOHy");

var $aP411 = parcelRequire("aP411");

var $3So8J = parcelRequire("3So8J");

var $kLf6M = parcelRequire("kLf6M");
const $af4d1e79757bede8$var$CreateButton = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $3So8J.default), {
        id: "unhandled",
        packageName: "jiraCreateDashboardsButton",
        teamName: "keystone"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $aP411.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $kLf6M.default), {
        onClick: props.onClick
    })));
$af4d1e79757bede8$var$CreateButton.defaultProps = {
    onClick: undefined
};
var $af4d1e79757bede8$export$2e2bcd8739ae039 = $af4d1e79757bede8$var$CreateButton;

});
parcelRegister("kLf6M", function(module, exports) {
$parcel$export(module.exports, "default", () => $007540805de067ca$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $eJOHy = parcelRequire("eJOHy");

var $eq3Hf = parcelRequire("eq3Hf");

var $12DRg = parcelRequire("12DRg");

var $goZPP = parcelRequire("goZPP");

var $k71qx = parcelRequire("k71qx");

var $6sjW5 = parcelRequire("6sjW5");

var $7EgC9 = parcelRequire("7EgC9");

var $idGBm = parcelRequire("idGBm");

var $5Ste8 = parcelRequire("5Ste8");

var $koAZ4 = parcelRequire("koAZ4");

var $83DiZ = parcelRequire("83DiZ");

var $2tYPT = parcelRequire("2tYPT");
const $007540805de067ca$var$CreateButtonWithModal = ({ onClick: onClick, intl: { formatMessage: formatMessage } })=>{
    const { push: push } = (0, $83DiZ.useRouterActions)();
    const navigateToDashboard = (0, $eJOHy.useCallback)(// @ts-expect-error - TS7006 - Parameter 'id' implicitly has an 'any' type.
    (id)=>{
        push(`/jira/dashboards/${id}/edit`);
    }, [
        push
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $koAZ4.TenantContextSubscriber), null, ({ tenantContext: tenantContext })=>tenantContext.atlassianAccountId ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $5Ste8.ModalsContainer), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $5Ste8.ModalsSubscriber), null, (isOpen, { open: open, close: close })=>{
            // @ts-expect-error - TS2304 - Cannot find name 'DashboardOperationData'. | TS7031 - Binding element 'id' implicitly has an 'any' type.
            const onSuccess = (_, { id: id })=>{
                navigateToDashboard(id);
                close();
            };
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $goZPP.default), {
                // @ts-expect-error - TS2322 - Type '(e: Event, analyticsEvent: UIAnalyticsEventInterface) => void | Promise<void>' is not assignable to type '(e: MouseEvent<HTMLElement, MouseEvent>, analyticsEvent: UIAnalyticsEvent) => void'.
                onClick: (0, (/*@__PURE__*/$parcel$interopDefault($eq3Hf)))(onClick, open),
                appearance: "primary",
                externalId: "directory.dashboards-v2.create-button" // eslint-disable-next-line jira/integration/test-id-by-folder-structure
                ,
                "data-test-id": "directory.dashboards-v2.create-button"
            }, formatMessage((0, $2tYPT.default).createDashboard)), isOpen && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $7EgC9.default), {
                onSuccess: onSuccess,
                onCancel: close
            }));
        })) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $k71qx.default), {
            content: formatMessage((0, $2tYPT.default).notAllowed)
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $goZPP.default), {
            isDisabled: true,
            onClick: (0, (/*@__PURE__*/$parcel$interopDefault($12DRg))),
            appearance: "primary"
        }, formatMessage((0, $2tYPT.default).createDashboard))));
};
const $007540805de067ca$export$6d3c345ce7c38fd9 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($007540805de067ca$var$CreateButtonWithModal, props);
$007540805de067ca$export$6d3c345ce7c38fd9.defaultProps = {
    onClick: (0, (/*@__PURE__*/$parcel$interopDefault($12DRg)))
};
var $007540805de067ca$export$2e2bcd8739ae039 = (0, (/*@__PURE__*/$parcel$interopDefault($eq3Hf)))((0, $6sjW5.default)({
    onClick: 'createDashboard'
}), (0, $idGBm.injectIntlV2))($007540805de067ca$export$6d3c345ce7c38fd9);

});
parcelRegister("5Ste8", function(module, exports) {
$parcel$export(module.exports, "ModalsContainer", () => $17059759b478c401$export$5dffa5a5319be22d);
$parcel$export(module.exports, "ModalsSubscriber", () => $17059759b478c401$export$facc296933ebcadf);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state

var $6E16M = parcelRequire("6E16M");
var $ht3nQ = parcelRequire("ht3nQ");

var $lezjz = parcelRequire("lezjz");
const $17059759b478c401$export$5dffa5a5319be22d = (0, $6E16M.createContainer)((0, $lezjz.default));
const $17059759b478c401$export$facc296933ebcadf = (0, $ht3nQ.createSubscriber)((0, $lezjz.default), {
    displayName: 'ModalsSubscriber',
    selector: (state)=>state.isOpen
});

});
parcelRegister("lezjz", function(module, exports) {
$parcel$export(module.exports, "default", () => $7a024ebd7ef786d8$export$2e2bcd8739ae039);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state

var $GtRbT = parcelRequire("GtRbT");

var $139Z7 = parcelRequire("139Z7");
const $7a024ebd7ef786d8$var$initialState = {
    isOpen: false
};
var $7a024ebd7ef786d8$export$2e2bcd8739ae039 = (0, $GtRbT.createStore)({
    name: 'modals',
    initialState: $7a024ebd7ef786d8$var$initialState,
    actions: $139Z7.default
});

});
parcelRegister("139Z7", function(module, exports) {
$parcel$export(module.exports, "default", () => $15892008fa8602a9$export$2e2bcd8739ae039);
const $15892008fa8602a9$var$actions = {
    open: ()=>({ setState: setState })=>{
            setState({
                isOpen: true
            });
        },
    close: ()=>({ setState: setState })=>{
            setState({
                isOpen: false
            });
        }
};
var $15892008fa8602a9$export$2e2bcd8739ae039 = $15892008fa8602a9$var$actions;

});



parcelRegister("2tYPT", function(module, exports) {
$parcel$export(module.exports, "default", () => $c84421d1e282e1b6$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
const $c84421d1e282e1b6$var$messages = (0, $7qGN1.defineMessages)({
    createDashboard: {
        "id": "directories.dashboards-v2.create-button.create-dashboard",
        "defaultMessage": "Create dashboard"
    },
    notAllowed: {
        "id": "directories.dashboards-v2.create-button.not-allowed",
        "defaultMessage": "You must be logged in to create dashboards"
    }
});
var $c84421d1e282e1b6$export$2e2bcd8739ae039 = $c84421d1e282e1b6$var$messages;

});



parcelRegister("9s5bB", function(module, exports) {
$parcel$export(module.exports, "default", () => $a3263d47dd619363$export$2e2bcd8739ae039);
// eslint-disable-next-line jira/restricted/react-component-props

var $eJOHy = parcelRequire("eJOHy");

var $12DRg = parcelRequire("12DRg");

var $guWba = parcelRequire("guWba");

var $7iHUq = parcelRequire("7iHUq");

var $aP411 = parcelRequire("aP411");

var $3So8J = parcelRequire("3So8J");

var $714QC = parcelRequire("714QC");

var $g6VcM = parcelRequire("g6VcM");

var $5XlOX = parcelRequire("5XlOX");

var $fIzGh = parcelRequire("fIzGh");

var $ec7Ui = parcelRequire("ec7Ui");

var $aeZny = parcelRequire("aeZny");

var $2TDyc = parcelRequire("2TDyc");

var $iRGx7 = parcelRequire("iRGx7");

var $8QlCt = parcelRequire("8QlCt");
class $a3263d47dd619363$export$2e2bcd8739ae039 extends (0, $eJOHy.Component) {
    static{
        this.defaultProps = {
            query: undefined,
            withPageReadyMetrics: true,
            prefetchedData: {},
            onUnmount: (0, (/*@__PURE__*/$parcel$interopDefault($12DRg))),
            onQueryChanged: (0, (/*@__PURE__*/$parcel$interopDefault($12DRg)))
        };
    }
    constructor(props){
        super(props);
        this.store = (0, $2TDyc.default)((0, $5XlOX.default));
        const { dispatch: dispatch } = this.store;
        const { dashboards: dashboards } = props.prefetchedData;
        dispatch((0, $fIzGh.setAppProps)(props));
        dispatch((0, $aeZny.setQuery)(props.query || (0, $714QC.initialQuery)));
        if (dashboards) dispatch((0, $ec7Ui.retrieved)(dashboards));
    }
    componentDidMount() {
        const { dispatch: dispatch } = this.store;
        const { dashboards: dashboards } = this.props.prefetchedData;
        if (!dashboards) dispatch((0, $ec7Ui.retrieve)());
    }
    componentDidUpdate() {
        this.store.dispatch((0, $fIzGh.setAppProps)(this.props));
        // @ts-expect-error - TS2345 - Argument of type 'Partial<Query>' is not assignable to parameter of type 'Query'.
        if (this.props.query && (0, $g6VcM.isQueryChanged)(this.props.query, (0, $iRGx7.getQuery)(this.store.getState()))) {
            this.store.dispatch((0, $aeZny.setQuery)(this.props.query));
            this.store.dispatch((0, $ec7Ui.retrieve)());
        }
    }
    componentWillUnmount() {
        this.props.onUnmount();
    }
    render() {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $7iHUq.default), {
            store: this.store,
            hasErrorBoundary: false
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $3So8J.default), {
            id: "unhandled",
            packageName: "jiraDashboardsMain",
            teamName: "keystone"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $guWba.default), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $aP411.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8QlCt.default), null))));
    }
}

});
parcelRegister("g6VcM", function(module, exports) {
$parcel$export(module.exports, "isQueryChanged", () => $d9a5381ea9a73df2$export$dcc7e61e8982458d);

var $cSmYj = parcelRequire("cSmYj");
const $d9a5381ea9a73df2$var$getQueryValues = (target)=>{
    const { page: page, sortField: sortField, sortDirection: sortDirection, filter: filter } = target;
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    const { text: text, owner: owner, project: project, group: group } = filter;
    return {
        page: page,
        sortField: sortField,
        sortDirection: sortDirection,
        filter: {
            text: text,
            owner: owner && owner.accountId,
            project: project && project.value,
            group: group && group.value
        }
    };
};
const $d9a5381ea9a73df2$export$dcc7e61e8982458d = (newQuery, prevQuery)=>!(0, (/*@__PURE__*/$parcel$interopDefault($cSmYj)))($d9a5381ea9a73df2$var$getQueryValues(newQuery), $d9a5381ea9a73df2$var$getQueryValues(prevQuery));

});

parcelRegister("5XlOX", function(module, exports) {
$parcel$export(module.exports, "default", () => $4db13b49c2f00cf7$export$2e2bcd8739ae039);

var $4tM8k = parcelRequire("4tM8k");

var $4fe96 = parcelRequire("4fe96");

var $feqqt = parcelRequire("feqqt");

var $iGA34 = parcelRequire("iGA34");
var $4db13b49c2f00cf7$export$2e2bcd8739ae039 = (0, $4tM8k.combineEpics)((0, $feqqt.default), (0, $iGA34.default), (0, $4fe96.default));

});
parcelRegister("4fe96", function(module, exports) {
$parcel$export(module.exports, "default", () => $2fcdb0513e8f9fb5$export$2e2bcd8739ae039);
parcelRequire("7La6O");
parcelRequire("8yIb3");

var $c7Vu4 = parcelRequire("c7Vu4");

var $fIzGh = parcelRequire("fIzGh");

var $bpMvQ = parcelRequire("bpMvQ");
const $2fcdb0513e8f9fb5$var$pageReadyEpic = (action$, store)=>action$.ofType((0, $fIzGh.READY)).do(()=>{
        (0, $bpMvQ.isWithPageReadyMetrics)(store.getState()) && (0, $c7Vu4.pageReady)();
    }).ignoreElements();
var $2fcdb0513e8f9fb5$export$2e2bcd8739ae039 = $2fcdb0513e8f9fb5$var$pageReadyEpic;

});
parcelRegister("c7Vu4", function(module, exports) {
$parcel$export(module.exports, "pageReady", () => $a86e47308bff0971$export$674e3a896edcf7c);
// Replace with lodash/noop
// eslint-disable-next-line @typescript-eslint/no-empty-function
const $a86e47308bff0971$export$674e3a896edcf7c = ()=>{};

});

parcelRegister("fIzGh", function(module, exports) {
$parcel$export(module.exports, "SET_APP_PROPS", () => $0d36f3e5694bc9c9$export$8aefe701a6f431e0);
$parcel$export(module.exports, "setAppProps", () => $0d36f3e5694bc9c9$export$cfda7627848a58cd);
$parcel$export(module.exports, "READY", () => $0d36f3e5694bc9c9$export$4bf05b02be91f13a);
$parcel$export(module.exports, "ready", () => $0d36f3e5694bc9c9$export$28ee1007e174a2a6);
const $0d36f3e5694bc9c9$export$8aefe701a6f431e0 = 'state.actions.app.SET_APP_PROPS';
const $0d36f3e5694bc9c9$export$cfda7627848a58cd = (payload)=>({
        type: $0d36f3e5694bc9c9$export$8aefe701a6f431e0,
        payload: payload
    });
const $0d36f3e5694bc9c9$export$4bf05b02be91f13a = 'state.actions.app.READY';
const $0d36f3e5694bc9c9$export$28ee1007e174a2a6 = ()=>({
        type: $0d36f3e5694bc9c9$export$4bf05b02be91f13a
    });

});

parcelRegister("bpMvQ", function(module, exports) {
$parcel$export(module.exports, "getLoggedInUserAccountId", () => $8a8b69d03f388b50$export$a304ee7b66f5d1e);
$parcel$export(module.exports, "getOnQueryChanged", () => $8a8b69d03f388b50$export$59e4f8ebf6520bf7);
$parcel$export(module.exports, "getFavoriteChangeContext", () => $8a8b69d03f388b50$export$6fa121a48411f085);
$parcel$export(module.exports, "isWithPageReadyMetrics", () => $8a8b69d03f388b50$export$29e8a85166eb4498);
const $8a8b69d03f388b50$export$a304ee7b66f5d1e = (state)=>state.app.props.accountId;
const $8a8b69d03f388b50$export$59e4f8ebf6520bf7 = (state)=>state.app.props.onQueryChanged;
const $8a8b69d03f388b50$export$14407a25c57e1f92 = (state)=>state.app.props.xsrfToken;
const $8a8b69d03f388b50$export$6fa121a48411f085 = (state)=>state.app.props.favoriteChangeContext;
const $8a8b69d03f388b50$export$29e8a85166eb4498 = (state)=>state.app.props.withPageReadyMetrics;

});


parcelRegister("feqqt", function(module, exports) {
$parcel$export(module.exports, "default", () => $d047116263d3ba01$export$2e2bcd8739ae039);

var $4tM8k = parcelRequire("4tM8k");
parcelRequire("1AyD5");
parcelRequire("6cJUr");

var $k4x9q = parcelRequire("k4x9q");

var $7kixv = parcelRequire("7kixv");

var $aeZny = parcelRequire("aeZny");

var $bpMvQ = parcelRequire("bpMvQ");

var $iRGx7 = parcelRequire("iRGx7");
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $d047116263d3ba01$var$querySet = (action$, store)=>action$.ofType((0, $aeZny.SET_QUERY)).mergeMap(({ payload: payload })=>{
        const state = store.getState();
        const callback = (0, $bpMvQ.getOnQueryChanged)(state);
        if (typeof callback === 'function') callback(payload);
        return (0, $7kixv.Observable).empty();
    });
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $d047116263d3ba01$var$queryPatched = (action$, store)=>action$.ofType((0, $aeZny.PATCH_QUERY)).mergeMap(({ payload: payload })=>{
        const state = store.getState();
        const callback = (0, $bpMvQ.getOnQueryChanged)(state);
        if (typeof callback === 'function') callback((0, (/*@__PURE__*/$parcel$interopDefault($k4x9q)))(payload, (0, $iRGx7.getQuery)(state)));
        return (0, $7kixv.Observable).empty();
    });
var $d047116263d3ba01$export$2e2bcd8739ae039 = (0, $4tM8k.combineEpics)($d047116263d3ba01$var$querySet, $d047116263d3ba01$var$queryPatched);

});
parcelRegister("aeZny", function(module, exports) {
$parcel$export(module.exports, "SET_QUERY", () => $5a88ccdbdb8d768d$export$11bcea24b35a126f);
$parcel$export(module.exports, "setQuery", () => $5a88ccdbdb8d768d$export$f3b215b0b382f63b);
$parcel$export(module.exports, "PATCH_QUERY", () => $5a88ccdbdb8d768d$export$403065a1ff0b1663);
$parcel$export(module.exports, "patchQuery", () => $5a88ccdbdb8d768d$export$8a4e224aafd3a2bf);
const $5a88ccdbdb8d768d$export$11bcea24b35a126f = 'state.actions.query.SET_QUERY';
const $5a88ccdbdb8d768d$export$f3b215b0b382f63b = (payload)=>({
        type: $5a88ccdbdb8d768d$export$11bcea24b35a126f,
        payload: payload
    });
const $5a88ccdbdb8d768d$export$403065a1ff0b1663 = 'state.actions.query.PATCH_QUERY';
const $5a88ccdbdb8d768d$export$8a4e224aafd3a2bf = (payload)=>({
        type: $5a88ccdbdb8d768d$export$403065a1ff0b1663,
        payload: payload
    });

});

parcelRegister("iRGx7", function(module, exports) {
$parcel$export(module.exports, "getQuery", () => $9165a95dca4063aa$export$71eec30d9db46a56);
$parcel$export(module.exports, "getSortField", () => $9165a95dca4063aa$export$9b753af5a9fb5911);
$parcel$export(module.exports, "getSortDirection", () => $9165a95dca4063aa$export$509e2b9937961873);
$parcel$export(module.exports, "getPage", () => $9165a95dca4063aa$export$c2a6433281518c91);
$parcel$export(module.exports, "getFilter", () => $9165a95dca4063aa$export$61ec8404f465cd36);
$parcel$export(module.exports, "getSearchQuery", () => $9165a95dca4063aa$export$1664b92369554829);
$parcel$export(module.exports, "getSelectedProject", () => $9165a95dca4063aa$export$1ebc7a42c839af66);
$parcel$export(module.exports, "getSelectedGroup", () => $9165a95dca4063aa$export$27ee39f0d715ac22);
$parcel$export(module.exports, "getSelectedOwner", () => $9165a95dca4063aa$export$858444e3fc2798fd);
$parcel$export(module.exports, "isFilterApplied", () => $9165a95dca4063aa$export$980aed36f19060a5);

var $ahm5r = parcelRequire("ahm5r");
const $9165a95dca4063aa$export$71eec30d9db46a56 = (state)=>state.query;
const $9165a95dca4063aa$export$9b753af5a9fb5911 = (state)=>state.query.sortField;
const $9165a95dca4063aa$export$509e2b9937961873 = (state)=>state.query.sortDirection;
const $9165a95dca4063aa$export$c2a6433281518c91 = (state)=>state.query.page;
const $9165a95dca4063aa$export$61ec8404f465cd36 = (state)=>state.query.filter;
const $9165a95dca4063aa$export$1664b92369554829 = (state)=>$9165a95dca4063aa$export$61ec8404f465cd36(state).text || '';
const $9165a95dca4063aa$export$1ebc7a42c839af66 = (state)=>$9165a95dca4063aa$export$61ec8404f465cd36(state).project;
const $9165a95dca4063aa$export$27ee39f0d715ac22 = (state)=>$9165a95dca4063aa$export$61ec8404f465cd36(state).group;
const $9165a95dca4063aa$export$858444e3fc2798fd = (state)=>$9165a95dca4063aa$export$61ec8404f465cd36(state).owner;
const $9165a95dca4063aa$export$980aed36f19060a5 = (0, $ahm5r.createSelector)($9165a95dca4063aa$export$1664b92369554829, $9165a95dca4063aa$export$1ebc7a42c839af66, $9165a95dca4063aa$export$27ee39f0d715ac22, $9165a95dca4063aa$export$858444e3fc2798fd, (queryValue, projectValue, groupValue, ownerValue)=>!!queryValue || !!projectValue || !!groupValue || !!ownerValue);

});


parcelRegister("iGA34", function(module, exports) {
$parcel$export(module.exports, "default", () => $b503989c428a6b53$export$2e2bcd8739ae039);
parcelRequire("9BkTq");
parcelRequire("cBiei");
parcelRequire("hfuHK");
parcelRequire("c1D7V");
parcelRequire("6cJUr");

var $7kixv = parcelRequire("7kixv");

var $9pTd3 = parcelRequire("9pTd3");

var $4pI3S = parcelRequire("4pI3S");

var $ec7Ui = parcelRequire("ec7Ui");

var $iRGx7 = parcelRequire("iRGx7");

var $9OXcT = parcelRequire("9OXcT");
const $b503989c428a6b53$var$retrieveDashboards = (action$, store)=>{
    const getDashboardsRequestAction$ = action$.ofType((0, $ec7Ui.RETRIEVE));
    return getDashboardsRequestAction$.mergeMap(()=>{
        const state = store.getState();
        const request = (0, $9OXcT.getServiceRequest)(state);
        const filter = (0, $iRGx7.getFilter)(state);
        const actionStartTimestamp = Date.now();
        return (0, $7kixv.Observable).fromPromise((0, $4pI3S.default)(request, filter)).mergeMap((result)=>(0, $7kixv.Observable).of((0, $ec7Ui.retrieved)(result))).takeUntil(getDashboardsRequestAction$).catch((error)=>{
            (0, $9pTd3.fireErrorAnalytics)({
                error: error,
                meta: {
                    id: 'retrieveDashboards',
                    packageName: 'jiraDashboardsMain',
                    teamName: 'keystone'
                },
                attributes: {
                    durationInMs: Date.now() - actionStartTimestamp
                }
            });
            return (0, $7kixv.Observable).of((0, $ec7Ui.retrieveFailed)());
        });
    });
};
var $b503989c428a6b53$export$2e2bcd8739ae039 = $b503989c428a6b53$var$retrieveDashboards;

});
parcelRegister("4pI3S", function(module, exports) {
$parcel$export(module.exports, "default", () => $db3234e7494d02d3$export$2e2bcd8739ae039);

var $jJwbY = parcelRequire("jJwbY");

var $g5Nzo = parcelRequire("g5Nzo");
const $db3234e7494d02d3$var$getDashboards = async (request, filter)=>{
    const restResponse = await (0, $jJwbY.default)(request, filter);
    return (0, $g5Nzo.transformDashboards)(restResponse.values, restResponse.total);
};
var $db3234e7494d02d3$export$2e2bcd8739ae039 = $db3234e7494d02d3$var$getDashboards;

});
parcelRegister("jJwbY", function(module, exports) {
$parcel$export(module.exports, "default", () => $26313a2113851e9a$export$2e2bcd8739ae039);

var $8sbs2 = parcelRequire("8sbs2");

var $b5RwB = parcelRequire("b5RwB");

var $k6LT0 = parcelRequire("k6LT0");

var $a571L = parcelRequire("a571L");

var $eSnSE = parcelRequire("eSnSE");

var $eBhI6 = parcelRequire("eBhI6");
const $26313a2113851e9a$export$20e00d0048bb5104 = ()=>'/rest/api/2/dashboard/search';
const $26313a2113851e9a$var$createQueryFilter = (filter)=>({
        dashboardName: filter.text
    });
const $26313a2113851e9a$var$createProjectFilter = (filter)=>({
        projectId: filter.project ? filter.project.value : undefined
    });
const $26313a2113851e9a$var$createGroupFilter = (filter)=>({
        groupname: filter.group ? filter.group.value : undefined
    });
const $26313a2113851e9a$var$createOwnerFilter = (filter)=>({
        accountId: filter.owner ? filter.owner.accountId : undefined
    });
const $26313a2113851e9a$var$logError = async (error, currentTry)=>{
    (0, $eSnSE.default).safeErrorWithoutCustomerData('ops.rest.dashboards.get', `Cannot fetch dashboards - is SSR: ${String(false)}, attempt: ${currentTry}`, error);
};
const $26313a2113851e9a$export$7138c24907de3954 = (request, filter)=>{
    const queryParams = {
        ...(0, (/*@__PURE__*/$parcel$interopDefault($8sbs2)))(request, 'startAt', 'maxResults', 'orderBy', 'expand'),
        ...filter.text ? $26313a2113851e9a$var$createQueryFilter(filter) : undefined,
        ...filter.project ? $26313a2113851e9a$var$createProjectFilter(filter) : undefined,
        ...filter.group ? $26313a2113851e9a$var$createGroupFilter(filter) : undefined,
        ...filter.owner ? $26313a2113851e9a$var$createOwnerFilter(filter) : undefined
    };
    return `${$26313a2113851e9a$export$20e00d0048bb5104()}?${(0, $b5RwB.stringify)(queryParams)}`;
};
const $26313a2113851e9a$var$getDashboards = async (request, filter)=>{
    const url = $26313a2113851e9a$export$7138c24907de3954(request, filter);
    const response = await (0, $a571L.fetchWithRetry)(url, (0, $eBhI6.getDefaultOptions)(url), $26313a2113851e9a$var$logError);
    if (response.ok) return response.json();
    throw await (0, $k6LT0.getErrorFromResponse)(response, 'Cannot fetch dashboards');
};
var $26313a2113851e9a$export$2e2bcd8739ae039 = $26313a2113851e9a$var$getDashboards;

});
parcelRegister("k6LT0", function(module, exports) {
$parcel$export(module.exports, "getErrorFromResponse", () => $79c4b7796896939e$export$7780d7826aafbede);

var $14RSn = parcelRequire("14RSn");

var $3ugTQ = parcelRequire("3ugTQ");
const $79c4b7796896939e$export$7780d7826aafbede = async (response, defaultMessage)=>{
    let errorMessage = defaultMessage;
    try {
        const json = await response.json();
        const { errors: errors, errorMessages: errorMessages } = json;
        if (errors && Object.keys(errors).length) return (0, $3ugTQ.transformValidationErrorFromServer)(json);
        errorMessage = errorMessages[0];
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (e) {
    /**/ }
    return new (0, $14RSn.default)(response.status, errorMessage);
};

});

parcelRegister("a571L", function(module, exports) {
$parcel$export(module.exports, "fetchWithRetry", () => $5dd1c9e5c72ce527$export$cffaac380b94df26);

var $eBhI6 = parcelRequire("eBhI6");

var $k6LT0 = parcelRequire("k6LT0");
const $5dd1c9e5c72ce527$export$fbc55f9ab8ae7207 = false ? 1 : 3;
const $5dd1c9e5c72ce527$var$logResponseError = async (logSafeErrorWithoutCustomerData, response, currentTry)=>{
    const error = await (0, $k6LT0.getErrorFromResponse)(response, 'Directory fetch with retry failed');
    await logSafeErrorWithoutCustomerData(error, currentTry);
};
const $5dd1c9e5c72ce527$export$cffaac380b94df26 = async (url, options, logSafeErrorWithoutCustomerData, currentTry = 1)=>{
    try {
        const response = await fetch(url, (0, $eBhI6.getDefaultOptions)(url));
        if (!response.ok) {
            await $5dd1c9e5c72ce527$var$logResponseError(logSafeErrorWithoutCustomerData, response, currentTry);
            if (currentTry < $5dd1c9e5c72ce527$export$fbc55f9ab8ae7207) return $5dd1c9e5c72ce527$export$cffaac380b94df26(url, options, logSafeErrorWithoutCustomerData, currentTry + 1);
        }
        return response;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        await logSafeErrorWithoutCustomerData(error, currentTry);
        if (currentTry < $5dd1c9e5c72ce527$export$fbc55f9ab8ae7207) return $5dd1c9e5c72ce527$export$cffaac380b94df26(url, options, logSafeErrorWithoutCustomerData, currentTry + 1);
        throw error;
    }
};

});


parcelRegister("g5Nzo", function(module, exports) {
$parcel$export(module.exports, "transformDashboards", () => $b3307e69a28dbe05$export$71617175ef5c22ee);

var $9g7yh = parcelRequire("9g7yh");

var $huH03 = parcelRequire("huH03");

var $jwDdO = parcelRequire("jwDdO");
const $b3307e69a28dbe05$export$71617175ef5c22ee = (dashboards, total)=>{
    const order = dashboards.map((i)=>i.id);
    const responsesById = (0, (/*@__PURE__*/$parcel$interopDefault($9g7yh)))(dashboards, (dashboard)=>dashboard.id);
    const page = (0, (/*@__PURE__*/$parcel$interopDefault($huH03)))(responsesById, (response)=>(0, $jwDdO.transformDashboard)(response));
    return {
        page: page,
        order: order,
        total: total
    };
};

});
parcelRegister("9g7yh", function(module, exports) {

var $iBJlb = parcelRequire("iBJlb");

var $a9KaZ = parcelRequire("a9KaZ");
/**
 * Creates an object composed of keys generated from the results of running
 * each element of `collection` thru `iteratee`. The corresponding value of
 * each key is the last element responsible for generating the key. The
 * iteratee is invoked with one argument: (value).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
 * @returns {Object} Returns the composed aggregate object.
 * @example
 *
 * var array = [
 *   { 'dir': 'left', 'code': 97 },
 *   { 'dir': 'right', 'code': 100 }
 * ];
 *
 * _.keyBy(array, function(o) {
 *   return String.fromCharCode(o.code);
 * });
 * // => { 'a': { 'dir': 'left', 'code': 97 }, 'd': { 'dir': 'right', 'code': 100 } }
 *
 * _.keyBy(array, 'dir');
 * // => { 'left': { 'dir': 'left', 'code': 97 }, 'right': { 'dir': 'right', 'code': 100 } }
 */ var $6bdb775087644ec3$var$keyBy = $a9KaZ(function(result, value, key) {
    $iBJlb(result, key, value);
});
module.exports = $6bdb775087644ec3$var$keyBy;

});

parcelRegister("jwDdO", function(module, exports) {
$parcel$export(module.exports, "transformDashboard", () => $f6a2965ee47239a2$export$4e6ec9d8b34b3fb);

var $5DL51 = parcelRequire("5DL51");
const $f6a2965ee47239a2$export$4e6ec9d8b34b3fb = (item)=>({
        id: item.id,
        name: item.name,
        viewUrl: `/jira/dashboards/${item.id}`,
        owner: item.owner ? (0, $5DL51.transformUser)(item.owner) : null,
        isFavourite: item.isFavourite,
        popularity: item.popularity || 0,
        shares: item.sharePermissions ? item.sharePermissions.map((0, $5DL51.transformSharePermission)).filter(Boolean) : [],
        edits: item.editPermissions ? item.editPermissions.map((0, $5DL51.transformSharePermission)).filter(Boolean) : [],
        description: item.description,
        isWritable: item.isWritable === true,
        systemDashboard: item.systemDashboard === true
    });

});
parcelRegister("5DL51", function(module, exports) {
$parcel$export(module.exports, "transformUser", () => $6e6cbad6f60e414e$export$88dcd5c1adae8021);
$parcel$export(module.exports, "transformSharePermission", () => $6e6cbad6f60e414e$export$443a799045209d52);
$parcel$export(module.exports, "transformSharePermissionsToServer", () => $6e6cbad6f60e414e$export$e05899da868da914);


var $a62R3 = parcelRequire("a62R3");

var $4cTDP = parcelRequire("4cTDP");

const $6e6cbad6f60e414e$var$assertUnreachable = (_x)=>{
    throw new Error("Didn't expect to get here");
};
const $6e6cbad6f60e414e$export$88dcd5c1adae8021 = (user)=>{
    let profileUrl;
    if ((0, $4cTDP.fg)('jira-adopt-teams-nav-config')) {
        const { href: href } = (0, $a62R3.getNavigateToTeamsApp)({
            type: 'USER',
            payload: {
                userId: user.accountId
            }
        });
        profileUrl = href;
    } else profileUrl = `/jira/people/${user.accountId}`;
    return {
        displayName: user.displayName,
        avatarUrl: user.avatarUrls && user.avatarUrls['48x48'],
        accountId: user.accountId,
        profileUrl: profileUrl
    };
};
const $6e6cbad6f60e414e$export$443a799045209d52 = (sharePermission)=>{
    switch(sharePermission.type){
        case 0, $6f7399fe14fedc2b$export$86517eb0163ef745:
            return {
                type: (0, $6f7399fe14fedc2b$export$86517eb0163ef745)
            };
        case 0, $6f7399fe14fedc2b$export$b0a0e62d9b1a8269:
            return {
                type: (0, $6f7399fe14fedc2b$export$b0a0e62d9b1a8269)
            };
        case 0, $6f7399fe14fedc2b$export$b02d7412182d1bce:
            return {
                type: (0, $6f7399fe14fedc2b$export$b02d7412182d1bce),
                group: {
                    ...sharePermission.group
                }
            };
        case 0, $6f7399fe14fedc2b$export$5ef95a67b8fd1ff6:
            {
                const { project: project, role: role } = sharePermission;
                return {
                    type: (0, $6f7399fe14fedc2b$export$5ef95a67b8fd1ff6),
                    project: {
                        id: project.id,
                        name: project.name,
                        avatarUrl: project.avatarUrls['48x48']
                    },
                    role: role && {
                        id: role.id,
                        name: role.name
                    }
                };
            }
        case 0, $6f7399fe14fedc2b$export$487da0972e3459fe:
            return sharePermission;
        case 0, $6f7399fe14fedc2b$export$aea0835048e1c730:
            {
                const { user: user } = sharePermission;
                return {
                    type: (0, $6f7399fe14fedc2b$export$aea0835048e1c730),
                    user: {
                        accountId: user.accountId,
                        displayName: user.displayName,
                        avatarUrl: user.avatarUrls['48x48']
                    }
                };
            }
        default:
            $6e6cbad6f60e414e$var$assertUnreachable(sharePermission);
            return null;
    }
};
const $6e6cbad6f60e414e$export$e05899da868da914 = (sharePermissions, shouldReturnGroupIdForGroupIfAvailable = false)=>sharePermissions.map((sharePermission)=>{
        switch(sharePermission.type){
            case 0, $6f7399fe14fedc2b$export$b02d7412182d1bce:
                {
                    let group = {
                        name: sharePermission.group.name
                    };
                    if (shouldReturnGroupIdForGroupIfAvailable && sharePermission.group.groupId) group = {
                        groupId: sharePermission.group.groupId
                    };
                    return {
                        type: sharePermission.type,
                        group: group
                    };
                }
            case 0, $6f7399fe14fedc2b$export$aea0835048e1c730:
                return {
                    type: sharePermission.type,
                    user: {
                        accountId: sharePermission.user.accountId
                    }
                };
            case 0, $6f7399fe14fedc2b$export$5ef95a67b8fd1ff6:
                {
                    const permission = {
                        type: sharePermission.role ? (0, $72721d8cb7d8a0db$export$4d955b5fb0c1d4d7) : (0, $6f7399fe14fedc2b$export$5ef95a67b8fd1ff6),
                        project: {
                            id: sharePermission.project.id
                        }
                    };
                    if (sharePermission.role) permission.role = {
                        id: sharePermission.role.id
                    };
                    return permission;
                }
            case 0, $6f7399fe14fedc2b$export$487da0972e3459fe:
                return sharePermission;
            case 0, $6f7399fe14fedc2b$export$b0a0e62d9b1a8269:
                return {
                    type: (0, $72721d8cb7d8a0db$export$e2fe9963c33d5918)
                };
            case 0, $6f7399fe14fedc2b$export$86517eb0163ef745:
                return sharePermission;
            default:
                $6e6cbad6f60e414e$var$assertUnreachable(sharePermission);
                return sharePermission;
        }
    });

});
const $6f7399fe14fedc2b$export$b02d7412182d1bce = 'group';
const $6f7399fe14fedc2b$export$5ef95a67b8fd1ff6 = 'project';
const $6f7399fe14fedc2b$export$487da0972e3459fe = 'project-unknown';
const $6f7399fe14fedc2b$export$b0a0e62d9b1a8269 = 'loggedin';
const $6f7399fe14fedc2b$export$86517eb0163ef745 = 'global';
const $6f7399fe14fedc2b$export$aea0835048e1c730 = 'user';
 // this is what can come from backend

const $72721d8cb7d8a0db$export$e2fe9963c33d5918 = 'authenticated';
const $72721d8cb7d8a0db$export$4d955b5fb0c1d4d7 = 'projectRole';





parcelRegister("ec7Ui", function(module, exports) {
$parcel$export(module.exports, "RETRIEVE", () => $07ba7c73fdc7e62d$export$7bf2c28a4e08c796);
$parcel$export(module.exports, "retrieve", () => $07ba7c73fdc7e62d$export$8a4d17b6e8486e66);
$parcel$export(module.exports, "RETRIEVED", () => $07ba7c73fdc7e62d$export$1a07e8ff5bab976c);
$parcel$export(module.exports, "retrieved", () => $07ba7c73fdc7e62d$export$4058166ec369dd8);
$parcel$export(module.exports, "RETRIEVE_FAILED", () => $07ba7c73fdc7e62d$export$26e5d507c83e3d5a);
$parcel$export(module.exports, "retrieveFailed", () => $07ba7c73fdc7e62d$export$1c9b9c3d8868d26f);
$parcel$export(module.exports, "PATCH", () => $07ba7c73fdc7e62d$export$54950d96c4d7b0);
$parcel$export(module.exports, "patch", () => $07ba7c73fdc7e62d$export$b76953f99ab2be78);
const $07ba7c73fdc7e62d$export$7bf2c28a4e08c796 = 'state.actions.dashboards.RETRIEVE';
const $07ba7c73fdc7e62d$export$8a4d17b6e8486e66 = ()=>({
        type: $07ba7c73fdc7e62d$export$7bf2c28a4e08c796
    });
const $07ba7c73fdc7e62d$export$1a07e8ff5bab976c = 'state.actions.dashboards.RETRIEVED';
const $07ba7c73fdc7e62d$export$4058166ec369dd8 = (payload)=>({
        type: $07ba7c73fdc7e62d$export$1a07e8ff5bab976c,
        payload: payload
    });
const $07ba7c73fdc7e62d$export$26e5d507c83e3d5a = 'state.actions.dashboards.RETRIEVE_FAILED';
const $07ba7c73fdc7e62d$export$1c9b9c3d8868d26f = ()=>({
        type: $07ba7c73fdc7e62d$export$26e5d507c83e3d5a
    });
const $07ba7c73fdc7e62d$export$54950d96c4d7b0 = 'state.actions.dashboards.PATCH';
const $07ba7c73fdc7e62d$export$b76953f99ab2be78 = (payload)=>({
        type: $07ba7c73fdc7e62d$export$54950d96c4d7b0,
        payload: payload
    });

});

parcelRegister("9OXcT", function(module, exports) {
$parcel$export(module.exports, "getServiceRequest", () => $0a0038f80d8c64fb$export$d7889f7cae5c51ff);

var $g6mse = parcelRequire("g6mse");

var $8RLFk = parcelRequire("8RLFk");

var $awhT9 = parcelRequire("awhT9");


var $iRGx7 = parcelRequire("iRGx7");
const $0a0038f80d8c64fb$var$getSort = (state)=>({
        direction: (0, $iRGx7.getSortDirection)(state),
        field: (0, $awhT9.SORT_FIELDS)[(0, $iRGx7.getSortField)(state)]
    });
const $0a0038f80d8c64fb$export$d7889f7cae5c51ff = (state)=>(0, $g6mse.createPageRequest)((0, $iRGx7.getPage)(state), (0, $33a46ec40e5080c7$export$ec93a669a20aa982), $0a0038f80d8c64fb$var$getSort(state), (0, $8RLFk.EXPAND_PARAMETERS));

});
parcelRegister("g6mse", function(module, exports) {
$parcel$export(module.exports, "createPageRequest", () => $b7650b03bb8c63eb$export$6c268d1798324d1);
const $b7650b03bb8c63eb$export$a2b44ae778ac3391 = (startAt, maxResults, order, expand)=>{
    const pageRequest = {
        maxResults: maxResults,
        startAt: startAt
    };
    if (order) {
        const orderString = `${order.direction === 'ASC' ? '+' : '-'}${order.field}`;
        pageRequest.orderBy = orderString;
    }
    if (expand && expand.length) pageRequest.expand = expand.join(',');
    return pageRequest;
};
const $b7650b03bb8c63eb$export$2db35c6ee4729a76 = (startAt, maxResults, order, expand, // @ts-expect-error - TS1016 - A required parameter cannot follow an optional parameter.
searchBy)=>{
    const pageRequest = {
        maxResults: maxResults,
        startAt: startAt
    };
    if (order) {
        const orderString = `${order.direction === 'ASC' ? '+' : '-'}${order.field}`;
        pageRequest.orderBy = orderString;
    }
    if (expand && expand.length) pageRequest.expand = expand.join(',');
    if (searchBy && searchBy.length) pageRequest.searchBy = searchBy.join(',');
    return pageRequest;
};
const $b7650b03bb8c63eb$export$6c268d1798324d1 = (page, itemsPerPage, order, expand)=>$b7650b03bb8c63eb$export$a2b44ae778ac3391(itemsPerPage * (page - 1), itemsPerPage, order, expand);
const $b7650b03bb8c63eb$export$98ffd4f2a2fa32d7 = (page, itemsPerPage, order, expand, // @ts-expect-error - TS1016 - A required parameter cannot follow an optional parameter.
searchBy)=>$b7650b03bb8c63eb$export$2db35c6ee4729a76(itemsPerPage * (page - 1), itemsPerPage, order, expand, searchBy);

});

parcelRegister("8RLFk", function(module, exports) {
$parcel$export(module.exports, "EXPAND_PARAMETERS", () => $02c1d72eca5dd9de$export$ac5ed0fd17aacb1c);
const $02c1d72eca5dd9de$export$ac5ed0fd17aacb1c = [
    'owner',
    'favourite',
    'favouritedCount',
    'sharePermissions',
    'editPermissions',
    'description',
    'isWritable',
    'systemDashboard'
];

});

const $33a46ec40e5080c7$export$ec93a669a20aa982 = 25;




parcelRegister("2TDyc", function(module, exports) {
$parcel$export(module.exports, "default", () => $dd9b3e6516a231f8$export$2e2bcd8739ae039);

var $gs6vs = parcelRequire("gs6vs");

var $7I7aJ = parcelRequire("7I7aJ");
const $dd9b3e6516a231f8$var$createStore = (rootEpic)=>(0, $gs6vs.default)({
        appName: 'directories/dashboards',
        rootReducer: $7I7aJ.default,
        rootEpic: rootEpic
    });
var $dd9b3e6516a231f8$export$2e2bcd8739ae039 = $dd9b3e6516a231f8$var$createStore;

});
parcelRegister("7I7aJ", function(module, exports) {
$parcel$export(module.exports, "default", () => $ebae087e415e96d3$export$2e2bcd8739ae039);

var $7HHI1 = parcelRequire("7HHI1");

var $2e1Sg = parcelRequire("2e1Sg");

var $kw8My = parcelRequire("kw8My");

var $if1Bc = parcelRequire("if1Bc");
var $ebae087e415e96d3$export$2e2bcd8739ae039 = (0, $7HHI1.combineReducers)({
    app: $2e1Sg.default,
    dashboards: $kw8My.default,
    query: $if1Bc.default
});

});
parcelRegister("2e1Sg", function(module, exports) {
$parcel$export(module.exports, "default", () => $e6c3e1d618e1ff77$export$2e2bcd8739ae039);

var $jFHCE = parcelRequire("jFHCE");

var $fIzGh = parcelRequire("fIzGh");
const $e6c3e1d618e1ff77$export$d4c72bab9d6cc13a = {
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions, @typescript-eslint/no-explicit-any
    props: undefined
};
const $e6c3e1d618e1ff77$var$reducer = (state = $e6c3e1d618e1ff77$export$d4c72bab9d6cc13a, action)=>{
    switch(action.type){
        case 0, $fIzGh.SET_APP_PROPS:
            return {
                ...state,
                props: (0, (/*@__PURE__*/$parcel$interopDefault($jFHCE)))(action.payload, 'query')
            };
        default:
            {
                const _exhaustiveCheck = action.type;
                return state;
            }
    }
};
var $e6c3e1d618e1ff77$export$2e2bcd8739ae039 = $e6c3e1d618e1ff77$var$reducer;

});

parcelRegister("kw8My", function(module, exports) {
$parcel$export(module.exports, "default", () => $69158e4e15012464$export$2e2bcd8739ae039);

var $ec7Ui = parcelRequire("ec7Ui");
const $69158e4e15012464$export$d4c72bab9d6cc13a = {
    page: {},
    order: [],
    total: 0,
    isLoading: true,
    isError: false
};
const $69158e4e15012464$var$reducer = (state = $69158e4e15012464$export$d4c72bab9d6cc13a, action)=>{
    switch(action.type){
        case 0, $ec7Ui.RETRIEVE:
            return {
                ...state,
                isLoading: true
            };
        case 0, $ec7Ui.RETRIEVED:
            return {
                ...state,
                page: action.payload.page,
                order: action.payload.order,
                total: action.payload.total,
                isLoading: false,
                isError: false
            };
        case 0, $ec7Ui.RETRIEVE_FAILED:
            return {
                ...state,
                isLoading: false,
                isError: true
            };
        case 0, $ec7Ui.PATCH:
            return {
                ...state,
                page: {
                    ...state.page,
                    [action.payload.id]: {
                        ...state.page[action.payload.id],
                        ...action.payload.patch
                    }
                }
            };
        default:
            {
                const _exhaustiveCheck = action;
                return state;
            }
    }
};
var $69158e4e15012464$export$2e2bcd8739ae039 = $69158e4e15012464$var$reducer;

});

parcelRegister("if1Bc", function(module, exports) {
$parcel$export(module.exports, "default", () => $4563fa8884ed93b8$export$2e2bcd8739ae039);

var $714QC = parcelRequire("714QC");

var $aeZny = parcelRequire("aeZny");
const $4563fa8884ed93b8$export$d4c72bab9d6cc13a = (0, $714QC.initialQuery);
const $4563fa8884ed93b8$var$query = (state = $4563fa8884ed93b8$export$d4c72bab9d6cc13a, action)=>{
    switch(action.type){
        case 0, $aeZny.SET_QUERY:
            return action.payload;
        case 0, $aeZny.PATCH_QUERY:
            return {
                ...state,
                ...action.payload,
                filter: {
                    ...state.filter,
                    ...action.payload.filter ? action.payload.filter : undefined
                }
            };
        default:
            {
                const _exhaustiveCheck = action;
                return state;
            }
    }
};
var $4563fa8884ed93b8$export$2e2bcd8739ae039 = $4563fa8884ed93b8$var$query;

});



parcelRegister("8QlCt", function(module, exports) {
$parcel$export(module.exports, "default", () => $bf5db9f22a2bf423$export$2e2bcd8739ae039);

var $3PAYT = parcelRequire("3PAYT");

var $gnQAk = parcelRequire("gnQAk");


var $fIzGh = parcelRequire("fIzGh");

var $ec7Ui = parcelRequire("ec7Ui");

var $aeZny = parcelRequire("aeZny");

var $cK5WJ = parcelRequire("cK5WJ");

var $iRGx7 = parcelRequire("iRGx7");

var $bsBqn = parcelRequire("bsBqn");

var $da3cc = parcelRequire("da3cc");

var $iUBQb = parcelRequire("iUBQb");

var $6loCM = parcelRequire("6loCM");
const $bf5db9f22a2bf423$var$mapStateToProps = (state)=>({
        // data
        entityIds: (0, $cK5WJ.getIds)(state),
        totalItems: (0, $cK5WJ.getTotal)(state),
        itemsPerPage: (0, $33a46ec40e5080c7$export$ec93a669a20aa982),
        isLoading: (0, $cK5WJ.isLoading)(state),
        isError: (0, $cK5WJ.isError)(state),
        page: (0, $iRGx7.getPage)(state),
        sortField: (0, $iRGx7.getSortField)(state),
        sortDirection: (0, $iRGx7.getSortDirection)(state),
        filter: (0, $iRGx7.isFilterApplied)(state) ? (0, $iRGx7.getFilter)(state) : undefined,
        // ui
        firstColumnHeadingAlignment: 'center',
        lastColumnHeadingAlignment: 'right',
        FilterView: // views
        $iUBQb.default,
        tableConfiguration: (0, $6loCM.getTableConfiguration)(state),
        tableLabel: (0, $6loCM.getTableLabel)(),
        resultsAnnouncerMessage: (0, $6loCM.getResultsAnnouncerMessage)(),
        emptyFilterResultConfiguration: $6loCM.emptyFilterResultConfiguration,
        operationModals: $6loCM.operationModals,
        EmptyView: $bsBqn.default,
        ErrorView: $da3cc.default
    });
const $bf5db9f22a2bf423$var$mapDispatchToProps = (dispatch)=>({
        // @ts-expect-error - TS7031 - Binding element 'id' implicitly has an 'any' type. | TS7031 - Binding element 'patch' implicitly has an 'any' type.
        onPatch: ({ id: id, patch: patch })=>dispatch((0, $ec7Ui.patch)({
                id: id,
                patch: patch
            })),
        onReload: (query)=>{
            dispatch((0, $aeZny.patchQuery)(query));
            dispatch((0, $ec7Ui.retrieve)());
        },
        onFirstRender: ()=>dispatch((0, $fIzGh.ready)())
    });
var // @ts-expect-error - TS2345 - Argument of type 'typeof Directory' is not assignable to parameter of type 'Component<{ entityIds: string[]; totalItems: number; itemsPerPage: number; isLoading: boolean; isError: boolean; page: number; sortField: SortField; sortDirection: SortDirection; ... 8 more ...; ErrorView: ComponentClass<...> & { ...; }; } & { ...; }>'.
$bf5db9f22a2bf423$export$2e2bcd8739ae039 = (0, $gnQAk.connect)($bf5db9f22a2bf423$var$mapStateToProps, $bf5db9f22a2bf423$var$mapDispatchToProps)((0, $3PAYT.default));

});
parcelRegister("3PAYT", function(module, exports) {
$parcel$export(module.exports, "default", () => $53c8e3e55d4aeb5e$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $12DRg = parcelRequire("12DRg");

var $eSnSE = parcelRequire("eSnSE");

var $cH6Qf = parcelRequire("cH6Qf");

var $5HL8i = parcelRequire("5HL8i");

var $91zZ6 = parcelRequire("91zZ6");

var $f5HHa = parcelRequire("f5HHa");

var $llsfE = parcelRequire("llsfE");

var $jZqH9 = parcelRequire("jZqH9");

var $9UtD0 = parcelRequire("9UtD0");

const $53c8e3e55d4aeb5e$var$defaultEntityIds = [];
class $53c8e3e55d4aeb5e$export$2e2bcd8739ae039 extends (0, $eJOHy.Component) {
    static{
        this.defaultProps = {
            isOnboardingEnabled: false,
            headerConfiguration: undefined,
            FilterView: undefined,
            TableMaskView: undefined,
            CreateModal: undefined,
            metrics: {
                tableMounted: undefined
            },
            entityIds: $53c8e3e55d4aeb5e$var$defaultEntityIds,
            dataProvider: undefined,
            renderOnboardingSpotlight: ()=>null,
            tableLabel: undefined,
            onboardingSpotlightTargets: [],
            onFirstRender: (0, (/*@__PURE__*/$parcel$interopDefault($12DRg)))
        };
    }
    constructor(props){
        super(props);
        if (props.entityIds !== $53c8e3e55d4aeb5e$var$defaultEntityIds && props.dataProvider) (0, $eSnSE.default).safeErrorWithoutCustomerData('directory.base', 'Please provide only one of props: [entityIds] or [dataProvider], dataProvider will be used');
        this.store = (0, $jZqH9.default)((0, $f5HHa.default));
        this.store.dispatch((0, $llsfE.setAppProps)(props));
    }
    componentDidUpdate() {
        this.store.dispatch((0, $llsfE.setAppProps)(this.props));
    }
    render() {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $91zZ6.Provider), {
            store: this.store
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $5HL8i.default), {
            onFirstMount: this.props.onFirstRender
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $9UtD0.default), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $cH6Qf.SpaStatePageReady), null)));
    }
}

});
parcelRegister("5HL8i", function(module, exports) {
$parcel$export(module.exports, "default", () => $651368c8da8f3dac$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $5yd4l = parcelRequire("5yd4l");
class $651368c8da8f3dac$export$2e2bcd8739ae039 extends (0, $eJOHy.Component) {
    render() {
        const { children: children } = this.props;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $5yd4l.default).Provider, {
            value: {
                reportMount: this.onSubtreeMount
            }
        }, children);
    }
    constructor(...args){
        super(...args), this.onSubtreeMount = ()=>{
            if (!this.hasAnyMounted) {
                this.hasAnyMounted = true;
                this.props.onFirstMount();
            }
        }, this.hasAnyMounted = false;
    }
}

});
parcelRegister("5yd4l", function(module, exports) {
$parcel$export(module.exports, "default", () => $702adc31848c45b7$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $12DRg = parcelRequire("12DRg");
var $702adc31848c45b7$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $eJOHy.createContext)({
    reportMount: (0, (/*@__PURE__*/$parcel$interopDefault($12DRg)))
});

});


parcelRegister("91zZ6", function(module, exports) {
$parcel$export(module.exports, "useDirectoryDispatch", () => $8f86e69c8ed7499f$export$98942df89ffbd315);
$parcel$export(module.exports, "storeOptions", () => $8f86e69c8ed7499f$export$12cf63d9f5bd0793);
$parcel$export(module.exports, "Provider", () => $8f86e69c8ed7499f$export$2881499e37b75b9a);
$parcel$export(module.exports, "connect", () => $8f86e69c8ed7499f$export$64605811ab45167f);

var $eJOHy = parcelRequire("eJOHy");

var $dyOHn = parcelRequire("dyOHn");

var $gnQAk = parcelRequire("gnQAk");
const $8f86e69c8ed7499f$var$STORE_KEY = 'project-directories.directory.story';
const $8f86e69c8ed7499f$export$d03cc44e35038f93 = /*#__PURE__*/ (0, $eJOHy.createContext)(null);
const $8f86e69c8ed7499f$export$98942df89ffbd315 = (0, $dyOHn.createDispatchHook)($8f86e69c8ed7499f$export$d03cc44e35038f93);
const $8f86e69c8ed7499f$export$12cf63d9f5bd0793 = {
    storeKey: $8f86e69c8ed7499f$var$STORE_KEY,
    context: $8f86e69c8ed7499f$export$d03cc44e35038f93
};
const $8f86e69c8ed7499f$export$2881499e37b75b9a = (0, $gnQAk.createProvider)($8f86e69c8ed7499f$export$d03cc44e35038f93);
const $8f86e69c8ed7499f$export$64605811ab45167f = (// eslint-disable-next-line @typescript-eslint/no-explicit-any
mapStateToProps, // eslint-disable-next-line @typescript-eslint/no-explicit-any
mapDispatchToProps, // eslint-disable-next-line @typescript-eslint/no-explicit-any
mergeProps, // eslint-disable-next-line @typescript-eslint/no-explicit-any
options = Object.freeze({}))=>(0, $gnQAk.connect)(mapStateToProps, mapDispatchToProps, mergeProps, {
        ...options,
        context: $8f86e69c8ed7499f$export$d03cc44e35038f93,
        storeKey: $8f86e69c8ed7499f$var$STORE_KEY
    });

});

parcelRegister("f5HHa", function(module, exports) {
$parcel$export(module.exports, "default", () => $2c081aa275619817$export$2e2bcd8739ae039);

var $4tM8k = parcelRequire("4tM8k");

var $hTgaW = parcelRequire("hTgaW");

var $kobzH = parcelRequire("kobzH");
var $2c081aa275619817$export$2e2bcd8739ae039 = (0, $4tM8k.combineEpics)((0, $hTgaW.default), (0, $kobzH.default));

});
parcelRegister("hTgaW", function(module, exports) {
$parcel$export(module.exports, "default", () => $8af2749c3fdf06e7$export$2e2bcd8739ae039);
parcelRequire("1AyD5");
parcelRequire("6cJUr");

var $7kixv = parcelRequire("7kixv");

var $4wOQJ = parcelRequire("4wOQJ");

var $6SY0Q = parcelRequire("6SY0Q");
// flow can't deal with the generics here
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $8af2749c3fdf06e7$var$entityCreated = (action$, store)=>action$.ofType((0, $4wOQJ.ENTITY_CREATED)).mergeMap(()=>{
        const state = store.getState();
        const page = (0, $6SY0Q.getPage)(state);
        (0, $6SY0Q.getOnReload)(state)({
            page: page
        });
        return (0, $7kixv.Observable).empty();
    });
var $8af2749c3fdf06e7$export$2e2bcd8739ae039 = $8af2749c3fdf06e7$var$entityCreated;

});
parcelRegister("4wOQJ", function(module, exports) {
$parcel$export(module.exports, "INITIATE", () => $465651927b7e774a$export$643daa42aa3148d5);
$parcel$export(module.exports, "initiate", () => $465651927b7e774a$export$b14c4413e822aa8d);
$parcel$export(module.exports, "ENTITY_CREATED", () => $465651927b7e774a$export$61bc72c2b62d14ed);
$parcel$export(module.exports, "entityCreated", () => $465651927b7e774a$export$5e2c0a0dc191dd3e);
$parcel$export(module.exports, "ENTITY_CREATE_FAILED", () => $465651927b7e774a$export$ac0dd97afb285388);
$parcel$export(module.exports, "entityCreateFailed", () => $465651927b7e774a$export$b71626a5d7099742);
$parcel$export(module.exports, "CANCELLED", () => $465651927b7e774a$export$6b4658081fcf1aed);
$parcel$export(module.exports, "cancelled", () => $465651927b7e774a$export$b108ea1063c657e3);
const $465651927b7e774a$export$643daa42aa3148d5 = 'state.actions.create.INITIATE';
const $465651927b7e774a$export$b14c4413e822aa8d = ()=>({
        type: $465651927b7e774a$export$643daa42aa3148d5
    });
const $465651927b7e774a$export$61bc72c2b62d14ed = 'state.actions.create.ENTITY_CREATED';
const $465651927b7e774a$export$5e2c0a0dc191dd3e = (payload)=>({
        type: $465651927b7e774a$export$61bc72c2b62d14ed,
        payload: payload
    });
const $465651927b7e774a$export$ac0dd97afb285388 = 'state.actions.create.ENTITY_CREATE_FAILED';
const $465651927b7e774a$export$b71626a5d7099742 = (payload)=>({
        type: $465651927b7e774a$export$ac0dd97afb285388,
        payload: payload
    });
const $465651927b7e774a$export$6b4658081fcf1aed = 'state.actions.create.CANCELLED';
const $465651927b7e774a$export$b108ea1063c657e3 = ()=>({
        type: $465651927b7e774a$export$6b4658081fcf1aed
    });

});

parcelRegister("6SY0Q", function(module, exports) {
$parcel$export(module.exports, "getEntityIds", () => $e7e252b338858314$export$1fe43832be7d1fcb);
$parcel$export(module.exports, "getDataProvider", () => $e7e252b338858314$export$add6bf8e4261fead);
$parcel$export(module.exports, "getTotalItems", () => $e7e252b338858314$export$cbc4bdd6c02fac4d);
$parcel$export(module.exports, "getPage", () => $e7e252b338858314$export$c2a6433281518c91);
$parcel$export(module.exports, "getItemsPerPage", () => $e7e252b338858314$export$347447940701b338);
$parcel$export(module.exports, "getSortField", () => $e7e252b338858314$export$9b753af5a9fb5911);
$parcel$export(module.exports, "getSortDirection", () => $e7e252b338858314$export$509e2b9937961873);
$parcel$export(module.exports, "getFilter", () => $e7e252b338858314$export$61ec8404f465cd36);
$parcel$export(module.exports, "getHeaderConfiguration", () => $e7e252b338858314$export$60b0ef02721854ed);
$parcel$export(module.exports, "getFilterView", () => $e7e252b338858314$export$4a62b01f13af161e);
$parcel$export(module.exports, "getTableConfiguration", () => $e7e252b338858314$export$6847365bea1c5392);
$parcel$export(module.exports, "getTableLabel", () => $e7e252b338858314$export$b2d196af18e06ad6);
$parcel$export(module.exports, "getResultsAnnouncerMessage", () => $e7e252b338858314$export$64df75861e57fb7f);
$parcel$export(module.exports, "getEmptyView", () => $e7e252b338858314$export$6ad7beec028137c);
$parcel$export(module.exports, "getErrorView", () => $e7e252b338858314$export$67942d5525c28c28);
$parcel$export(module.exports, "getEmptyFilterResultConfiguration", () => $e7e252b338858314$export$dae3c68be4c9569d);
$parcel$export(module.exports, "getTableMaskView", () => $e7e252b338858314$export$7a35128187f8245c);
$parcel$export(module.exports, "getCreateModal", () => $e7e252b338858314$export$be5bc82ccf7ca5ca);
$parcel$export(module.exports, "getOperationModal", () => $e7e252b338858314$export$3f5ae3b2bfec9457);
$parcel$export(module.exports, "getOnReload", () => $e7e252b338858314$export$7158eb69f7a0b59);
$parcel$export(module.exports, "getOnPatch", () => $e7e252b338858314$export$944f52419ab8e737);
$parcel$export(module.exports, "isLoading", () => $e7e252b338858314$export$20bb0d907fbbe433);
$parcel$export(module.exports, "isError", () => $e7e252b338858314$export$e6127cc7fe7395c3);
$parcel$export(module.exports, "getTotalPages", () => $e7e252b338858314$export$652b307566494a6);
$parcel$export(module.exports, "getFirstColumnHeadingAlignment", () => $e7e252b338858314$export$22b039be773dbf63);
$parcel$export(module.exports, "getLastColumnHeadingAlignment", () => $e7e252b338858314$export$affaf5a34a669e16);
$parcel$export(module.exports, "isCreateOpen", () => $e7e252b338858314$export$996a71275221ab9e);
$parcel$export(module.exports, "getOperations", () => $e7e252b338858314$export$acc17f62bededcaf);
$parcel$export(module.exports, "getOperationInitializationStatusPerEntity", () => $e7e252b338858314$export$69a0d9b5be75b55d);
$parcel$export(module.exports, "getIsOnboardingEnabled", () => $e7e252b338858314$export$65890ce3309e3ccf);
$parcel$export(module.exports, "getRenderOnboardingSpotlight", () => $e7e252b338858314$export$98db60f26810390);
$parcel$export(module.exports, "getSpotlightForCell", () => $e7e252b338858314$export$1faee8e10b588885);
$parcel$export(module.exports, "getAvailableSpotlightTargets", () => $e7e252b338858314$export$7eda79d5ce9a0b8b);

var $ahm5r = parcelRequire("ahm5r");

var $9g7yh = parcelRequire("9g7yh");

var $huH03 = parcelRequire("huH03");

var $2CrAx = parcelRequire("2CrAx");
const $e7e252b338858314$export$876089ea65adc54 = (state)=>state.app.props;
const $e7e252b338858314$export$1fe43832be7d1fcb = (state)=>state.app.props.entityIds;
const $e7e252b338858314$export$add6bf8e4261fead = (state)=>state.app.props.dataProvider || undefined;
const $e7e252b338858314$export$cbc4bdd6c02fac4d = (state)=>state.app.props.totalItems;
const $e7e252b338858314$export$c2a6433281518c91 = (state)=>state.app.props.page;
const $e7e252b338858314$export$347447940701b338 = (state)=>state.app.props.itemsPerPage;
const $e7e252b338858314$export$9b753af5a9fb5911 = (state)=>state.app.props.sortField;
const $e7e252b338858314$export$509e2b9937961873 = (state)=>state.app.props.sortDirection;
const $e7e252b338858314$export$61ec8404f465cd36 = (state)=>state.app.props.filter;
const $e7e252b338858314$export$60b0ef02721854ed = (state)=>state.app.props.headerConfiguration;
const $e7e252b338858314$export$4a62b01f13af161e = (state)=>state.app.props.FilterView;
const $e7e252b338858314$export$6847365bea1c5392 = (state)=>state.app.props.tableConfiguration;
const $e7e252b338858314$export$b2d196af18e06ad6 = (state)=>state.app.props.tableLabel;
const $e7e252b338858314$export$64df75861e57fb7f = (state)=>state.app.props.resultsAnnouncerMessage;
const $e7e252b338858314$export$6ad7beec028137c = (state)=>state.app.props.EmptyView;
const $e7e252b338858314$export$67942d5525c28c28 = (state)=>state.app.props.ErrorView;
const $e7e252b338858314$export$dae3c68be4c9569d = (state)=>state.app.props.emptyFilterResultConfiguration;
const $e7e252b338858314$export$7a35128187f8245c = (state)=>state.app.props.TableMaskView;
const $e7e252b338858314$export$be5bc82ccf7ca5ca = (state)=>state.app.props.CreateModal;
const $e7e252b338858314$export$3f5ae3b2bfec9457 = (state, operation)=>state.app.props.operationModals[operation];
const $e7e252b338858314$export$7158eb69f7a0b59 = (state)=>state.app.props.onReload;
const $e7e252b338858314$export$944f52419ab8e737 = (state)=>state.app.props.onPatch;
const $e7e252b338858314$export$20bb0d907fbbe433 = (state)=>state.app.props.isLoading;
const $e7e252b338858314$export$e6127cc7fe7395c3 = (state)=>state.app.props.isError;
const $e7e252b338858314$var$getTotalPagesInternal = (0, $ahm5r.createSelector)(// @ts-expect-error - TS2769 - No overload matches this call.
$e7e252b338858314$export$cbc4bdd6c02fac4d, $e7e252b338858314$export$347447940701b338, (totalItems, itemsOnPage)=>(0, $2CrAx.calculateTotalPages)(totalItems, itemsOnPage));
const $e7e252b338858314$export$652b307566494a6 = (state)=>$e7e252b338858314$var$getTotalPagesInternal(state);
const $e7e252b338858314$export$22b039be773dbf63 = (state)=>state.app.props.firstColumnHeadingAlignment;
const $e7e252b338858314$export$affaf5a34a669e16 = (state)=>state.app.props.lastColumnHeadingAlignment;
const $e7e252b338858314$export$996a71275221ab9e = (state)=>state.create.isOpen;
const $e7e252b338858314$export$acc17f62bededcaf = (state)=>state.operations;
const $e7e252b338858314$var$getOperationInitializationStatusPerEntityInternal = (0, $ahm5r.createSelector)(// @ts-expect-error - TS2571 - Object is of type 'unknown'.
(state)=>state.operations, (operations)=>(0, (/*@__PURE__*/$parcel$interopDefault($huH03)))((0, (/*@__PURE__*/$parcel$interopDefault($9g7yh)))(operations, ({ id: id })=>id), ({ isInitializing: isInitializing })=>isInitializing));
const $e7e252b338858314$export$69a0d9b5be75b55d = (state)=>$e7e252b338858314$var$getOperationInitializationStatusPerEntityInternal(state);
const $e7e252b338858314$export$65890ce3309e3ccf = (state)=>state.app.props.isOnboardingEnabled;
const $e7e252b338858314$export$ee9bc95b4b33fe7b = (state)=>state.app.props.onboardingSpotlightTargets;
const $e7e252b338858314$export$98db60f26810390 = (state)=>state.app.props.renderOnboardingSpotlight;
const $e7e252b338858314$export$1faee8e10b588885 = (state)=>(id, colIndex)=>$e7e252b338858314$export$ee9bc95b4b33fe7b(state).find((c)=>c.entityId === id && c.colIndex === colIndex);
const $e7e252b338858314$export$7eda79d5ce9a0b8b = (state)=>// @ts-expect-error - TS2322 - Type 'unknown' is not assignable to type 'string[]'.
    (0, $ahm5r.createSelector)(// @ts-expect-error - TS2769 - No overload matches this call.
    $e7e252b338858314$export$6847365bea1c5392, $e7e252b338858314$export$add6bf8e4261fead, $e7e252b338858314$export$1fe43832be7d1fcb, $e7e252b338858314$export$1faee8e10b588885, (tableConfig, dataProvider, entitiesIds, getSpotlightCellTarget)=>{
        const availableSpotlightTargets = [];
        const ids = dataProvider ? dataProvider.getData().map((entity)=>dataProvider.idSelector(entity)) : entitiesIds;
        if (ids && tableConfig) ids.forEach((entityId)=>{
            for(let i = 0; i < tableConfig.length; i += 1){
                const cellMatch = getSpotlightCellTarget(entityId, i);
                if (cellMatch && cellMatch.spotlightId) availableSpotlightTargets.push(entityId);
            }
        });
        return availableSpotlightTargets;
    })(state);

});


parcelRegister("kobzH", function(module, exports) {
$parcel$export(module.exports, "default", () => $4eb7e9d263f87a09$export$2e2bcd8739ae039);
parcelRequire("1AyD5");
parcelRequire("6cJUr");

var $7kixv = parcelRequire("7kixv");

var $2CrAx = parcelRequire("2CrAx");


var $5cBQu = parcelRequire("5cBQu");

var $6SY0Q = parcelRequire("6SY0Q");
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $4eb7e9d263f87a09$var$entityUpdated = (action$, store)=>// eslint-disable-next-line @typescript-eslint/no-explicit-any
    action$.ofType((0, $5cBQu.ENTITY_UPDATED)).mergeMap((action)=>{
        const { id: id, operation: operation, patch: patch } = action.payload;
        const state = store.getState();
        const currentPage = (0, $6SY0Q.getPage)(state);
        if (patch) {
            (0, $6SY0Q.getOnPatch)(state)({
                id: id,
                patch: patch
            }); // change page's state with a patch instead of reloading a table's page
            return (0, $7kixv.Observable).empty();
        }
        if (operation === (0, $85bfce414eef38c7$export$4bd2facc4a3e6aa1)) {
            const itemsPerPage = (0, $6SY0Q.getItemsPerPage)(state);
            const totalItems = (0, $6SY0Q.getTotalItems)(state);
            const predictedPage = (0, $2CrAx.predictPageToRequestAfterItemDeletion)(itemsPerPage, totalItems, currentPage);
            (0, $6SY0Q.getOnReload)(state)({
                page: predictedPage
            });
        } else (0, $6SY0Q.getOnReload)(state)({
            page: currentPage
        });
        return (0, $7kixv.Observable).empty();
    });
var $4eb7e9d263f87a09$export$2e2bcd8739ae039 = $4eb7e9d263f87a09$var$entityUpdated;

});
const $85bfce414eef38c7$export$250171a898bf7ef = 'EDIT';
const $85bfce414eef38c7$export$4bd2facc4a3e6aa1 = 'DELETE';
const $85bfce414eef38c7$export$257be95a51c84145 = 'DUPLICATE';
const $85bfce414eef38c7$export$a7c1ec142e70d69d = 'ARCHIVE';
const $85bfce414eef38c7$export$92f9e1ed9114d3a6 = 'COPY';
const $85bfce414eef38c7$export$346f08c1f0d0fe41 = 'MOVE';
const $85bfce414eef38c7$export$bbf2495ca7d54c9f = 'SHOW_DETAILS';
const $85bfce414eef38c7$export$39d2a7fb21967424 = 'CHANGE_OWNER';
const $85bfce414eef38c7$export$2b848a0670941e75 = 'TRASH';
const $85bfce414eef38c7$export$aeed50488a8a79d7 = 'RESTORE';

parcelRegister("5cBQu", function(module, exports) {
$parcel$export(module.exports, "INITIATE", () => $2081d7c120cf42cb$export$643daa42aa3148d5);
$parcel$export(module.exports, "initiate", () => $2081d7c120cf42cb$export$b14c4413e822aa8d);
$parcel$export(module.exports, "ENTITY_DATA_RETRIEVE_FAILED", () => $2081d7c120cf42cb$export$d5657bfeb6a06769);
$parcel$export(module.exports, "entityDataRetrieveFailed", () => $2081d7c120cf42cb$export$7771a5f3a1cb2756);
$parcel$export(module.exports, "DIALOG_SHOWN", () => $2081d7c120cf42cb$export$54e32bf20c0b405b);
$parcel$export(module.exports, "dialogShown", () => $2081d7c120cf42cb$export$7aca9ee5930fa3ea);
$parcel$export(module.exports, "ENTITY_UPDATED", () => $2081d7c120cf42cb$export$93e8e914b5b8b20d);
$parcel$export(module.exports, "entityUpdated", () => $2081d7c120cf42cb$export$c0932263cb70e08f);
$parcel$export(module.exports, "ENTITY_UPDATE_FAILED", () => $2081d7c120cf42cb$export$d2d41c22dcb7b1db);
$parcel$export(module.exports, "entityUpdateFailed", () => $2081d7c120cf42cb$export$fbb84be2ae83b4ed);
$parcel$export(module.exports, "CANCELLED", () => $2081d7c120cf42cb$export$6b4658081fcf1aed);
$parcel$export(module.exports, "cancelled", () => $2081d7c120cf42cb$export$b108ea1063c657e3);
// initiate
const $2081d7c120cf42cb$export$643daa42aa3148d5 = 'state.actions.operation.INITIATE';
const $2081d7c120cf42cb$export$b14c4413e822aa8d = (payload)=>({
        type: $2081d7c120cf42cb$export$643daa42aa3148d5,
        payload: payload
    });
const $2081d7c120cf42cb$export$d5657bfeb6a06769 = 'state.actions.operation.ENTITY_DATA_RETRIEVE_FAILED';
const $2081d7c120cf42cb$export$7771a5f3a1cb2756 = (payload)=>({
        type: $2081d7c120cf42cb$export$d5657bfeb6a06769,
        payload: payload
    });
const $2081d7c120cf42cb$export$54e32bf20c0b405b = 'state.actions.operation.DIALOG_SHOWN';
const $2081d7c120cf42cb$export$7aca9ee5930fa3ea = (payload)=>({
        type: $2081d7c120cf42cb$export$54e32bf20c0b405b,
        payload: payload
    });
const $2081d7c120cf42cb$export$93e8e914b5b8b20d = 'state.actions.operation.ENTITY_UPDATED';
const $2081d7c120cf42cb$export$c0932263cb70e08f = (payload)=>({
        type: $2081d7c120cf42cb$export$93e8e914b5b8b20d,
        payload: payload
    });
const $2081d7c120cf42cb$export$d2d41c22dcb7b1db = 'state.actions.operation.ENTITY_UPDATE_FAILED';
const $2081d7c120cf42cb$export$fbb84be2ae83b4ed = (payload)=>({
        type: $2081d7c120cf42cb$export$d2d41c22dcb7b1db,
        payload: payload
    });
const $2081d7c120cf42cb$export$6b4658081fcf1aed = 'state.actions.operation.CANCELLED';
const $2081d7c120cf42cb$export$b108ea1063c657e3 = (payload)=>({
        type: $2081d7c120cf42cb$export$6b4658081fcf1aed,
        payload: payload
    });

});



parcelRegister("llsfE", function(module, exports) {
$parcel$export(module.exports, "SET_APP_PROPS", () => $c40c7b4c0b8c00a8$export$8aefe701a6f431e0);
$parcel$export(module.exports, "setAppProps", () => $c40c7b4c0b8c00a8$export$cfda7627848a58cd);
const $c40c7b4c0b8c00a8$export$8aefe701a6f431e0 = 'state.actions.app.SET_APP_PROPS';
const $c40c7b4c0b8c00a8$export$cfda7627848a58cd = (payload)=>({
        type: $c40c7b4c0b8c00a8$export$8aefe701a6f431e0,
        payload: payload
    });

});

parcelRegister("jZqH9", function(module, exports) {
$parcel$export(module.exports, "default", () => $c497e626334b193e$export$2e2bcd8739ae039);

var $gs6vs = parcelRequire("gs6vs");

var $g7VIj = parcelRequire("g7VIj");
const $c497e626334b193e$var$createStore = (rootEpic)=>{
    // @ts-expect-error - TS2322 - Type 'Reducer<unknown>' is not assignable to type 'Reducer<TState>'.
    const fixedTypeRootReducer = (0, $g7VIj.default);
    // @ts-expect-error - TS2344 - Type 'TAction' does not satisfy the constraint '{ type: any; }'.
    return (0, $gs6vs.default)({
        appName: 'directory-base',
        rootReducer: fixedTypeRootReducer,
        rootEpic: rootEpic
    });
};
var $c497e626334b193e$export$2e2bcd8739ae039 = $c497e626334b193e$var$createStore;

});
parcelRegister("g7VIj", function(module, exports) {
$parcel$export(module.exports, "default", () => $3895fd1311d5eb92$export$2e2bcd8739ae039);

var $7HHI1 = parcelRequire("7HHI1");

var $hLCQ2 = parcelRequire("hLCQ2");

var $4YoOg = parcelRequire("4YoOg");

var $2ReZV = parcelRequire("2ReZV");
var $3895fd1311d5eb92$export$2e2bcd8739ae039 = (0, $7HHI1.combineReducers)({
    app: $hLCQ2.default,
    create: $4YoOg.default,
    operations: $2ReZV.default
});

});
parcelRegister("hLCQ2", function(module, exports) {
$parcel$export(module.exports, "default", () => $a5feebf187192e75$export$2e2bcd8739ae039);

var $llsfE = parcelRequire("llsfE");
const $a5feebf187192e75$var$app = (state = {
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions, @typescript-eslint/no-explicit-any
    props: undefined
}, action)=>{
    switch(action.type){
        case 0, $llsfE.SET_APP_PROPS:
            return {
                ...state,
                props: action.payload
            };
        default:
            {
                const _exhaustiveCheck = action.type;
                return state;
            }
    }
};
var $a5feebf187192e75$export$2e2bcd8739ae039 = $a5feebf187192e75$var$app;

});

parcelRegister("4YoOg", function(module, exports) {
$parcel$export(module.exports, "default", () => $de678fc2cad6993c$export$2e2bcd8739ae039);

var $4wOQJ = parcelRequire("4wOQJ");
const $de678fc2cad6993c$var$initialState = {
    isOpen: false
};
const $de678fc2cad6993c$var$create = (state = $de678fc2cad6993c$var$initialState, action)=>{
    switch(action.type){
        case 0, $4wOQJ.INITIATE:
            return {
                isOpen: true
            };
        case 0, $4wOQJ.ENTITY_CREATED:
        case 0, $4wOQJ.ENTITY_CREATE_FAILED:
        case 0, $4wOQJ.CANCELLED:
            return {
                isOpen: false
            };
        default:
            {
                const _exhaustiveCheck = action;
                return state;
            }
    }
};
var $de678fc2cad6993c$export$2e2bcd8739ae039 = $de678fc2cad6993c$var$create;

});

parcelRegister("2ReZV", function(module, exports) {
$parcel$export(module.exports, "default", () => $d3ec6054d969c464$export$2e2bcd8739ae039);

var $5cBQu = parcelRequire("5cBQu");
const $d3ec6054d969c464$var$reducer = (state = [], action)=>{
    switch(action.type){
        case 0, $5cBQu.INITIATE:
            // adding new operation to array will render new <OperationModal>, showing new dialog/modal in UI
            return [
                ...state,
                {
                    ...action.payload,
                    isInitializing: true
                }
            ];
        case 0, $5cBQu.DIALOG_SHOWN:
            // change isInitializing from true to false
            return [
                ...state.filter(({ id: id, operation: operation })=>id !== action.payload.id || operation !== action.payload.operation),
                {
                    ...action.payload,
                    isInitializing: false
                }
            ];
        case 0, $5cBQu.ENTITY_DATA_RETRIEVE_FAILED:
        case 0, $5cBQu.ENTITY_UPDATED:
        case 0, $5cBQu.ENTITY_UPDATE_FAILED:
        case 0, $5cBQu.CANCELLED:
            return state.filter(({ id: id, operation: operation })=>id !== action.payload.id || operation !== action.payload.operation);
        default:
            {
                const _exhaustiveCheck = action;
                return state;
            }
    }
};
var $d3ec6054d969c464$export$2e2bcd8739ae039 = $d3ec6054d969c464$var$reducer;

});



parcelRegister("9UtD0", function(module, exports) {
$parcel$export(module.exports, "default", () => $b32baacdda11dc59$export$2e2bcd8739ae039);

var $gnQAk = parcelRequire("gnQAk");

var $91zZ6 = parcelRequire("91zZ6");

var $adOqF = parcelRequire("adOqF");

var $54lJh = parcelRequire("54lJh");

var $dIYLk = parcelRequire("dIYLk");
var $b32baacdda11dc59$export$2e2bcd8739ae039 = (0, $gnQAk.connect)(()=>({
        Content: $adOqF.default,
        Modals: $54lJh.default
    }), null, null, (0, $91zZ6.storeOptions))((0, $dIYLk.default));

});
parcelRegister("adOqF", function(module, exports) {
$parcel$export(module.exports, "default", () => $eca44ecd751fd778$export$2e2bcd8739ae039);

var $LFmXM = parcelRequire("LFmXM");

var $gnQAk = parcelRequire("gnQAk");

var $4MchI = parcelRequire("4MchI");

var $eS6Sp = parcelRequire("eS6Sp");

var $91zZ6 = parcelRequire("91zZ6");

var $4wOQJ = parcelRequire("4wOQJ");

var $6SY0Q = parcelRequire("6SY0Q");

var $bt4Z6 = parcelRequire("bt4Z6");

var $6FHTv = parcelRequire("6FHTv");

var $jCVOe = parcelRequire("jCVOe");

var $1YsZU = parcelRequire("1YsZU");

var $lzizg = parcelRequire("lzizg");

var $5FTzj = parcelRequire("5FTzj");

var $bj0qr = parcelRequire("bj0qr");
const $eca44ecd751fd778$var$getEmptyViewSelectorMemoized = ()=>(0, $4MchI.createSelector)((state)=>(0, $eS6Sp.withMountReporting)((0, $6SY0Q.getEmptyView)(state)), (res)=>res);
const $eca44ecd751fd778$var$getErrorViewSelectorMemoized = ()=>(0, $4MchI.createSelector)((state)=>(0, $eS6Sp.withMountReporting)((0, $6SY0Q.getErrorView)(state)), (res)=>res);
const $eca44ecd751fd778$var$getAvailableSpotlightTargetsSelectorMemoized = ()=>(0, $4MchI.createSelector)((state)=>(0, $6SY0Q.getAvailableSpotlightTargets)(state), (res)=>res);
const $eca44ecd751fd778$var$mapStateToPropsFactory = ()=>{
    const getEmptyViewSelectorInstance = $eca44ecd751fd778$var$getEmptyViewSelectorMemoized();
    const getErrorViewSelectorInstance = $eca44ecd751fd778$var$getErrorViewSelectorMemoized();
    const getAvailableSpotlightTargetsSelectorInstance = $eca44ecd751fd778$var$getAvailableSpotlightTargetsSelectorMemoized();
    const onRetryFactory = (0, $LFmXM.default)((state)=>()=>(0, $6SY0Q.getOnReload)(state)({}));
    return (state)=>{
        let Header;
        const FilterView = (0, $6SY0Q.getFilterView)(state);
        if (FilterView) Header = (0, $6FHTv.default);
        else {
            const headerConfiguration = (0, $6SY0Q.getHeaderConfiguration)(state);
            if (headerConfiguration) {
                // @ts-expect-error - TS2339 - Property 'View' does not exist on type 'HeaderConfiguration<TFilter>'.
                if (headerConfiguration.View) Header = (0, $1YsZU.default);
                else Header = (0, $jCVOe.default);
            }
        }
        return {
            Header: Header,
            Table: $5FTzj.default,
            Paginator: $lzizg.default,
            Empty: getEmptyViewSelectorInstance(state),
            Error: getErrorViewSelectorInstance(state),
            status: (0, $bt4Z6.getStatus)(state),
            onRetry: onRetryFactory(state),
            isOnboardingEnabled: (0, $6SY0Q.getIsOnboardingEnabled)(state),
            renderOnboardingSpotlight: (0, $6SY0Q.getRenderOnboardingSpotlight)(state),
            availableSpotlightTargets: getAvailableSpotlightTargetsSelectorInstance(state)
        };
    };
};
const $eca44ecd751fd778$var$mapDispatchToProps = {
    onAdd: (0, $4wOQJ.initiate)
};
var $eca44ecd751fd778$export$2e2bcd8739ae039 = (0, $gnQAk.connect)($eca44ecd751fd778$var$mapStateToPropsFactory, $eca44ecd751fd778$var$mapDispatchToProps, null, (0, $91zZ6.storeOptions))((0, $bj0qr.default));

});
parcelRegister("eS6Sp", function(module, exports) {
$parcel$export(module.exports, "withMountReporting", () => $ef98fa099ffbdef1$export$95fa4b7a60ebef6);
$parcel$export(module.exports, "default", () => $ef98fa099ffbdef1$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $eK5AI = parcelRequire("eK5AI");

var $5yd4l = parcelRequire("5yd4l");
// eslint-disable-next-line jira/react/no-class-components
class $ef98fa099ffbdef1$var$Reporter extends (0, $eJOHy.Component) {
    static{
        this.defaultProps = {
            performanceMarkKey: undefined
        };
    }
    componentDidMount() {
        this.props.onMounted();
    }
    render() {
        const { performanceMarkKey: performanceMarkKey } = this.props;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, performanceMarkKey && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $eK5AI.default), {
            metricKey: performanceMarkKey
        }), this.props.children);
    }
}
function $ef98fa099ffbdef1$export$95fa4b7a60ebef6(Wrapped) {
    return (props)=>{
        const { performanceMarkKey: performanceMarkKey, ...rest } = props;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $5yd4l.default).Consumer, null, ({ reportMount: reportMount })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($ef98fa099ffbdef1$var$Reporter, {
                onMounted: reportMount,
                performanceMarkKey: performanceMarkKey
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(Wrapped, rest)));
    };
}
const $ef98fa099ffbdef1$var$MountReporter = $ef98fa099ffbdef1$export$95fa4b7a60ebef6(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null));
var $ef98fa099ffbdef1$export$2e2bcd8739ae039 = $ef98fa099ffbdef1$var$MountReporter;

});

parcelRegister("bt4Z6", function(module, exports) {
$parcel$export(module.exports, "getStatus", () => $efad135e16b62051$export$b70265791d2079d4);

var $6SY0Q = parcelRequire("6SY0Q");
const $efad135e16b62051$export$b70265791d2079d4 = (state)=>{
    if ((0, $6SY0Q.isError)(state)) return 'error';
    if ((0, $6SY0Q.isLoading)(state)) return 'has-entities';
    const dataProvider = (0, $6SY0Q.getDataProvider)(state);
    const elementsCount = dataProvider ? dataProvider.getData().length : (0, $6SY0Q.getEntityIds)(state).length;
    return elementsCount === 0 && (0, $6SY0Q.getFilter)(state) === undefined && (0, $6SY0Q.getPage)(state) === 1 ? 'empty' : 'has-entities';
};

});

parcelRegister("6FHTv", function(module, exports) {
$parcel$export(module.exports, "default", () => $e0574a56fae741f0$export$2e2bcd8739ae039);

var $LFmXM = parcelRequire("LFmXM");

var $91zZ6 = parcelRequire("91zZ6");

var $6SY0Q = parcelRequire("6SY0Q");

var $bt4Z6 = parcelRequire("bt4Z6");

var $cXdYX = parcelRequire("cXdYX");
const $e0574a56fae741f0$var$mapStateToPropsFactory = ()=>{
    const onFilterFactory = (0, $LFmXM.default)((state)=>// eslint-disable-next-line @typescript-eslint/no-explicit-any
        (filter)=>(0, $6SY0Q.getOnReload)(state)({
                page: 1,
                filter: filter
            }));
    return (state)=>({
            FilterView: (0, $6SY0Q.getFilterView)(state),
            onFilter: onFilterFactory(state),
            hasEntities: (0, $bt4Z6.getStatus)(state) === 'has-entities'
        });
};
var // @ts-expect-error - TS2554 - Expected 3-4 arguments, but got 2. | TS2345 - Argument of type '<T>(props: Props<T>) => false | Element' is not assignable to parameter of type 'Component<DispatchProp<any>>'.
$e0574a56fae741f0$export$2e2bcd8739ae039 = (0, $91zZ6.connect)($e0574a56fae741f0$var$mapStateToPropsFactory, {})((0, $cXdYX.default));

});
parcelRegister("cXdYX", function(module, exports) {
$parcel$export(module.exports, "default", () => $bee0d7cc05606f81$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $8nu6j = parcelRequire("8nu6j");
var $1DXK0 = parcelRequire("1DXK0");
function $bee0d7cc05606f81$export$2e2bcd8739ae039(props) {
    const { hasEntities: hasEntities, FilterView: FilterView, onFilter: onFilter } = props;
    return hasEntities ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
        xcss: $bee0d7cc05606f81$var$wrapperStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(FilterView, {
        onFilter: onFilter
    })) : null;
}
const $bee0d7cc05606f81$var$wrapperStyles = (0, $1DXK0.xcss)({
    marginBottom: 'space.200'
});

});


parcelRegister("jCVOe", function(module, exports) {
$parcel$export(module.exports, "default", () => $caf4a8d1960fcc3c$export$2e2bcd8739ae039);

var $gnQAk = parcelRequire("gnQAk");

var $91zZ6 = parcelRequire("91zZ6");

var $6SY0Q = parcelRequire("6SY0Q");

var $bt4Z6 = parcelRequire("bt4Z6");

var $lBd8e = parcelRequire("lBd8e");

var $dbkrW = parcelRequire("dbkrW");

var $bgiMi = parcelRequire("bgiMi");
const $caf4a8d1960fcc3c$var$mapStateToProps = (state)=>{
    const headerConfiguration = (0, $6SY0Q.getHeaderConfiguration)(state);
    // @ts-expect-error - TS2339 - Property 'View' does not exist on type 'HeaderConfiguration<TFilter>'.
    if (!headerConfiguration || headerConfiguration.View) throw new Error('Invalid state - Default Header view must not be mounted');
    return {
        Filter: $dbkrW.default,
        // @ts-expect-error - TS2339 - Property 'ActionsView' does not exist on type 'HeaderConfiguration<TFilter>'.
        Actions: headerConfiguration.ActionsView || (0, $lBd8e.default),
        hasEntities: (0, $bt4Z6.getStatus)(state) === 'has-entities',
        // @ts-expect-error - TS2339 - Property 'caption' does not exist on type 'HeaderConfiguration<TFilter>'.
        caption: headerConfiguration.caption || null
    };
};
var // @ts-expect-error - TS2345 - Argument of type 'ComponentType<Diff<Record<any, any> | (Record<any, any> & { children?: ReactNode; }), InjectIntlVoidProps>>' is not assignable to parameter of type 'Component<DispatchProp<any> & { Filter: ComponentClass<Omit<DispatchProp<any>, "dispatch">> & { WrappedComponent: Component<DispatchProp<any>>; }; Actions: any; hasEntities: boolean; caption: any; }>'.
$caf4a8d1960fcc3c$export$2e2bcd8739ae039 = (0, $gnQAk.connect)($caf4a8d1960fcc3c$var$mapStateToProps, null, null, (0, $91zZ6.storeOptions))((0, $bgiMi.default));

});
parcelRegister("lBd8e", function(module, exports) {
$parcel$export(module.exports, "default", () => $35248647e13a4408$export$2e2bcd8739ae039);

var $gnQAk = parcelRequire("gnQAk");

var $91zZ6 = parcelRequire("91zZ6");

var $4wOQJ = parcelRequire("4wOQJ");

var $6SY0Q = parcelRequire("6SY0Q");

var $byghB = parcelRequire("byghB");
const $35248647e13a4408$var$mapStateToProps = (state)=>{
    const headerConfiguration = (0, $6SY0Q.getHeaderConfiguration)(state);
    // @ts-expect-error - TS2339 - Property 'View' does not exist on type 'HeaderConfiguration<TFilter>'. | TS2339 - Property 'ActionsView' does not exist on type 'HeaderConfiguration<TFilter>'.
    if (headerConfiguration && !headerConfiguration.View && !headerConfiguration.ActionsView) {
        // @ts-expect-error - TS2339 - Property 'isAddAllowed' does not exist on type 'HeaderConfiguration<TFilter>'. | TS2339 - Property 'addButtonCaption' does not exist on type 'HeaderConfiguration<TFilter>'.
        const { isAddAllowed: isAddAllowed, addButtonCaption: addButtonCaption } = headerConfiguration;
        return {
            canAdd: isAddAllowed,
            caption: addButtonCaption
        };
    }
    return {};
};
const $35248647e13a4408$var$mapDispatchToProps = {
    onAdd: (0, $4wOQJ.initiate)
};
var $35248647e13a4408$export$2e2bcd8739ae039 = (0, $gnQAk.connect)($35248647e13a4408$var$mapStateToProps, $35248647e13a4408$var$mapDispatchToProps, null, (0, $91zZ6.storeOptions))((0, $byghB.default));

});
parcelRegister("byghB", function(module, exports) {
$parcel$export(module.exports, "default", () => $d0b84cb0461ed13a$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $goZPP = parcelRequire("goZPP");

var $lRq8t = parcelRequire("lRq8t");
function $d0b84cb0461ed13a$var$Add(props) {
    const { canAdd: canAdd, caption: caption, onAdd: onAdd } = props;
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    return canAdd ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $goZPP.default), {
        appearance: "primary",
        onClick: onAdd
    }, caption && formatMessage(caption)) : null;
}
$d0b84cb0461ed13a$var$Add.defaultProps = {
    canAdd: false
};
var $d0b84cb0461ed13a$export$2e2bcd8739ae039 = $d0b84cb0461ed13a$var$Add;

});


parcelRegister("dbkrW", function(module, exports) {
$parcel$export(module.exports, "default", () => $56b26b42f2c579c7$export$2e2bcd8739ae039);

var $LFmXM = parcelRequire("LFmXM");

var $91zZ6 = parcelRequire("91zZ6");

var $6SY0Q = parcelRequire("6SY0Q");

var $181ce = parcelRequire("181ce");
const $56b26b42f2c579c7$var$mapStateToPropsFactory = ()=>{
    const onFilterFactory = (0, $LFmXM.default)((state)=>(filter)=>(0, $6SY0Q.getOnReload)(state)({
                page: 1,
                filter: filter
            }));
    return (state)=>{
        const headerConfiguration = (0, $6SY0Q.getHeaderConfiguration)(state);
        // @ts-expect-error - TS2339 - Property 'FilterView' does not exist on type 'HeaderConfiguration<TFilter>'.
        if (!headerConfiguration || !headerConfiguration.FilterView) throw new Error('Invalid state - Filter wrapper must not be mounted');
        return {
            // @ts-expect-error - TS2339 - Property 'FilterView' does not exist on type 'HeaderConfiguration<TFilter>'.
            FilterView: headerConfiguration.FilterView,
            onFilter: onFilterFactory(state)
        };
    };
};
var // @ts-expect-error - TS2554 - Expected 3-4 arguments, but got 2. | TS2345 - Argument of type 'typeof Filter' is not assignable to parameter of type 'Component<DispatchProp<any>>'.
$56b26b42f2c579c7$export$2e2bcd8739ae039 = (0, $91zZ6.connect)($56b26b42f2c579c7$var$mapStateToPropsFactory, {})((0, $181ce.default));

});
parcelRegister("181ce", function(module, exports) {
$parcel$export(module.exports, "default", () => $ee176a642e448aa0$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");
function $ee176a642e448aa0$export$2e2bcd8739ae039(props) {
    const { FilterView: FilterView, onFilter: onFilter } = props;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(FilterView, {
        onFilter: onFilter
    });
}

});


parcelRegister("bgiMi", function(module, exports) {
$parcel$export(module.exports, "default", () => $206ccb85f3340cfa$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $gHI4w = parcelRequire("gHI4w");

var $idGBm = parcelRequire("idGBm");
function $206ccb85f3340cfa$var$Default(props) {
    const { Filter: Filter, Actions: Actions, caption: caption, hasEntities: hasEntities, intl: { formatMessage: formatMessage } } = props;
    let searchBar = null;
    let actions = null;
    if (hasEntities) {
        searchBar = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(Filter, null);
        actions = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(Actions, null);
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $gHI4w.default), {
        truncateTitle: true,
        actions: actions,
        bottomBar: searchBar
    }, caption ? formatMessage(caption) : '');
}
var $206ccb85f3340cfa$export$2e2bcd8739ae039 = (0, $idGBm.injectIntlV2)($206ccb85f3340cfa$var$Default);

});


parcelRegister("1YsZU", function(module, exports) {
$parcel$export(module.exports, "default", () => $862a891411120bc1$export$2e2bcd8739ae039);

var $LFmXM = parcelRequire("LFmXM");

var $91zZ6 = parcelRequire("91zZ6");

var $4wOQJ = parcelRequire("4wOQJ");

var $6SY0Q = parcelRequire("6SY0Q");

var $bt4Z6 = parcelRequire("bt4Z6");

var $cadFR = parcelRequire("cadFR");
const $862a891411120bc1$var$mapStateToPropsFactory = ()=>{
    const onFilterFactory = (0, $LFmXM.default)((state)=>(filter)=>(0, $6SY0Q.getOnReload)(state)({
                page: 1,
                filter: filter
            }));
    return (state)=>{
        const headerConfiguration = (0, $6SY0Q.getHeaderConfiguration)(state);
        // @ts-expect-error - TS2339 - Property 'View' does not exist on type 'HeaderConfiguration<TFilter>'.
        if (!headerConfiguration || !headerConfiguration.View) throw new Error('Invalid state - Header wrapper must not be mounted');
        return {
            // @ts-expect-error - TS2339 - Property 'View' does not exist on type 'HeaderConfiguration<TFilter>'.
            HeaderView: headerConfiguration.View,
            hasEntities: (0, $bt4Z6.getStatus)(state) === 'has-entities',
            onFilter: onFilterFactory(state)
        };
    };
};
const $862a891411120bc1$var$mapDispatchToProps = {
    onAdd: (0, $4wOQJ.initiate)
};
var // @ts-expect-error - TS2554 - Expected 3-4 arguments, but got 2. | TS2345 - Argument of type 'typeof Wrapper' is not assignable to parameter of type 'Component<DispatchProp<any>>'.
$862a891411120bc1$export$2e2bcd8739ae039 = (0, $91zZ6.connect)($862a891411120bc1$var$mapStateToPropsFactory, $862a891411120bc1$var$mapDispatchToProps)((0, $cadFR.default));

});
parcelRegister("cadFR", function(module, exports) {
$parcel$export(module.exports, "default", () => $b0b6660764944ecf$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");
function $b0b6660764944ecf$export$2e2bcd8739ae039(props) {
    const { HeaderView: HeaderView, hasEntities: hasEntities, onAdd: onAdd, onFilter: onFilter } = props;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(HeaderView, {
        hasEntities: hasEntities,
        onAdd: onAdd,
        onFilter: onFilter
    });
}

});


parcelRegister("lzizg", function(module, exports) {
$parcel$export(module.exports, "default", () => $7006066677abaaa5$export$2e2bcd8739ae039);

var $LFmXM = parcelRequire("LFmXM");

var $gnQAk = parcelRequire("gnQAk");

var $91zZ6 = parcelRequire("91zZ6");

var $6SY0Q = parcelRequire("6SY0Q");

var $6rNj9 = parcelRequire("6rNj9");
const $7006066677abaaa5$var$mapStateToPropsFactory = ()=>{
    const onPageChangeFactory = (0, $LFmXM.default)(// @ts-expect-error - TS7006 - Parameter 'event' implicitly has an 'any' type. | TS7006 - Parameter 'page' implicitly has an 'any' type.
    (state)=>(event, page)=>(0, $6SY0Q.getOnReload)(state)({
                page: page
            }));
    return (state)=>({
            currentPage: (0, $6SY0Q.getPage)(state),
            totalPages: (0, $6SY0Q.getTotalPages)(state),
            onPageChange: onPageChangeFactory(state)
        });
};
var $7006066677abaaa5$export$2e2bcd8739ae039 = (0, $gnQAk.connect)($7006066677abaaa5$var$mapStateToPropsFactory, {}, null, (0, $91zZ6.storeOptions))((0, $6rNj9.default));

});
parcelRegister("6rNj9", function(module, exports) {
$parcel$export(module.exports, "default", () => $c9bf74b4e5ee6e93$export$2e2bcd8739ae039);
/* view.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $tGEEK = parcelRequire("tGEEK");

var $b3eVo = parcelRequire("b3eVo");

var $2sLVw = parcelRequire("2sLVw");

var $idGBm = parcelRequire("idGBm");

var $kRgKj = parcelRequire("kRgKj");

var $6XJko = parcelRequire("6XJko");

var $7NPCc = parcelRequire("7NPCc");
function $c9bf74b4e5ee6e93$var$Paginator(props) {
    const { currentPage: currentPage, totalPages: totalPages, intl: { formatMessage: formatMessage } } = props;
    const onPageChange = (data, event, analyticsEvent)=>{
        props.onPageChange(data, event);
        if (analyticsEvent) (0, $kRgKj.fireUIAnalytics)(analyticsEvent, 'pagination');
    };
    const content = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $b3eVo.default), {
        selectedIndex: currentPage - 1,
        onChange: onPageChange,
        pages: (0, (/*@__PURE__*/$parcel$interopDefault($tGEEK)))(1, totalPages + 1),
        previousLabel: formatMessage((0, $7NPCc.default).previousButton),
        nextLabel: formatMessage((0, $7NPCc.default).nextButton)
    });
    if (totalPages > 1) return (0, $6XJko.isVisualRefreshEnabled)() ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $2sLVw.default), {
        alignItems: "center",
        justifyContent: "center",
        xcss: $c9bf74b4e5ee6e93$var$styles.paginationContainer,
        testId: "global-pages.directories.directory-base.content.paginator.container"
    }, content) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($c9bf74b4e5ee6e93$var$Container, {
        "data-testId": "global-pages.directories.directory-base.content.paginator.container"
    }, content);
    return null;
}
var $c9bf74b4e5ee6e93$export$2e2bcd8739ae039 = (0, $idGBm.injectIntlV2)($c9bf74b4e5ee6e93$var$Paginator);
const $c9bf74b4e5ee6e93$var$styles = {
    paginationContainer: "_n3td1ejb _18u0xmi2"
}; // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $c9bf74b4e5ee6e93$var$Container = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_n3td1ejb _18u0xmi2",
            __cmplp.className
        ])
    });
});

});
parcelRegister("b3eVo", function(module, exports) {
$parcel$export(module.exports, "default", () => $2e9938bbbd4852c0$export$2e2bcd8739ae039);
/* pagination.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $jrFnt = parcelRequire("jrFnt");

var $3Vuhz = parcelRequire("3Vuhz");

var $7O2l7 = parcelRequire("7O2l7");

var $a2JSB = parcelRequire("a2JSB");

var $1kTzc = parcelRequire("1kTzc");

var $8IeH1 = parcelRequire("8IeH1");
var $6djmC = parcelRequire("6djmC");

var $2xCo3 = parcelRequire("2xCo3");

var $6CP4r = parcelRequire("6CP4r");

var $3IiVn = parcelRequire("3IiVn");

var $1CN10 = parcelRequire("1CN10");

var $1hfAD = parcelRequire("1hfAD");
const $2e9938bbbd4852c0$var$styles = {
    paginationMenu: "_ca0qze3t _u5f3ze3t _n3tdze3t _19bvze3t _19pkze3t _2hwxze3t _otyrze3t _18u0ze3t",
    paginationMenuItem: "_1pfhze3t _ect41gqc",
    navigatorIconWrapper: "_18zr12x7"
};
const $2e9938bbbd4852c0$var$analyticsAttributes = {
    componentName: 'pagination',
    packageName: "platform-pkg",
    packageVersion: "0.0.0-use.local"
};
function $2e9938bbbd4852c0$var$NavigatorIcon({ chevronDirection: chevronDirection }) {
    const Chevron = chevronDirection === 'left' ? (0, (/*@__PURE__*/$parcel$interopDefault($a2JSB))) : (0, (/*@__PURE__*/$parcel$interopDefault($1kTzc)));
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $8IeH1.default), {
        as: "span",
        xcss: $2e9938bbbd4852c0$var$styles.navigatorIconWrapper,
        children: /*#__PURE__*/ (0, $gt9Am.jsx)(Chevron, {
            label: "",
            LEGACY_margin: `0 ${"var(--ds-space-negative-075, -6px)"}`,
            color: "currentColor",
            size: "small"
        })
    });
}
function $2e9938bbbd4852c0$var$InnerPagination({ components: components = (0, $1CN10.emptyObject), defaultSelectedIndex: defaultSelectedIndex = 0, selectedIndex: selectedIndex, label: label = 'pagination', pageLabel: pageLabel = 'page', previousLabel: previousLabel = 'previous', nextLabel: nextLabel = 'next', style: style = (0, $1CN10.emptyObject), max: max = 7, onChange: onChange = (0, $3Vuhz.default), pages: pages, getPageLabel: getPageLabel, renderEllipsis: renderEllipsis = (0, $3IiVn.default), analyticsContext: analyticsContext, testId: testId, isDisabled: isDisabled }, ref) {
    const [selectedIndexValue, setSelectedIndexValue] = (0, $7O2l7.default)(selectedIndex, ()=>defaultSelectedIndex || 0);
    const onChangeWithAnalytics = (0, $jrFnt.usePlatformLeafEventHandler)({
        fn: (value, analyticsEvent)=>{
            const { event: event, selectedPageIndex: selectedPageIndex } = value;
            if (selectedIndex === undefined) setSelectedIndexValue(selectedPageIndex);
            if (onChange) onChange(event, pages[selectedPageIndex], analyticsEvent);
        },
        action: 'changed',
        actionSubject: 'pageNumber',
        analyticsData: analyticsContext,
        ...$2e9938bbbd4852c0$var$analyticsAttributes
    });
    const transform = (page, currPageIndex, testId)=>{
        const selectedPage = pages[selectedIndexValue];
        const pageIndexLabel = `${pageLabel} ${getPageLabel ? getPageLabel(page, currPageIndex) : page}`;
        const isCurrentPage = page === selectedPage;
        return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $6djmC.default), {
            as: "li",
            xcss: $2e9938bbbd4852c0$var$styles.paginationMenuItem,
            children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $6CP4r.default), {
                component: components.Page,
                onClick: (event)=>onChangeWithAnalytics({
                        event: event,
                        selectedPageIndex: currPageIndex
                    }),
                "aria-current": isCurrentPage ? 'page' : undefined,
                "aria-label": pageIndexLabel,
                isSelected: isCurrentPage,
                isDisabled: isDisabled,
                page: page,
                testId: testId && `${testId}--${isCurrentPage ? 'current-' : ''}page-${currPageIndex}`,
                children: getPageLabel ? getPageLabel(page, currPageIndex) : page
            })
        }, `page-${getPageLabel ? getPageLabel(page, currPageIndex) : currPageIndex}`);
    };
    return(// eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
    /*#__PURE__*/ (0, $gt9Am.jsx)((0, $8IeH1.default), {
        testId: testId,
        style: style,
        ref: ref,
        "aria-label": label,
        as: "nav",
        children: /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $6djmC.default), {
            space: "space.0",
            alignBlock: "center",
            children: [
                /*#__PURE__*/ (0, $gt9Am.jsx)((0, $2xCo3.default), {
                    component: components.Previous,
                    onClick: (event)=>onChangeWithAnalytics({
                            event: event,
                            selectedPageIndex: selectedIndexValue - 1
                        }),
                    isDisabled: isDisabled || selectedIndexValue === 0,
                    iconBefore: /*#__PURE__*/ (0, $gt9Am.jsx)($2e9938bbbd4852c0$var$NavigatorIcon, {
                        chevronDirection: "left"
                    }),
                    "aria-label": previousLabel,
                    testId: testId && `${testId}--left-navigator`
                }, "left-navigator"),
                /*#__PURE__*/ (0, $gt9Am.jsx)((0, $6djmC.default), {
                    space: "space.0",
                    alignBlock: "baseline",
                    as: "ul",
                    xcss: $2e9938bbbd4852c0$var$styles.paginationMenu,
                    children: (0, $1hfAD.default)(pages, selectedIndexValue, {
                        max: max,
                        ellipsis: renderEllipsis,
                        transform: transform
                    }, testId)
                }),
                /*#__PURE__*/ (0, $gt9Am.jsx)((0, $2xCo3.default), {
                    component: components.Next,
                    onClick: (event)=>onChangeWithAnalytics({
                            event: event,
                            selectedPageIndex: selectedIndexValue + 1
                        }),
                    isDisabled: isDisabled || selectedIndexValue === pages.length - 1,
                    iconBefore: /*#__PURE__*/ (0, $gt9Am.jsx)($2e9938bbbd4852c0$var$NavigatorIcon, {
                        chevronDirection: "right"
                    }),
                    "aria-label": nextLabel,
                    testId: testId && `${testId}--right-navigator`
                }, "right-navigator")
            ]
        })
    }));
}
/**
 * __Pagination__
 *
 * Pagination allows you to divide large amounts of content into smaller chunks across multiple pages.
 *
 * - [Examples](https://atlassian.design/components/pagination/examples)
 * - [Code](https://atlassian.design/components/pagination/code)
 * - [Usage](https://atlassian.design/components/pagination/usage)
 */ const $2e9938bbbd4852c0$var$Pagination = /*#__PURE__*/ (0, $eJOHy.memo)(/*#__PURE__*/ (0, $eJOHy.forwardRef)($2e9938bbbd4852c0$var$InnerPagination));
var $2e9938bbbd4852c0$export$2e2bcd8739ae039 = $2e9938bbbd4852c0$var$Pagination;

});
parcelRegister("a2JSB", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::8e8ea817ec2fe685ddbf301b825d4978>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $74fdae0df2a41f03$var$_react = $74fdae0df2a41f03$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $74fdae0df2a41f03$var$_chevronLeft = $74fdae0df2a41f03$var$_interopRequireDefault((parcelRequire("8PCRQ")));

var $74fdae0df2a41f03$var$_chevronLeftLarge = $74fdae0df2a41f03$var$_interopRequireDefault((parcelRequire("k9ooi")));
function $74fdae0df2a41f03$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for ChevronLeftIcon.
 * This component is ChevronLeftIcon, with `UNSAFE_fallbackIcon` set to "ChevronLeftLargeIcon".
 *
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Do not use 16px chevrons within buttons, icon buttons, or dropdowns to maintain visual cohesion with ADS which uses 12px chevrons.
Known uses: Navigate back, show previous page of pagination results
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $74fdae0df2a41f03$var$ChevronLeftIcon = (props)=>/*#__PURE__*/ $74fdae0df2a41f03$var$_react.default.createElement($74fdae0df2a41f03$var$_chevronLeft.default, Object.assign({
        name: "ChevronLeftIcon",
        LEGACY_fallbackIcon: $74fdae0df2a41f03$var$_chevronLeftLarge.default
    }, props));
$74fdae0df2a41f03$var$ChevronLeftIcon.displayName = 'ChevronLeftIconMigration';
var $74fdae0df2a41f03$var$_default = module.exports.default = $74fdae0df2a41f03$var$ChevronLeftIcon;

});
parcelRegister("8PCRQ", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::8ee9ad5072a30451ff7ca2ddc0961d03>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $66e13c6de5d90262$var$_react = $66e13c6de5d90262$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $66e13c6de5d90262$var$_baseNew = $66e13c6de5d90262$var$_interopRequireDefault((parcelRequire("fGWXz")));
function $66e13c6de5d90262$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "ChevronLeft".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Do not use 16px chevrons within buttons, icon buttons, or dropdowns to maintain visual cohesion with ADS which uses 12px chevrons.
Known uses: Navigate back, show previous page of pagination results
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $66e13c6de5d90262$var$ChevronLeftIcon = (props)=>/*#__PURE__*/ $66e13c6de5d90262$var$_react.default.createElement($66e13c6de5d90262$var$_baseNew.default, Object.assign({
        name: "ChevronLeftIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" d="m9.97 1.47-6 6a.75.75 0 0 0-.052 1.004l.052.056 6 6 1.06-1.06L5.56 8l5.47-5.47z"/>`
    }, props));
$66e13c6de5d90262$var$ChevronLeftIcon.displayName = 'ChevronLeftIcon';
var $66e13c6de5d90262$var$_default = module.exports.default = $66e13c6de5d90262$var$ChevronLeftIcon;

});

parcelRegister("k9ooi", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $eab7917427604e36$var$_react = $eab7917427604e36$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $fL0In = parcelRequire("fL0In");
function $eab7917427604e36$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $eab7917427604e36$var$ChevronLeftLargeIcon = (props)=>/*#__PURE__*/ $eab7917427604e36$var$_react.default.createElement($fL0In.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="m9.005 10.995 4.593-4.593a.99.99 0 1 1 1.4 1.4l-3.9 3.9 3.9 3.9a.99.99 0 0 1-1.4 1.4L9.005 12.41a1 1 0 0 1 0-1.414"/></svg>`
    }, props));
$eab7917427604e36$var$ChevronLeftLargeIcon.displayName = 'ChevronLeftLargeIcon';
var $eab7917427604e36$var$_default = module.exports.default = $eab7917427604e36$var$ChevronLeftLargeIcon;

});


parcelRegister("2xCo3", function(module, exports) {
$parcel$export(module.exports, "default", () => $390a465a7b875c7d$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $goZPP = parcelRequire("goZPP");
function $390a465a7b875c7d$export$2e2bcd8739ae039(props) {
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $goZPP.default), {
        "aria-label": props['aria-label'],
        isDisabled: props.isDisabled,
        iconBefore: props.iconBefore,
        testId: props.testId,
        onClick: props.onClick,
        component: props.component,
        appearance: "subtle"
    });
}

});

parcelRegister("6CP4r", function(module, exports) {
$parcel$export(module.exports, "default", () => $a7a0738c73e50f62$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $goZPP = parcelRequire("goZPP");
function $a7a0738c73e50f62$export$2e2bcd8739ae039(props) {
    // eslint-disable-next-line @repo/internal/react/no-unsafe-spread-props
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $goZPP.default), {
        ...props,
        appearance: "subtle"
    });
}

});

parcelRegister("3IiVn", function(module, exports) {
$parcel$export(module.exports, "default", () => $eee95bde3b212432$export$2e2bcd8739ae039);
/* render-ellipsis.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $8IeH1 = parcelRequire("8IeH1");
var $3cMgR = parcelRequire("3cMgR");

var $6fs4r = parcelRequire("6fs4r");
const $eee95bde3b212432$var$styles = {
    container: "_1e0c1txw _kqswh2mm"
};
function $eee95bde3b212432$export$2e2bcd8739ae039({ key: key, testId: testId, from: from, to: to }) {
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $8IeH1.default), {
        as: "li",
        testId: testId,
        xcss: $eee95bde3b212432$var$styles.container,
        paddingInline: "space.100",
        children: /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $3cMgR.default), {
            testId: testId && `${testId}-text`,
            children: [
                /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $6fs4r.default), {
                    children: [
                        "Skipped pages from ",
                        from,
                        " to ",
                        to
                    ]
                }),
                "\u2026"
            ]
        })
    }, key);
}

});

parcelRegister("1CN10", function(module, exports) {
$parcel$export(module.exports, "emptyObject", () => $1b85b3c8ab534085$export$3f860eba1218f8d3);
const $1b85b3c8ab534085$export$3f860eba1218f8d3 = {};

});

parcelRegister("1hfAD", function(module, exports) {
$parcel$export(module.exports, "default", () => $916df7f6e7c50105$export$2e2bcd8739ae039);

var $LFmXM = parcelRequire("LFmXM");
// TODO: comma needed after generic declaration below, or the .tsx file thinks
// it is a JSX element. Tidy up in a future refactor.
const $916df7f6e7c50105$var$collapseRange = (pages, current, { max: max, ellipsis: ellipsis, transform: transform }, testId)=>{
    const total = pages.length;
    // only need ellipsis if we have more pages than we can display
    const needEllipsis = total > max;
    // show start ellipsis if the current page is further away than max - 4 from the first page
    const hasStartEllipsis = needEllipsis && max - 4 < current;
    // show end ellipsis if the current page is further than total - max + 3 from the last page
    const hasEndEllipsis = needEllipsis && current < total - max + 3;
    const getPageComponents = (0, $LFmXM.default)((startIndex = 0, lastIndex = total)=>{
        return pages.slice(startIndex, lastIndex).map((page, index)=>transform(page, startIndex + index, testId));
    });
    if (!needEllipsis) return getPageComponents(0, total);
    if (hasStartEllipsis && !hasEndEllipsis) {
        const pageCount = max - 2;
        return [
            ...getPageComponents(0, 1),
            ellipsis({
                key: 'ellipsis-1',
                testId: testId && `${testId}-ellipsis`,
                from: 2,
                to: total - pageCount
            }),
            ...getPageComponents(total - pageCount)
        ];
    }
    if (!hasStartEllipsis && hasEndEllipsis) {
        const pageCount = max - 2;
        return [
            ...getPageComponents(0, pageCount),
            ellipsis({
                key: 'ellipsis-1',
                testId: testId && `${testId}-ellipsis`,
                from: pageCount + 1,
                to: total - 1
            }),
            ...getPageComponents(total - 1)
        ];
    }
    // we have both start and end ellipsis
    const pageCount = max - 4;
    return [
        ...getPageComponents(0, 1),
        ellipsis({
            key: 'ellipsis-1',
            testId: testId && `${testId}-ellipsis`,
            from: 2,
            to: current - Math.floor(pageCount / 2)
        }),
        ...getPageComponents(current - Math.floor(pageCount / 2), current + pageCount - 1),
        ellipsis({
            key: 'ellipsis-2',
            testId: testId && `${testId}-ellipsis`,
            from: current + 3,
            to: total - 1
        }),
        ...getPageComponents(total - 1)
    ];
};
var $916df7f6e7c50105$export$2e2bcd8739ae039 = $916df7f6e7c50105$var$collapseRange;

});


parcelRegister("7NPCc", function(module, exports) {
$parcel$export(module.exports, "default", () => $07ec01bbb9ef28ec$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
const $07ec01bbb9ef28ec$var$messages = (0, $7qGN1.defineMessages)({
    previousButton: {
        "id": "directory-base.content.paginator.previous-button",
        "defaultMessage": "Previous page"
    },
    nextButton: {
        "id": "directory-base.content.paginator.next-button",
        "defaultMessage": "Next page"
    }
});
var $07ec01bbb9ef28ec$export$2e2bcd8739ae039 = $07ec01bbb9ef28ec$var$messages;

});



parcelRegister("5FTzj", function(module, exports) {
$parcel$export(module.exports, "default", () => $a468657d4ef5c51d$export$2e2bcd8739ae039);

var $ahm5r = parcelRequire("ahm5r");

var $LFmXM = parcelRequire("LFmXM");

var $91zZ6 = parcelRequire("91zZ6");

var $5cBQu = parcelRequire("5cBQu");

var $6SY0Q = parcelRequire("6SY0Q");

var $4fI4K = parcelRequire("4fI4K");

var $hd1Pz = parcelRequire("hd1Pz");

var $96vM9 = parcelRequire("96vM9");
const $a468657d4ef5c51d$var$getSpotlightForCellSelectorMemoized = ()=>(0, $ahm5r.createSelector)((state)=>(0, $6SY0Q.getSpotlightForCell)(state), (res)=>res);
const $a468657d4ef5c51d$var$mapStateToPropsFactory = ()=>{
    const getSpotlightForCellSelectorInstance = $a468657d4ef5c51d$var$getSpotlightForCellSelectorMemoized();
    const onSortFactory = (0, $LFmXM.default)(// @ts-expect-error - TS7006 - Parameter 'sort' implicitly has an 'any' type.
    (state)=>(sort)=>(0, $6SY0Q.getOnReload)(state)({
                page: 1,
                ...sort
            }));
    return (state)=>{
        // @ts-expect-error - TS2339 - Property 'View' does not exist on type 'EmptyFilterResultConfiguration'.
        const EmptyView = (0, $6SY0Q.getEmptyFilterResultConfiguration)(state).View || (0, $hd1Pz.default);
        const TableMaskView = (0, $6SY0Q.getTableMaskView)(state);
        const filter = (0, $6SY0Q.getFilter)(state);
        const filterQuery = filter ? filter.query : '';
        return {
            tableConfiguration: (0, $6SY0Q.getTableConfiguration)(state),
            tableLabel: (0, $6SY0Q.getTableLabel)(state),
            resultsAnnouncerMessage: (0, $6SY0Q.getResultsAnnouncerMessage)(state),
            EmptyView: EmptyView,
            TableMaskView: TableMaskView,
            dataProvider: (0, $6SY0Q.getDataProvider)(state),
            entityIds: (0, $6SY0Q.getEntityIds)(state),
            totalItems: (0, $6SY0Q.getTotalItems)(state),
            operationInitializationStatusPerEntity: (0, $6SY0Q.getOperationInitializationStatusPerEntity)(state),
            isLoading: (0, $6SY0Q.isLoading)(state),
            sortField: (0, $6SY0Q.getSortField)(state),
            sortDirection: (0, $6SY0Q.getSortDirection)(state),
            onSort: onSortFactory(state),
            mountMetricKey: (0, $4fI4K.getTableMountedMetricKey)(state),
            getSpotlightForCell: getSpotlightForCellSelectorInstance(state),
            firstColumnHeadingAlignment: (0, $6SY0Q.getFirstColumnHeadingAlignment)(state),
            lastColumnHeadingAlignment: (0, $6SY0Q.getLastColumnHeadingAlignment)(state),
            filterQuery: filterQuery
        };
    };
};
const $a468657d4ef5c51d$var$mapDispatchToProps = {
    onOperationRequested: (0, $5cBQu.initiate)
};
var // @ts-expect-error - TS2554 - Expected 3-4 arguments, but got 2.
$a468657d4ef5c51d$export$2e2bcd8739ae039 = (0, $91zZ6.connect)($a468657d4ef5c51d$var$mapStateToPropsFactory, $a468657d4ef5c51d$var$mapDispatchToProps)((0, $96vM9.default));

});
parcelRegister("4fI4K", function(module, exports) {
$parcel$export(module.exports, "getTableMountedMetricKey", () => $9e43c8fdf7968ae6$export$b6c1493984bb04f9);
const $9e43c8fdf7968ae6$export$b6c1493984bb04f9 = (state)=>state.app.props.metrics.tableMounted;

});

parcelRegister("hd1Pz", function(module, exports) {
$parcel$export(module.exports, "default", () => $ccf583b38e8b01a8$export$2e2bcd8739ae039);

var $gnQAk = parcelRequire("gnQAk");

var $91zZ6 = parcelRequire("91zZ6");

var $6SY0Q = parcelRequire("6SY0Q");

var $46lOx = parcelRequire("46lOx");
const $ccf583b38e8b01a8$var$mapStateToProps = (state)=>{
    const configuration = (0, $6SY0Q.getEmptyFilterResultConfiguration)(state);
    // @ts-expect-error - TS2339 - Property 'message' does not exist on type 'EmptyFilterResultConfiguration'.
    if (!configuration.message) throw new Error('Invalid state - Default empty view should not be mounted');
    return {
        // @ts-expect-error - TS2339 - Property 'message' does not exist on type 'EmptyFilterResultConfiguration'.
        message: configuration.message
    };
};
var $ccf583b38e8b01a8$export$2e2bcd8739ae039 = (0, $gnQAk.connect)($ccf583b38e8b01a8$var$mapStateToProps, null, null, (0, $91zZ6.storeOptions))((0, $46lOx.default));

});
parcelRegister("46lOx", function(module, exports) {
$parcel$export(module.exports, "default", () => $cdf52a671bcf0851$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $6MnLl = parcelRequire("6MnLl");

var $6YFG2 = parcelRequire("6YFG2");

var $hj82Y = parcelRequire("hj82Y");

var $6XJko = parcelRequire("6XJko");

var $87ztG = parcelRequire("87ztG");
function $cdf52a671bcf0851$var$DefaultEmptyView(props) {
    const { message: message } = props;
    const { intl: { formatMessage: formatMessage } } = props;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("div", {
        "data-testId": "global-pages.directories.directory-base.content.table.default-empty-view.empty-state"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $6MnLl.default), {
        imageUrl: (0, $6XJko.isVisualRefreshEnabled)() ? (0, (/*@__PURE__*/$parcel$interopDefault($hj82Y))) : (0, (/*@__PURE__*/$parcel$interopDefault($87ztG))),
        header: formatMessage(message),
        width: "narrow",
        headingLevel: 2
    }));
}
var $cdf52a671bcf0851$export$2e2bcd8739ae039 = (0, $6YFG2.default)($cdf52a671bcf0851$var$DefaultEmptyView);

});
parcelRegister("hj82Y", function(module, exports) {
module.exports = new URL("search-no-results.1d478205.svg", import.meta.url).toString();

});

parcelRegister("87ztG", function(module, exports) {
module.exports = new URL("generic-no-results.fb302821.svg", import.meta.url).toString();

});



parcelRegister("96vM9", function(module, exports) {
$parcel$export(module.exports, "default", () => $58d4afddfb7fcf61$export$2e2bcd8739ae039);
/* view.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");
var $awdRS = parcelRequire("awdRS");

var $12DRg = parcelRequire("12DRg");

var $aXKmr = parcelRequire("aXKmr");

var $lOOiG = parcelRequire("lOOiG");

var $guChT = parcelRequire("guChT");

var $8IeH1 = parcelRequire("8IeH1");
var $2sLVw = parcelRequire("2sLVw");
var $3cMgR = parcelRequire("3cMgR");

var $8nw3F = parcelRequire("8nw3F");


var $idGBm = parcelRequire("idGBm");

var $kRgKj = parcelRequire("kRgKj");

var $6XJko = parcelRequire("6XJko");

var $eS6Sp = parcelRequire("eS6Sp");

var $8TMMM = parcelRequire("8TMMM");
class $58d4afddfb7fcf61$var$Table extends (0, $eJOHy.Component) {
    static{
        this.defaultProps = {
            isLoading: false,
            entityIds: [],
            totalItems: 0,
            sortDirection: (0, $88c5923de10af20c$export$1dee026a19752d6b),
            mountMetricKey: undefined,
            getSpotlightForCell: (0, (/*@__PURE__*/$parcel$interopDefault($12DRg))),
            TableMaskView: undefined,
            firstColumnHeadingAlignment: 'left',
            lastColumnHeadingAlignment: 'left',
            filterQuery: '',
            tableLabel: undefined,
            resultsAnnouncerMessage: (0, $8TMMM.default).filterResultsAnnouncement,
            onSort: (0, (/*@__PURE__*/$parcel$interopDefault($12DRg))),
            onOperationRequested: (0, (/*@__PURE__*/$parcel$interopDefault($12DRg)))
        };
    }
    componentDidUpdate(prevProps) {
        if (prevProps.sortDirection !== this.props.sortDirection || prevProps.sortField !== this.props.sortField) this.state.hasSortingChanged = true;
        if (!prevProps.isLoading && this.props.isLoading) this.state.shouldAnnounceResults = !this.state.hasSortingChanged;
        else if (prevProps.isLoading && !this.props.isLoading) this.state.hasSortingChanged = false;
        if (this.state.returnFocusTo) {
            // Find the index of the sort field that we should put focus on, then go through all the headers and find the one that matches the sort field index
            const sortFieldIndex = this.props.tableConfiguration.findIndex((config)=>config.sortField === this.state.returnFocusTo);
            if (sortFieldIndex >= 0) {
                const allHeaders = globalThis.document.querySelectorAll('thead th');
                if (sortFieldIndex < allHeaders.length) {
                    const targetHeader = allHeaders[sortFieldIndex];
                    const sortButton = targetHeader.querySelector('button[aria-roledescription="Sort button"]');
                    if (sortButton instanceof HTMLElement) sortButton.focus();
                }
            }
        }
    }
    render() {
        const { tableConfiguration: tableConfiguration, entityIds: entityIds, totalItems: totalItems, EmptyView: EmptyView, isLoading: isLoading, operationInitializationStatusPerEntity: operationInitializationStatusPerEntity, sortField: sortField, sortDirection: sortDirection, mountMetricKey: mountMetricKey, getSpotlightForCell: getSpotlightForCell, TableMaskView: TableMaskView, dataProvider: dataProvider, firstColumnHeadingAlignment: firstColumnHeadingAlignment, lastColumnHeadingAlignment: lastColumnHeadingAlignment, intl: { formatMessage: formatMessage }, tableLabel: tableLabel, resultsAnnouncerMessage: resultsAnnouncerMessage } = this.props;
        const headCells = tableConfiguration.map(({ title: title, width: width, sortField: cellSortField, dataTestId: dataTestId, isIconOnlyHeader: isIconOnlyHeader, ascendingSortTooltip: ascendingSortTooltip, descendingSortTooltip: descendingSortTooltip })=>{
            let content = '';
            const wrapperProps = dataTestId ? {
                'data-test-id': dataTestId
            } : {};
            if (dataTestId) // @ts-expect-error - TS2322 - Type 'Element' is not assignable to type 'string'.
            content = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($58d4afddfb7fcf61$var$NonBreakingCell, wrapperProps);
            if (typeof title === 'function') {
                // eslint-disable-next-line @typescript-eslint/no-explicit-any
                const HeaderCell = title; // @ts-expect-error - TS2322 - Type 'Element' is not assignable to type 'string'.
                content = (()=>{
                    if (!(0, $6XJko.isVisualRefreshEnabled)()) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($58d4afddfb7fcf61$var$HeaderWrapper, wrapperProps, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(HeaderCell, null));
                    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8IeH1.default), {
                        xcss: $58d4afddfb7fcf61$var$styles.headerWrapper,
                        testId: dataTestId
                    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(HeaderCell, null));
                })();
            } else if (typeof title !== 'undefined') {
                // eslint-disable-next-line @typescript-eslint/consistent-type-assertions, @typescript-eslint/no-explicit-any
                const message = title; // @ts-expect-error - TS2322 - Type 'Element' is not assignable to type 'string'.
                content = (0, $6XJko.isVisualRefreshEnabled)() ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $2sLVw.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $3cMgR.default), {
                    testId: dataTestId,
                    color: "color.text.subtle",
                    maxLines: 1,
                    weight: "bold",
                    size: "small"
                }, formatMessage(message))) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($58d4afddfb7fcf61$var$NonBreakingCell, wrapperProps, formatMessage(message));
            }
            return {
                key: cellSortField || (0, $aXKmr.v1)(),
                isSortable: !!cellSortField,
                content: content,
                width: width,
                isIconOnlyHeader: (0, $6XJko.isVisualRefreshEnabled)() ? !!isIconOnlyHeader : undefined,
                ascendingSortTooltip: ascendingSortTooltip && (0, $6XJko.isVisualRefreshEnabled)() ? formatMessage(ascendingSortTooltip) : undefined,
                descendingSortTooltip: descendingSortTooltip && (0, $6XJko.isVisualRefreshEnabled)() ? formatMessage(descendingSortTooltip) : undefined
            };
        });
        const head = {
            cells: headCells
        };
        const ids = dataProvider ? dataProvider.getData().map((entity)=>dataProvider.idSelector(entity)) : entityIds;
        const tableAriaLabel = tableLabel ? formatMessage(tableLabel) : undefined;
        const rowCells = ids.map((entityId, rowIndex)=>{
            // the page is already sorted (by the API), so fake key,
            // so that DynamicTable won't destroy it
            const key = sortDirection === 'DESC' ? -(rowIndex + 1) : rowIndex + 1;
            const entity = dataProvider ? dataProvider.getData()[rowIndex] : undefined;
            const cells = tableConfiguration.map(({ Cell: Cell }, colIndex)=>{
                const content = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(Cell, {
                    id: entityId,
                    entity: entity,
                    isOperationInProgress: !!operationInitializationStatusPerEntity[entityId],
                    onOperationRequested: (operation, operationParams)=>this.props.onOperationRequested({
                            id: entityId,
                            childEntityId: operationParams && operationParams.childEntityId,
                            operation: operation
                        })
                });
                const getVisuallyRefreshedContent = (visuallyRefreshedContent)=>{
                    return visuallyRefreshedContent;
                };
                const cellMatch = getSpotlightForCell(entityId, colIndex);
                if (cellMatch && cellMatch.spotlightId) {
                    const onboardingContent = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $guChT.default), {
                        name: cellMatch.spotlightId
                    }, getVisuallyRefreshedContent(content));
                    return {
                        content: onboardingContent,
                        key: key
                    };
                }
                return {
                    content: getVisuallyRefreshedContent(content),
                    key: key
                };
            });
            return {
                cells: cells
            };
        });
        return(// Note: the data-test-id attribute is used by Pollinator checks in Jalapeno so avoid changing if possible
        /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($58d4afddfb7fcf61$var$Container, {
            "data-testId": "global-pages.directories.directory-base.content.table.container",
            firstColumnHeadingAlignment: firstColumnHeadingAlignment,
            lastColumnHeadingAlignment: lastColumnHeadingAlignment,
            visualRefreshEnabled: (0, $6XJko.isVisualRefreshEnabled)(),
            visuallyRefreshedHeight: (0, $6XJko.isVisualRefreshEnabled)()
        }, !isLoading && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $eS6Sp.default), {
            performanceMarkKey: mountMetricKey
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nw3F.AnnouncerV2), {
            message: formatMessage(resultsAnnouncerMessage || (0, $8TMMM.default).filterResultsAnnouncement, {
                itemCount: totalItems
            }),
            shouldAnnounce: !isLoading && this.state.shouldAnnounceResults
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $lOOiG.default), {
            isFixedSize: true,
            isLoading: isLoading,
            head: head,
            rows: rowCells,
            onSort: this.onSort,
            sortKey: sortField,
            sortOrder: sortDirection,
            emptyView: isLoading ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($58d4afddfb7fcf61$var$EmptyLoadingView, null) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(EmptyView, null),
            label: tableAriaLabel
        }), TableMaskView && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(TableMaskView, null)));
    }
    constructor(...args){
        super(...args), this.state = {
            hasSortingChanged: false,
            shouldAnnounceResults: false,
            returnFocusTo: null
        }, /**
   * We very much wish that `attrs` is an object of this type {| key: string, sortOrder: string |}
   * but unfortunately @atlaskit/dynamic-table types do not give any guarantee of that
   * so we should be handling mixed here.
   */ this.onSort = (attrs, analyticsEvent)=>{
            // @ts-expect-error - TS2339 - Property 'key' does not exist on type 'unknown'. | TS2339 - Property 'sortOrder' does not exist on type 'unknown'.
            const { key: key, sortOrder: sortOrder } = attrs;
            const { onSort: onSort } = this.props;
            if (analyticsEvent) (0, $kRgKj.fireUIAnalytics)(analyticsEvent, 'tableHeader', {
                key: key
            });
            onSort({
                sortField: key,
                sortDirection: sortOrder
            });
            this.setState({
                returnFocusTo: key
            });
        };
    }
}
var // @ts-expect-error - Argument of type 'typeof Table' is not assignable to parameter of type 'ComponentType<WithIntlProvided<Props<unknown, string, unknown, unknown>>> & typeof Table'.
$58d4afddfb7fcf61$export$2e2bcd8739ae039 = (0, $idGBm.injectIntlV2)($58d4afddfb7fcf61$var$Table);
const $58d4afddfb7fcf61$var$TABLE_ROW_HEIGHT = '40px'; // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $58d4afddfb7fcf61$var$NonBreakingCell = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_o5721q9c",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $58d4afddfb7fcf61$var$Container = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { firstColumnHeadingAlignment: firstColumnHeadingAlignment, visuallyRefreshedHeight: visuallyRefreshedHeight, visualRefreshEnabled: visualRefreshEnabled, lastColumnHeadingAlignment: lastColumnHeadingAlignment, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmpldp,
        style: {
            ...__cmpls,
            "--_1bgnkvw": (0, $awdRS.default)(__cmplp.firstColumnHeadingAlignment),
            "--_xer3jx": (0, $awdRS.default)(__cmplp.visuallyRefreshedHeight ? '16px' : '14px'),
            "--_w6gjp2": (0, $awdRS.default)(__cmplp.visualRefreshEnabled ? '16px' : '14px'),
            "--_jlq5ur": (0, $awdRS.default)(__cmplp.lastColumnHeadingAlignment)
        },
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_kqswh2mm _2ws7jp4b _p4liidpf _6autidpf _7dd61ux8 _13jcr73l _496i159m _9yen1pfg _10wbnkob _jwot4jg8",
            __cmplp.visualRefreshEnabled && "_19ib1qi0 _y4woe4h9 _oaa6nqa1 _10okmuej _cnoh1vhk _1o7fzgxb _1m2zqbzx _1cuj1ylp _4lbnglyw _1ttwzgxb _qass1qi0 _1g001qi0",
            __cmplp.className
        ])
    });
});
const $58d4afddfb7fcf61$var$styles = {
    headerWrapper: "_19bvu2gc _u5f31b66 _ca0q1b66 _n3td1b66",
    headerWrapperOld: "_18zr1b66 _1rjcu2gc _4cvr1h6o _1bah1h6o _1bsbzwfg"
}; // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $58d4afddfb7fcf61$var$EmptyLoadingView = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_4t3i1w81",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $58d4afddfb7fcf61$var$HeaderWrapper = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_1e0c1o8l",
            __cmplp.className
        ])
    });
});

});
parcelRegister("lOOiG", function(module, exports) {
$parcel$export(module.exports, "default", () => $976d89647138dbc1$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $jrFnt = parcelRequire("jrFnt");

var $3Vuhz = parcelRequire("3Vuhz");


var $aXVGO = parcelRequire("aXVGO");

var $khVsD = parcelRequire("khVsD");

var $1NCSA = parcelRequire("1NCSA");

var $bEPjZ = parcelRequire("bEPjZ");

var $04ZiM = parcelRequire("04ZiM");

var $foLeX = parcelRequire("foLeX");

var $goxGh = parcelRequire("goxGh");

var $5hPH6 = parcelRequire("5hPH6");

var $iXYwm = parcelRequire("iXYwm");
function $976d89647138dbc1$var$toggleSortOrder(currentSortOrder) {
    switch(currentSortOrder){
        case 0, $861def5c205d1816$export$b6abcf7fa1d94f65:
            return 0, $861def5c205d1816$export$1dee026a19752d6b;
        case 0, $861def5c205d1816$export$1dee026a19752d6b:
            return 0, $861def5c205d1816$export$b6abcf7fa1d94f65;
        default:
            return currentSortOrder;
    }
}
const $976d89647138dbc1$var$DynamicTable = ({ caption: caption, head: head, highlightedRowIndex: highlightedRowIndex, rows: rows, sortKey: sortKey, sortOrder: sortOrder, loadingLabel: loadingLabel, onPageRowsUpdate: onPageRowsUpdate, testId: testId, totalRows: passedDownTotalRows, label: label, isLoading: isLoading = false, isFixedSize: isFixedSize = false, rowsPerPage: rowsPerPage = Infinity, onSetPage: onSetPage = (0, $3Vuhz.default), onSort: providedOnSort = (0, $3Vuhz.default), page: page = 1, emptyView: emptyView, isRankable: isRankable = false, isRankingDisabled: isRankingDisabled = false, onRankStart: onRankStart = (0, $3Vuhz.default), onRankEnd: providedOnRankEnd = (0, $3Vuhz.default), loadingSpinnerSize: loadingSpinnerSize, paginationi18n: paginationi18n = {
    prev: 'Previous Page',
    next: 'Next Page',
    // eslint-disable-next-line @atlassian/i18n/no-literal-string-in-object
    label: 'Pagination',
    pageLabel: 'Page'
} })=>{
    const [isRanking, setIsRanking] = (0, $eJOHy.useState)(false);
    const tableBodyRef = (0, $eJOHy.useRef)(null);
    const onSort = (0, $jrFnt.usePlatformLeafEventHandler)({
        fn: providedOnSort,
        action: 'sorted',
        componentName: 'dynamicTable',
        packageName: "platform-pkg",
        packageVersion: "0.0.0-use.local"
    });
    const onRankEnd = (0, $jrFnt.usePlatformLeafEventHandler)({
        fn: providedOnRankEnd,
        action: 'ranked',
        componentName: 'dynamicTable',
        packageName: "platform-pkg",
        packageVersion: "0.0.0-use.local"
    });
    (0, $eJOHy.useEffect)(()=>{
        (0, $aXVGO.validateSortKey)(sortKey, head);
        (0, $aXVGO.assertIsSortable)(head);
    }, [
        sortKey,
        head
    ]);
    const onSortHandler = (item)=>()=>{
            const { key: key } = item;
            if (!key) return;
            if (onSort && isRankable && key === sortKey && sortOrder === (0, $861def5c205d1816$export$b6abcf7fa1d94f65)) {
                onSort({
                    key: null,
                    sortOrder: null,
                    item: item
                });
                return;
            }
            const sortOrderFormatted = key !== sortKey ? (0, $861def5c205d1816$export$1dee026a19752d6b) : $976d89647138dbc1$var$toggleSortOrder(sortOrder);
            if (onSort) onSort({
                key: key,
                item: item,
                sortOrder: sortOrderFormatted
            });
        };
    const onSetPageHandler = (page, event)=>{
        onSetPage(page, event);
    };
    const onRankStartHandler = (params)=>{
        setIsRanking(true);
        onRankStart(params);
    };
    const onRankEndHandler = (params)=>{
        setIsRanking(false);
        onRankEnd(params);
    };
    const getSpinnerSize = ()=>{
        if (loadingSpinnerSize) return loadingSpinnerSize;
        return (0, $aXVGO.getPageRows)(rows || [], page, rowsPerPage).length > 2 ? (0, $861def5c205d1816$export$7b93a10c0fefe3e3) : (0, $861def5c205d1816$export$71dd4c8ecd45e95f);
    };
    const renderEmptyBody = ()=>{
        if (isLoading) return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $1NCSA.EmptyViewWithFixedHeight), {
            testId: testId
        });
        return emptyView && /*#__PURE__*/ (0, $gt9Am.jsx)((0, $1NCSA.EmptyViewContainer), {
            testId: testId,
            children: emptyView
        });
    };
    const rowsLength = rows && rows.length;
    let totalPages;
    // set a flag to denote the dynamic table might get only one page of data
    // for paginated data
    let isTotalPagesControlledExternally = false;
    if (passedDownTotalRows && Number.isInteger(passedDownTotalRows) && rowsPerPage && rowsLength && rowsLength <= passedDownTotalRows) {
        /**
     * If total number of rows / records have been passed down as prop
     * Then table is being fed paginated data from server or other sources
     * In this case, we want to respect information passed down by server or external source
     * Rather than relying on our computation based on number of rows
     */ totalPages = Math.ceil(passedDownTotalRows / rowsPerPage);
        isTotalPagesControlledExternally = true;
    } else totalPages = rowsLength && rowsPerPage ? Math.ceil(rowsLength / rowsPerPage) : 0;
    totalPages = totalPages < 1 ? 1 : totalPages;
    const getPageNumber = page > totalPages ? totalPages : page; // page! required, because typescript can't yet see defaultProps to know that this won't be undefined
    const rowsExist = !!rowsLength;
    const spinnerSize = getSpinnerSize();
    const emptyBody = renderEmptyBody();
    return /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $gt9Am.Fragment), {
        children: [
            /*#__PURE__*/ (0, $gt9Am.jsx)((0, $goxGh.default), {
                isLoading: isLoading && rowsExist,
                spinnerSize: spinnerSize,
                targetRef: ()=>tableBodyRef.current,
                testId: testId,
                loadingLabel: loadingLabel,
                children: /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $khVsD.Table), {
                    isFixedSize: isFixedSize,
                    "aria-label": label,
                    hasDataRow: rowsExist,
                    testId: testId,
                    isLoading: isLoading,
                    children: [
                        !!caption && /*#__PURE__*/ (0, $gt9Am.jsx)((0, $khVsD.Caption), {
                            children: caption
                        }),
                        head && /*#__PURE__*/ (0, $gt9Am.jsx)((0, $iXYwm.default), {
                            head: head,
                            onSort: onSortHandler,
                            sortKey: sortKey,
                            sortOrder: sortOrder,
                            isRanking: isRanking,
                            isRankable: isRankable,
                            testId: testId
                        }),
                        rowsExist && /*#__PURE__*/ (0, $gt9Am.jsx)($976d89647138dbc1$var$TableBody, {
                            ref: tableBodyRef,
                            highlightedRowIndex: highlightedRowIndex,
                            rows: rows,
                            head: head,
                            sortKey: sortKey,
                            sortOrder: sortOrder,
                            rowsPerPage: rowsPerPage,
                            page: getPageNumber,
                            isFixedSize: isFixedSize || false,
                            onPageRowsUpdate: onPageRowsUpdate,
                            isTotalPagesControlledExternally: isTotalPagesControlledExternally,
                            testId: testId,
                            isRankable: isRankable,
                            isRanking: isRanking,
                            onRankStart: onRankStartHandler,
                            onRankEnd: onRankEndHandler,
                            isRankingDisabled: isRankingDisabled || isLoading || false
                        })
                    ]
                })
            }),
            totalPages <= 1 ? null : // only show pagination if there's MORE than 1 page
            /*#__PURE__*/ (0, $gt9Am.jsx)((0, $khVsD.PaginationWrapper), {
                testId: testId,
                children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $5hPH6.default), {
                    value: getPageNumber,
                    onChange: onSetPageHandler,
                    total: totalPages,
                    i18n: paginationi18n,
                    isDisabled: isLoading,
                    testId: testId
                })
            }),
            !rowsExist && emptyBody && /*#__PURE__*/ (0, $gt9Am.jsx)((0, $foLeX.default), {
                isLoading: isLoading,
                spinnerSize: (0, $861def5c205d1816$export$7b93a10c0fefe3e3),
                testId: testId,
                loadingLabel: loadingLabel,
                children: emptyBody
            })
        ]
    });
};

const $976d89647138dbc1$var$RankableTableBody = /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("itCCG")));
const $976d89647138dbc1$var$TableBody = /*#__PURE__*/ (0, $eJOHy.forwardRef)(function TableBody({ isRankable: isRankable = false, isRanking: isRanking, onRankStart: onRankStart, onRankEnd: onRankEnd, isRankingDisabled: isRankingDisabled, ...bodyProps }, ref) {
    const canRank = isRankable && !bodyProps.sortKey;
    /**
   * React 16 does not support SSR for lazy components,
   * so we avoid rendering the `Suspense` on the server.
   */ const [canRenderRankable, setCanRenderRankable] = (0, $eJOHy.useState)(false);
    (0, $eJOHy.useEffect)(()=>{
        if (canRank) setCanRenderRankable(true);
    }, [
        canRank
    ]);
    const nonRankableBody = /*#__PURE__*/ (0, $gt9Am.jsx)((0, $bEPjZ.default), {
        ref: ref,
        ...bodyProps
    });
    return canRank && canRenderRankable ? /*#__PURE__*/ (0, $gt9Am.jsx)((0, $04ZiM.ErrorBoundary), {
        fallback: nonRankableBody,
        children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $eJOHy.Suspense), {
            fallback: nonRankableBody,
            children: /*#__PURE__*/ (0, $gt9Am.jsx)($976d89647138dbc1$var$RankableTableBody, {
                ref: ref,
                ...bodyProps,
                isRanking: isRanking,
                onRankStart: onRankStart,
                onRankEnd: onRankEnd,
                isRankingDisabled: isRankingDisabled
            })
        })
    }) : nonRankableBody;
});
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$976d89647138dbc1$export$2e2bcd8739ae039 = $976d89647138dbc1$var$DynamicTable;

});
const $861def5c205d1816$export$1dee026a19752d6b = 'ASC';
const $861def5c205d1816$export$b6abcf7fa1d94f65 = 'DESC';
const $861def5c205d1816$export$71dd4c8ecd45e95f = 'small';
const $861def5c205d1816$export$7b93a10c0fefe3e3 = 'large';
const $861def5c205d1816$export$3843c586a90b9cbf = 0.22;

parcelRegister("aXVGO", function(module, exports) {
$parcel$export(module.exports, "getPageRows", () => $d0bfac7c95a14ce3$export$3987dc24b734dcab);
$parcel$export(module.exports, "assertIsSortable", () => $d0bfac7c95a14ce3$export$5eb35a4771ec4090);
$parcel$export(module.exports, "validateSortKey", () => $d0bfac7c95a14ce3$export$9133f5a8bfe8a200);
$parcel$export(module.exports, "inlineStylesIfRanking", () => $d0bfac7c95a14ce3$export$a601f1775e10043f);
$parcel$export(module.exports, "reorderRows", () => $d0bfac7c95a14ce3$export$c476bbe5da59992d);
const $d0bfac7c95a14ce3$export$3987dc24b734dcab = (allRows, pageNumber, rowsPerPage)=>{
    if (!pageNumber || !rowsPerPage || !allRows.length) return [];
    return allRows.slice((pageNumber - 1) * rowsPerPage, pageNumber * rowsPerPage);
};
const $d0bfac7c95a14ce3$export$5eb35a4771ec4090 = (head)=>{
    if (!head || !head.cells) return;
    head.cells.forEach((cell)=>{
        if (cell.isSortable && !cell.key) try {
            throw Error("isSortable can't be set to true, if the 'key' prop is missing.");
        } catch (e) {
            // eslint-disable-next-line no-console
            console.error(e);
        }
    });
};
const $d0bfac7c95a14ce3$export$9133f5a8bfe8a200 = (sortKey, head)=>{
    if (!sortKey) return;
    const headHasKey = head && head.cells.map((cell)=>cell.key).includes(sortKey);
    if (!headHasKey) try {
        throw Error(`Cell with ${sortKey} key not found in head.`);
    } catch (e) {
        // eslint-disable-next-line no-console
        console.error(e);
    }
};
const $d0bfac7c95a14ce3$export$a601f1775e10043f = (isRanking, width, height)=>{
    if (!isRanking) return {};
    if (height) return {
        width: width,
        height: height
    };
    return {
        width: width
    };
};
const $d0bfac7c95a14ce3$export$92bcb1ed38b134a1 = (index, page, rowsPerPage)=>{
    const itemOnPreviousPages = rowsPerPage && isFinite(rowsPerPage) ? (page - 1) * rowsPerPage : 0;
    return index + itemOnPreviousPages;
};
const $d0bfac7c95a14ce3$export$c476bbe5da59992d = (rankEnd, rows, page = 1, rowsPerPage)=>{
    const { destination: destination, sourceIndex: sourceIndex } = rankEnd;
    if (!destination) return rows;
    const fromIndex = $d0bfac7c95a14ce3$export$92bcb1ed38b134a1(sourceIndex, page, rowsPerPage);
    const toIndex = $d0bfac7c95a14ce3$export$92bcb1ed38b134a1(destination.index, page, rowsPerPage);
    const reordered = rows.slice();
    const [removed] = reordered.splice(fromIndex, 1);
    reordered.splice(toIndex, 0, removed);
    return reordered;
};

});

parcelRegister("khVsD", function(module, exports) {
$parcel$export(module.exports, "Table", () => $fd7ebbab92fbe669$export$54ec01a60f47d33d);
$parcel$export(module.exports, "Caption", () => $fd7ebbab92fbe669$export$32fbfacc5d962e0c);
$parcel$export(module.exports, "PaginationWrapper", () => $fd7ebbab92fbe669$export$3e5e12dc01f20a43);
/* dynamic-table.tsx generated by @compiled/babel-plugin v0.36.1 */ /* eslint-disable @repo/internal/react/require-jsdoc */ 
var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");
const $fd7ebbab92fbe669$var$fixedSizeTableStyles = null;
const $fd7ebbab92fbe669$var$tableStyles = null;
const $fd7ebbab92fbe669$var$bodyBorder = null;
const $fd7ebbab92fbe669$export$54ec01a60f47d33d = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ isFixedSize: isFixedSize, hasDataRow: hasDataRow, children: children, testId: testId, isLoading: isLoading, ...rest }, ref)=>{
    return /*#__PURE__*/ (0, $gt9Am.jsx)("table", {
        inert: isLoading ? '' : undefined,
        style: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            '--local-dynamic-table-hover-bg': "var(--ds-background-neutral-subtle-hovered, #091E420F)",
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            '--local-dynamic-table-highlighted-bg': "var(--ds-background-selected, #E9F2FF)",
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            '--local-dynamic-table-hover-highlighted-bg': "var(--ds-background-selected-hovered, #CCE0FF)",
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            '--local-dynamic-table-row-focus-outline': "var(--ds-border-focused, #388BFF)"
        },
        ref: ref,
        ...rest,
        "data-testid": testId && `${testId}--table`,
        className: (0, $hcewu.default)([
            "_1bsb1osq _yq5h18uv _btyzidpf _ect41gqc",
            isFixedSize && "_1kqm1n9t",
            hasDataRow && "_179r187z"
        ]),
        children: children
    });
});
const $fd7ebbab92fbe669$var$captionStyles = null;
const $fd7ebbab92fbe669$export$32fbfacc5d962e0c = ({ children: children })=>/*#__PURE__*/ (0, $gt9Am.jsx)("caption", {
        className: (0, $hcewu.default)([
            "_11c8lodh _6rthu2gc _1pfh1ejb _m6k41e03"
        ]),
        children: children
    });
const $fd7ebbab92fbe669$var$paginationWrapperStyles = null;
const $fd7ebbab92fbe669$export$3e5e12dc01f20a43 = ({ children: children, testId: testId })=>/*#__PURE__*/ (0, $gt9Am.jsx)("div", {
        "data-testid": testId && `${testId}--pagination--container`,
        className: (0, $hcewu.default)([
            "_1e0c1txw _1bah1h6o"
        ]),
        children: children
    });

});

parcelRegister("1NCSA", function(module, exports) {
$parcel$export(module.exports, "EmptyViewWithFixedHeight", () => $b2a7a5f88e6f100c$export$8f45b9407d4090d7);
$parcel$export(module.exports, "EmptyViewContainer", () => $b2a7a5f88e6f100c$export$381ea436de119582);
/* empty-body.tsx generated by @compiled/babel-plugin v0.36.1 */ /* eslint-disable @repo/internal/react/require-jsdoc */ 
var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");
const $b2a7a5f88e6f100c$var$fixedHeightStyles = null;
const $b2a7a5f88e6f100c$export$8f45b9407d4090d7 = ({ children: children, testId: testId })=>/*#__PURE__*/ (0, $gt9Am.jsx)("div", {
        "data-testid": testId && `${testId}--empty-view-with-fixed-height`,
        className: (0, $hcewu.default)([
            "_4t3i1jdh"
        ]),
        children: children
    });
const $b2a7a5f88e6f100c$var$emptyViewContainerStyles = null;
const $b2a7a5f88e6f100c$export$381ea436de119582 = (props)=>{
    const { children: children, testId: testId } = props;
    return /*#__PURE__*/ (0, $gt9Am.jsx)("div", {
        "data-testid": testId && `${testId}--empty-view-container`,
        className: (0, $hcewu.default)([
            "_19pk1wug _2hwx1wug _otyr1wug _18u01wug _ca0q19bv _u5f319bv _n3td19bv _19bv19bv _1bsb1ssb _y3gn1h6o"
        ]),
        children: children
    });
};

});

parcelRegister("bEPjZ", function(module, exports) {
$parcel$export(module.exports, "default", () => $2c021f4be43795a4$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $jNhOC = parcelRequire("jNhOC");

var $lW0bH = parcelRequire("lW0bH");
// eslint-disable-next-line @repo/internal/react/no-class-components
class $2c021f4be43795a4$var$BodyComponent extends (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Component {
    render() {
        const { pageRows: pageRows, head: head, isFixedSize: isFixedSize, highlightedRowIndex: highlightedRowIndex, testId: testId, forwardedRef: forwardedRef } = this.props;
        return /*#__PURE__*/ (0, $gt9Am.jsx)("tbody", {
            "data-testid": testId && `${testId}--body`,
            ref: forwardedRef,
            children: pageRows.map((row, rowIndex)=>/*#__PURE__*/ (0, $gt9Am.jsx)((0, $lW0bH.default), {
                    head: head,
                    isFixedSize: isFixedSize,
                    row: row,
                    isHighlighted: row.isHighlighted || !!highlightedRowIndex && (typeof highlightedRowIndex === 'number' ? highlightedRowIndex === rowIndex : highlightedRowIndex.indexOf(rowIndex) > -1),
                    testId: testId
                }, row.key || rowIndex))
        });
    }
}
const $2c021f4be43795a4$var$Body = (0, $jNhOC.default)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).forwardRef((props, ref)=>{
    return /*#__PURE__*/ (0, $gt9Am.jsx)($2c021f4be43795a4$var$BodyComponent, {
        ...props,
        forwardedRef: ref
    });
}));
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$2c021f4be43795a4$export$2e2bcd8739ae039 = $2c021f4be43795a4$var$Body;

});
parcelRegister("jNhOC", function(module, exports) {
$parcel$export(module.exports, "default", () => $835026024c70c744$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");


var $aXVGO = parcelRequire("aXVGO");
const $835026024c70c744$var$getSortingCellValue = (cells, head, sortKey)=>{
    for(let i = 0; i < cells.length; i++){
        if (head.cells[i] && head.cells[i]?.key === sortKey) return cells[i]?.key;
    }
    return undefined;
};
// sort all rows based on sort key and order
const $835026024c70c744$var$getSortedRows = (head, rows, sortKey, sortOrder)=>{
    if (!sortKey || !head) return rows;
    if (!rows) return [];
    const modifier = sortOrder === (0, $861def5c205d1816$export$1dee026a19752d6b) ? 1 : -1;
    // Re-initialising an I18n Collator on every sort is performance intensive, thus constructed outside
    const collator = new Intl.Collator(undefined, {
        numeric: true,
        sensitivity: 'accent'
    });
    // Get copy of rows to avoid sorting prop in place
    const sortableRows = Array.from(rows);
    // Reorder rows in table based on sorting cell value
    // Algorithm will sort numerics or strings, but not both
    return sortableRows.sort((a, b)=>{
        const valA = $835026024c70c744$var$getSortingCellValue(a.cells, head, sortKey);
        const valB = $835026024c70c744$var$getSortingCellValue(b.cells, head, sortKey);
        if (valA === undefined || valB === undefined) return modifier;
        if (typeof valA !== typeof valB) {
            // numbers are always grouped higher in the sort
            if (typeof valA === 'number') return -1;
            if (typeof valB === 'number') return 1;
            // strings are grouped next
            if (typeof valA === 'string') return -1;
            if (typeof valB === 'string') return 1;
        }
        if (typeof valA === 'string' && typeof valB === 'string') return modifier * collator.compare(valA, valB);
        if (!valA && valA !== 0 || valA < valB) return -modifier;
        if (!valB && valB !== 0 || valA > valB) return modifier;
        if (valA === valB) return 0;
        return 1;
    });
};
function $835026024c70c744$export$2e2bcd8739ae039(WrappedComponent) {
    // eslint-disable-next-line @repo/internal/react/no-class-components
    class WithSortedPageRows extends (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Component {
        static getDerivedStateFromProps(props, state) {
            const { rows: rows, head: head, sortKey: sortKey, sortOrder: sortOrder, page: page, rowsPerPage: rowsPerPage, isTotalPagesControlledExternally: isTotalPagesControlledExternally } = props;
            (0, $aXVGO.validateSortKey)(sortKey, head);
            let sortedRows;
            let pageRows;
            if (isTotalPagesControlledExternally) {
                sortedRows = rows;
                pageRows = rows;
            } else {
                sortedRows = $835026024c70c744$var$getSortedRows(head, rows, sortKey, sortOrder) || [];
                pageRows = (0, $aXVGO.getPageRows)(sortedRows, page, rowsPerPage);
            }
            return {
                ...state,
                pageRows: pageRows
            };
        }
        componentDidMount() {
            this.props.onPageRowsUpdate && this.props.onPageRowsUpdate(this.state.pageRows);
        }
        componentDidUpdate(_prevProps, prevState) {
            if (this.props.onPageRowsUpdate && this.state.pageRows !== prevState.pageRows) this.props.onPageRowsUpdate(this.state.pageRows);
        }
        render() {
            const { rows: rows, head: head, sortKey: sortKey, sortOrder: sortOrder, rowsPerPage: rowsPerPage, page: page, forwardedRef: forwardedRef, ...restProps } = this.props;
            return /*#__PURE__*/ (0, $gt9Am.jsx)(WrappedComponent, {
                //@ts-expect-error TODO Fix legit TypeScript 3.9.6 improved inference error
                pageRows: this.state.pageRows,
                head: head,
                ...restProps,
                ref: forwardedRef
            });
        }
        constructor(...args){
            super(...args), this.state = {
                pageRows: []
            };
        }
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).forwardRef((props, ref)=>{
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore: to unblock React 18.2.0 -> 18.3.1 version bump in Jira
        return /*#__PURE__*/ (0, $gt9Am.jsx)(WithSortedPageRows, {
            ...props,
            forwardedRef: ref
        });
    });
}

});

parcelRegister("lW0bH", function(module, exports) {
$parcel$export(module.exports, "default", () => $c4bfc9d23dedd74e$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $5ljLr = parcelRequire("5ljLr");

var $268TF = parcelRequire("268TF");
const $c4bfc9d23dedd74e$var$Row = ({ row: row, head: head, testId: testId, isFixedSize: isFixedSize, isHighlighted: isHighlighted })=>{
    const { cells: cells, ...restRowProps } = row;
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $268TF.TableBodyRow), {
        ...restRowProps,
        isHighlighted: isHighlighted,
        ...isHighlighted ? {
            'data-ts--dynamic-table--table-row--highlighted': true
        } : null,
        testId: row.testId || testId && `${testId}--row-${restRowProps.key}`,
        children: cells.map((cell, cellIndex)=>{
            const { content: content, testId: cellTestId, ...restCellProps } = cell;
            const { shouldTruncate: shouldTruncate, width: width } = (head || {
                cells: []
            }).cells[cellIndex] || {};
            return /*#__PURE__*/ (0, $eJOHy.createElement)((0, $5ljLr.TableBodyCell), {
                "data-testid": cellTestId || testId && `${testId}--cell-${cellIndex}`,
                ...restCellProps,
                isFixedSize: isFixedSize,
                key: cellIndex,
                shouldTruncate: shouldTruncate,
                width: width
            }, content);
        })
    });
};
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$c4bfc9d23dedd74e$export$2e2bcd8739ae039 = $c4bfc9d23dedd74e$var$Row;

});
parcelRegister("5ljLr", function(module, exports) {
$parcel$export(module.exports, "TableBodyCell", () => $6d87de66ba7880ae$export$948e91fcef170792);
/* table-cell.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $1eoPo = parcelRequire("1eoPo");
const $6d87de66ba7880ae$var$fixedSizeTruncateStyles = null;
const $6d87de66ba7880ae$var$overflowTruncateStyles = null;
const $6d87de66ba7880ae$var$truncationWidthStyles = null;
const $6d87de66ba7880ae$var$cellStyles = null;
const $6d87de66ba7880ae$export$948e91fcef170792 = ({ width: width, isFixedSize: isFixedSize, shouldTruncate: shouldTruncate, innerRef: innerRef, ...props })=>/*#__PURE__*/ (0, $gt9Am.jsx)("td", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        style: (0, $1eoPo.getTruncationStyleVars)({
            width: width
        }),
        // HOC withDimensions complains about the types but it is working fine
        // @ts-ignore
        ref: innerRef,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
        className: (0, $hcewu.default)([
            "_1bsb8a2a",
            isFixedSize && shouldTruncate && "_1bto1l2s _o5721q9c",
            isFixedSize && "_1reo15vq _18m915vq",
            "_19itglyw _85i51b66 _1q511b66 _y4tiu2gc _bozgu2gc _y3gn1e5h _1s37ze3t _uupyze3t",
            props.className
        ]),
        ...props
    });

});
parcelRegister("1eoPo", function(module, exports) {
$parcel$export(module.exports, "getTruncationStyleVars", () => $91687adffdb20f71$export$5e6497a652ae30b5);
const $91687adffdb20f71$var$CSS_VAR_WIDTH = '--local-dynamic-table-width';
const $91687adffdb20f71$export$5e6497a652ae30b5 = ({ width: width })=>typeof width !== 'undefined' ? {
        [$91687adffdb20f71$var$CSS_VAR_WIDTH]: `${width}%`
    } : undefined;

});


parcelRegister("268TF", function(module, exports) {
$parcel$export(module.exports, "TableBodyRow", () => $a53c59e604030c6d$export$45f39d9c38b886d5);
/* table-row.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");
const $a53c59e604030c6d$var$rowStyles = null;
const $a53c59e604030c6d$var$rowBackgroundStyles = null;
const $a53c59e604030c6d$var$rowHighlightedBackgroundStyles = null;
const $a53c59e604030c6d$export$45f39d9c38b886d5 = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ isHighlighted: isHighlighted, children: children, style: style, testId: testId, className: className, ...rest }, ref)=>{
    return /*#__PURE__*/ (0, $gt9Am.jsx)("tr", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        style: style,
        /**
   * We rely on this `className` for the `RankableTableBodyRow` to apply extra styles.
   * With Compiled it needs to be statically analyzable. It does not get applied via spread props.
   */ // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
        className: (0, $hcewu.default)([
            "_bfhk1w7a _1ygbsglb _1ah312gs",
            isHighlighted ? "_bfhktkjs _irr31ae3" : "_irr3s8ts",
            className
        ]),
        ...rest,
        ref: ref,
        "data-testid": testId,
        children: children
    });
});

});



parcelRegister("04ZiM", function(module, exports) {
$parcel$export(module.exports, "ErrorBoundary", () => $fd6eb2a47216dc9b$export$e926676385687eaf);

var $eJOHy = parcelRequire("eJOHy");
class $fd6eb2a47216dc9b$export$e926676385687eaf extends (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Component {
    constructor(props){
        super(props);
        this.state = {
            hasError: false
        };
    }
    static getDerivedStateFromError() {
        // Update state so the next render will show the fallback UI.
        return {
            hasError: true
        };
    }
    render() {
        if (this.state.hasError) // You can render any custom fallback UI
        return this.props.fallback;
        return this.props.children;
    }
}

});

parcelRegister("foLeX", function(module, exports) {
$parcel$export(module.exports, "default", () => $7869f2e695a66a65$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $7ep4S = parcelRequire("7ep4S");


var $CEHHO = parcelRequire("CEHHO");
class $7869f2e695a66a65$export$2e2bcd8739ae039 extends (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Component {
    static{
        this.defaultProps = {
            isLoading: true,
            spinnerSize: (0, $861def5c205d1816$export$7b93a10c0fefe3e3),
            contentsOpacity: (0, $861def5c205d1816$export$3843c586a90b9cbf),
            loadingLabel: 'Loading table'
        };
    }
    render() {
        const { children: children, isLoading: isLoading, spinnerSize: spinnerSize, contentsOpacity: contentsOpacity, testId: testId, loadingLabel: loadingLabel } = this.props;
        return /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $CEHHO.Container), {
            testId: testId,
            children: [
                !isLoading ? children : /*#__PURE__*/ (0, $gt9Am.jsx)((0, $CEHHO.ContentsContainer), {
                    contentsOpacity: contentsOpacity,
                    testId: testId,
                    children: children
                }),
                isLoading && /*#__PURE__*/ (0, $gt9Am.jsx)((0, $CEHHO.SpinnerContainer), {
                    testId: testId,
                    children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $7ep4S.default), {
                        size: spinnerSize,
                        testId: testId && `${testId}--loadingSpinner`,
                        label: loadingLabel
                    })
                })
            ]
        });
    }
}

});
parcelRegister("CEHHO", function(module, exports) {
$parcel$export(module.exports, "Container", () => $dfc2e003c707e1fb$export$42a852a2b6b56249);
$parcel$export(module.exports, "ContentsContainer", () => $dfc2e003c707e1fb$export$67c29eae8ae2137a);
$parcel$export(module.exports, "SpinnerContainer", () => $dfc2e003c707e1fb$export$a5e06607a5ac6158);
/* loading-container.tsx generated by @compiled/babel-plugin v0.36.1 */ /* eslint-disable @repo/internal/react/require-jsdoc */ 
var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");
const $dfc2e003c707e1fb$export$c335a80381ec61f5 = '--contents-opacity';
const $dfc2e003c707e1fb$var$containerStyles = null;
const $dfc2e003c707e1fb$export$42a852a2b6b56249 = ({ children: children, testId: testId })=>/*#__PURE__*/ (0, $gt9Am.jsx)("div", {
        "data-testid": testId && `${testId}--container`,
        className: (0, $hcewu.default)([
            "_kqswh2mm"
        ]),
        children: children
    });
const $dfc2e003c707e1fb$var$contentsContainerStyles = null;
const $dfc2e003c707e1fb$export$67c29eae8ae2137a = ({ children: children, contentsOpacity: contentsOpacity, testId: testId })=>/*#__PURE__*/ (0, $gt9Am.jsx)("div", {
        style: {
            [$dfc2e003c707e1fb$export$c335a80381ec61f5]: contentsOpacity
        },
        "data-testid": testId && `${testId}--contents--container`,
        className: (0, $hcewu.default)([
            "_tzy4saf5 _lcxvglyw"
        ]),
        children: children
    });
const $dfc2e003c707e1fb$var$spinnerContainerStyles = null;
const $dfc2e003c707e1fb$export$a5e06607a5ac6158 = ({ children: children, testId: testId })=>/*#__PURE__*/ (0, $gt9Am.jsx)("div", {
        "data-testid": testId && `${testId}--spinner--container`,
        className: (0, $hcewu.default)([
            "_1r04idpf _1e0c1txw _kqswstnw _4cvr1h6o _1bah1h6o"
        ]),
        children: children
    });

});


parcelRegister("goxGh", function(module, exports) {
$parcel$export(module.exports, "default", () => $313fee558443ede2$export$2e2bcd8739ae039);
/* eslint-disable @repo/internal/dom-events/no-unsafe-event-listeners */ 
var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $7ep4S = parcelRequire("7ep4S");


var $3rtaW = parcelRequire("3rtaW");
class $313fee558443ede2$export$2e2bcd8739ae039 extends (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Component {
    static{
        this.defaultProps = {
            isLoading: true,
            spinnerSize: (0, $861def5c205d1816$export$7b93a10c0fefe3e3),
            contentsOpacity: `var(--ds-opacity-loading, ${`${0, $861def5c205d1816$export$3843c586a90b9cbf}`})`,
            loadingLabel: 'Loading table'
        };
    }
    attachListeners() {
        window.addEventListener('scroll', this.handleScroll);
        window.addEventListener('resize', this.handleResize);
    }
    detachListeners() {
        window.removeEventListener('scroll', this.handleScroll);
        window.removeEventListener('resize', this.handleResize);
    }
    updateSpinnerPosition() {
        const viewportHeight = window.innerHeight;
        const targetNode = this.getTargetNode();
        const spinnerNode = this.spinnerRef?.current;
        if (!targetNode || typeof targetNode.getBoundingClientRect !== 'function' || !spinnerNode) return;
        const targetRect = targetNode.getBoundingClientRect();
        const spinnerRect = spinnerNode.getBoundingClientRect();
        const spinnerHeight = spinnerRect.height;
        const isInViewport = this.isVerticallyVisible(targetRect, viewportHeight);
        const { top: top, bottom: bottom, height: height } = targetRect;
        if (isInViewport) {
            // The spinner may follow the element only if there is enough space:
            // Let's say the element can fit at least three spinners (vertically)
            const canFollow = height >= spinnerHeight * 3;
            if (canFollow && !this.isFullyVerticallyVisible(targetRect, viewportHeight)) {
                if (top >= 0) {
                    // Only the head of the element is visible
                    const viewportSpaceTakenByElement = viewportHeight - top;
                    const diff = viewportSpaceTakenByElement / 2 + top - spinnerHeight / 2;
                    const y = viewportSpaceTakenByElement < spinnerHeight * 3 ? top + spinnerHeight : diff;
                    this.translateSpinner(spinnerNode, y, true);
                } else if (top < 0 && bottom > viewportHeight) {
                    // The element takes all viewport, nor its head nor tail are visible
                    const y = viewportHeight / 2 - spinnerHeight / 2;
                    this.translateSpinner(spinnerNode, y, true);
                } else {
                    // Only the tail of the element is visible
                    const diff = bottom / 2 - spinnerHeight / 2;
                    const y = diff < spinnerHeight ? diff - (spinnerHeight - diff) : diff;
                    this.translateSpinner(spinnerNode, y, true);
                }
                return;
            }
        } else {
            // If both the element and the spinner are off screen - quit
            if (!this.isVerticallyVisible(spinnerRect, viewportHeight)) return;
        }
        // Three options here:
        // 1) the element is fully visible
        // 2) the element is too small for the spinner to follow
        // 3) the spinner might still be visible while the element isn't
        const containerNode = this.containerRef?.current;
        if (containerNode && typeof containerNode.getBoundingClientRect === 'function') {
            const thisTop = containerNode.getBoundingClientRect().top;
            const y = (top - thisTop) / 2;
            this.translateSpinner(spinnerNode, y, false);
        }
    }
    render() {
        const { children: children, isLoading: isLoading, spinnerSize: spinnerSize, testId: testId, loadingLabel: loadingLabel } = this.props;
        return /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $3rtaW.Container), {
            testId: testId && `${testId}--loading--container--advanced`,
            ref: this.containerRef,
            children: [
                children,
                isLoading && /*#__PURE__*/ (0, $gt9Am.jsx)((0, $3rtaW.SpinnerBackdrop), {
                    testId: testId,
                    children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $3rtaW.SpinnerContainer), {
                        ref: this.spinnerRef,
                        children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $7ep4S.default), {
                            size: spinnerSize,
                            testId: testId && `${testId}--loadingSpinner`,
                            label: loadingLabel
                        })
                    })
                })
            ]
        });
    }
    constructor(...args){
        super(...args), this.spinnerRef = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createRef(), this.containerRef = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createRef(), this.componentDidMount = ()=>{
            if (this.props.isLoading && this.hasTargetNode()) {
                this.attachListeners();
                this.updateTargetAppearance();
                this.updateSpinnerPosition();
            }
        }, this.UNSAFE_componentWillReceiveProps = (nextProps)=>{
            if (!nextProps.isLoading || !this.hasTargetNode(nextProps)) this.detachListeners();
            else if (!this.props.isLoading) this.attachListeners();
        }, this.componentDidUpdate = ()=>{
            if (this.hasTargetNode()) {
                this.updateTargetAppearance();
                if (this.props.isLoading) this.updateSpinnerPosition();
            }
        }, this.componentWillUnmount = ()=>{
            this.detachListeners();
        }, this.getTargetNode = (nextProps = this.props)=>{
            const { targetRef: targetRef } = nextProps;
            const target = targetRef?.();
            return target || this.containerRef.current;
        }, this.hasTargetNode = (nextProps)=>!!this.getTargetNode(nextProps), this.isVerticallyVisible = (elementRect, viewportHeight)=>{
            const { top: top, bottom: bottom } = elementRect;
            if (bottom <= 0) return false;
            return top < viewportHeight;
        }, this.isFullyVerticallyVisible = (elementRect, viewportHeight)=>{
            const { top: top, bottom: bottom } = elementRect;
            return top >= 0 && bottom <= viewportHeight;
        }, this.handleResize = ()=>{
            this.updateSpinnerPosition();
        }, this.handleScroll = ()=>{
            this.updateSpinnerPosition();
        }, this.translateSpinner = (spinnerNode, transformY, isFixed)=>{
            spinnerNode.style.position = isFixed ? 'fixed' : '';
            spinnerNode.style.transform = transformY !== 0 ? `translate3d(0, ${transformY}px, 0)` : '';
        }, this.updateTargetAppearance = ()=>{
            const targetNode = this.getTargetNode();
            const { isLoading: isLoading, contentsOpacity: contentsOpacity } = this.props;
            if (targetNode && targetNode.style && typeof targetNode.style === 'object') {
                targetNode.style.pointerEvents = isLoading ? 'none' : '';
                targetNode.style.opacity = isLoading ? contentsOpacity.toString() : '';
            }
        };
    }
}

});
parcelRegister("3rtaW", function(module, exports) {
$parcel$export(module.exports, "Container", () => $dcd16b6cedc99af6$export$42a852a2b6b56249);
$parcel$export(module.exports, "SpinnerBackdrop", () => $dcd16b6cedc99af6$export$aa207050321b0c53);
$parcel$export(module.exports, "SpinnerContainer", () => $dcd16b6cedc99af6$export$a5e06607a5ac6158);
/* loading-container-advanced.tsx generated by @compiled/babel-plugin v0.36.1 */ /* eslint-disable @repo/internal/react/require-jsdoc */ 
var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");
const $dcd16b6cedc99af6$var$containerStyles = null;
const $dcd16b6cedc99af6$export$42a852a2b6b56249 = /*#__PURE__*/ (0, $eJOHy.forwardRef)((props, ref)=>{
    const { children: children, testId: testId, ...rest } = props;
    return /*#__PURE__*/ (0, $gt9Am.jsx)("div", {
        ...rest,
        "data-testid": testId,
        ref: ref,
        className: (0, $hcewu.default)([
            "_kqswh2mm _6rth1ejb"
        ]),
        children: children
    });
});
const $dcd16b6cedc99af6$var$spinnerBackdropStyles = null;
const $dcd16b6cedc99af6$export$aa207050321b0c53 = ({ children: children, testId: testId })=>/*#__PURE__*/ (0, $gt9Am.jsx)("div", {
        "data-testid": testId && `${testId}--spinner-backdrop`,
        className: (0, $hcewu.default)([
            "_1r04idpf _1e0c1txw _kqswstnw _4cvr1h6o _1bah1h6o _lcxvglyw"
        ]),
        children: children
    });
const $dcd16b6cedc99af6$var$spinnerContainerStyles = null;
const $dcd16b6cedc99af6$export$a5e06607a5ac6158 = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ children: children }, ref)=>/*#__PURE__*/ (0, $gt9Am.jsx)("div", {
        ref: ref,
        className: (0, $hcewu.default)([
            "_kqswh2mm _152tidpf"
        ]),
        children: children
    }));

});


parcelRegister("5hPH6", function(module, exports) {
$parcel$export(module.exports, "default", () => $d482c3e387def2e8$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $b3eVo = parcelRequire("b3eVo");
class $d482c3e387def2e8$export$2e2bcd8739ae039 extends (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Component {
    render() {
        const { total: total, value: value = 1, i18n: i18n, testId: testId, isDisabled: isDisabled } = this.props;
        const pages = [
            ...Array(total)
        ].map((_, index)=>index + 1);
        // Pagination accepts array now thus selectedIndex starts with 0
        // So, we are substracting value by one thus not breaking dynamic table
        const selectedIndex = value - 1;
        return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $b3eVo.default), {
            selectedIndex: selectedIndex,
            isDisabled: isDisabled,
            label: i18n?.label,
            nextLabel: i18n?.next,
            previousLabel: i18n?.prev,
            pageLabel: i18n?.pageLabel,
            onChange: this.onChange,
            pages: pages,
            testId: testId && `${testId}--pagination`
        });
    }
    constructor(...args){
        super(...args), this.onChange = (_event, newValue, analyticsEvent)=>{
            this.props.onChange(newValue, analyticsEvent);
        };
    }
}

});

parcelRegister("iXYwm", function(module, exports) {
$parcel$export(module.exports, "default", () => $eab3a1b41c933c64$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $aXVGO = parcelRequire("aXVGO");

var $6d05d = parcelRequire("6d05d");

var $2YodG = parcelRequire("2YodG");

var $dYUdf = parcelRequire("dYUdf");
// eslint-disable-next-line @repo/internal/react/no-class-components
class $eab3a1b41c933c64$var$TableHead extends (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Component {
    constructor(props){
        super(props);
        this.state = {
            activeSortButtonId: null
        };
    }
    UNSAFE_componentWillMount() {
        (0, $aXVGO.validateSortKey)(this.props.sortKey, this.props.head);
    }
    UNSAFE_componentWillReceiveProps(nextProps) {
        if (this.props.sortKey !== nextProps.sortKey || this.props.head !== nextProps.head) (0, $aXVGO.validateSortKey)(nextProps.sortKey, nextProps.head);
    }
    render() {
        const { head: head, sortKey: sortKey, sortOrder: sortOrder, isFixedSize: isFixedSize, onSort: onSort, isRanking: isRanking, isRankable: isRankable, testId: testId } = this.props;
        const { activeSortButtonId: activeSortButtonId } = this.state;
        if (!head) return null;
        const HeadCellComponent = isRankable ? (0, $2YodG.default) : (0, $dYUdf.default);
        // TODO: Remove `rest` props and use only what is explicitly in the API.
        // Some tests use this to pass in onClick and other stuff within the `head`
        // variable here, but considering it's not in the API, it should probably
        // be removed.
        const { cells: cells, ...rest } = head;
        return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $6d05d.Head), {
            ...rest,
            isRanking: isRanking,
            testId: testId && `${testId}--head`,
            children: /*#__PURE__*/ (0, $gt9Am.jsx)("tr", {
                children: cells.map((cell, index)=>{
                    const { ascendingSortTooltip: ascendingSortTooltip, buttonAriaRoleDescription: buttonAriaRoleDescription, colSpan: colSpan, content: content, descendingSortTooltip: descendingSortTooltip, isIconOnlyHeader: isIconOnlyHeader, isSortable: isSortable, key: key, shouldTruncate: shouldTruncate, testId: cellTestId, width: width, // TODO: Remove `rest` props and use only what is explicitly in
                    // the API.
                    ...restCellProps } = cell;
                    const headCellId = `head-cell-${index}`;
                    const handleClick = ()=>{
                        this.setState({
                            activeSortButtonId: headCellId
                        });
                        if (isSortable) onSort(cell)();
                    };
                    return /*#__PURE__*/ (0, $gt9Am.jsx)(HeadCellComponent, {
                        colSpan: colSpan,
                        content: content,
                        isFixedSize: isFixedSize,
                        isIconOnlyHeader: isIconOnlyHeader,
                        isSortable: !!isSortable,
                        isRanking: isRanking,
                        headCellId: headCellId,
                        activeSortButtonId: activeSortButtonId,
                        onClick: handleClick,
                        testId: cellTestId || testId,
                        shouldTruncate: shouldTruncate,
                        sortOrder: key === sortKey ? sortOrder : undefined,
                        width: width,
                        ascendingSortTooltip: ascendingSortTooltip,
                        descendingSortTooltip: descendingSortTooltip,
                        buttonAriaRoleDescription: buttonAriaRoleDescription,
                        ...restCellProps
                    }, key || index);
                })
            })
        });
    }
}
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$eab3a1b41c933c64$export$2e2bcd8739ae039 = $eab3a1b41c933c64$var$TableHead;

});
parcelRegister("6d05d", function(module, exports) {
$parcel$export(module.exports, "Head", () => $8e34007a1dac0529$export$e93312b7773dfcac);
$parcel$export(module.exports, "HeadCell", () => $8e34007a1dac0529$export$4e8024263ace498b);
/* table-head.tsx generated by @compiled/babel-plugin v0.36.1 */ /* eslint-disable @repo/internal/react/require-jsdoc */ 
var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");


var $1eoPo = parcelRequire("1eoPo");
const $8e34007a1dac0529$var$CSS_VAR_TEXT_COLOR = '--local-dynamic-table-text-color';
const $8e34007a1dac0529$var$rankingStyles = null;
const $8e34007a1dac0529$var$headStyles = null;
const $8e34007a1dac0529$var$overflowTruncateStyles = null;
const $8e34007a1dac0529$var$truncationWidthStyles = null;
const $8e34007a1dac0529$var$fixedSizeTruncateStyles = null;
const $8e34007a1dac0529$var$cellStyles = null;
const $8e34007a1dac0529$export$e93312b7773dfcac = ({ isRanking: isRanking, testId: testId, ...props })=>{
    return /*#__PURE__*/ (0, $gt9Am.jsx)("thead", {
        "data-testid": testId,
        ...props,
        className: (0, $hcewu.default)([
            "_179rglyw",
            isRanking && "_1e0c1ule"
        ])
    });
};
const $8e34007a1dac0529$var$headCellBaseStyles = null;
const $8e34007a1dac0529$export$4e8024263ace498b = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ width: width, children: children, isSortable: isSortable, sortOrder: sortOrder, isFixedSize: isFixedSize, shouldTruncate: shouldTruncate, onClick: onClick, style: style, testId: testId, ...rest }, ref)=>{
    const mergedStyles = {
        ...style,
        ...width && (0, $1eoPo.getTruncationStyleVars)({
            width: width
        }),
        [$8e34007a1dac0529$var$CSS_VAR_TEXT_COLOR]: "var(--ds-text-subtlest, #626F86)"
    };
    const isASC = sortOrder === (0, $861def5c205d1816$export$1dee026a19752d6b);
    const isDESC = sortOrder === (0, $861def5c205d1816$export$b6abcf7fa1d94f65);
    const getFormattedSortOrder = ()=>{
        if (isASC) return 'ascending';
        else if (isDESC) return 'descending';
        return;
    };
    // If there is no content in the cell, it should be rendered as an empty `td`, not a `th`.
    // https://dequeuniversity.com/rules/axe/4.7/empty-table-header
    const Component = children ? 'th' : 'td';
    return /*#__PURE__*/ (0, $gt9Am.jsx)(Component, {
        "aria-sort": getFormattedSortOrder(),
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        style: mergedStyles,
        onClick: undefined,
        ref: ref,
        "data-testid": testId,
        ...rest,
        className: (0, $hcewu.default)([
            "_izbqglyw _h7alglyw _85i51b66 _1q511b66 _y4tiu2gc _bozgu2gc _y3gn1e5h _1s37ze3t _uupyze3t",
            "_11c8dcr7 _179r187z _mqm2glyw _kqswh2mm _syaz34id _k48pmoej _y3gn1e5h _s7n4nkob _1ygbi3bv",
            "_1bsb8a2a",
            isFixedSize && shouldTruncate && "_1bto1l2s _o5721q9c",
            isFixedSize && "_1reo15vq _18m915vq"
        ]),
        children: children
    });
});

});

parcelRegister("2YodG", function(module, exports) {
$parcel$export(module.exports, "default", () => $e8fde9bd86f03325$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $fTTHR = parcelRequire("fTTHR");

var $aXVGO = parcelRequire("aXVGO");

var $dYUdf = parcelRequire("dYUdf");
// eslint-disable-next-line @repo/internal/react/no-class-components
class $e8fde9bd86f03325$var$RankableTableHeadCellComponent extends (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Component {
    render() {
        const { isRanking: isRanking, refHeight: refHeight, refWidth: refWidth, ...restProps } = this.props;
        const inlineStyles = (0, $aXVGO.inlineStylesIfRanking)(isRanking, refWidth);
        return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $dYUdf.default), {
            inlineStyles: inlineStyles,
            ...restProps
        });
    }
}
const $e8fde9bd86f03325$var$RankableTableHeadCell = (0, $fTTHR.default)($e8fde9bd86f03325$var$RankableTableHeadCellComponent);
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$e8fde9bd86f03325$export$2e2bcd8739ae039 = $e8fde9bd86f03325$var$RankableTableHeadCell;

});
parcelRegister("fTTHR", function(module, exports) {
$parcel$export(module.exports, "default", () => $173dc77e0c07b527$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");
function $173dc77e0c07b527$export$2e2bcd8739ae039(WrappedComponent) {
    return class WithDimensions extends (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Component {
        UNSAFE_componentWillReceiveProps(nextProps) {
            const wasRanking = this.props.isRanking;
            const willRanking = nextProps.isRanking;
            if (willRanking && !wasRanking) this.updateDimensions();
        }
        render() {
            const { refWidth: refWidth, refHeight: refHeight } = this.state;
            return /*#__PURE__*/ (0, $gt9Am.jsx)(WrappedComponent, {
                //@ts-expect-error TODO Fix legit TypeScript 3.9.6 improved inference error
                refWidth: refWidth,
                //@ts-expect-error TODO Fix legit TypeScript 3.9.6 improved inference error
                refHeight: refHeight,
                innerRef: this.innerRef,
                ...this.props
            });
        }
        constructor(...args){
            super(...args), this.state = {
                refWidth: 0,
                refHeight: 0
            }, this.innerRef = (ref)=>{
                if (ref && !this.props.isRanking) this.ref = ref;
            }, this.updateDimensions = ()=>{
                if (!this.ref) return;
                const clientRect = this.ref.getBoundingClientRect();
                const { width: width } = clientRect;
                const { height: height } = clientRect;
                if (width !== this.state.refWidth || height !== this.state.refHeight) this.setState({
                    refWidth: width,
                    refHeight: height
                });
            };
        }
    };
}

});

parcelRegister("dYUdf", function(module, exports) {
$parcel$export(module.exports, "default", () => $f5386cb5a0fc1b36$export$2e2bcd8739ae039);
/* table-head-cell.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");

var $hcewu = parcelRequire("hcewu");

var $eJOHy = parcelRequire("eJOHy");

var $8Gywp = parcelRequire("8Gywp");

var $aDbql = parcelRequire("aDbql");

var $8IeH1 = parcelRequire("8IeH1");
var $2sLVw = parcelRequire("2sLVw");
var $46R8N = parcelRequire("46R8N");

var $k71qx = parcelRequire("k71qx");


var $6d05d = parcelRequire("6d05d");
const $f5386cb5a0fc1b36$var$styles = {
    buttonWrapper: "_1e0c1txw _bfhk18uv _4cvr1h6o _ca0qze3t _u5f3ze3t _n3tdze3t _19bvze3t _d0altlke",
    sortIconHiddenWrapper: "_1e0c1txw _tzy4idpf _bfhk18uv _ca0q1b66 _u5f31b66 _n3td1b66 _19bv1b66 _1h7hkb7n",
    sortIconVisibleWrapper: "_1e0c1txw _tzy4kb7n _bfhk18uv _ca0q1b66 _u5f31b66 _n3td1b66 _19bv1b66",
    hideIconHeaderWrapper: "_tzy4idpf _18u010v4",
    visibleHeaderWrapper: "_tzy4kb7n _u5f31b66"
};
const $f5386cb5a0fc1b36$var$headCellStyles = {
    headCellContainer: "_1e0c1txw _4cvr1h6o",
    text: "_11c81o8v _syaz1gjq _k48pmoej"
};
const $f5386cb5a0fc1b36$var$TableHeadCell = ({ content: content, inlineStyles: inlineStyles, testId: testId, isRanking: isRanking, innerRef: innerRef, isSortable: isSortable, sortOrder: sortOrder, onClick: onClick, headCellId: headCellId, activeSortButtonId: activeSortButtonId, ascendingSortTooltip: ascendingSortTooltip = 'Sort ascending', descendingSortTooltip: descendingSortTooltip = 'Sort descending', buttonAriaRoleDescription: buttonAriaRoleDescription = 'Sort button', isIconOnlyHeader: isIconOnlyHeader, ...rest })=>{
    const [isHovered, setIsHovered] = (0, $eJOHy.useState)(false);
    const [isFocused, setIsFocused] = (0, $eJOHy.useState)(false);
    const isActive = headCellId === activeSortButtonId || sortOrder !== undefined;
    const isSortIconVisible = isHovered || isActive || isFocused;
    const isVisibleIconOnlyHeader = isSortIconVisible && isIconOnlyHeader;
    const shouldRenderSortIcon = !isIconOnlyHeader || isSortIconVisible || isIconOnlyHeader && !isFocused;
    const handleFocus = (0, $eJOHy.useCallback)(()=>{
        setIsFocused?.(true);
    }, [
        setIsFocused
    ]);
    const handleBlur = (0, $eJOHy.useCallback)(()=>{
        setIsFocused?.(false);
    }, [
        setIsFocused
    ]);
    const handleMouseEnter = (0, $eJOHy.useCallback)(()=>{
        setIsHovered(true);
    }, [
        setIsHovered
    ]);
    const handleMouseLeave = (0, $eJOHy.useCallback)(()=>{
        setIsHovered(false);
    }, [
        setIsHovered
    ]);
    const visuallyRefreshedButton = /*#__PURE__*/ (0, $gt9Am.jsx)((0, $8IeH1.default), {
        xcss: $f5386cb5a0fc1b36$var$headCellStyles.headCellContainer,
        onMouseEnter: handleMouseEnter,
        onMouseLeave: handleMouseLeave,
        onFocus: handleFocus,
        onBlur: handleBlur,
        children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $k71qx.default), {
            content: sortOrder === (0, $861def5c205d1816$export$1dee026a19752d6b) ? ascendingSortTooltip : descendingSortTooltip,
            children: /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $46R8N.default), {
                onClick: onClick,
                xcss: $f5386cb5a0fc1b36$var$styles.buttonWrapper,
                "aria-roledescription": buttonAriaRoleDescription,
                children: [
                    /*#__PURE__*/ (0, $gt9Am.jsx)((0, $2sLVw.default), {
                        xcss: isVisibleIconOnlyHeader ? $f5386cb5a0fc1b36$var$styles.hideIconHeaderWrapper : $f5386cb5a0fc1b36$var$styles.visibleHeaderWrapper,
                        children: /*#__PURE__*/ (0, $gt9Am.jsx)("span", {
                            className: (0, $hcewu.default)([
                                $f5386cb5a0fc1b36$var$headCellStyles.text
                            ]),
                            children: content
                        })
                    }),
                    shouldRenderSortIcon && /*#__PURE__*/ (0, $gt9Am.jsx)((0, $2sLVw.default), {
                        xcss: isSortIconVisible ? $f5386cb5a0fc1b36$var$styles.sortIconVisibleWrapper : $f5386cb5a0fc1b36$var$styles.sortIconHiddenWrapper,
                        children: sortOrder === (0, $861def5c205d1816$export$1dee026a19752d6b) ? /*#__PURE__*/ (0, $gt9Am.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($aDbql))), {
                            label: "",
                            color: "var(--ds-text-subtle, #44546F)",
                            testId: testId && `${testId}--up--icon`
                        }) : /*#__PURE__*/ (0, $gt9Am.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($8Gywp))), {
                            label: "",
                            color: "var(--ds-text-subtle, #44546F)",
                            testId: testId && `${testId}--down--icon`
                        })
                    })
                ]
            })
        })
    });
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $6d05d.HeadCell), {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        style: inlineStyles,
        testId: testId && `${testId}--head--cell`,
        ref: typeof innerRef !== 'string' ? innerRef : null,
        ...rest,
        isSortable: isSortable,
        sortOrder: sortOrder,
        children: isSortable ? visuallyRefreshedButton : content
    });
};
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$f5386cb5a0fc1b36$export$2e2bcd8739ae039 = $f5386cb5a0fc1b36$var$TableHeadCell;

});
parcelRegister("8Gywp", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::fcfd9fc2877ad309c8a5d6e5d6ea9482>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $652d0645e24346a6$var$_react = $652d0645e24346a6$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $652d0645e24346a6$var$_baseNew = $652d0645e24346a6$var$_interopRequireDefault((parcelRequire("fGWXz")));
function $652d0645e24346a6$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "ArrowDown".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Know uses: sorting table headers or Bitbucket code difference.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $652d0645e24346a6$var$ArrowDownIcon = (props)=>/*#__PURE__*/ $652d0645e24346a6$var$_react.default.createElement($652d0645e24346a6$var$_baseNew.default, Object.assign({
        name: "ArrowDownIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M8.75 1v11.44l3.72-3.72 1.06 1.06-5 5a.75.75 0 0 1-1.06 0l-5-5 1.06-1.06 3.72 3.72V1z" clip-rule="evenodd"/>`
    }, props));
$652d0645e24346a6$var$ArrowDownIcon.displayName = 'ArrowDownIcon';
var $652d0645e24346a6$var$_default = module.exports.default = $652d0645e24346a6$var$ArrowDownIcon;

});

parcelRegister("aDbql", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::be13ec6c7b346b13ffda97746cc85c67>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $7bd6687a611ada9e$var$_react = $7bd6687a611ada9e$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $7bd6687a611ada9e$var$_baseNew = $7bd6687a611ada9e$var$_interopRequireDefault((parcelRequire("fGWXz")));
function $7bd6687a611ada9e$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "ArrowUp".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: back to top.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $7bd6687a611ada9e$var$ArrowUpIcon = (props)=>/*#__PURE__*/ $7bd6687a611ada9e$var$_react.default.createElement($7bd6687a611ada9e$var$_baseNew.default, Object.assign({
        name: "ArrowUpIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M8.75 15V3.56l3.72 3.72 1.06-1.06-5-5a.75.75 0 0 0-1.06 0l-5 5 1.06 1.06 3.72-3.72V15z" clip-rule="evenodd"/>`
    }, props));
$7bd6687a611ada9e$var$ArrowUpIcon.displayName = 'ArrowUpIcon';
var $7bd6687a611ada9e$var$_default = module.exports.default = $7bd6687a611ada9e$var$ArrowUpIcon;

});




parcelRegister("itCCG", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = Promise.all([
    $ewTvA("76n7a"),
    $ewTvA("l253H"),
    $ewTvA("4aw4p")
]).then(()=>parcelRequire('l7wPr'));

});


parcelRegister("8TMMM", function(module, exports) {
$parcel$export(module.exports, "default", () => $a1b6dcf21e6f1de9$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
const $a1b6dcf21e6f1de9$var$messages = (0, $7qGN1.defineMessages)({
    filterResultAnnounce: {
        "id": "directory-base.content.table.filter-result-announce",
        "defaultMessage": "{itemCount, plural, one {One item was found after filtering.} other {{itemCount} items were found after filtering.}}"
    },
    filterResultsAnnouncement: {
        "id": "directory-base.content.table.filter-results-announcement",
        "defaultMessage": "{itemCount, plural, =0 {No results were found that match your search} one {{itemCount} result found} other {{itemCount} results found}}"
    }
});
var $a1b6dcf21e6f1de9$export$2e2bcd8739ae039 = $a1b6dcf21e6f1de9$var$messages;

});



parcelRegister("bj0qr", function(module, exports) {
$parcel$export(module.exports, "default", () => $017eecc563c11f26$export$2e2bcd8739ae039);
/* view.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $eJOHy = parcelRequire("eJOHy");

var $12DRg = parcelRequire("12DRg");

var $54CI2 = parcelRequire("54CI2");
function $017eecc563c11f26$export$2e2bcd8739ae039(props) {
    const { Header: Header, Table: Table, Paginator: Paginator, Empty: Empty, Error: Error, status: status, onAdd: onAdd, onRetry: onRetry, isOnboardingEnabled: isOnboardingEnabled, renderOnboardingSpotlight: renderOnboardingSpotlight, availableSpotlightTargets: availableSpotlightTargets } = props;
    let main = null;
    let spotlight = null;
    switch(status){
        case 'has-entities':
            main = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(Table, null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(Paginator, null));
            spotlight = isOnboardingEnabled && renderOnboardingSpotlight && renderOnboardingSpotlight(availableSpotlightTargets);
            break;
        case 'empty':
            main = Empty ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(Empty, {
                onAdd: onAdd
            }) : null;
            break;
        case 'error':
            main = Error ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(Error, {
                onRetry: onRetry
            }) : null;
            break;
        default:
            break;
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $54CI2.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, spotlight, Header ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(Header, null) : null, main));
}
$017eecc563c11f26$export$2e2bcd8739ae039.defaultProps = {
    isOnboardingEnabled: false,
    renderOnboardingSpotlight: ()=>null,
    availableSpotlightTargets: [],
    onAdd: (0, (/*@__PURE__*/$parcel$interopDefault($12DRg))),
    onRetry: (0, (/*@__PURE__*/$parcel$interopDefault($12DRg)))
};

});


parcelRegister("54lJh", function(module, exports) {
$parcel$export(module.exports, "default", () => $7c677f42b9a16635$export$2e2bcd8739ae039);
// eslint-disable-next-line jira/restricted/react-component-props

var $91zZ6 = parcelRequire("91zZ6");

var $6SY0Q = parcelRequire("6SY0Q");

var $ePZvy = parcelRequire("ePZvy");

var $7EfkR = parcelRequire("7EfkR");

var $dZ0bL = parcelRequire("dZ0bL");
const $7c677f42b9a16635$var$mapStateToProps = (state)=>({
        isCreateModalShown: (0, $6SY0Q.isCreateOpen)(state),
        CreateModal: $ePZvy.default,
        operations: (0, $6SY0Q.getOperations)(state),
        OperationModal: $7EfkR.default
    });
var // @ts-expect-error - TS2554 - Expected 3-4 arguments, but got 2. | TS2345 - Argument of type 'typeof Modals' is not assignable to parameter of type 'Component<DispatchProp<any>>'.
$7c677f42b9a16635$export$2e2bcd8739ae039 = (0, $91zZ6.connect)($7c677f42b9a16635$var$mapStateToProps, {})((0, $dZ0bL.default));

});
parcelRegister("ePZvy", function(module, exports) {
$parcel$export(module.exports, "default", () => $e85a5d5d8af0cf08$export$2e2bcd8739ae039);

var $gnQAk = parcelRequire("gnQAk");

var $91zZ6 = parcelRequire("91zZ6");

var $4wOQJ = parcelRequire("4wOQJ");

var $6SY0Q = parcelRequire("6SY0Q");

var $5kAHG = parcelRequire("5kAHG");
const $e85a5d5d8af0cf08$var$mapStateToProps = (state)=>{
    const CreateModal = (0, $6SY0Q.getCreateModal)(state);
    if (!CreateModal) throw new Error('Invalid state - no Create Modal provided');
    return {
        CreateModal: CreateModal
    };
};
const $e85a5d5d8af0cf08$var$mapDispatchToProps = {
    onCreated: (0, $4wOQJ.entityCreated),
    onCreateFailed: (0, $4wOQJ.entityCreateFailed),
    onCancel: (0, $4wOQJ.cancelled)
};
var $e85a5d5d8af0cf08$export$2e2bcd8739ae039 = (0, $gnQAk.connect)($e85a5d5d8af0cf08$var$mapStateToProps, $e85a5d5d8af0cf08$var$mapDispatchToProps, null, (0, $91zZ6.storeOptions))((0, $5kAHG.default));

});
parcelRegister("5kAHG", function(module, exports) {
$parcel$export(module.exports, "default", () => $b78add7cdc0c3965$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");
function $b78add7cdc0c3965$export$2e2bcd8739ae039(props) {
    const { CreateModal: CreateModal, onCreated: onCreated, onCreateFailed: onCreateFailed, onCancel: onCancel } = props;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(CreateModal, {
        onCreated: onCreated,
        onCreateFailed: onCreateFailed,
        onCancel: onCancel
    });
}

});


parcelRegister("7EfkR", function(module, exports) {
$parcel$export(module.exports, "default", () => $6ea54fa0c184bfea$export$2e2bcd8739ae039);

var $LFmXM = parcelRequire("LFmXM");

var $91zZ6 = parcelRequire("91zZ6");

var $5cBQu = parcelRequire("5cBQu");

var $6SY0Q = parcelRequire("6SY0Q");

var $aeXGs = parcelRequire("aeXGs");
const $6ea54fa0c184bfea$var$mapStateToPropsFactory = ()=>{
    const onDataRetrievedFactory = (0, $LFmXM.default)((state, id)=>// @ts-expect-error - TS7031 - Binding element 'patch' implicitly has an 'any' type.
        ({ patch: patch })=>(0, $6SY0Q.getOnPatch)(state)({
                id: id,
                patch: patch
            }));
    return (state, ownProps)=>{
        const { id: id, operation: operation } = ownProps;
        return {
            OperationModal: (0, $6SY0Q.getOperationModal)(state, operation),
            onDataRetrieved: onDataRetrievedFactory(state, id)
        };
    };
};
const $6ea54fa0c184bfea$var$mapDispatchToProps = (dispatch, ownProps)=>{
    const { id: id, operation: operation, childEntityId: childEntityId, isInitializing: isInitializing } = ownProps;
    return {
        entityId: id,
        isInitializing: isInitializing,
        onDialogShown: ()=>dispatch((0, $5cBQu.dialogShown)({
                id: id,
                operation: operation,
                childEntityId: childEntityId
            })),
        onDataRetrieveFailed: ()=>dispatch((0, $5cBQu.entityDataRetrieveFailed)({
                id: id,
                operation: operation
            })),
        // @ts-expect-error - TS2525 - Initializer provides no value for this binding element and the binding element has no default value.
        onUpdated: ({ patch: patch } = {})=>dispatch((0, $5cBQu.entityUpdated)({
                id: id,
                operation: operation,
                patch: patch
            })),
        onUpdateFailed: ()=>dispatch((0, $5cBQu.entityUpdateFailed)({
                id: id,
                operation: operation
            })),
        onCancel: ()=>dispatch((0, $5cBQu.cancelled)({
                id: id,
                operation: operation
            }))
    };
};
var // @ts-expect-error - TS2554 - Expected 3-4 arguments, but got 2. | TS2345 - Argument of type 'typeof Operation' is not assignable to parameter of type 'Component<DispatchProp<any>>'.
$6ea54fa0c184bfea$export$2e2bcd8739ae039 = (0, $91zZ6.connect)($6ea54fa0c184bfea$var$mapStateToPropsFactory, $6ea54fa0c184bfea$var$mapDispatchToProps)((0, $aeXGs.default));

});
parcelRegister("aeXGs", function(module, exports) {
$parcel$export(module.exports, "default", () => $0fff5b41a33d1817$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");
function $0fff5b41a33d1817$export$2e2bcd8739ae039(props) {
    const { OperationModal: OperationModal, ...modalProps } = props;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(OperationModal, modalProps);
}

});


parcelRegister("dZ0bL", function(module, exports) {
$parcel$export(module.exports, "default", () => $b3018c586c391011$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");
function $b3018c586c391011$export$2e2bcd8739ae039(props) {
    const { isCreateModalShown: isCreateModalShown, CreateModal: CreateModal, operations: operations, OperationModal: OperationModal } = props;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("div", null, isCreateModalShown && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(CreateModal, null), operations.map(({ id: id, operation: operation, childEntityId: childEntityId, isInitializing: isInitializing })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(OperationModal, {
            key: id,
            id: id,
            operation: operation,
            childEntityId: childEntityId,
            isInitializing: isInitializing
        })));
}

});


parcelRegister("dIYLk", function(module, exports) {
$parcel$export(module.exports, "default", () => $4d4b3dfd6658db1e$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");
function $4d4b3dfd6658db1e$export$2e2bcd8739ae039(props) {
    const { Content: Content, Modals: Modals } = props;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(Content, null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(Modals, null));
}

});



parcelRegister("cK5WJ", function(module, exports) {
$parcel$export(module.exports, "getIds", () => $c8a73610e3893eda$export$24b60fe7179439bc);
$parcel$export(module.exports, "getTotal", () => $c8a73610e3893eda$export$94860ac4a286a8d9);
$parcel$export(module.exports, "isLoading", () => $c8a73610e3893eda$export$20bb0d907fbbe433);
$parcel$export(module.exports, "isError", () => $c8a73610e3893eda$export$e6127cc7fe7395c3);
$parcel$export(module.exports, "getName", () => $c8a73610e3893eda$export$7d9f7e9c1c02b41e);
$parcel$export(module.exports, "getOwner", () => $c8a73610e3893eda$export$5f4ed0d56c2c0edf);
$parcel$export(module.exports, "getIsWritable", () => $c8a73610e3893eda$export$8e04de5241998cf7);
$parcel$export(module.exports, "getViewUrl", () => $c8a73610e3893eda$export$bdccd6a672e4a607);
$parcel$export(module.exports, "getShares", () => $c8a73610e3893eda$export$3b3cfad4475f6525);
$parcel$export(module.exports, "getEdits", () => $c8a73610e3893eda$export$ade2933f0cc600b);
$parcel$export(module.exports, "getSystemDashboard", () => $c8a73610e3893eda$export$3123e858ea4af38b);
$parcel$export(module.exports, "isFavorite", () => $c8a73610e3893eda$export$70b3463aa7e3e514);
$parcel$export(module.exports, "isPending", () => $c8a73610e3893eda$export$872dec21e9a69476);
$parcel$export(module.exports, "getPopularity", () => $c8a73610e3893eda$export$34145270e160ba15);
$parcel$export(module.exports, "getChangeFavorite", () => $c8a73610e3893eda$export$85b24bd43a2bd6cf);

var $bpMvQ = parcelRequire("bpMvQ");
const $c8a73610e3893eda$export$dd1bc94b04021eeb = (state)=>state.dashboards.order.length === 0;
const $c8a73610e3893eda$export$24b60fe7179439bc = (state)=>state.dashboards.order;
const $c8a73610e3893eda$export$94860ac4a286a8d9 = (state)=>state.dashboards.total;
const $c8a73610e3893eda$export$20bb0d907fbbe433 = (state)=>state.dashboards.isLoading;
const $c8a73610e3893eda$export$e6127cc7fe7395c3 = (state)=>state.dashboards.isError;
const $c8a73610e3893eda$export$889a4d2bde32b973 = (state, id)=>Boolean(state.dashboards.page[id]);
const $c8a73610e3893eda$export$7d9f7e9c1c02b41e = (state, id)=>state.dashboards.page[id]?.name;
const $c8a73610e3893eda$export$5f4ed0d56c2c0edf = (state, id)=>state.dashboards.page[id]?.owner;
const $c8a73610e3893eda$export$8e04de5241998cf7 = (state, id)=>state.dashboards.page[id]?.isWritable;
const $c8a73610e3893eda$export$bdccd6a672e4a607 = (state, id)=>state.dashboards.page[id]?.viewUrl;
const $c8a73610e3893eda$export$3b3cfad4475f6525 = (state, id)=>state.dashboards.page[id]?.shares;
const $c8a73610e3893eda$export$ade2933f0cc600b = (state, id)=>state.dashboards.page[id]?.edits;
const $c8a73610e3893eda$export$3123e858ea4af38b = (state, id)=>state.dashboards.page[id]?.systemDashboard;
const $c8a73610e3893eda$var$getFavoriteChangeContextItem = (state, id)=>(0, $bpMvQ.getFavoriteChangeContext)(state).items.dashboards?.[id];
const $c8a73610e3893eda$export$70b3463aa7e3e514 = (state, id)=>{
    const itemChanged = $c8a73610e3893eda$var$getFavoriteChangeContextItem(state, id);
    return itemChanged ? itemChanged.value : state.dashboards.page[id]?.isFavourite;
};
const $c8a73610e3893eda$export$872dec21e9a69476 = (state, id)=>{
    const item = $c8a73610e3893eda$var$getFavoriteChangeContextItem(state, id);
    return !!(item && item.pending);
};
const $c8a73610e3893eda$export$34145270e160ba15 = (state, id)=>{
    const popularityInState = state.dashboards.page[id]?.popularity;
    const isFavoriteInState = state.dashboards.page[id]?.isFavourite;
    const item = $c8a73610e3893eda$var$getFavoriteChangeContextItem(state, id);
    if (!item) return popularityInState;
    if (item.value && !isFavoriteInState) return popularityInState + 1;
    if (!item.value && isFavoriteInState) return popularityInState - 1;
    return popularityInState;
};
const $c8a73610e3893eda$export$85b24bd43a2bd6cf = (state)=>(0, $bpMvQ.getFavoriteChangeContext)(state).changeFavorite;

});

parcelRegister("bsBqn", function(module, exports) {
$parcel$export(module.exports, "default", () => $b223a00b352cb4e6$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");
const $b223a00b352cb4e6$var$EmptyView = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null);
var $b223a00b352cb4e6$export$2e2bcd8739ae039 = $b223a00b352cb4e6$var$EmptyView;

});

parcelRegister("da3cc", function(module, exports) {
$parcel$export(module.exports, "default", () => $d614be7d5d6e92c4$export$2e2bcd8739ae039);

var $gnQAk = parcelRequire("gnQAk");

var $cK5WJ = parcelRequire("cK5WJ");

var $iLd4G = parcelRequire("iLd4G");
const $d614be7d5d6e92c4$var$mapStateToProps = (state)=>({
        isLoading: (0, $cK5WJ.isLoading)(state)
    });
var $d614be7d5d6e92c4$export$2e2bcd8739ae039 = (0, $gnQAk.connect)($d614be7d5d6e92c4$var$mapStateToProps, {})((0, $iLd4G.default));

});
parcelRegister("iLd4G", function(module, exports) {
$parcel$export(module.exports, "default", () => $11aca1f600f8ddbe$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $4sAyo = parcelRequire("4sAyo");

var $lRq8t = parcelRequire("lRq8t");

var $dgvGo = parcelRequire("dgvGo");
function $11aca1f600f8ddbe$var$Error(props) {
    const { isLoading: isLoading, onRetry: onRetry } = props;
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $4sAyo.default), {
        header: formatMessage((0, $dgvGo.default).header),
        description: formatMessage((0, $dgvGo.default).description),
        isLoading: isLoading,
        onRetry: onRetry
    });
}
$11aca1f600f8ddbe$var$Error.defaultProps = {
    isLoading: false
};
var $11aca1f600f8ddbe$export$2e2bcd8739ae039 = $11aca1f600f8ddbe$var$Error;

});
parcelRegister("4sAyo", function(module, exports) {
$parcel$export(module.exports, "default", () => $453bd51fb9ccfc1a$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $goZPP = parcelRequire("goZPP");

var $6MnLl = parcelRequire("6MnLl");

var $idGBm = parcelRequire("idGBm");

var $ixx7q = parcelRequire("ixx7q");

var $3Wbl1 = parcelRequire("3Wbl1");

var $ahcp8 = parcelRequire("ahcp8");
function $453bd51fb9ccfc1a$export$edf27be85e5f6da0(props) {
    const { header: header, description: description, size: size, onRetry: onRetry, isLoading: isLoading, intl: { formatMessage: formatMessage }, errorImage: errorImage, isSubtle: isSubtle, imageWidth: imageWidth, maxImageHeight: maxImageHeight, retryMessage: retryMessage, renderErrorImage: renderErrorImage, headingLevel: headingLevel } = props;
    const buttonAppearance = isSubtle ? 'default' : 'primary';
    const defaultImageUrl = isSubtle ? (0, (/*@__PURE__*/$parcel$interopDefault($ixx7q))) : (0, (/*@__PURE__*/$parcel$interopDefault($3Wbl1)));
    const fallbackImage = errorImage || defaultImageUrl;
    let imageUrl;
    if (renderErrorImage) imageUrl = undefined;
    else imageUrl = fallbackImage;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $6MnLl.default), {
        testId: "common-components-error-state.empty-state",
        width: size,
        imageWidth: imageWidth,
        imageUrl: imageUrl,
        header: header,
        description: description,
        isLoading: isLoading,
        maxImageHeight: maxImageHeight,
        primaryAction: !onRetry ? null : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $goZPP.default), {
            appearance: buttonAppearance,
            isDisabled: isLoading,
            onClick: onRetry
        }, formatMessage(retryMessage)),
        renderImage: renderErrorImage,
        headingLevel: headingLevel
    });
}
$453bd51fb9ccfc1a$export$edf27be85e5f6da0.defaultProps = {
    header: '',
    size: 'wide',
    isLoading: false,
    isSubtle: false,
    retryMessage: (0, $ahcp8.default).retry
};
var $453bd51fb9ccfc1a$export$2e2bcd8739ae039 = (0, $idGBm.injectIntlV2)($453bd51fb9ccfc1a$export$edf27be85e5f6da0);

});
parcelRegister("ixx7q", function(module, exports) {
module.exports = new URL("error-subtle.580d9941.svg", import.meta.url).toString();

});

parcelRegister("3Wbl1", function(module, exports) {
module.exports = new URL("error.4fa1b24b.svg", import.meta.url).toString();

});

parcelRegister("ahcp8", function(module, exports) {
$parcel$export(module.exports, "default", () => $3c9decea4f84155e$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
const $3c9decea4f84155e$var$messages = (0, $7qGN1.defineMessages)({
    retry: {
        "id": "common.components.error-state.retry-action",
        "defaultMessage": "Try again"
    }
});
var $3c9decea4f84155e$export$2e2bcd8739ae039 = $3c9decea4f84155e$var$messages;

});


parcelRegister("dgvGo", function(module, exports) {
$parcel$export(module.exports, "default", () => $d797c4479882502c$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
const $d797c4479882502c$var$messages = (0, $7qGN1.defineMessages)({
    header: {
        "id": "directories.dashboards-v2.main.content.error.header",
        "defaultMessage": "We couldn't load your dashboards"
    },
    description: {
        "id": "directories.dashboards-v2.main.content.error.description",
        "defaultMessage": "Give it another try. If you run into more trouble, contact your admin for help."
    }
});
var $d797c4479882502c$export$2e2bcd8739ae039 = $d797c4479882502c$var$messages;

});



parcelRegister("iUBQb", function(module, exports) {
$parcel$export(module.exports, "default", () => $12562f21ee4f48a9$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $LFmXM = parcelRequire("LFmXM");

var $jjRt1 = parcelRequire("jjRt1");

var $6sjW5 = parcelRequire("6sjW5");

var $jubdf = parcelRequire("jubdf");

var $k3q7u = parcelRequire("k3q7u");

var $gnQAk = parcelRequire("gnQAk");

var $fucyK = parcelRequire("fucyK");

var $714QC = parcelRequire("714QC");

var $bpMvQ = parcelRequire("bpMvQ");

var $iRGx7 = parcelRequire("iRGx7");

var $kKEaJ = parcelRequire("kKEaJ");

var $c9fEk = parcelRequire("c9fEk");
const $12562f21ee4f48a9$var$SearchWithAnalytics = (0, $6sjW5.default)({
    onChange: 'search'
})((0, $jjRt1.default));
const $12562f21ee4f48a9$var$OwnerPickerWithAnalytics = (0, $6sjW5.default)({
    onChange: 'owner'
})((0, $fucyK.default));
const $12562f21ee4f48a9$var$ProjectTypePickerWithAnalytics = (0, $6sjW5.default)({
    onChange: 'project'
})((0, $k3q7u.default));
const $12562f21ee4f48a9$var$GroupPickerWithAnalytics = (0, $6sjW5.default)({
    onChange: 'group'
})((0, $jubdf.default));
const $12562f21ee4f48a9$var$renderFilterSearch = (state)=>// eslint-disable-next-line @typescript-eslint/no-explicit-any
    (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($12562f21ee4f48a9$var$SearchWithAnalytics, {
            ...props,
            value: (0, $iRGx7.getSearchQuery)(state),
            isAlwaysExpanded: true,
            placeholderAlwaysVisible: true,
            shouldFitContainerWidth: true
        });
const $12562f21ee4f48a9$var$renderOwnerPicker = (state)=>// eslint-disable-next-line @typescript-eslint/no-explicit-any
    (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($12562f21ee4f48a9$var$OwnerPickerWithAnalytics, {
            ...props,
            selectedUser: (0, $iRGx7.getSelectedOwner)(state),
            suggestedAccountId: (0, $bpMvQ.getLoggedInUserAccountId)(state),
            inputId: "dashboard-filters-owner-picker-select",
            isCompact: true,
            shouldFitContainer: true
        });
const $12562f21ee4f48a9$var$renderProjectPicker = (state)=>// eslint-disable-next-line @typescript-eslint/no-explicit-any
    (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($12562f21ee4f48a9$var$ProjectTypePickerWithAnalytics, {
            ...props,
            selectedProject: (0, $iRGx7.getSelectedProject)(state),
            isCompact: true,
            inputId: "dashboard-filters-project-picker-select",
            width: "100%"
        });
const $12562f21ee4f48a9$var$renderGroupPicker = (state)=>// eslint-disable-next-line @typescript-eslint/no-explicit-any
    (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($12562f21ee4f48a9$var$GroupPickerWithAnalytics, {
            ...props,
            selectedGroup: (0, $iRGx7.getSelectedGroup)(state),
            isCompact: true,
            inputId: "dashboard-filters-group-picker-select",
            width: "100%"
        });
const $12562f21ee4f48a9$var$renderClear = (state)=>// eslint-disable-next-line @typescript-eslint/no-explicit-any
    (props)=>(0, $iRGx7.isFilterApplied)(state) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $kKEaJ.default), props);
const $12562f21ee4f48a9$var$mapStateToPropsFactory = ()=>{
    const renderFilterSearchFactory = (0, $LFmXM.default)($12562f21ee4f48a9$var$renderFilterSearch);
    const renderOwnerPickerFactory = (0, $LFmXM.default)($12562f21ee4f48a9$var$renderOwnerPicker);
    const renderProjectPickerFactory = (0, $LFmXM.default)($12562f21ee4f48a9$var$renderProjectPicker);
    const renderGroupPickerFactory = (0, $LFmXM.default)($12562f21ee4f48a9$var$renderGroupPicker);
    const renderClearFactory = (0, $LFmXM.default)($12562f21ee4f48a9$var$renderClear);
    return (state, ownProps)=>({
            renderFilterSearch: renderFilterSearchFactory(state),
            renderOwnerPicker: renderOwnerPickerFactory(state),
            renderProjectPicker: renderProjectPickerFactory(state),
            renderGroupPicker: renderGroupPickerFactory(state),
            renderClear: renderClearFactory(state),
            initialFilter: (0, $714QC.initialQuery).filter,
            value: (0, $iRGx7.getFilter)(state),
            onChange: ownProps.onFilter
        });
};
var $12562f21ee4f48a9$export$2e2bcd8739ae039 = (0, $gnQAk.connect)($12562f21ee4f48a9$var$mapStateToPropsFactory, {})((0, $c9fEk.default));

});
parcelRegister("jjRt1", function(module, exports) {
$parcel$export(module.exports, "default", () => $5a0c664de71f5fe1$export$2e2bcd8739ae039);

var $as6H2 = parcelRequire("as6H2");

var $gPaDt = parcelRequire("gPaDt");
const $5a0c664de71f5fe1$var$FilterSearchWithAnalytics = (0, $as6H2.default)('filterSearch', {
    onChange: 'changed'
})((0, $gPaDt.default));
var $5a0c664de71f5fe1$export$2e2bcd8739ae039 = $5a0c664de71f5fe1$var$FilterSearchWithAnalytics;

});
parcelRegister("gPaDt", function(module, exports) {
$parcel$export(module.exports, "default", () => $ae2458133d2ad358$export$2e2bcd8739ae039);
// eslint-disable-next-line jira/restricted/react

var $eJOHy = parcelRequire("eJOHy");

var $3s8bj = parcelRequire("3s8bj");

var $dqc6Z = parcelRequire("dqc6Z");
const $ae2458133d2ad358$export$4c4c11a6ab1f5b09 = 1000;
const $ae2458133d2ad358$var$debouncedSearch = (0, (/*@__PURE__*/$parcel$interopDefault($3s8bj)))((value, callback)=>callback(value), $ae2458133d2ad358$export$4c4c11a6ab1f5b09);
// eslint-disable-next-line jira/react/no-class-components
class $ae2458133d2ad358$var$Filter extends (0, $eJOHy.PureComponent) {
    static{
        this.defaultProps = {
            value: '',
            placeholder: '',
            describedById: '',
            hasAutoFocus: false,
            isCompact: true,
            increasedWidth: false,
            placeholderAlwaysVisible: false
        };
    }
    getSearchValue(value) {
        const searchValue = value === this.prevSearchValue ? this.prevQueryValue : value;
        if (value !== this.prevSearchValue) {
            this.prevSearchValue = value;
            this.prevQueryValue = value;
        }
        return searchValue;
    }
    render() {
        const searchValue = this.getSearchValue(this.props.value);
        const { hasAutoFocus: autoFocus, ariaLabelText: ariaLabelText, ...props } = this.props;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $dqc6Z.SearchField), {
            ...props,
            autoFocus: autoFocus,
            value: searchValue,
            onChange: this.handleOnChange,
            onEnter: this.handleNewValue,
            ariaLabelText: ariaLabelText,
            showIconBeforeInput: true
        });
    }
    constructor(...args){
        super(...args), this.prevQueryValue = this.props.value, this.prevSearchValue = this.props.value, this.handleNewValue = (newValue)=>{
            $ae2458133d2ad358$var$debouncedSearch.cancel();
            if (newValue !== this.props.value) this.props.onChange(newValue);
        }, this.handleOnChange = (newValue)=>{
            this.prevQueryValue = newValue;
            newValue === '' ? this.handleNewValue(newValue) : $ae2458133d2ad358$var$debouncedSearch(newValue, this.handleNewValue);
        };
    }
}
var $ae2458133d2ad358$export$2e2bcd8739ae039 = $ae2458133d2ad358$var$Filter;

});
parcelRegister("dqc6Z", function(module, exports) {
$parcel$export(module.exports, "SearchField", () => $84caf67c6542222b$export$b94867ecbd698f21);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");
var $awdRS = parcelRequire("awdRS");

var $6S4l2 = parcelRequire("6S4l2");

var $ftN6c = parcelRequire("ftN6c");

var $sY9BV = parcelRequire("sY9BV");

var $k71qx = parcelRequire("k71qx");

var $lmgo6 = parcelRequire("lmgo6");
var $1DXK0 = parcelRequire("1DXK0");

var $lRq8t = parcelRequire("lRq8t");

var $bzbsd = parcelRequire("bzbsd");

var $4cTDP = parcelRequire("4cTDP");

var $1uv7v = parcelRequire("1uv7v");

var $kUoGK = parcelRequire("kUoGK");

var $1302Y = parcelRequire("1302Y");

var $7CY7m = parcelRequire("7CY7m");

var $4jrRd = parcelRequire("4jrRd");

var $ixnXK = parcelRequire("ixnXK");
// This class prevents filled in input field causing confirmation dialog
// when user wants to navigate away. This functionality is coming from Jira monolith.
const $84caf67c6542222b$var$className = 'ajs-dirty-warning-exempt';
const $84caf67c6542222b$var$SearchFieldContainer = ({ shouldFitContainerWidth: shouldFitContainerWidth, reducedHeight: reducedHeight, children: children })=>{
    const { isSoftwareFullTheming: isSoftwareFullTheming } = (0, $kUoGK.useSoftwareProjectTheming)();
    return (0, $1302Y.getIsSoftwareThemingM2Enabled)() ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $lmgo6.default), {
        xcss: [
            shouldFitContainerWidth && $84caf67c6542222b$var$fitContainerStyles,
            reducedHeight && $84caf67c6542222b$var$reducedHeightStyles,
            isSoftwareFullTheming && $84caf67c6542222b$var$themedBgStyles
        ]
    }, children) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($84caf67c6542222b$var$Container, {
        shouldFitContainerWidth: shouldFitContainerWidth,
        reducedHeight: reducedHeight
    }, children);
};
const $84caf67c6542222b$var$STABLE_EMPTY_OBJECT = {};
const $84caf67c6542222b$var$SearchFieldUnmemoized = ({ onEnter: onEnter, onChange: onChange, onFocus: onFocus, onBlur: onBlur, placeholder: placeholder = '', inputRef: inputRef, value: externalValue, autoFocus: autoFocus = false, isCompact: isCompact = false, isDisabled: isDisabled = false, shouldFitContainerWidth: shouldFitContainerWidth = false, isAutocompleteDisabled: isAutocompleteDisabled = false, placeholderAlwaysVisible: placeholderAlwaysVisible = false, searchIconVisible: searchIconVisible = true, isAlwaysExpanded: isAlwaysExpanded = false, increasedWidth: increasedWidth = false, reducedHeight: reducedHeight = false, maxLength: maxLength, describedById: describedById = '', ariaLabelText: ariaLabelText, id: id, renderCustomSearchField: renderCustomSearchField, testId: testId, inputProps: inputProps = $84caf67c6542222b$var$STABLE_EMPTY_OBJECT, isResponsive: isResponsive = false, showIconBeforeInput: showIconBeforeInput = false, renderTooltipContent: renderTooltipContent = null })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $ftN6c.useAnalyticsEvents)();
    const [isFocused, setIsFocused] = (0, $eJOHy.useState)(false);
    const [value, setValue] = (0, $eJOHy.useState)(externalValue || '');
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const textInput = (0, $eJOHy.useRef)(null);
    const previousValueRef = (0, $eJOHy.useRef)();
    const previousValue = previousValueRef.current;
    if (externalValue !== previousValue && externalValue !== value) // @ts-expect-error - TS2345 - Argument of type 'string | undefined' is not assignable to parameter of type 'SetStateAction<string>'.
    setValue(externalValue);
    previousValueRef.current = externalValue;
    const handleOnFocus = (0, $eJOHy.useCallback)((event)=>{
        setIsFocused(true);
        onFocus && onFocus(event);
    }, [
        onFocus
    ]);
    const handleOnBlur = (0, $eJOHy.useCallback)((event)=>{
        onBlur && onBlur(event);
        setIsFocused(false);
    }, [
        onBlur
    ]);
    const handleOnChange = (0, $eJOHy.useCallback)(({ currentTarget: currentTarget })=>{
        const { value: val } = currentTarget;
        const analyticsEvent = createAnalyticsEvent({
            action: 'changed'
        });
        setValue(val);
        onChange(val, analyticsEvent);
    }, [
        createAnalyticsEvent,
        onChange
    ]);
    const handleKeyDown = (0, $eJOHy.useCallback)((event)=>{
        const analyticsEvent = createAnalyticsEvent({
            action: 'changed'
        });
        if (event.key === 'Escape') {
            setValue('');
            onChange('', analyticsEvent);
        }
        if (onEnter && event.keyCode === (0, (/*@__PURE__*/$parcel$interopDefault($6S4l2)))('enter')) {
            event.preventDefault();
            onEnter(event.currentTarget && event.currentTarget.value);
        }
    }, [
        createAnalyticsEvent,
        onChange,
        onEnter
    ]);
    const handleOnClear = (0, $eJOHy.useCallback)(()=>{
        if (value !== '') {
            const analyticsEvent = createAnalyticsEvent({
                action: 'changed'
            });
            setValue('');
            onChange('', analyticsEvent);
        }
        if (inputRef && inputRef.current !== null) inputRef.current.blur();
        if (textInput.current !== null) // @ts-expect-error - TS2571 - Object is of type 'unknown'.
        textInput.current.blur();
    }, [
        createAnalyticsEvent,
        inputRef,
        onChange,
        value
    ]);
    const isExpanded = isFocused || value !== '' || isAlwaysExpanded;
    const textFieldProps = (0, $eJOHy.useMemo)(()=>{
        return {
            ...inputProps,
            'aria-label': ariaLabelText || placeholder || formatMessage((0, $7CY7m.messages).search),
            'aria-describedby': describedById,
            type: 'text',
            'data-test-id': 'searchfield',
            testId: testId ?? 'searchfield',
            name: 'search',
            className: $84caf67c6542222b$var$className,
            placeholder: placeholder,
            onFocus: handleOnFocus,
            onBlur: handleOnBlur,
            width: '120px',
            onChange: handleOnChange,
            onKeyDown: handleKeyDown,
            ref: inputRef || textInput,
            isCompact: isCompact,
            autoFocus: autoFocus,
            autoComplete: isAutocompleteDisabled ? 'off' : 'on',
            value: value,
            maxLength: maxLength,
            isDisabled: isDisabled
        };
    }, [
        ariaLabelText,
        autoFocus,
        describedById,
        formatMessage,
        handleKeyDown,
        handleOnBlur,
        handleOnChange,
        handleOnFocus,
        inputProps,
        inputRef,
        isAutocompleteDisabled,
        isCompact,
        isDisabled,
        maxLength,
        placeholder,
        testId,
        value
    ]);
    const searchIconDynamic = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $ixnXK.SearchFieldIconDynamic), {
        onClear: handleOnClear,
        hasValue: value !== '',
        clearIconLabel: formatMessage((0, $7CY7m.messages).clear),
        searchIconVisible: searchIconVisible,
        onlyIconSpacing: isResponsive && !isExpanded,
        ...(0, $4cTDP.fg)('jira_jif_jam_clear_text_icon') ? {
            inCustomSearchField: renderCustomSearchField !== undefined
        } : {}
    });
    const searchIcon = showIconBeforeInput ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $ixnXK.SearchFieldIcon), {
        searchIconVisible: searchIconVisible,
        onlyIconSpacing: isResponsive && !isExpanded
    }) : undefined;
    const clearIcon = showIconBeforeInput && value !== '' ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $4jrRd.ClearFieldIcon), {
        onClear: handleOnClear,
        clearIconLabel: formatMessage((0, $7CY7m.messages).clear)
    }) : undefined;
    const { onFocus: onFocusTextField, ref: textFieldRef, 'aria-describedby': textfieldAriaDescription, onBlur: onBlurTextField, ...restTextFieldProps } = textFieldProps;
    const showTooltip = (0, $eJOHy.useMemo)(()=>{
        return renderTooltipContent !== null && renderTooltipContent !== undefined && value === '';
    }, [
        renderTooltipContent,
        value
    ]);
    const useShowTooltip = (0, $eJOHy.useCallback)(()=>showTooltip, [
        showTooltip
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($84caf67c6542222b$var$SearchFieldContainer, {
        shouldFitContainerWidth: shouldFitContainerWidth,
        reducedHeight: reducedHeight
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($84caf67c6542222b$var$InputWrapper, {
        isExpanded: isExpanded,
        shouldFitContainerWidth: shouldFitContainerWidth,
        maxWidth: increasedWidth ? 328 : 184,
        placeholderAlwaysVisible: placeholderAlwaysVisible,
        isResponsive: isResponsive
    }, renderCustomSearchField !== undefined ? renderCustomSearchField({
        textFieldProps: textFieldProps,
        searchIcon: searchIconDynamic
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $k71qx.default), {
        content: renderTooltipContent,
        canAppear: useShowTooltip,
        position: "bottom-start",
        hideTooltipOnClick: true,
        ignoreTooltipPointerEvents: true
    }, ({ onFocus: onFocusTooltip, ref: tooltipRef, 'aria-describedby': tooltipAriaDescription, onBlur: onBlurTooltip, ...tooltipProps })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $sY9BV.default), {
            ...tooltipProps,
            ...restTextFieldProps,
            elemBeforeInput: searchIcon,
            elemAfterInput: !showIconBeforeInput ? searchIconDynamic : clearIcon,
            ...id !== undefined ? {
                id: id
            } : {},
            // eslint-disable-next-line react-hooks/rules-of-hooks
            onFocus: (0, $eJOHy.useCallback)((event)=>{
                onFocusTextField && onFocusTextField(event);
                onFocusTooltip(event);
            }, [
                onFocusTooltip
            ]),
            // eslint-disable-next-line react-hooks/rules-of-hooks
            onBlur: (0, $eJOHy.useCallback)((event)=>{
                onBlurTextField && onBlurTextField(event);
                onBlurTooltip(event);
            }, [
                onBlurTooltip
            ]),
            ref: (0, $bzbsd.mergeRefs)(textFieldRef, tooltipRef),
            "aria-describedby": tooltipAriaDescription || textfieldAriaDescription
        }))));
};
$84caf67c6542222b$var$SearchFieldUnmemoized.displayName = 'Search';
$84caf67c6542222b$var$SearchFieldUnmemoized.whyDidYouRender = true;
const $84caf67c6542222b$export$b94867ecbd698f21 = /*#__PURE__*/ (0, $eJOHy.memo)($84caf67c6542222b$var$SearchFieldUnmemoized);
$84caf67c6542222b$export$b94867ecbd698f21.displayName = 'Search';
const $84caf67c6542222b$var$fitContainerStyles = (0, $1DXK0.xcss)({
    width: '100%'
});
const $84caf67c6542222b$var$reducedHeightStyles = (0, $1DXK0.xcss)({
    height: '32px'
});
const $84caf67c6542222b$var$themedBgStyles = (0, $1DXK0.xcss)({
    // @ts-expect-error - Apply the dominant colour behind the search input for image background themes
    backgroundColor: (0, $1uv7v.Tokens).COLOR_ELEVATION_SURFACE /* eslint-disable-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values */ ,
    borderRadius: "var(--ds-radius-small, 4px)"
}); // Delete when cleaning up getIsSoftwareThemingM2Enabled
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $84caf67c6542222b$var$Container = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { shouldFitContainerWidth: shouldFitContainerWidth, reducedHeight: reducedHeight, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_1e0c1txw",
            __cmplp.shouldFitContainerWidth && "_1bsb1osq",
            __cmplp.reducedHeight && "_4t3izwfg",
            __cmplp.className
        ])
    });
});
const $84caf67c6542222b$var$InputWrapper = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { placeholderAlwaysVisible: placeholderAlwaysVisible, isResponsive: isResponsive, maxWidth: maxWidth, isExpanded: isExpanded, shouldFitContainerWidth: shouldFitContainerWidth, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmpldp,
        style: {
            ...__cmpls,
            "--_1et2rhb": (0, $awdRS.default)(__cmplp.maxWidth, "px"),
            "--_47juog": (0, $awdRS.default)(__cmplp.isExpanded ? `${__cmplp.maxWidth}px` : '30px'),
            "--_5cv8rq": (0, $awdRS.default)(__cmplp.isExpanded ? 'auto' : '32px'),
            "--_jy5l88": (0, $awdRS.default)(__cmplp.isExpanded ? `${"var(--ds-space-050, 4px)"} ${"var(--ds-space-075, 6px)"}` : "var(--ds-space-0, 0px)"),
            "--_1skyi4s": (0, $awdRS.default)(__cmplp.isExpanded ? 'auto' : 0),
            "--_1qenfck": (0, $awdRS.default)(__cmplp.isExpanded ? 1 : 0),
            "--_1b7586u": (0, $awdRS.default)(__cmplp.isExpanded ? `${__cmplp.maxWidth}px` : '120px'),
            "--_1b72lxu": (0, $awdRS.default)(__cmplp.shouldFitContainerWidth ? '100%' : `${__cmplp.isExpanded ? __cmplp.maxWidth : 120}px`)
        },
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_v564zpk5 _1e0c1txw _166qglyw _101ad2bq _i2ybkb7n",
            __cmplp.placeholderAlwaysVisible ? "_lav0kb7n" : "_lav0idpf",
            __cmplp.isResponsive ? "_1bsb1ayu _1s4pflvl _1kneabdv _odci1sf5 _ffa416hp _5xde1wic _1hr27bcq" : "_1bsb1di6",
            __cmplp.className
        ])
    });
});

});
parcelRegister("7CY7m", function(module, exports) {
$parcel$export(module.exports, "messages", () => $1790c56385a948ce$export$defe85febe8b728c);

var $7qGN1 = parcelRequire("7qGN1");
const $1790c56385a948ce$export$defe85febe8b728c = (0, $7qGN1.defineMessages)({
    clear: {
        "id": "searchfield.clear",
        "defaultMessage": "Clear"
    },
    search: {
        "id": "searchfield.search",
        "defaultMessage": "Search"
    }
});

});

parcelRegister("4jrRd", function(module, exports) {
$parcel$export(module.exports, "ClearFieldIcon", () => $047d370cc11f69d8$export$84038b503874befa);

var $eJOHy = parcelRequire("eJOHy");

var $Ay1uj = parcelRequire("Ay1uj");

var $6zhpo = parcelRequire("6zhpo");

var $a03qM = parcelRequire("a03qM");

var $8nu6j = parcelRequire("8nu6j");
var $6efFi = parcelRequire("6efFi");
var $bQP4O = parcelRequire("bQP4O");
var $1DXK0 = parcelRequire("1DXK0");

var $4cTDP = parcelRequire("4cTDP");
const $047d370cc11f69d8$export$84038b503874befa = ({ onClear: onClear, clearIconLabel: clearIconLabel })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
        xcss: [
            (0, $4cTDP.fg)('jira_jif_jam_clear_text_icon') ? $047d370cc11f69d8$var$wrapperStylesClearIcon : $047d370cc11f69d8$var$wrapperStylesCloseIcon
        ]
    }, (0, $4cTDP.fg)('jira_jif_jam_clear_text_icon') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $bQP4O.default), {
        xcss: $047d370cc11f69d8$var$iconWrapperStyles,
        onClick: onClear,
        // Clear button should not be focusable
        // see https://hello.atlassian.net/wiki/spaces/A11YKB/pages/3031993460/Clear+options+on+an+input+field
        tabIndex: -1,
        "aria-label": clearIconLabel,
        testId: "searchfield.ui.clearfield-icon.clear-button"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($a03qM))), {
        label: ""
    })) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $Ay1uj.default), {
        appearance: "subtle",
        testId: "searchfield.ui.clearfield-icon.clear-button",
        onClick: onClear,
        label: clearIconLabel,
        spacing: "compact",
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($6zhpo)))
    }));
const $047d370cc11f69d8$var$wrapperStylesCloseIcon = (0, $1DXK0.xcss)({
    display: 'flex',
    marginRight: 'space.025',
    [(0, $6efFi.media).above.md]: {
        marginRight: 'space.050'
    }
});
const $047d370cc11f69d8$var$wrapperStylesClearIcon = (0, $1DXK0.xcss)({
    display: 'flex',
    marginRight: 'space.050',
    [(0, $6efFi.media).above.md]: {
        marginRight: 'space.075'
    }
});
const $047d370cc11f69d8$var$iconWrapperStyles = (0, $1DXK0.xcss)({
    display: 'flex',
    cursor: 'pointer',
    paddingInlineStart: 'space.0',
    paddingInlineEnd: 'space.0',
    paddingBlockStart: 'space.0',
    paddingBlockEnd: 'space.0',
    borderRadius: 'radius.full',
    color: 'color.text.subtlest',
    ':hover': {
        color: 'color.text.accent.gray'
    }
});

});

parcelRegister("ixnXK", function(module, exports) {
$parcel$export(module.exports, "SearchFieldIconDynamic", () => $fd1be89cde4ae981$export$9eef03e91cdeba14);
$parcel$export(module.exports, "SearchFieldIcon", () => $fd1be89cde4ae981$export$8a82bff895521bd9);

var $eJOHy = parcelRequire("eJOHy");

var $goZPP = parcelRequire("goZPP");

var $6zhpo = parcelRequire("6zhpo");

var $dt3aG = parcelRequire("dt3aG");

var $8nu6j = parcelRequire("8nu6j");
var $6efFi = parcelRequire("6efFi");
var $bQP4O = parcelRequire("bQP4O");
var $1DXK0 = parcelRequire("1DXK0");

var $a03qM = parcelRequire("a03qM");

var $4cTDP = parcelRequire("4cTDP");
const $fd1be89cde4ae981$export$9eef03e91cdeba14 = ({ onClear: onClear, hasValue: hasValue, searchIconVisible: searchIconVisible, clearIconLabel: clearIconLabel, primaryColor: primaryColor, onlyIconSpacing: onlyIconSpacing = false, inCustomSearchField: inCustomSearchField = false })=>{
    const akSearchIcon = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($dt3aG))), {
        label: "",
        LEGACY_primaryColor: primaryColor,
        color: "currentColor"
    });
    const searchIcon = searchIconVisible ? akSearchIcon : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
        xcss: [
            $fd1be89cde4ae981$var$wrapperStyles,
            onlyIconSpacing && $fd1be89cde4ae981$var$spacingStyles,
            inCustomSearchField && (0, $4cTDP.fg)('jira_jif_jam_clear_text_icon') && $fd1be89cde4ae981$var$minimalSpacingStyles
        ]
    }, // eslint-disable-next-line no-nested-ternary
    hasValue ? (0, $4cTDP.fg)('jira_jif_jam_clear_text_icon') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $bQP4O.default), {
        xcss: $fd1be89cde4ae981$var$iconWrapperStyles,
        onClick: onClear,
        // Clear button should not be focusable
        // see https://hello.atlassian.net/wiki/spaces/A11YKB/pages/3031993460/Clear+options+on+an+input+field
        tabIndex: -1,
        testId: "searchfield.ui.searchfield-icon.clear-button",
        "aria-label": clearIconLabel
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($a03qM))), {
        label: ""
    })) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $goZPP.default), {
        appearance: "subtle",
        spacing: "none",
        // eslint-disable-next-line jira/integration/enforce-data-testid-usage
        "data-test-id": "searchfield.ui.searchfield-icon.clear-button",
        testId: "searchfield.ui.searchfield-icon.clear-button",
        onClick: onClear,
        iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($6zhpo))), {
            label: clearIconLabel,
            LEGACY_primaryColor: primaryColor,
            color: "currentColor"
        })
    }) : searchIcon);
};
const $fd1be89cde4ae981$export$8a82bff895521bd9 = ({ searchIconVisible: searchIconVisible, onlyIconSpacing: onlyIconSpacing = false })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
        xcss: [
            $fd1be89cde4ae981$var$wrapperStylesBefore,
            onlyIconSpacing && $fd1be89cde4ae981$var$spacingStylesBefore
        ]
    }, searchIconVisible ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($dt3aG))), {
        spacing: "none",
        label: "",
        color: "var(--ds-icon, #44546F)"
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null));
const $fd1be89cde4ae981$var$wrapperStyles = (0, $1DXK0.xcss)({
    color: 'color.text.accent.gray',
    marginTop: 'space.0',
    // the wider marginRight is applicable for when the search/clear icon is after the input
    marginRight: 'space.100',
    marginBottom: 'space.0',
    marginLeft: 'space.0',
    height: '16px',
    display: 'flex',
    alignItems: 'center'
});
// if this icon is used in a custom search field, we won't assume any spacing since we don't know where their searchIcon is used
// i.e. before or after the input
// it will be up to the consumers to add spacing where needed
const $fd1be89cde4ae981$var$minimalSpacingStyles = (0, $1DXK0.xcss)({
    marginRight: 'space.0'
});
const $fd1be89cde4ae981$var$spacingStyles = (0, $1DXK0.xcss)({
    marginRight: 'space.075',
    [(0, $6efFi.media).above.md]: {
        marginRight: 'space.100'
    }
});
const $fd1be89cde4ae981$var$wrapperStylesBefore = (0, $1DXK0.xcss)({
    display: 'flex',
    marginRight: 'space.0',
    marginLeft: 'space.075',
    [(0, $6efFi.media).above.md]: {
        marginLeft: 'space.100'
    }
});
const $fd1be89cde4ae981$var$spacingStylesBefore = (0, $1DXK0.xcss)({
    marginLeft: 'space.075',
    [(0, $6efFi.media).above.md]: {
        marginLeft: 'space.100'
    }
});
const $fd1be89cde4ae981$var$iconWrapperStyles = (0, $1DXK0.xcss)({
    display: 'flex',
    cursor: 'pointer',
    paddingInlineStart: 'space.0',
    paddingInlineEnd: 'space.0',
    paddingBlockStart: 'space.0',
    paddingBlockEnd: 'space.0',
    borderRadius: 'radius.full',
    color: 'color.text.subtlest',
    ':hover': {
        color: 'color.text.accent.gray'
    }
});

});




parcelRegister("jubdf", function(module, exports) {
$parcel$export(module.exports, "default", () => $8003c333d6bcdf2a$export$2e2bcd8739ae039);

var $as6H2 = parcelRequire("as6H2");

var $1Ejia = parcelRequire("1Ejia");
var $8003c333d6bcdf2a$export$2e2bcd8739ae039 = (0, $as6H2.default)('GroupPicker', {
    onChange: 'changed'
})((0, $1Ejia.default));

});
parcelRegister("1Ejia", function(module, exports) {
$parcel$export(module.exports, "default", () => $517a0c57c4b325d5$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $aXKmr = parcelRequire("aXKmr");

var $hxN6p = parcelRequire("hxN6p");

var $2sHLK = parcelRequire("2sHLK");

var $idGBm = parcelRequire("idGBm");

var $l01aN = parcelRequire("l01aN");

var $403OI = parcelRequire("403OI");
class $517a0c57c4b325d5$export$471c4c2b52766e8d extends (0, $eJOHy.Component) {
    static{
        this.defaultProps = {
            isRequired: false,
            isDisabled: false,
            isClearable: true,
            isCompact: false,
            fetchOnce: false,
            width: 200
        };
    }
    constructor(props){
        super(props), this.state = {
            options: [],
            selectedGroup: this.props.selectedGroup,
            prevSelectedGroup: this.props.selectedGroup
        }, this.onSelected = (selectedOption)=>{
            this.setState({
                selectedGroup: selectedOption
            });
            this.props.onChange(selectedOption);
        }, /* eslint-disable jira/react-arrow-function-property-naming */ this.formatOptionDataTransformer = (group)=>({
                // @ts-expect-error - TS2769 - No overload matches this call.
                avatar: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($hxN6p))), null),
                label: group.name
            }), /* eslint-disable jira/react-arrow-function-property-naming */ this.fetchAllGroups = (searchQuery)=>(0, $l01aN.getAllGroups)(searchQuery), /* eslint-disable jira/react-arrow-function-property-naming */ this.fetchUserGroups = (searchQuery)=>this.props.withMember ? (0, $l01aN.getUserGroups)(this.props.withMember, searchQuery) : Promise.resolve();
        this.groupPickerId = `group-picker.label.id-${(0, $aXKmr.v4)()}`;
    }
    static getDerivedStateFromProps(props, state) {
        const currentGroup = props.selectedGroup && props.selectedGroup.value;
        const prevGroup = state.prevSelectedGroup && state.prevSelectedGroup.value;
        if (currentGroup !== prevGroup) return {
            ...state,
            selectedGroup: props.selectedGroup,
            prevSelectedGroup: props.selectedGroup
        };
        return null;
    }
    componentDidMount() {
        const { fetchOnce: fetchOnce } = this.props;
        if (fetchOnce === true) {
            const getOptions = this.getFetchOptionsFunction();
            getOptions('').then((groups)=>this.setState({
                    // @ts-expect-error - TS2322 - Type 'void | Group[]' is not assignable to type 'Group[]'.
                    options: groups
                }));
        }
    }
    getFetchOptionsFunction() {
        return this.props.withMember ? this.fetchUserGroups : this.fetchAllGroups;
    }
    render() {
        const { intl: { formatMessage: formatMessage }, placeholder: placeholder = this.props.placeholder || formatMessage((0, $403OI.default).placeholder), onChange: onChange, fetchOnce: fetchOnce, ...props } = this.props;
        const { selectedGroup: selectedGroup } = this.state;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $2sHLK.PickerWithAvatar), {
            "aria-label": !this.props.label ? formatMessage((0, $403OI.default).labelText) : undefined,
            inputId: this.groupPickerId,
            ...props,
            errorMessage: formatMessage((0, $403OI.default).error),
            placeholder: placeholder,
            onSelected: this.onSelected,
            // @ts-expect-error - TS2769 - No overload matches this call.
            options: fetchOnce === true ? this.state.options : this.getFetchOptionsFunction(),
            formatOptionDataTransformer: this.formatOptionDataTransformer,
            value: selectedGroup && selectedGroup.name ? selectedGroup : null
        });
    }
}
var $517a0c57c4b325d5$export$2e2bcd8739ae039 = (0, $idGBm.injectIntlV2)($517a0c57c4b325d5$export$471c4c2b52766e8d);

});
parcelRegister("2sHLK", function(module, exports) {
$parcel$export(module.exports, "PickerWithAvatar", () => $3183b99370c8c0ed$export$e6b8a87858f7afd1);
$parcel$export(module.exports, "PickerWithAvatarAndAnalytics", () => $3183b99370c8c0ed$export$3d409af828769e2e);
/**
 * This is the base for Picker that can be used to create any type of component:
 * 1) with a list of predefined options
 * 2) that dynamically fetches its options from external resource.
 */ 
var $as6H2 = parcelRequire("as6H2");

var $fJTOm = parcelRequire("fJTOm");

var $87K62 = parcelRequire("87K62");
const $3183b99370c8c0ed$export$e6b8a87858f7afd1 = (0, $87K62.default);
const $3183b99370c8c0ed$export$3d409af828769e2e = (0, $as6H2.default)('picker', {
    onSelected: 'changed',
    onMultiSelected: 'multi-changed'
})((0, $87K62.default));
const $3183b99370c8c0ed$export$d8d9f25d80d89b16 = (0, $as6H2.default)('picker', {
    onSelected: 'changed',
    onMultiSelected: 'multi-changed'
})((0, $fJTOm.default));

});
parcelRegister("fJTOm", function(module, exports) {
$parcel$export(module.exports, "getOptionBaseStyles", () => $69685483963d086b$export$cef6e25059b681a);
$parcel$export(module.exports, "Picker", () => $69685483963d086b$export$ba25329847403e11);
$parcel$export(module.exports, "default", () => $69685483963d086b$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $eJOHy = parcelRequire("eJOHy");

var $3s8bj = parcelRequire("3s8bj");

var $12DRg = parcelRequire("12DRg");

var $4ibbN = parcelRequire("4ibbN");

var $1jVV7 = parcelRequire("1jVV7");

var $goZPP = parcelRequire("goZPP");

var $8IeH1 = parcelRequire("8IeH1");

var $3DNvO = parcelRequire("3DNvO");
var $6UCkD = parcelRequire("6UCkD");
var $6XEne = parcelRequire("6XEne");
var $kVcjU = parcelRequire("kVcjU");
var $c4OV1 = parcelRequire("c4OV1");

var $k71qx = parcelRequire("k71qx");

var $fceQU = parcelRequire("fceQU");

var $4cTDP = parcelRequire("4cTDP");

var $lxUP5 = parcelRequire("lxUP5");

var $6joHJ = parcelRequire("6joHJ");

var $6YFG2 = parcelRequire("6YFG2");

var $6rlhA = parcelRequire("6rlhA");
const $69685483963d086b$export$3a3072dd741f354b = 500;
const $69685483963d086b$export$cef6e25059b681a = (optionState)=>({
        ...optionState.isDisabled ? {
            cursor: 'not-allowed',
            color: "var(--ds-text-subtlest, #626F86)",
            '&, :active': {
                backgroundColor: 'transparent'
            }
        } : {
            cursor: 'pointer'
        },
        whiteSpace: 'nowrap',
        overflow: 'hidden',
        textOverflow: 'ellipsis'
    });
class $69685483963d086b$export$ba25329847403e11 extends (0, $eJOHy.Component) {
    static{
        this.defaultProps = {
            isRequired: false,
            isDisabled: false,
            isClearable: false,
            isCompact: false,
            isCreatable: false,
            isMulti: false,
            noPortal: false,
            isCheckbox: false,
            label: undefined,
            defaultValue: undefined,
            width: 'auto',
            onSelected: (0, (/*@__PURE__*/$parcel$interopDefault($12DRg))),
            onMultiSelected: (0, (/*@__PURE__*/$parcel$interopDefault($12DRg)))
        };
    }
    static getDerivedStateFromProps(props) {
        if (props.menuIsOpen !== undefined) return {
            menuIsOpen: props.menuIsOpen
        };
        return null;
    }
    constructor(props){
        super(props), this.state = {
            validationState: 'default',
            showErrorMessage: false,
            menuWasOpen: false,
            menuIsOpen: false,
            initialFocusHandled: false
        }, this.onSelected = (selection, action, analyticsEvent)=>{
            this.setState(()=>({
                    menuIsOpen: false
                }));
            const { isMulti: isMulti } = this.props;
            if (Array.isArray(selection)) {
                if (isMulti) // @ts-expect-error - TS2554 - Expected 1 arguments, but got 2.
                this.props.onMultiSelected(selection, analyticsEvent);
                else // When the selection is cleared in single select mode, selection is an array.
                this.props.onSelected(undefined, analyticsEvent);
            } else // @ts-expect-error - TS2339 - Property 'value' does not exist on type 'SelectOption'.
            selection && selection.value ? this.props.onSelected(selection, analyticsEvent) : this.props.onSelected(undefined, analyticsEvent);
        }, this.onMenuOpen = ()=>{
            this.setState(()=>({
                    menuIsOpen: true,
                    menuWasOpen: true
                }));
        }, this.onMenuClose = ()=>{
            this.setState(()=>({
                    menuIsOpen: false
                }));
        }, this.onBlur = (event)=>{
            this.hideErrorMessage();
            const { onBlur: onBlur } = this.props;
            if (onBlur && typeof onBlur === 'function') onBlur(event);
        }, this.onFocus = (event)=>{
            this.showErrorMessage();
            const { onFocus: onFocus } = this.props;
            if (onFocus && typeof onFocus === 'function') onFocus(event);
        }, this.setErrorState = ()=>{
            this.setState({
                showErrorMessage: true,
                validationState: 'error'
            });
        }, this.showErrorMessage = ()=>this.setState({
                showErrorMessage: true
            }), this.hideErrorMessage = ()=>this.setState({
                showErrorMessage: false
            }) // eslint-disable-next-line @typescript-eslint/no-explicit-any
        , this.loadOptions = (filter, callback)=>{
            this.setState({
                validationState: 'default'
            });
            this.debouncedLoadOptions(filter, callback);
        }, this.renderOption = (props)=>{
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            const propsData = props.data;
            const disableReason = props.isDisabled && propsData && propsData.disableReason || null;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $k71qx.default), {
                position: "right",
                content: disableReason
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $6XEne.components).Option // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            , props));
        } // Will remove this renderMenuList when clean up FG since it's no longer needed
        , this.renderMenuList = (menuListProps)=>{
            const { isClearable: isClearable, intl: { formatMessage: formatMessage } } = this.props;
            return(// @ts-expect-error - TS2740 - Type '{ children: (Element | ReactNode)[]; hasValue: boolean; clearValue: () => void; }' is missing the following properties from type 'CommonProps<OptionTypeBase, boolean, GroupTypeBase<OptionTypeBase>>': cx, getStyles, getValue, isMulti, and 6 more.
            /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $6XEne.components).MenuList, menuListProps, isClearable && menuListProps.hasValue && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8IeH1.default), {
                xcss: $69685483963d086b$var$styles.clearButtonWrapper
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $goZPP.default), {
                appearance: "link",
                shouldFitContainer: true,
                onClick: menuListProps.clearValue
            }, formatMessage((0, $6rlhA.default).clearSelected))), menuListProps.children));
        }, this.renderValueContainer = (props)=>{
            const { onValueContainerClick: onValueContainerClick } = props.selectProps;
            return(// eslint-disable-next-line @atlassian/a11y/interactive-element-not-keyboard-focusable
            /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8IeH1.default), {
                xcss: $69685483963d086b$var$styles.valueContainer,
                onClick: onValueContainerClick,
                testId: "common-components-picker.base.react-dnd-and-select-focus-bug-fix"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $6XEne.components).ValueContainer, props)));
        }; // This is initialized in constructor because when it is a class property then flow gets confused about the generic type in callback.
        // That is a known bug: https://github.com/facebook/flow/issues/6978
        this.debouncedLoadOptions = (0, (/*@__PURE__*/$parcel$interopDefault($3s8bj)))(// eslint-disable-next-line @typescript-eslint/no-explicit-any
        (filter, callback)=>{
            // @ts-expect-error - TS2349 - This expression is not callable.
            this.props.options(filter).then(callback, ()=>{
                callback([]);
                this.setErrorState();
            });
        }, $69685483963d086b$export$3a3072dd741f354b); // @ts-expect-error - Property 'selectRef' does not exist on type 'Picker<SelectOption>'
        this.selectRef = /*#__PURE__*/ (0, $eJOHy.createRef)();
    }
    getSelectComponent(isAsync) {
        if (this.props.isCreatable) return isAsync ? (0, $3DNvO.default) : (0, $kVcjU.default);
        if (isAsync) return 0, $4ibbN.AsyncSelectWithAnalytics;
        return this.props.isCheckbox ? (0, $6UCkD.default) : (0, $c4OV1.default);
    }
    getComponentOverrides() {
        const { menuWasOpen: menuWasOpen } = this.state;
        const Option = {
            Option: this.renderOption
        }; // Remove MenuList when clean up FG since we no longer need to override to add `Clear Selected` button
        const MenuList = (0, $4cTDP.fg)('jfp-a11y-team_update_legacy_select_clear_fuction') ? {} : {
            MenuList: this.renderMenuList
        };
        const LoadingIndicator = menuWasOpen ? {} : {
            LoadingIndicator: null
        };
        return {
            ...this.props.components,
            ...Option,
            ...MenuList,
            ...LoadingIndicator
        };
    }
    render() {
        const { showErrorMessage: showErrorMessage, validationState: validationState, menuIsOpen: menuIsOpen } = this.state;
        const { intl: { formatMessage: formatMessage } } = this.props;
        const { label: label, listItemCustomStyles: listItemCustomStyles, placeholder: placeholder = formatMessage((0, $6rlhA.default).defaultPlaceholder), defaultValue: defaultValue, isRequired: isRequired, isDisabled: isDisabled, isCompact: isCompact, isClearableWithCrossIcon: isClearableWithCrossIcon, errorMessage: errorMessage, options: options, width: width, minWidth: minWidth, noPortal: noPortal, isCheckbox: isCheckbox, hasDraggableParentComponent: hasDraggableParentComponent } = this.props;
        const isAsync = typeof options === 'function';
        const SelectComponent = this.getSelectComponent(isAsync);
        const isErrorMessageOpened = showErrorMessage && validationState === 'error';
        let selectParams = {
            placeholder: placeholder,
            isDisabled: isDisabled,
            isClearable: isClearableWithCrossIcon || false,
            defaultValue: defaultValue,
            defaultOptions: true,
            autoFocus: !!this.props.autoFocus,
            loadOptions: isAsync && this.loadOptions,
            options: !isAsync && options,
            onChange: this.onSelected,
            noOptionsMessage: ()=>this.props.noOptionsMessage ?? formatMessage((0, $6rlhA.default).noOptions),
            loadingMessage: ()=>formatMessage((0, $6rlhA.default).loading),
            validationState: this.state.validationState,
            onBlur: this.onBlur,
            onFocus: this.onFocus,
            menuPortalTarget: noPortal ? null : (0, $fceQU.getDocument)()?.body,
            spacing: isCompact ? 'compact' : 'default',
            styles: {
                ...this.props.styles,
                // without properly set zIndex value dropdown with options is cut inside modal dialogs
                // @ts-expect-error - TS7006 - Parameter 'base' implicitly has an 'any' type.
                menuPortal: (base)=>({
                        ...base,
                        zIndex: (0, $1jVV7.layers).modal
                    }),
                // @ts-expect-error - TS7006 - Parameter 'base' implicitly has an 'any' type.
                container: (base)=>({
                        ...base,
                        width: width,
                        minWidth: minWidth
                    }),
                // @ts-expect-error - TS7006 - Parameter 'base' implicitly has an 'any' type. | TS7006 - Parameter 'optionState' implicitly has an 'any' type.
                option: (base, optionState)=>({
                        ...base,
                        ...$69685483963d086b$export$cef6e25059b681a(optionState),
                        ...listItemCustomStyles
                    }),
                // @ts-expect-error - TS7006 - Parameter 'base' implicitly has an 'any' type. | TS7006 - Parameter 'optionState' implicitly has an 'any' type.
                menu: (base)=>{
                    return {
                        ...base,
                        width: 'max-content',
                        // This makes the menu fit the widest content
                        minWidth: '100%'
                    };
                }
            }
        };
        if (!isCheckbox) selectParams = {
            ...selectParams,
            menuIsOpen: // @ts-expect-error - TS2322 - Type '{ menuIsOpen: boolean; onMenuOpen: () => void; onMenuClose: () => void; components: { LoadingIndicator?: undefined; MenuList: (menuListProps: MenuListProps) => JSX.Element; Option: (props: CommonProps<...> & ... 1 more ... & { ...; }) => JSX.Element; } | { ...; }; ... 16 more ...; styles: { ...; }; }' is not assignable to type '{ placeholder: string; isDisabled: boolean | undefined; isClearable: boolean; defaultValue: SelectOption | undefined; defaultOptions: boolean; autoFocus: boolean; loadOptions: false | ((filter: string, callback: (arg1: SelectOption[]) => Record<...>) => void); ... 9 more ...; styles: { ...; }; }'.
            menuIsOpen,
            onMenuOpen: this.onMenuOpen,
            onMenuClose: this.onMenuClose,
            components: this.getComponentOverrides()
        };
         // When "hasDraggableParentComponent" is true, this means <Select /> is nested inside <Draggable /> from react-beautiful-dnd
        // This relationship prevents the dropdown menu from opening because of bugs in the default focus state and clicking in a particular area of <Select />
        // Context: https://hello.atlassian.net/wiki/spaces/~989411314/pages/2861097485/Investigation+Notes+for+atlaskit+select+react-beautiful-dnd#Temporary-Solution
        if (hasDraggableParentComponent) {
            const { initialFocusHandled: initialFocusHandled } = this.state;
            const handleClick = ()=>{
                if (initialFocusHandled) // As <Select /> is already focused, calling this.selectRef.current.focus() again no longer triggers its own handlers (i.e. onMenuOpen, onMenuClose)
                // We have to manually handle the open and close states of the dropdown menu based on a user's click from this point onwards to prevent the bug
                this.setState((state)=>({
                        menuIsOpen: !state.menuIsOpen
                    }));
                else if (!menuIsOpen) {
                    // Trigger focus state when ValueContainer is clicked for the first time
                    // The focused state will then invoke <Select /> instance's own handlers (e.g. onMenuOpen, onMenuClose)
                    // to manage the state of the dropdown menu
                    // @ts-expect-error - Property 'selectRef' does not exist on type 'Picker<SelectOption>'
                    this.selectRef.current.focus();
                    this.setState(()=>({
                            initialFocusHandled: true
                        }));
                }
            };
            selectParams = {
                ...selectParams,
                // @ts-expect-error - Object literal may only specify known properties, and 'ref' does not exist in type '{ placeholder: string; isDisabled: boolean | undefined; isClearable: boolean; defaultValue: SelectOption | undefined; defaultOptions: boolean; autoFocus: boolean; loadOptions: false | ((filter: string, callback: (arg1: SelectOption[]) => Record<...>) => void); ... 9 more ...; styles: { ...; }; }'
                // + Property 'selectRef' does not exist on type 'Picker<SelectOption>'
                ref: this.selectRef,
                components: {
                    ...this.getComponentOverrides,
                    ValueContainer: this.renderValueContainer
                },
                onValueContainerClick: handleClick,
                openMenuOnFocus: true
            };
        }
        const { isClearable: isClearable } = this.props;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, label && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $lxUP5.FieldLabel), {
            htmlFor: this.props.inputId,
            label: label,
            isRequired: isRequired
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $6joHJ.JiraInlineDialog), {
            content: errorMessage,
            isOpen: isErrorMessageOpened,
            messageId: `common-components-picker.base.jira-inline-dialog.pickerErrorMessage.${this.props.inputId ?? 'unnamedInputId'}`,
            messageType: "transactional",
            placement: "right"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(SelectComponent, {
            inputId: this.props.inputId,
            ...this.props,
            ...selectParams,
            ...(0, $4cTDP.fg)('jfp-a11y-team_update_legacy_select_clear_fuction') ? {
                isClearable: isClearable
            } : {},
            options: isAsync ? undefined : this.props.options
        })));
    }
}
// @ts-expect-error This is required because of the ratcheted conversion from intlV2 to intl
const $69685483963d086b$var$PickerWithIntl = (0, $6YFG2.default)($69685483963d086b$export$ba25329847403e11);
const $69685483963d086b$var$DefaultPicker = (props)=>{
    // this function exists only to "preserve" generic on the Picker that is lost at injectIntl
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions, @typescript-eslint/no-explicit-any
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($69685483963d086b$var$PickerWithIntl, props);
};
$69685483963d086b$var$DefaultPicker.defaultProps = $69685483963d086b$export$ba25329847403e11.defaultProps;
var $69685483963d086b$export$2e2bcd8739ae039 = $69685483963d086b$var$DefaultPicker;
const $69685483963d086b$var$styles = {
    clearButtonWrapper: "_n7zl7r9e",
    valueContainer: "_16jlkb7n"
};

});
parcelRegister("4ibbN", function(module, exports) {
$parcel$export(module.exports, "AsyncSelectWithAnalytics", () => $ff7c32c387190ed2$export$ee664e5add893f9);

var $gWITR = parcelRequire("gWITR");

var $as6H2 = parcelRequire("as6H2");
const $ff7c32c387190ed2$export$ee664e5add893f9 = (0, $as6H2.default)('select', {
    onChange: 'changed'
})((0, $gWITR.default));

});

parcelRegister("3DNvO", function(module, exports) {
$parcel$export(module.exports, "default", () => $35aa8c3d4d43b8a4$export$2e2bcd8739ae039);

var $7pkFT = parcelRequire("7pkFT");

var $dDv66 = parcelRequire("dDv66");
const $35aa8c3d4d43b8a4$var$AsyncCreatableSelect = (0, $dDv66.default)((0, $7pkFT.default));
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$35aa8c3d4d43b8a4$export$2e2bcd8739ae039 = $35aa8c3d4d43b8a4$var$AsyncCreatableSelect;

});
parcelRegister("7pkFT", function(module, exports) {
$parcel$export(module.exports, "default", () => $69fba18f5363b86b$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $5tlgh = parcelRequire("5tlgh");

var $iSKoM = parcelRequire("iSKoM");

var $9gNEN = parcelRequire("9gNEN");

var $gVVTN = parcelRequire("gVVTN");
const $69fba18f5363b86b$var$AsyncCreatableSelect = /*#__PURE__*/ (0, $eJOHy.forwardRef)((props, ref)=>{
    const stateManagerProps = (0, $iSKoM.default)(props);
    const creatableProps = (0, $gVVTN.default)(stateManagerProps);
    const selectProps = (0, $9gNEN.default)(creatableProps);
    // @ts-ignore - TS2322: Complex generic type causing issues for help-center local consumption with TS 5.9.2
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $5tlgh.default), {
        ref: ref,
        ...selectProps
    });
});
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$69fba18f5363b86b$export$2e2bcd8739ae039 = $69fba18f5363b86b$var$AsyncCreatableSelect;

});


parcelRegister("lxUP5", function(module, exports) {
$parcel$export(module.exports, "FieldLabel", () => $02d61fcf6733b580$export$1acdcf5a973a8414);
/* main.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $806LH = parcelRequire("806LH");
const $02d61fcf6733b580$export$1acdcf5a973a8414 = ({ label: label, htmlFor: htmlFor, isRequired: isRequired = false })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($02d61fcf6733b580$var$Label, {
        htmlFor: htmlFor
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $806LH.default), {
        size: "xxsmall",
        as: "h2"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("div", {
        className: (0, $hcewu.default)([
            "_19pkidpf _2hwxidpf _otyridpf _18u0idpf _syaz131l _1e0c1ule _ca0qv47k _u5f3idpf _n3td1b66 _19bvidpf _ect41gqc"
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("span", null, label), isRequired ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("span", {
        role: "presentation",
        className: (0, $hcewu.default)([
            "_syaz1tmw _19bvv77o _ect41gqc"
        ])
    }, "*") : null)));
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $02d61fcf6733b580$var$Label = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "label", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_1e0c1ule",
            __cmplp.className
        ])
    });
});
const $02d61fcf6733b580$var$labelStyle = null;
const $02d61fcf6733b580$var$requiredIndicatorStyle = null;

});

parcelRegister("6joHJ", function(module, exports) {
$parcel$export(module.exports, "JiraInlineDialog", () => $765bdfac52a4c302$export$7ab52478615504b3);

var $eJOHy = parcelRequire("eJOHy");

var $cwZBT = parcelRequire("cwZBT");

var $bRMVI = parcelRequire("bRMVI");

var $fYeTG = parcelRequire("fYeTG");

var $1kIuW = parcelRequire("1kIuW");
const $765bdfac52a4c302$export$7ab52478615504b3 = (props)=>{
    if ((0, $bRMVI.shouldBeChoreographed)(props)) {
        if ((0, $fYeTG.isMobileAndInViewPanelIterationExperiment)()) return null;
        const { messageType: messageType, ...rest } = props;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1kIuW.ChoreographerInlineDialog), rest);
    }
    const { messageType: messageType, messageId: messageId, onMessageDisposition: onMessageDisposition, ...rest } = props;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $cwZBT.default), rest);
};

});
parcelRegister("1kIuW", function(module, exports) {
$parcel$export(module.exports, "ChoreographerInlineDialog", () => $7432b934335413bd$export$44a404f218b0e66e);

var $cwZBT = parcelRequire("cwZBT");

var $4GudG = parcelRequire("4GudG");
const $7432b934335413bd$export$44a404f218b0e66e = (0, $4GudG.withChoreographedToggle)((0, $cwZBT.default), 'isOpen', 'content');

});


parcelRegister("6rlhA", function(module, exports) {
$parcel$export(module.exports, "default", () => $742c5e69dae6a49f$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
const $742c5e69dae6a49f$var$messages = (0, $7qGN1.defineMessages)({
    noOptions: {
        "id": "common.components.picker.base.no-options",
        "defaultMessage": "No results"
    },
    loading: {
        "id": "common.components.picker.base.loading",
        "defaultMessage": "Searching..."
    },
    defaultPlaceholder: {
        "id": "common.components.picker.base.default-placeholder",
        "defaultMessage": "Select..."
    },
    clearSelected: {
        "id": "common.components.picker.base.clear-selected",
        "defaultMessage": "Clear selected"
    }
});
var $742c5e69dae6a49f$export$2e2bcd8739ae039 = $742c5e69dae6a49f$var$messages;

});


parcelRegister("87K62", function(module, exports) {
$parcel$export(module.exports, "default", () => $33a231bde2dbcecf$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $5DgXR = parcelRequire("5DgXR");

var $2sLVw = parcelRequire("2sLVw");

var $fJTOm = parcelRequire("fJTOm");
class $33a231bde2dbcecf$export$2e2bcd8739ae039 extends (0, $eJOHy.Component) {
    static{
        this.defaultProps = {
            showFocusedAvatar: false
        };
    }
    render() {
        const { formatOptionDataTransformer: formatOptionDataTransformer, showFocusedAvatar: showFocusedAvatar, ...props } = this.props;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $fJTOm.default), {
            ...props,
            onBlur: this.onBlur,
            onFocus: this.onFocus,
            formatOptionLabel: this.renderOption
        });
    }
    constructor(...args){
        super(...args), this.state = {
            canShowAvatar: true
        }, this.onBlur = (event)=>{
            this.setState(()=>({
                    canShowAvatar: true
                }));
            this.props.onBlur && this.props.onBlur(event);
        }, this.onFocus = (event)=>{
            if (!this.props.showFocusedAvatar) this.setState(()=>({
                    canShowAvatar: false
                }));
            this.props.onFocus && this.props.onFocus(event);
        }, this.renderOption = (option, { context: context // eslint-disable-next-line @typescript-eslint/no-explicit-any
         })=>{
            const { avatar: avatar, label: label } = this.props.formatOptionDataTransformer(option);
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($33a231bde2dbcecf$var$OptionWrapper, null, typeof avatar !== 'undefined' && (context !== 'value' || this.state.canShowAvatar) ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $2sLVw.default), null, typeof avatar === 'string' ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $5DgXR.default), {
                src: avatar,
                size: "xsmall"
            }) : avatar) : null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($33a231bde2dbcecf$var$LabelWrapper, null, label));
        };
    }
}
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $33a231bde2dbcecf$var$OptionWrapper = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_zulpu2gc _1e0c1txw _4cvr1h6o",
            __cmplp.className
        ])
    });
});
const $33a231bde2dbcecf$var$LabelWrapper = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_1reo15vq _18m915vq _o5721q9c _1bto1l2s",
            __cmplp.className
        ])
    });
});

});


parcelRegister("l01aN", function(module, exports) {
$parcel$export(module.exports, "getAllGroups", () => $7a95b05e333f0285$export$c243565349cba18c);
$parcel$export(module.exports, "getUserGroups", () => $7a95b05e333f0285$export$bda937ecc753b1f3);

var $8B2Am = parcelRequire("8B2Am");

var $1fygZ = parcelRequire("1fygZ");
const $7a95b05e333f0285$export$c243565349cba18c = (searchQuery, maxResults)=>(0, $8B2Am.getAllGroups)(searchQuery, maxResults).then((0, $1fygZ.transformAllGroups));
const $7a95b05e333f0285$export$bda937ecc753b1f3 = (accountId, searchQuery)=>{
    if (!accountId) return Promise.resolve([]);
    return (0, $8B2Am.getUserGroups)(accountId).then((response)=>{
        const filteredGroups = (0, $1fygZ.filterUserGroups)(response, searchQuery);
        return (0, $1fygZ.transformUserGroups)(filteredGroups);
    });
};

});
parcelRegister("8B2Am", function(module, exports) {
$parcel$export(module.exports, "getAllGroups", () => $6d1f3f29001b39a3$export$c243565349cba18c);
$parcel$export(module.exports, "getUserGroups", () => $6d1f3f29001b39a3$export$bda937ecc753b1f3);

var $hgi0g = parcelRequire("hgi0g");
// Get all groups (including ones user is not a member of)
const $6d1f3f29001b39a3$var$MAX_GROUPS = 5;
const $6d1f3f29001b39a3$export$dc22b2cc8b5a1431 = ()=>'/rest/api/2/groups/picker';
const $6d1f3f29001b39a3$var$getAllGroupsUrl = (query, maxResults = $6d1f3f29001b39a3$var$MAX_GROUPS)=>`${$6d1f3f29001b39a3$export$dc22b2cc8b5a1431()}?maxResults=${maxResults}&query=${encodeURIComponent(query)}`;
const $6d1f3f29001b39a3$export$c243565349cba18c = (query = '', maxResults = $6d1f3f29001b39a3$var$MAX_GROUPS)=>(0, $hgi0g.default)($6d1f3f29001b39a3$var$getAllGroupsUrl(query, maxResults));
const $6d1f3f29001b39a3$export$a1f49428f96f52c7 = ()=>'/rest/api/3/user/groups';
const $6d1f3f29001b39a3$var$getUserGroupsUrl = (accountId)=>`${$6d1f3f29001b39a3$export$a1f49428f96f52c7()}?accountId=${accountId}`;
const $6d1f3f29001b39a3$export$bda937ecc753b1f3 = (accountId)=>(0, $hgi0g.default)($6d1f3f29001b39a3$var$getUserGroupsUrl(accountId));

});

parcelRegister("1fygZ", function(module, exports) {
$parcel$export(module.exports, "transformAllGroups", () => $ff9b793dc903753d$export$b53a6053f3a37f82);
$parcel$export(module.exports, "filterUserGroups", () => $ff9b793dc903753d$export$3803c0f966c39ffc);
$parcel$export(module.exports, "transformUserGroups", () => $ff9b793dc903753d$export$3e297671f207b321);
const $ff9b793dc903753d$export$b53a6053f3a37f82 = (response)=>response && response.groups && response.groups.map(({ name: name, groupId: groupId })=>({
            name: name,
            label: name,
            value: name,
            groupId: groupId
        }));
const $ff9b793dc903753d$export$3803c0f966c39ffc = (groupsRest, searchQuery)=>{
    if (!searchQuery) return groupsRest;
    return groupsRest.filter((group)=>group.name.includes(searchQuery || '')); // `|| ''` check is just for Flow
};
const $ff9b793dc903753d$export$3e297671f207b321 = (groupsRest)=>groupsRest.map(({ name: name, groupId: groupId })=>({
            name: name,
            label: name,
            value: name,
            groupId: groupId
        }));

});


parcelRegister("403OI", function(module, exports) {
$parcel$export(module.exports, "default", () => $f3e7a132e0991919$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
const $f3e7a132e0991919$var$messages = (0, $7qGN1.defineMessages)({
    error: {
        "id": "group-picker.error",
        "defaultMessage": "We couldn't retrieve groups"
    },
    placeholder: {
        "id": "group-picker.placeholder",
        "defaultMessage": "Group"
    },
    labelText: {
        "id": "group-picker.label-text",
        "defaultMessage": "Group"
    }
});
var $f3e7a132e0991919$export$2e2bcd8739ae039 = $f3e7a132e0991919$var$messages;

});



parcelRegister("k3q7u", function(module, exports) {
$parcel$export(module.exports, "default", () => $993004d92fc3087c$export$2e2bcd8739ae039);

var $as6H2 = parcelRequire("as6H2");

var $2uf1V = parcelRequire("2uf1V");
var $993004d92fc3087c$export$2e2bcd8739ae039 = (0, $as6H2.default)('ProjectPicker', {
    onChange: 'changed'
})((0, $2uf1V.default));

});
parcelRegister("2uf1V", function(module, exports) {
$parcel$export(module.exports, "default", () => $649631acf9dc7036$export$2e2bcd8739ae039);
// eslint-disable-next-line jira/restricted/react-component-props

var $eJOHy = parcelRequire("eJOHy");

var $aXKmr = parcelRequire("aXKmr");

var $2sHLK = parcelRequire("2sHLK");

var $idGBm = parcelRequire("idGBm");

var $7RIAd = parcelRequire("7RIAd");

var $559oH = parcelRequire("559oH");
class $649631acf9dc7036$export$a4519235a2ef9605 extends (0, $eJOHy.Component) {
    static{
        this.defaultProps = {
            isRequired: false,
            isDisabled: false,
            isClearable: true,
            isCompact: false,
            detailed: false,
            width: '200px',
            requireBrowsePermission: false,
            requireEditPermission: false,
            label: undefined,
            inputId: undefined,
            projectType: undefined,
            filterCallbackFn: undefined
        };
    }
    constructor(props){
        super(props), this.state = {
            selectedProject: this.props.selectedProject,
            projects: [],
            prevSelectedProject: this.props.selectedProject
        }, this.onSelected = (selectedOption)=>{
            this.setState({
                selectedProject: selectedOption
            });
            this.props.onChange(selectedOption);
        }, /* eslint-disable jira/react-arrow-function-property-naming */ this.formatOptionDataTransformer = (project)=>{
            const { avatarUrl: avatarUrl, name: name } = project;
            const avatar = this.props.renderAvatar ? this.props.renderAvatar(avatarUrl) : avatarUrl;
            return {
                avatar: avatar,
                label: name
            };
        }, /* eslint-disable jira/react-arrow-function-property-naming */ this.fetchOptions = async (filter)=>{
            let projects = await (0, $7RIAd.requestProjects)(filter, {
                detailed: this.props.detailed,
                requireBrowsePermission: this.props.requireBrowsePermission,
                requireEditPermission: this.props.requireEditPermission,
                projectType: this.props.projectType,
                maxResults: this.props.maxResults
            });
            if (this.props.filterCallbackFn) projects = projects.filter(this.props.filterCallbackFn);
            this.setState({
                projects: projects
            });
            return projects;
        };
        this.projectPickerId = `project-picker.label.id-${(0, $aXKmr.v4)()}`;
    }
    static getDerivedStateFromProps(props, state) {
        const currentProjectId = props.selectedProject && props.selectedProject.value;
        const prevProjectId = state.prevSelectedProject && state.prevSelectedProject.value;
        if (currentProjectId !== prevProjectId) return {
            ...state,
            selectedProject: props.selectedProject,
            prevSelectedProject: props.selectedProject
        };
        return null;
    }
    componentDidMount() {
        const { selectedProject: selectedProject } = this.state;
        if (selectedProject && !selectedProject.name) this.fetchProject(selectedProject);
    }
    componentDidUpdate() {
        const { selectedProject: selectedProject } = this.state;
        if (selectedProject && !selectedProject.name) this.fetchProject(selectedProject);
    }
    fetchProject(selectedProject) {
        const projectValue = selectedProject.value;
        // @ts-expect-error - TS7006 - Parameter 'newProject' implicitly has an 'any' type.
        const updateSelectedProject = (newProject)=>{
            const currentProject = this.state.selectedProject;
            const currentProjectValue = currentProject && currentProject.value;
            // Update the state only in case the project wasn't changed
            if (currentProjectValue === projectValue) {
                this.setState({
                    selectedProject: newProject
                });
                this.props.onChange(newProject);
            }
        };
        return (0, $7RIAd.requestProject)(projectValue).then((project)=>updateSelectedProject(project)).catch(()=>updateSelectedProject(undefined));
    }
    render() {
        const { intl: { formatMessage: formatMessage }, selectedProject: selectedProject, onChange: onChange, ...props } = this.props;
        const { selectedProject: project, projects: projects } = this.state;
        // the selected option needs to have same object reference to be correctly announced by screen readers
        const selectedOptionWithObjectReference = projects?.find((projectInList)=>projectInList.value === project?.value);
        const selectedOption = selectedOptionWithObjectReference || (project && project.name ? project : null);
        return(// @ts-expect-error - TS2769 - No overload matches this call.
        /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $2sHLK.PickerWithAvatar), {
            "aria-label": !this.props.label ? formatMessage((0, $559oH.default).labelText) : undefined,
            ...props,
            inputId: !this.props.inputId ? this.projectPickerId : this.props.inputId,
            errorMessage: formatMessage((0, $559oH.default).error),
            placeholder: this.props.placeholder || formatMessage((0, $559oH.default).placeholder),
            onSelected: this.onSelected,
            options: this.fetchOptions,
            formatOptionDataTransformer: this.formatOptionDataTransformer,
            value: selectedOption,
            showFocusedAvatar: true
        }));
    }
}
var $649631acf9dc7036$export$2e2bcd8739ae039 = (0, $idGBm.injectIntlV2)($649631acf9dc7036$export$a4519235a2ef9605);

});
parcelRegister("7RIAd", function(module, exports) {
$parcel$export(module.exports, "requestProjects", () => $335c617be9654301$export$fd47004f2da106d6);
$parcel$export(module.exports, "requestProject", () => $335c617be9654301$export$5fc96122a11240fa);

var $ki1Cz = parcelRequire("ki1Cz");

var $lN5GE = parcelRequire("lN5GE");
const $335c617be9654301$export$fd47004f2da106d6 = (filter, { detailed: detailed, requireBrowsePermission: requireBrowsePermission, requireEditPermission: requireEditPermission, maxResults: maxResults, projectType: projectType })=>(0, $ki1Cz.getProjects)(filter, detailed, requireBrowsePermission, requireEditPermission, maxResults, projectType).then((0, $lN5GE.transformProjects));
const $335c617be9654301$export$5fc96122a11240fa = (projectId)=>(0, $ki1Cz.getProject)(projectId).then((0, $lN5GE.transformProject));

});
parcelRegister("ki1Cz", function(module, exports) {
$parcel$export(module.exports, "getProjects", () => $48d0e50622956812$export$b00a271f69f3d728);
$parcel$export(module.exports, "getProject", () => $48d0e50622956812$export$637b60a42bb03f06);

var $hgi0g = parcelRequire("hgi0g");
const $48d0e50622956812$var$MAX_PROJECTS = 5;
const $48d0e50622956812$var$VALID_PROJECT_TYPES = [
    'business',
    'service_desk',
    'software'
];
const $48d0e50622956812$export$897983d170945c20 = ()=>'/rest/api/2/project/search';
const $48d0e50622956812$export$40e632ede9793c84 = ()=>'/rest/api/2/project';
const $48d0e50622956812$export$3675f59ca23820db = (filter, detailed, requireBrowsePermission, requireEditPermission, maxResults = $48d0e50622956812$var$MAX_PROJECTS, projectType = '')=>{
    const urlSearchParams = new URLSearchParams();
    urlSearchParams.set('orderBy', 'NAME');
    urlSearchParams.set('startAt', '0');
    urlSearchParams.set('query', filter);
    urlSearchParams.set('maxResults', maxResults.toString());
    if (detailed) urlSearchParams.set('expand', 'lead,issueTypes');
    const actions = [];
    if (requireBrowsePermission) actions.push('browse');
    if (requireEditPermission) actions.push('edit');
    if (actions.length > 0) urlSearchParams.set('action', actions.join(','));
    if ($48d0e50622956812$var$VALID_PROJECT_TYPES.includes(projectType)) urlSearchParams.set('typeKey', projectType);
    const urlParams = `?${urlSearchParams.toString()}`;
    return `${$48d0e50622956812$export$897983d170945c20()}${urlParams}`;
};
const $48d0e50622956812$export$42f2db4bad372151 = (projectId)=>`${$48d0e50622956812$export$40e632ede9793c84()}/${encodeURIComponent(projectId)}`;
const $48d0e50622956812$export$b00a271f69f3d728 = (filter = '', detailed = false, requireBrowsePermission = false, requireEditPermission = false, maxResults = $48d0e50622956812$var$MAX_PROJECTS, projectType = '')=>(0, $hgi0g.default)($48d0e50622956812$export$3675f59ca23820db(filter, detailed, requireBrowsePermission, requireEditPermission, maxResults, projectType));
const $48d0e50622956812$export$637b60a42bb03f06 = (projectId = '')=>(0, $hgi0g.default)($48d0e50622956812$export$42f2db4bad372151(projectId));

});

parcelRegister("lN5GE", function(module, exports) {
$parcel$export(module.exports, "transformProject", () => $a026cc7331d138a2$export$e179869ce707f546);
$parcel$export(module.exports, "transformProjects", () => $a026cc7331d138a2$export$227473965d2e27db);
const $a026cc7331d138a2$var$transformLead = (leadResponse)=>leadResponse && {
        key: leadResponse.key,
        name: leadResponse.name,
        displayName: leadResponse.displayName,
        avatarUrl: leadResponse.avatarUrls['24x24']
    };
const $a026cc7331d138a2$var$transformIssueTypes = (types)=>types.map((t)=>({
            id: t.id,
            name: t.name,
            description: t.description,
            iconUrl: t.iconUrl,
            subtask: t.subtask
        }));
const $a026cc7331d138a2$var$transformDetails = (restResponse)=>({
        id: restResponse.id,
        key: restResponse.key,
        lead: $a026cc7331d138a2$var$transformLead(restResponse.lead),
        issueTypes: restResponse.issueTypes ? $a026cc7331d138a2$var$transformIssueTypes(restResponse.issueTypes) : [],
        projectTypeKey: restResponse.projectTypeKey,
        simplified: restResponse.simplified
    });
const $a026cc7331d138a2$export$e179869ce707f546 = (restResponse)=>restResponse && {
        value: restResponse.id,
        name: restResponse.name,
        label: restResponse.name,
        avatarUrl: restResponse.avatarUrls['24x24'],
        details: $a026cc7331d138a2$var$transformDetails(restResponse)
    };
const $a026cc7331d138a2$export$227473965d2e27db = (restResponse)=>restResponse && restResponse.values && restResponse.values.map($a026cc7331d138a2$export$e179869ce707f546);

});


parcelRegister("559oH", function(module, exports) {
$parcel$export(module.exports, "default", () => $333fdb33476e624f$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
const $333fdb33476e624f$var$messages = (0, $7qGN1.defineMessages)({
    error: {
        "id": "project-picker.error",
        "defaultMessage": "We couldn't retrieve projects"
    },
    placeholder: {
        "id": "project-picker.placeholder",
        "defaultMessage": "Project"
    },
    labelText: {
        "id": "project-picker.label-text",
        "defaultMessage": "Project"
    },
    errorProjectTermRefresh: {
        "id": "project-picker.error-project-term-refresh",
        "defaultMessage": "We couldn't retrieve spaces"
    },
    placeholderProjectTermRefresh: {
        "id": "project-picker.placeholder-project-term-refresh",
        "defaultMessage": "Space"
    },
    labelTextProjectTermRefresh: {
        "id": "project-picker.label-text-project-term-refresh",
        "defaultMessage": "Space"
    }
});
var $333fdb33476e624f$export$2e2bcd8739ae039 = $333fdb33476e624f$var$messages;

});



parcelRegister("fucyK", function(module, exports) {
$parcel$export(module.exports, "default", () => $cace7a5a03fd5f19$export$2e2bcd8739ae039);

var $as6H2 = parcelRequire("as6H2");

var $aPsSO = parcelRequire("aPsSO");
var $cace7a5a03fd5f19$export$2e2bcd8739ae039 = (0, $as6H2.default)('UserPicker', {
    onChange: 'changed'
})((0, $aPsSO.default));

});
parcelRegister("aPsSO", function(module, exports) {
$parcel$export(module.exports, "default", () => $8995af3cbc8e38f3$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $aXKmr = parcelRequire("aXKmr");

var $2sHLK = parcelRequire("2sHLK");

var $eSnSE = parcelRequire("eSnSE");

var $idGBm = parcelRequire("idGBm");

var $2e8aC = parcelRequire("2e8aC");

var $d5dE5 = parcelRequire("d5dE5");
class $8995af3cbc8e38f3$export$83e0c73b09b3a9cd extends (0, $eJOHy.Component) {
    static{
        this.defaultProps = {
            isRequired: false,
            isDisabled: false,
            isClearable: true,
            isClearableWithCrossIcon: false,
            isCompact: false,
            shouldFitContainer: false,
            width: '200px'
        };
    }
    constructor(props){
        super(props), this.state = {
            selectedUser: this.props.selectedUser,
            prevSelectedUser: this.props.selectedUser
        }, this.onSelected = (selectedUser)=>{
            this.setState({
                selectedUser: selectedUser
            });
            this.props.onChange(selectedUser);
        }, /* eslint-disable jira/react-arrow-function-property-naming */ this.formatOptionDataTransformer = (user)=>({
                avatar: user.avatarUrl,
                label: user.displayName
            }), this.fetchOptions = (query)=>{
            const { suggestedAccountId: suggestedAccountId } = this.props;
            if (query) return (0, $2e8aC.requestUsers)(query);
            if (suggestedAccountId) return new Promise((resolve)=>{
                (0, $2e8aC.requestUser)(suggestedAccountId).then((user)=>resolve([
                        user
                    ])).catch(()=>resolve([]));
            });
            return Promise.resolve([]);
        };
        this.userPickerId = `group-picker.label.id-${(0, $aXKmr.v4)()}`;
    }
    static getDerivedStateFromProps(props, state) {
        const currentAccountId = props.selectedUser && props.selectedUser.accountId;
        const prevAccountId = state.prevSelectedUser && state.prevSelectedUser.accountId;
        if (currentAccountId !== prevAccountId) return {
            ...state,
            selectedUser: props.selectedUser,
            prevSelectedUser: props.selectedUser
        };
        return null;
    }
    componentDidMount() {
        this.ensureSelectedUserInfoPresent();
    }
    componentDidUpdate(prevProps) {
        this.ensureSelectedUserInfoPresent();
        if (prevProps.suggestedAccountId !== this.props.suggestedAccountId) // Good to know:
        // react-select caches resolved Promise value for an empty filter so
        // there is no way to change the suggestion other then replacing the component with a new one
        (0, $eSnSE.default).safeErrorWithoutCustomerData('user-picker.prop-update', "suggestedAccountId prop change won't be applied, you have to replace the component with a new one");
    }
    ensureSelectedUserInfoPresent() {
        const { selectedUser: selectedUser } = this.state;
        if (!selectedUser || selectedUser.displayName) return;
        const { accountId: accountId } = selectedUser;
        // @ts-expect-error - TS7006 - Parameter 'newUser' implicitly has an 'any' type.
        const updateSelectedUser = (newUser)=>{
            const currentUser = this.state.selectedUser;
            const currentAccountId = currentUser && currentUser.accountId;
            // Update the state only in case the user wasn't changed
            if (currentAccountId === accountId) this.setState({
                selectedUser: newUser
            });
        };
        (0, $2e8aC.requestUser)(accountId).then((user)=>updateSelectedUser(user)).catch(()=>updateSelectedUser(undefined));
    }
    render() {
        const { intl: { formatMessage: formatMessage }, suggestedAccountId: suggestedAccountId, selectedUser: selectedUser, placeholder: placeholder = this.props.placeholder || formatMessage((0, $d5dE5.default).placeholder), onChange: onChange, shouldFitContainer: shouldFitContainer, width: width, isClearableWithCrossIcon: isClearableWithCrossIcon, ...props } = this.props;
        const { selectedUser: user } = this.state;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $2sHLK.PickerWithAvatar), {
            "aria-label": !this.props.label ? formatMessage((0, $d5dE5.default).labelText) : undefined,
            inputId: this.userPickerId,
            ...props,
            errorMessage: formatMessage((0, $d5dE5.default).error),
            placeholder: placeholder,
            onSelected: this.onSelected,
            options: this.fetchOptions,
            formatOptionDataTransformer: this.formatOptionDataTransformer,
            value: user && user.displayName ? user : null,
            width: shouldFitContainer ? undefined : width,
            isClearableWithCrossIcon: isClearableWithCrossIcon
        });
    }
}
var $8995af3cbc8e38f3$export$2e2bcd8739ae039 = (0, $idGBm.injectIntlV2)($8995af3cbc8e38f3$export$83e0c73b09b3a9cd);

});
parcelRegister("2e8aC", function(module, exports) {
$parcel$export(module.exports, "requestUser", () => $340ce2eca69238dd$export$949646a1c1731536);
$parcel$export(module.exports, "requestUsers", () => $340ce2eca69238dd$export$55b721778f931cc1);

var $37Xqw = parcelRequire("37Xqw");

var $1otmW = parcelRequire("1otmW");
const $340ce2eca69238dd$export$949646a1c1731536 = (accountId)=>(0, $37Xqw.getUser)(accountId).then((0, $1otmW.transformUser));
const $340ce2eca69238dd$export$55b721778f931cc1 = (query)=>(0, $37Xqw.getUsers)(query).then((0, $1otmW.transformUsers));

});
parcelRegister("37Xqw", function(module, exports) {
$parcel$export(module.exports, "getUser", () => $143cc0293437bb25$export$7cbf767827cd68ba);
$parcel$export(module.exports, "getUsers", () => $143cc0293437bb25$export$925a4945a6cd0f3e);

var $hgi0g = parcelRequire("hgi0g");
const $143cc0293437bb25$export$e45b57f6c6c40475 = 5;
const $143cc0293437bb25$export$7eaa662f51e316ae = ()=>'/rest/api/2/user';
const $143cc0293437bb25$export$8df721f926f55c9a = (accountId = '')=>`${$143cc0293437bb25$export$7eaa662f51e316ae()}?accountId=${encodeURIComponent(accountId)}`;
const $143cc0293437bb25$export$715964ba85b11e2b = ()=>'/rest/api/2/user/picker';
const $143cc0293437bb25$export$977bdbd87001f83 = (query = '')=>`${$143cc0293437bb25$export$715964ba85b11e2b()}?showAvatar=true&maxResults=${$143cc0293437bb25$export$e45b57f6c6c40475}&query=${query}`;
const $143cc0293437bb25$export$7cbf767827cd68ba = (accountId = '')=>(0, $hgi0g.default)($143cc0293437bb25$export$8df721f926f55c9a(accountId));
const $143cc0293437bb25$export$925a4945a6cd0f3e = (query = '')=>(0, $hgi0g.default)($143cc0293437bb25$export$977bdbd87001f83(query));

});

parcelRegister("1otmW", function(module, exports) {
$parcel$export(module.exports, "transformUser", () => $19e9ef34e6aae24a$export$88dcd5c1adae8021);
$parcel$export(module.exports, "transformUsers", () => $19e9ef34e6aae24a$export$fb8c90bfc4beaa59);
const $19e9ef34e6aae24a$export$88dcd5c1adae8021 = ({ accountId: accountId, displayName: displayName, avatarUrls: avatarUrls })=>({
        accountId: accountId,
        value: accountId,
        displayName: displayName,
        label: displayName,
        avatarUrl: avatarUrls['24x24']
    });
const $19e9ef34e6aae24a$export$fb8c90bfc4beaa59 = (response)=>response.users.map(({ accountId: accountId, avatarUrl: avatarUrl, displayName: displayName })=>({
            accountId: accountId,
            value: accountId,
            displayName: displayName,
            label: displayName,
            avatarUrl: avatarUrl
        }));

});


parcelRegister("d5dE5", function(module, exports) {
$parcel$export(module.exports, "default", () => $61835bca22ccc32e$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
const $61835bca22ccc32e$var$messages = (0, $7qGN1.defineMessages)({
    error: {
        "id": "user-picker.error",
        "defaultMessage": "We couldn't retrieve users"
    },
    placeholder: {
        "id": "user-picker.placeholder",
        "defaultMessage": "User"
    },
    labelText: {
        "id": "user-picker.label-text",
        "defaultMessage": "User"
    }
});
var $61835bca22ccc32e$export$2e2bcd8739ae039 = $61835bca22ccc32e$var$messages;

});



parcelRegister("kKEaJ", function(module, exports) {
$parcel$export(module.exports, "default", () => $21945a325786d7b6$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $eq3Hf = parcelRequire("eq3Hf");

var $5CSKW = parcelRequire("5CSKW");

var $6sjW5 = parcelRequire("6sjW5");

var $idGBm = parcelRequire("idGBm");

var $31bIe = parcelRequire("31bIe");
function $21945a325786d7b6$export$47d037774b685574(props) {
    const { onClick: onClick, intl: { formatMessage: formatMessage } } = props;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $5CSKW.default), {
        appearance: "subtle",
        onClick: onClick,
        shouldFitContainer: true
    }, formatMessage((0, $31bIe.default).label));
}
var $21945a325786d7b6$export$2e2bcd8739ae039 = (0, (/*@__PURE__*/$parcel$interopDefault($eq3Hf)))((0, $6sjW5.default)({
    onClick: 'clearFilters'
}), (0, $idGBm.injectIntlV2))($21945a325786d7b6$export$47d037774b685574);

});
parcelRegister("31bIe", function(module, exports) {
$parcel$export(module.exports, "default", () => $172b526b6eefc289$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
const $172b526b6eefc289$var$messages = (0, $7qGN1.defineMessages)({
    label: {
        "id": "directories.dashboards-v2.main.content.filter.clear.label",
        "defaultMessage": "Clear filters"
    }
});
var $172b526b6eefc289$export$2e2bcd8739ae039 = $172b526b6eefc289$var$messages;

});


parcelRegister("c9fEk", function(module, exports) {
$parcel$export(module.exports, "default", () => $d32d8b174d822684$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $8nu6j = parcelRequire("8nu6j");
var $1DXK0 = parcelRequire("1DXK0");

var $9QRvN = parcelRequire("9QRvN");

var $dJEUx = parcelRequire("dJEUx");

var $idGBm = parcelRequire("idGBm");

var $6XJko = parcelRequire("6XJko");

var $cxKOj = parcelRequire("cxKOj");

var $8BF74 = parcelRequire("8BF74");
class $d32d8b174d822684$export$ec91da630f36d5ea extends (0, $eJOHy.Component) {
    render() {
        const { renderFilterSearch: renderFilterSearch, renderOwnerPicker: renderOwnerPicker, renderProjectPicker: renderProjectPicker, renderGroupPicker: renderGroupPicker, renderClear: renderClear, intl: { formatMessage: formatMessage } } = this.props;
        const isVisualRefresh = (0, $6XJko.isVisualRefreshEnabled)();
        const projectLabelGalaxia = (0, $cxKOj.expVal)('project-terminology-refresh', 'isEnabled', false) ? (0, $8BF74.default).projectLabelGalaxia : (0, $8BF74.default).projectLabel;
        const projectPlaceholderGalaxia = (0, $cxKOj.expVal)('project-terminology-refresh', 'isEnabled', false) ? (0, $8BF74.default).projectPlaceholderGalaxia : (0, $8BF74.default).projectPlaceholder;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $9QRvN.FilterBar), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $dJEUx.FilterItem), {
            expandOnSmall: true
        }, renderFilterSearch({
            onChange: this.onSearchChange,
            placeholder: formatMessage((0, $8BF74.default).searchPlaceholder)
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $dJEUx.FilterItem), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
            xcss: !isVisualRefresh && $d32d8b174d822684$var$itemInnerStyles
        }, renderOwnerPicker({
            onChange: this.onOwnerChange,
            placeholder: isVisualRefresh ? formatMessage((0, $8BF74.default).ownerLabel) : formatMessage((0, $8BF74.default).ownerPlaceholder),
            label: isVisualRefresh ? undefined : formatMessage((0, $8BF74.default).ownerLabel)
        }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $dJEUx.FilterItem), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
            xcss: !isVisualRefresh && $d32d8b174d822684$var$itemInnerStyles
        }, renderProjectPicker({
            onChange: this.onProjectChange,
            placeholder: isVisualRefresh ? formatMessage(projectLabelGalaxia) : formatMessage(projectPlaceholderGalaxia),
            label: isVisualRefresh ? undefined : formatMessage((0, $8BF74.default).projectLabel)
        }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $dJEUx.FilterItem), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
            xcss: !isVisualRefresh && $d32d8b174d822684$var$itemInnerStyles
        }, renderGroupPicker({
            onChange: this.onGroupChange,
            placeholder: isVisualRefresh ? formatMessage((0, $8BF74.default).groupLabel) : formatMessage((0, $8BF74.default).groupPlaceholder),
            label: isVisualRefresh ? undefined : formatMessage((0, $8BF74.default).groupLabel)
        }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $dJEUx.FilterItem), {
            expandOnSmall: true
        }, renderClear({
            onClick: this.onClear
        })));
    }
    constructor(...args){
        super(...args), // @ts-expect-error - TS2322 - Type 'undefined' is not assignable to type 'string'.
        this.onSearchChange = (text, analyticsEvent)=>{
            this.props.onChange({
                ...this.props.value,
                text: text
            }, analyticsEvent);
        }, this.onOwnerChange = (owner, analyticsEvent)=>{
            this.props.onChange({
                ...this.props.value,
                owner: owner
            }, analyticsEvent);
        }, this.onProjectChange = (project, analyticsEvent)=>{
            this.props.onChange({
                ...this.props.value,
                project: project
            }, analyticsEvent);
        }, this.onGroupChange = (group, analyticsEvent)=>{
            this.props.onChange({
                ...this.props.value,
                group: group
            }, analyticsEvent);
        }, this.onClear = (analyticsEvent)=>{
            this.props.onChange({
                ...this.props.initialFilter
            }, analyticsEvent);
        };
    }
}
var $d32d8b174d822684$export$2e2bcd8739ae039 = (0, $idGBm.injectIntlV2)($d32d8b174d822684$export$ec91da630f36d5ea);
const $d32d8b174d822684$var$itemInnerStyles = (0, $1DXK0.xcss)({
    marginTop: 'space.negative.250'
});

});
parcelRegister("9QRvN", function(module, exports) {
$parcel$export(module.exports, "FilterBar", () => $3ecd990baea72ae1$export$56a20ec2552ffba2);

var $eJOHy = parcelRequire("eJOHy");

var $6DCNy = parcelRequire("6DCNy");

var $8nu6j = parcelRequire("8nu6j");
var $1DXK0 = parcelRequire("1DXK0");

var $gMRLG = parcelRequire("gMRLG");

var $6XJko = parcelRequire("6XJko");

const $3ecd990baea72ae1$export$56a20ec2552ffba2 = ({ children: children })=>{
    const [containerWidth, setContainerWidth] = (0, $eJOHy.useState)(900);
    const handleWidth = (0, (/*@__PURE__*/$parcel$interopDefault($6DCNy)))(setContainerWidth, 50);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
        xcss: $3ecd990baea72ae1$var$relativeWrapperStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $gMRLG.WidthObserver), {
        setWidth: handleWidth
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
        xcss: [
            $3ecd990baea72ae1$var$filterBarSharedStyles,
            (0, $6XJko.isVisualRefreshEnabled)() && $3ecd990baea72ae1$var$filterBarSharedStylesVisualRefresh,
            containerWidth > (0, $5b4f651e2b94645c$export$9cc428d7e02a0e8b) && $3ecd990baea72ae1$var$filterBarLargeStyles,
            containerWidth <= (0, $5b4f651e2b94645c$export$9cc428d7e02a0e8b) && containerWidth > (0, $5b4f651e2b94645c$export$99041d531d62aef9) && $3ecd990baea72ae1$var$filterBarMidStyles,
            containerWidth <= (0, $5b4f651e2b94645c$export$99041d531d62aef9) && containerWidth > (0, $5b4f651e2b94645c$export$54280d191a58e9f6) && $3ecd990baea72ae1$var$filterBarSmallStyles
        ]
    }, children));
};
const $3ecd990baea72ae1$var$relativeWrapperStyles = (0, $1DXK0.xcss)({
    position: 'relative'
});
const $3ecd990baea72ae1$var$filterBarSharedStyles = (0, $1DXK0.xcss)({
    width: '100%',
    display: 'grid',
    columnGap: 'space.200',
    rowGap: 'space.100',
    alignItems: 'flex-end'
});
const $3ecd990baea72ae1$var$filterBarSharedStylesVisualRefresh = (0, $1DXK0.xcss)({
    columnGap: 'space.100'
});
const $3ecd990baea72ae1$var$filterBarSmallStyles = (0, $1DXK0.xcss)({
    gridTemplateColumns: 'repeat(2, 1fr)'
});
const $3ecd990baea72ae1$var$filterBarMidStyles = (0, $1DXK0.xcss)({
    gridTemplateColumns: 'repeat(3, 1fr)'
});
const $3ecd990baea72ae1$var$filterBarLargeStyles = (0, $1DXK0.xcss)({
    display: 'flex',
    flexWrap: 'wrap'
});

});
parcelRegister("gMRLG", function(module, exports) {
$parcel$export(module.exports, "WidthObserver", () => $fc07c79ce5b93db8$export$b2ad68b9bc407b80);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $ghv3t = parcelRequire("ghv3t");
const $fc07c79ce5b93db8$export$b2ad68b9bc407b80 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).memo((props)=>{
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $ghv3t.WidthDetectorObserver), {
        setWidth: props.setWidth,
        offscreen: props.offscreen
    });
});
var $fc07c79ce5b93db8$export$2e2bcd8739ae039 = $fc07c79ce5b93db8$export$b2ad68b9bc407b80;

});
parcelRegister("ghv3t", function(module, exports) {
$parcel$export(module.exports, "WidthDetectorObserver", () => $8fd70c84fe96dcaa$export$ff983d2a2b6112ea);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $fecNP = parcelRequire("fecNP");
const $8fd70c84fe96dcaa$export$ff983d2a2b6112ea = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).memo(({ setWidth: setWidth, offscreen: offscreen })=>{
    const [inViewRef, inView, target] = (0, $fecNP.useInView)({
        /* Optional options */ threshold: 0
    });
    const observer = (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).useRef(()=>{
        if (typeof window === 'undefined') return null;
        // https://github.com/DefinitelyTyped/DefinitelyTyped/pull/40909
        // @ts-ignore
        return new ResizeObserver((entries)=>{
            if (!Array.isArray(entries) || !entries.length) return;
            const { width: width } = entries[0].contentRect;
            setWidth(Math.round(width));
        });
    });
    (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).useEffect(()=>{
        const { current: currentObserver } = observer;
        const resizeObserver = currentObserver();
        if (resizeObserver === null) return;
        if (target) {
            if (inView || offscreen) resizeObserver.observe(target);
            else resizeObserver.unobserve(target);
        }
        return ()=>{
            resizeObserver.disconnect();
        };
    }, [
        target,
        inView,
        offscreen
    ]);
    return /*#__PURE__*/ (0, $gt9Am.jsx)("div", {
        style: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            display: 'block',
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            width: '100%',
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            position: 'absolute'
        },
        ref: inViewRef
    });
});

});
parcelRegister("fecNP", function(module, exports) {
$parcel$export(module.exports, "useInView", () => $838e57da8fce74d2$export$2f62ee6831462844);

var $eJOHy = parcelRequire("eJOHy");
function $838e57da8fce74d2$export$2f62ee6831462844(options = {}) {
    const ref = (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).useRef();
    const observerInstance = (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).useRef();
    const [state, setState] = (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).useState({
        inView: false,
        entry: undefined,
        target: undefined
    });
    const { threshold: threshold, root: root, rootMargin: rootMargin } = options;
    const setRef = (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).useCallback((node)=>{
        observerInstance.current = new IntersectionObserver((entries)=>{
            if (entries && entries.length) {
                const intersection = entries[0];
                const { isIntersecting: isIntersecting, intersectionRatio: intersectionRatio } = intersection;
                if (intersectionRatio >= 0) {
                    // Note: `0` will be used here when an array of numbers is passed as the threshold, which doesn't feel right
                    const numericThreshold = typeof threshold === 'number' ? threshold : 0;
                    let inView = intersectionRatio >= numericThreshold;
                    if (isIntersecting !== undefined) inView = inView && isIntersecting;
                    setState({
                        inView: inView,
                        entry: intersection,
                        target: node
                    });
                }
            }
        }, {
            threshold: threshold,
            root: root,
            rootMargin: rootMargin
        });
        if (ref.current) observerInstance.current.unobserve(ref.current);
        if (node) observerInstance.current.observe(node);
        // Store a reference to the node
        ref.current = node;
    }, [
        threshold,
        root,
        rootMargin
    ]);
    /**
	 * Unsubscribe IntersectionObserver before unmounting a component.
	 */ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).useEffect(()=>{
        return ()=>{
            if (observerInstance.current && ref.current) observerInstance.current.unobserve(ref.current);
        };
    }, []);
    return [
        setRef,
        state.inView,
        state.target,
        state.entry
    ];
}

});



const $5b4f651e2b94645c$export$54280d191a58e9f6 = 420;
const $5b4f651e2b94645c$export$99041d531d62aef9 = 640;
const $5b4f651e2b94645c$export$9cc428d7e02a0e8b = 850;
const $5b4f651e2b94645c$export$a4477e829bcd1e02 = 200;


parcelRegister("dJEUx", function(module, exports) {
$parcel$export(module.exports, "FilterItem", () => $57ae9b62bc01824b$export$3cf161fcd24b6b4f);

var $eJOHy = parcelRequire("eJOHy");

var $8nu6j = parcelRequire("8nu6j");
var $1DXK0 = parcelRequire("1DXK0");
const $57ae9b62bc01824b$export$3cf161fcd24b6b4f = ({ expandOnSmall: expandOnSmall, children: children })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
        xcss: expandOnSmall ? [
            $57ae9b62bc01824b$var$filterItemContainerStyles,
            $57ae9b62bc01824b$var$filterItemContainerExpandedStyles
        ] : $57ae9b62bc01824b$var$filterItemContainerStyles
    }, children);
};
const $57ae9b62bc01824b$var$filterItemContainerStyles = (0, $1DXK0.xcss)({
    // 200px is the width commonly used for directory filters, so including it here helps
    // to ensure consistency with the existing design and gives us predictability for responsive behaviour
    minWidth: '200px'
});
const $57ae9b62bc01824b$var$filterItemContainerExpandedStyles = (0, $1DXK0.xcss)({
    gridColumn: '1 / -1'
});

});

parcelRegister("8BF74", function(module, exports) {
$parcel$export(module.exports, "default", () => $b52d224e020e52ce$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
const $b52d224e020e52ce$var$messages = (0, $7qGN1.defineMessages)({
    searchFilterAriaSearchDescription: {
        "id": "directories.dashboards-v2.main.content.filter.search-filter-aria-search-description",
        "defaultMessage": "The table will be filtered below as you type into the field"
    },
    searchPlaceholder: {
        "id": "directories.dashboards-v2.main.content.filter.search-placeholder",
        "defaultMessage": "Search dashboards"
    },
    ownerPlaceholder: {
        "id": "directories.dashboards-v2.main.content.filter.owner-placeholder",
        "defaultMessage": "Select owner"
    },
    projectPlaceholder: {
        "id": "directories.dashboards-v2.main.content.filter.project-placeholder",
        "defaultMessage": "Select project"
    },
    groupPlaceholder: {
        "id": "directories.dashboards-v2.main.content.filter.group-placeholder",
        "defaultMessage": "Select group"
    },
    searchLabel: {
        "id": "directories.dashboards-v2.main.content.filter.search-label",
        "defaultMessage": "Search"
    },
    ownerLabel: {
        "id": "directories.dashboards-v2.main.content.filter.owner-label",
        "defaultMessage": "Owner"
    },
    projectLabel: {
        "id": "directories.dashboards-v2.main.content.filter.project-label",
        "defaultMessage": "Project"
    },
    groupLabel: {
        "id": "directories.dashboards-v2.main.content.filter.group-label",
        "defaultMessage": "Group"
    },
    projectPlaceholderGalaxia: {
        "id": "directories.dashboards-v2.main.content.filter.project-placeholder-galaxia",
        "defaultMessage": "Select space"
    },
    projectLabelGalaxia: {
        "id": "directories.dashboards-v2.main.content.filter.project-label-galaxia",
        "defaultMessage": "Space"
    }
});
var $b52d224e020e52ce$export$2e2bcd8739ae039 = $b52d224e020e52ce$var$messages;

});



parcelRegister("6loCM", function(module, exports) {
$parcel$export(module.exports, "operationModals", () => $62418d0d75a1a065$export$fee8081fa482dfbf);
$parcel$export(module.exports, "emptyFilterResultConfiguration", () => $62418d0d75a1a065$export$972f54d0cb76a888);
$parcel$export(module.exports, "getTableConfiguration", () => $62418d0d75a1a065$export$6847365bea1c5392);
$parcel$export(module.exports, "getTableLabel", () => $62418d0d75a1a065$export$b2d196af18e06ad6);
$parcel$export(module.exports, "getResultsAnnouncerMessage", () => $62418d0d75a1a065$export$64df75861e57fb7f);

var $ahm5r = parcelRequire("ahm5r");

var $20b6k = parcelRequire("20b6k");


var $6XJko = parcelRequire("6XJko");

var $awhT9 = parcelRequire("awhT9");

var $bpMvQ = parcelRequire("bpMvQ");

var $97fxM = parcelRequire("97fxM");

var $g014H = parcelRequire("g014H");

var $9Wcrd = parcelRequire("9Wcrd");

var $k9N1W = parcelRequire("k9N1W");

var $flgeI = parcelRequire("flgeI");

var $8dY5q = parcelRequire("8dY5q");

var $e63eo = parcelRequire("e63eo");

var $c5o1z = parcelRequire("c5o1z");

var $5J9oH = parcelRequire("5J9oH");

var $9eKBp = parcelRequire("9eKBp");

var $kAUoD = parcelRequire("kAUoD");

var $h38eJ = parcelRequire("h38eJ");

var $ghyjR = parcelRequire("ghyjR");
const $62418d0d75a1a065$export$fee8081fa482dfbf = {
    [(0, $85bfce414eef38c7$export$92f9e1ed9114d3a6)]: (0, $9eKBp.default),
    [(0, $85bfce414eef38c7$export$250171a898bf7ef)]: (0, $h38eJ.default),
    [(0, $85bfce414eef38c7$export$4bd2facc4a3e6aa1)]: (0, $kAUoD.default),
    [(0, $85bfce414eef38c7$export$39d2a7fb21967424)]: (0, $5J9oH.default)
};
const $62418d0d75a1a065$export$972f54d0cb76a888 = {
    message: (0, $ghyjR.default).emptyFilterResultMessage
};
const $62418d0d75a1a065$export$6847365bea1c5392 = (0, $ahm5r.createSelector)((0, $bpMvQ.getLoggedInUserAccountId), (accountId)=>[
        accountId !== null ? {
            title: (0, $20b6k.default),
            Cell: (0, $k9N1W.default),
            sortField: (0, $awhT9.FAVOURITED),
            width: 3,
            isIconOnlyHeader: (0, $6XJko.isVisualRefreshEnabled)(),
            ascendingSortTooltip: (0, $6XJko.isVisualRefreshEnabled)() ? (0, $ghyjR.default).starredToUnstarredOrder : undefined,
            descendingSortTooltip: (0, $6XJko.isVisualRefreshEnabled)() ? (0, $ghyjR.default).unstarredToStarredOrder : undefined
        } : undefined,
        {
            title: (0, $ghyjR.default).name,
            Cell: (0, $c5o1z.default),
            sortField: (0, $awhT9.NAME),
            width: accountId ? 25 : 35,
            ascendingSortTooltip: (0, $6XJko.isVisualRefreshEnabled)() ? (0, $ghyjR.default).aToZOrder : undefined,
            descendingSortTooltip: (0, $6XJko.isVisualRefreshEnabled)() ? (0, $ghyjR.default).zToAOrder : undefined
        },
        accountId !== null ? {
            title: (0, $ghyjR.default).owner,
            Cell: (0, $flgeI.default),
            sortField: (0, $awhT9.OWNER),
            width: 19,
            ascendingSortTooltip: (0, $6XJko.isVisualRefreshEnabled)() ? (0, $ghyjR.default).aToZOrder : undefined,
            descendingSortTooltip: (0, $6XJko.isVisualRefreshEnabled)() ? (0, $ghyjR.default).zToAOrder : undefined
        } : undefined,
        {
            title: (0, $ghyjR.default).viewers,
            Cell: (0, $97fxM.default),
            // eslint-disable-next-line no-nested-ternary
            width: accountId ? (0, $6XJko.isVisualRefreshEnabled)() ? 19 : 19.5 : 25
        },
        {
            title: (0, $ghyjR.default).editors,
            Cell: (0, $9Wcrd.default),
            width: accountId ? 19 : 25
        },
        {
            title: (0, $ghyjR.default).popularity,
            Cell: accountId !== null && (0, $6XJko.isVisualRefreshEnabled)() ? (0, $8dY5q.default) : (0, $e63eo.default),
            sortField: (0, $awhT9.POPULARITY),
            width: accountId !== null && (0, $6XJko.isVisualRefreshEnabled)() ? 15 : 9,
            ascendingSortTooltip: (0, $6XJko.isVisualRefreshEnabled)() ? (0, $ghyjR.default).lowestToHighestOrder : undefined,
            descendingSortTooltip: (0, $6XJko.isVisualRefreshEnabled)() ? (0, $ghyjR.default).highestToLowestOrder : undefined
        },
        $62418d0d75a1a065$var$getActionsCell(accountId)
    ].filter(Boolean));
function $62418d0d75a1a065$var$getActionsCell(accountId) {
    if (!accountId) return undefined;
    // If Nav4, meatball menu will be shown in the popularity column
    if ((0, $6XJko.isVisualRefreshEnabled)()) return undefined;
    // We still need to show actions column for Nav3
    return {
        title: (0, $ghyjR.default).moreActions,
        Cell: (0, $g014H.default),
        width: 6,
        dataTestId: 'dashboards-main.content.headerCell.actions.container'
    };
}
const $62418d0d75a1a065$export$b2d196af18e06ad6 = ()=>(0, $ghyjR.default).tableAriaLabel;
const $62418d0d75a1a065$export$64df75861e57fb7f = ()=>(0, $ghyjR.default).filterResultsAnnouncement;

});
parcelRegister("20b6k", function(module, exports) {
$parcel$export(module.exports, "default", () => $13fe72c3ec28f4da$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $gGgaG = parcelRequire("gGgaG");

var $lRq8t = parcelRequire("lRq8t");

var $fxJiv = parcelRequire("fxJiv");
const $13fe72c3ec28f4da$var$StarTitleCell = ()=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($gGgaG))), {
        label: formatMessage((0, $fxJiv.messages).starred)
    });
};
var $13fe72c3ec28f4da$export$2e2bcd8739ae039 = $13fe72c3ec28f4da$var$StarTitleCell;

});
parcelRegister("fxJiv", function(module, exports) {
$parcel$export(module.exports, "messages", () => $e5142eb9230ff6a4$export$defe85febe8b728c);

var $7qGN1 = parcelRequire("7qGN1");
const $e5142eb9230ff6a4$export$defe85febe8b728c = (0, $7qGN1.defineMessages)({
    starred: {
        "id": "directories.common.components.star-title-cell.starred",
        "defaultMessage": "Starred"
    }
});

});


parcelRegister("97fxM", function(module, exports) {
$parcel$export(module.exports, "default", () => $1633242c217c9ebe$export$2e2bcd8739ae039);

var $jdOqs = parcelRequire("jdOqs");

var $gnQAk = parcelRequire("gnQAk");

var $cK5WJ = parcelRequire("cK5WJ");
const $1633242c217c9ebe$var$mapStateToProps = ()=>(state, ownProps)=>({
            shares: (0, $cK5WJ.getShares)(state, ownProps.id)
        });
var $1633242c217c9ebe$export$2e2bcd8739ae039 = (0, $gnQAk.connect)($1633242c217c9ebe$var$mapStateToProps, {})((0, $jdOqs.default));

});
parcelRegister("jdOqs", function(module, exports) {
$parcel$export(module.exports, "default", () => $ce93edf6e82d029b$export$2e2bcd8739ae039);
/* view.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $5DgXR = parcelRequire("5DgXR");

var $9QgTI = parcelRequire("9QgTI");

var $jPgjO = parcelRequire("jPgjO");

var $hxN6p = parcelRequire("hxN6p");

var $iBgxn = parcelRequire("iBgxn");

var $idGBm = parcelRequire("idGBm");


var $5GvLH = parcelRequire("5GvLH");
const $ce93edf6e82d029b$var$assertUnreachable = (_x)=>{
    throw new Error("Didn't expect to get here");
};
class $ce93edf6e82d029b$export$3026e5a52c747d2c extends (0, $eJOHy.Component) {
    static{
        // go/jfe-eslint
        // eslint-disable-next-line react/sort-comp
        this.defaultProps = {
            shares: []
        };
    }
    static renderAvatar(text, avatarUrl, idx, appearance) {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($ce93edf6e82d029b$var$Container, {
            key: idx
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($ce93edf6e82d029b$var$AvatarContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $5DgXR.default), {
            size: "small",
            src: avatarUrl,
            appearance: appearance
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($ce93edf6e82d029b$var$TextContainer, null, text));
    }
    static renderIcon(text, IconComponent, idx = 1) {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($ce93edf6e82d029b$var$Container, {
            key: idx
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($ce93edf6e82d029b$var$IconContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(IconComponent, {
            label: "",
            spacing: "spacious"
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($ce93edf6e82d029b$var$TextContainer, null, text));
    }
    render() {
        const { shares: shares, intl: { formatMessage: formatMessage } } = this.props;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($ce93edf6e82d029b$var$CellContainer, null, shares.length > 0 ? shares.map((share, idx)=>{
            switch(share.type){
                case 0, $6f7399fe14fedc2b$export$b0a0e62d9b1a8269:
                    return $ce93edf6e82d029b$export$3026e5a52c747d2c.renderIcon(formatMessage((0, $5GvLH.default).myOrganizationAccess), (0, (/*@__PURE__*/$parcel$interopDefault($jPgjO))), idx);
                case 0, $6f7399fe14fedc2b$export$86517eb0163ef745:
                    return $ce93edf6e82d029b$export$3026e5a52c747d2c.renderIcon(formatMessage((0, $5GvLH.default).publicAccess), (0, (/*@__PURE__*/$parcel$interopDefault($iBgxn))), idx);
                case 0, $6f7399fe14fedc2b$export$b02d7412182d1bce:
                    // @ts-expect-error - TS2345 - Type 'undefined' is not assignable to type 'string'
                    return $ce93edf6e82d029b$export$3026e5a52c747d2c.renderIcon(share.group.name, (0, (/*@__PURE__*/$parcel$interopDefault($hxN6p))), idx);
                case 0, $6f7399fe14fedc2b$export$aea0835048e1c730:
                    return $ce93edf6e82d029b$export$3026e5a52c747d2c.renderAvatar(share.user.displayName, share.user.avatarUrl, idx, 'circle');
                case 0, $6f7399fe14fedc2b$export$5ef95a67b8fd1ff6:
                    {
                        const roleName = share.role ? share.role.name : formatMessage((0, $5GvLH.default).allProjectRoles);
                        const text = `${share.project.name}, ${roleName}`;
                        return $ce93edf6e82d029b$export$3026e5a52c747d2c.renderAvatar(text, share.project.avatarUrl, idx, 'square');
                    }
                case 0, $6f7399fe14fedc2b$export$487da0972e3459fe:
                    return null;
                // hide from the list
                default:
                    $ce93edf6e82d029b$var$assertUnreachable(share);
                    return null;
            }
        }) : $ce93edf6e82d029b$export$3026e5a52c747d2c.renderIcon(formatMessage((0, $5GvLH.default).privateAccess), (0, (/*@__PURE__*/$parcel$interopDefault($9QgTI)))));
    }
}
var $ce93edf6e82d029b$export$2e2bcd8739ae039 // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
 = (0, $idGBm.injectIntlV2)($ce93edf6e82d029b$export$3026e5a52c747d2c);
const $ce93edf6e82d029b$var$Container = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_1e0c1txw _4cvr1h6o _n3td1b66",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $ce93edf6e82d029b$var$AvatarContainer = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_u5f3u2gc _vwz4kb7n _1o9zidpf",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $ce93edf6e82d029b$var$IconContainer = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_ca0qv77o _u5f3utpp _n3tdv77o _19bvv77o _vwz4kb7n _1o9zidpf",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $ce93edf6e82d029b$var$TextContainer = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_1reo15vq _18m915vq _slp31hna _16jlkb7n",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $ce93edf6e82d029b$var$CellContainer = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_ca0q12x7 _1e0c1txw _2lx21bp4",
            __cmplp.className
        ])
    });
});

});
parcelRegister("jPgjO", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::61e479f96d30ea6369ef34d699ad08b2>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $e6ef7042ada3add3$var$_react = $e6ef7042ada3add3$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $e6ef7042ada3add3$var$_baseNew = $e6ef7042ada3add3$var$_interopRequireDefault((parcelRequire("fGWXz")));
function $e6ef7042ada3add3$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "OfficeBuilding".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: office in Atlas, company.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $e6ef7042ada3add3$var$OfficeBuildingIcon = (props)=>/*#__PURE__*/ $e6ef7042ada3add3$var$_react.default.createElement($e6ef7042ada3add3$var$_baseNew.default, Object.assign({
        name: "OfficeBuildingIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M2 2a2 2 0 0 1 2-2h8a2 2 0 0 1 2 2v12.5h1V16H1v-1.5h1zm1.5 12.5h2v-3.75a.75.75 0 0 1 .75-.75h3.5a.75.75 0 0 1 .75.75v3.75h2V2a.5.5 0 0 0-.5-.5H4a.5.5 0 0 0-.5.5zm5.5 0v-3H7v3zm-2-10H5V3h2zm4 0H9V3h2zM5 6h2v1.5H5zm4 0h2v1.5H9z" clip-rule="evenodd"/>`
    }, props));
$e6ef7042ada3add3$var$OfficeBuildingIcon.displayName = 'OfficeBuildingIcon';
var $e6ef7042ada3add3$var$_default = module.exports.default = $e6ef7042ada3add3$var$OfficeBuildingIcon;

});

parcelRegister("5GvLH", function(module, exports) {
$parcel$export(module.exports, "default", () => $7680afc0f5076786$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
const $7680afc0f5076786$var$messages = (0, $7qGN1.defineMessages)({
    myOrganizationAccess: {
        "id": "directories.common.components.access-cell.my-organization-access",
        "defaultMessage": "My organization"
    },
    publicAccess: {
        "id": "directories.common.components.access-cell.public-access",
        "defaultMessage": "Public"
    },
    privateAccess: {
        "id": "directories.common.components.access-cell.private-access",
        "defaultMessage": "Private"
    },
    allProjectRoles: {
        "id": "directories.common.components.access-cell.all-project-roles",
        "defaultMessage": "All roles"
    }
});
var $7680afc0f5076786$export$2e2bcd8739ae039 = $7680afc0f5076786$var$messages;

});



parcelRegister("g014H", function(module, exports) {
$parcel$export(module.exports, "default", () => $51c84f637843741e$export$2e2bcd8739ae039);

var $eq3Hf = parcelRequire("eq3Hf");

var $LFmXM = parcelRequire("LFmXM");

var $6sjW5 = parcelRequire("6sjW5");


var $gnQAk = parcelRequire("gnQAk");

var $bpMvQ = parcelRequire("bpMvQ");

var $cK5WJ = parcelRequire("cK5WJ");

var $eEHFy = parcelRequire("eEHFy");
const $51c84f637843741e$var$mapStateToPropsFactory = ()=>{
    const onCopyFactory = (0, $LFmXM.default)((onOperationRequested)=>()=>// @ts-expect-error - TS2554 - Expected 2 arguments, but got 1.
            onOperationRequested((0, $85bfce414eef38c7$export$92f9e1ed9114d3a6)));
    const onEditFactory = (0, $LFmXM.default)((onOperationRequested)=>()=>// @ts-expect-error - TS2554 - Expected 2 arguments, but got 1.
            onOperationRequested((0, $85bfce414eef38c7$export$250171a898bf7ef)));
    const onChangeOwnerFactory = (0, $LFmXM.default)((onOperationRequested)=>()=>// @ts-expect-error - TS2554 - Expected 2 arguments, but got 1.
            onOperationRequested((0, $85bfce414eef38c7$export$39d2a7fb21967424)));
    const onDeleteFactory = (0, $LFmXM.default)((onOperationRequested)=>()=>// @ts-expect-error - TS2554 - Expected 2 arguments, but got 1.
            onOperationRequested((0, $85bfce414eef38c7$export$4bd2facc4a3e6aa1)));
    return (state, ownProps)=>({
            owner: (0, $cK5WJ.getOwner)(state, ownProps.id),
            caption: (0, $cK5WJ.getName)(state, ownProps.id),
            loggedInUserAccountId: (0, $bpMvQ.getLoggedInUserAccountId)(state),
            isWritable: (0, $cK5WJ.getIsWritable)(state, ownProps.id),
            systemDashboard: (0, $cK5WJ.getSystemDashboard)(state, ownProps.id),
            showSpinner: ownProps.isOperationInProgress,
            onCopy: onCopyFactory(ownProps.onOperationRequested),
            onEdit: onEditFactory(ownProps.onOperationRequested),
            onChangeOwner: onChangeOwnerFactory(ownProps.onOperationRequested),
            onDelete: onDeleteFactory(ownProps.onOperationRequested)
        });
};
var $51c84f637843741e$export$2e2bcd8739ae039 = (0, (/*@__PURE__*/$parcel$interopDefault($eq3Hf)))((0, $6sjW5.default)({
    onCopyDashboardClick: 'copy',
    onEditDashboardClick: 'edit',
    onDeleteDashboardClick: 'delete',
    onChangeOwnerClick: 'changeOwner'
}), (0, $gnQAk.connect)($51c84f637843741e$var$mapStateToPropsFactory, {}))((0, $eEHFy.default));

});
parcelRegister("eEHFy", function(module, exports) {
$parcel$export(module.exports, "default", () => $08cf99d3593bc59d$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $12DRg = parcelRequire("12DRg");

var $Ay1uj = parcelRequire("Ay1uj");

var $7rjYb = parcelRequire("7rjYb");
var $jYYbf = parcelRequire("jYYbf");
var $aLJ1L = parcelRequire("aLJ1L");

var $NByNW = parcelRequire("NByNW");

var $8IeH1 = parcelRequire("8IeH1");
var $6djmC = parcelRequire("6djmC");

var $as6H2 = parcelRequire("as6H2");

var $lRq8t = parcelRequire("lRq8t");

var $4cTDP = parcelRequire("4cTDP");

var $4aSRi = parcelRequire("4aSRi");

var $bzbsd = parcelRequire("bzbsd");

var $cewKx = parcelRequire("cewKx");
const $08cf99d3593bc59d$var$DropdownMenuWithAnalytics = (0, $as6H2.default)('dropdownMenu', {
    onOpenChange: 'open'
})((0, $7rjYb.default));
const $08cf99d3593bc59d$var$DropdownItemWithAnalytics = (0, $as6H2.default)('dropdownItem', {
    onClick: 'clicked'
})((0, $jYYbf.default));
// eslint-disable-next-line jira/react/no-class-components
class $08cf99d3593bc59d$var$ActionsOld extends (0, $eJOHy.Component) {
    static{
        this.defaultProps = {
            isWritable: false,
            systemDashboard: false,
            defaultOpen: false,
            showSpinner: false,
            owner: null,
            caption: '',
            onChangeOwner: (0, (/*@__PURE__*/$parcel$interopDefault($12DRg))),
            onCopy: (0, (/*@__PURE__*/$parcel$interopDefault($12DRg))),
            onEdit: (0, (/*@__PURE__*/$parcel$interopDefault($12DRg))),
            onDelete: (0, (/*@__PURE__*/$parcel$interopDefault($12DRg))),
            onCopyDashboardClick: (0, (/*@__PURE__*/$parcel$interopDefault($12DRg))),
            onEditDashboardClick: (0, (/*@__PURE__*/$parcel$interopDefault($12DRg))),
            onChangeOwnerClick: (0, (/*@__PURE__*/$parcel$interopDefault($12DRg))),
            onDeleteDashboardClick: (0, (/*@__PURE__*/$parcel$interopDefault($12DRg))),
            setReturnFocusTo: (0, (/*@__PURE__*/$parcel$interopDefault($12DRg)))
        };
    }
    /**
   * Close the menu with a minimal delay so the inner handlers are able to react on keypress properly.
   * In its current implementation if we close the menu right away it won't open the focused `href`.
   * Ideally we have to get right of this and few more methods when the bug linked below is fixed.
   * @see https://ecosystem.atlassian.net/browse/AK-4467
   */ delayedClose() {
        setTimeout(()=>this.setState(()=>({
                    isOpen: false
                })));
    }
    render() {
        const { showSpinner: showSpinner, loggedInUserAccountId: loggedInUserAccountId, owner: owner, isWritable: isWritable, systemDashboard: systemDashboard, caption: caption, intl: { formatMessage: formatMessage } } = this.props;
        const isOwnedByCurrentUser = owner && owner.accountId === loggedInUserAccountId;
        const { isOpen: isOpen } = this.state;
        // @ts-expect-error - TS7031 - Binding element 'triggerRef' implicitly has an 'any' type.
        const triggerFunction = ({ triggerRef: triggerRef, ...props })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $Ay1uj.default), {
                ...props,
                testId: "dashboards-main.content.cells.actions.button",
                appearance: "subtle",
                icon: (0, (/*@__PURE__*/$parcel$interopDefault($NByNW))),
                ref: (0, $bzbsd.mergeRefs)(triggerRef, this.triggerButtonRef),
                label: formatMessage((0, $cewKx.default).moreActions, {
                    dashboardName: caption
                }),
                isLoading: showSpinner
            });
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($08cf99d3593bc59d$var$Container, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($08cf99d3593bc59d$var$DropdownMenuWithAnalytics, {
            // @ts-expect-error - Type '{ children: Element; position: string; isOpen: boolean; onOpenChange: ({ isOpen }: { isOpen: any; }) => void; trigger: ({ triggerRef, ...props }: { [x: string]: any; triggerRef: any; }) => Element; }' is not assignable to type 'IntrinsicAttributes & Omit<{ appearance?: "default" | "tall" | undefined; autoFocus?: boolean | undefined; children?: ReactNode; isLoading?: boolean | undefined; ... 11 more ...; label?: string | undefined; }, keyof WithAnalyticsEventsProps>'.
            position: "bottom right",
            isOpen: isOpen,
            onOpenChange: this.onOpenChange,
            trigger: triggerFunction,
            shouldRenderToParent: true
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $aLJ1L.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($08cf99d3593bc59d$var$DropdownItemWithAnalytics, {
            onClick: this.onCopyDashboardClick
        }, formatMessage((0, $cewKx.default).copyAction)), isWritable === true && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($08cf99d3593bc59d$var$DropdownItemWithAnalytics, {
            onClick: this.onEditDashboardClick
        }, formatMessage(systemDashboard ? (0, $cewKx.default).shareAction : (0, $cewKx.default).renameOrShareAction)), isOwnedByCurrentUser === true && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($08cf99d3593bc59d$var$DropdownItemWithAnalytics, {
            onClick: this.onChangeOwnerClick
        }, formatMessage((0, $cewKx.default).changeOwner)), isOwnedByCurrentUser === true && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($08cf99d3593bc59d$var$DropdownItemWithAnalytics, {
            onClick: this.onDeleteDashboardClick
        }, formatMessage((0, $cewKx.default).moveToTrashAction)))));
    }
    constructor(...args){
        super(...args), this.state = {
            isOpen: this.props.defaultOpen
        }, this.triggerButtonRef = /*#__PURE__*/ (0, $eJOHy.createRef)(), // @ts-expect-error - TS7031 - Binding element 'isOpen' implicitly has an 'any' type.
        this.onOpenChange = ({ isOpen: isOpen })=>{
            this.setState(()=>({
                    isOpen: isOpen
                }));
        }, // eslint-disable-next-line @typescript-eslint/no-explicit-any
        this.onCopyDashboardClick = (e, analytics)=>{
            this.props.onCopyDashboardClick(analytics);
            this.props.onCopy();
            if ((0, $4cTDP.fg)('jfp_a11y_fix_dashboard_actions_modal_accessibility')) this.triggerButtonRef.current && this.props.setReturnFocusTo(this.triggerButtonRef);
        }, // eslint-disable-next-line @typescript-eslint/no-explicit-any
        this.onEditDashboardClick = (e, analytics)=>{
            this.props.onEditDashboardClick(analytics);
            this.props.onEdit();
            if ((0, $4cTDP.fg)('jfp_a11y_fix_dashboard_actions_modal_accessibility')) this.triggerButtonRef.current && this.props.setReturnFocusTo(this.triggerButtonRef);
        }, // eslint-disable-next-line @typescript-eslint/no-explicit-any
        this.onChangeOwnerClick = (e, analytics)=>{
            this.props.onChangeOwnerClick(analytics);
            this.props.onChangeOwner();
            if ((0, $4cTDP.fg)('jfp_a11y_fix_dashboard_actions_modal_accessibility')) this.triggerButtonRef.current && this.props.setReturnFocusTo(this.triggerButtonRef);
        }, // eslint-disable-next-line @typescript-eslint/no-explicit-any
        this.onDeleteDashboardClick = (e, analytics)=>{
            this.props.onDeleteDashboardClick(analytics);
            this.props.onDelete();
            if ((0, $4cTDP.fg)('jfp_a11y_fix_dashboard_actions_modal_accessibility')) this.triggerButtonRef.current && this.props.setReturnFocusTo(this.triggerButtonRef);
        };
    }
}
const $08cf99d3593bc59d$var$ActionsWithReturnToFocus = (props)=>{
    const { setReturnFocusTo: setReturnFocusTo } = (0, $4aSRi.useModalDialogActions)();
    const intl = (0, $lRq8t.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($08cf99d3593bc59d$var$ActionsOld, {
        ...props,
        intl: intl,
        setReturnFocusTo: setReturnFocusTo
    });
};
var $08cf99d3593bc59d$export$2e2bcd8739ae039 = $08cf99d3593bc59d$var$ActionsWithReturnToFocus;
const $08cf99d3593bc59d$var$Container = ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8IeH1.default), {
        paddingBlockStart: "space.050",
        paddingInlineEnd: "space.025"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $6djmC.default), {
        alignInline: "end"
    }, children));

});
parcelRegister("cewKx", function(module, exports) {
$parcel$export(module.exports, "default", () => $d621f06984e16fa5$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
const $d621f06984e16fa5$var$messages = (0, $7qGN1.defineMessages)({
    copyAction: {
        "id": "directories.dashboards-v2.main.content.cells.actions.copy-action",
        "defaultMessage": "Copy dashboard"
    },
    moveToTrashAction: {
        "id": "directories.dashboards-v2.main.content.cells.actions.move-to-trash-action",
        "defaultMessage": "Move to trash"
    },
    changeOwner: {
        "id": "directories.dashboards-v2.main.content.cells.actions.change-owner",
        "defaultMessage": "Change owner"
    },
    renameOrShareAction: {
        "id": "directories.dashboards-v2.main.content.cells.actions.rename-or-share-action",
        "defaultMessage": "Rename or share dashboard"
    },
    shareAction: {
        "id": "directories.dashboards-v2.main.content.cells.actions.share-action",
        "defaultMessage": "Share dashboard"
    },
    moreActions: {
        "id": "directories.dashboards-v2.main.content.cells.actions.more-actions",
        "defaultMessage": "More actions for {dashboardName}"
    }
});
var $d621f06984e16fa5$export$2e2bcd8739ae039 = $d621f06984e16fa5$var$messages;

});



parcelRegister("9Wcrd", function(module, exports) {
$parcel$export(module.exports, "default", () => $1f20d153fa9c4585$export$2e2bcd8739ae039);

var $jdOqs = parcelRequire("jdOqs");

var $gnQAk = parcelRequire("gnQAk");

var $cK5WJ = parcelRequire("cK5WJ");
const $1f20d153fa9c4585$var$mapStateToProps = (state, ownProps)=>({
        shares: (0, $cK5WJ.getEdits)(state, ownProps.id)
    });
var $1f20d153fa9c4585$export$2e2bcd8739ae039 = (0, $gnQAk.connect)($1f20d153fa9c4585$var$mapStateToProps, // We attempted to fix the below FixFlowMe but ran into issue with cross package dependencies which we do not want
// to introduce. We believe the unused fields in Props causes the below issue.
{})((0, $jdOqs.default));

});

parcelRegister("k9N1W", function(module, exports) {
$parcel$export(module.exports, "default", () => $c715f7e4c439ddc5$export$2e2bcd8739ae039);

var $eq3Hf = parcelRequire("eq3Hf");

var $LFmXM = parcelRequire("LFmXM");

var $fdpHV = parcelRequire("fdpHV");

var $k0CKR = parcelRequire("k0CKR");

var $gnQAk = parcelRequire("gnQAk");

var $cK5WJ = parcelRequire("cK5WJ");
const $c715f7e4c439ddc5$var$mapStateToPropsFactory = ()=>{
    const onClickFactory = (0, $LFmXM.default)((state, id)=>(analyticsEvent)=>{
            const changeFavorite = (0, $cK5WJ.getChangeFavorite)(state);
            return changeFavorite({
                id: id,
                type: 'dashboards',
                value: !(0, $cK5WJ.isFavorite)(state, id)
            }, analyticsEvent);
        });
    return (state, ownProps)=>({
            isFavorite: (0, $cK5WJ.isFavorite)(state, ownProps.id),
            favoriteItemName: (0, $cK5WJ.getName)(state, ownProps.id),
            pending: (0, $cK5WJ.isPending)(state, ownProps.id),
            onClick: onClickFactory(state, ownProps.id),
            isShownInList: true
        });
};
var $c715f7e4c439ddc5$export$2e2bcd8739ae039 = (0, (/*@__PURE__*/$parcel$interopDefault($eq3Hf)))((0, $fdpHV.AnalyticsSubject)('dashboard'), // @ts-expect-error - TS2589 - Type instantiation is excessively deep and possibly infinite.
(0, $gnQAk.connect)($c715f7e4c439ddc5$var$mapStateToPropsFactory, {}))((0, $k0CKR.FavoriteCellView));

});
parcelRegister("k0CKR", function(module, exports) {
$parcel$export(module.exports, "FavoriteCellView", () => $c36e74a942f9c7e3$export$7e4dcb8ef4c4afcd);
/* view.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $hcewu = parcelRequire("hcewu");

var $eJOHy = parcelRequire("eJOHy");

var $8nu6j = parcelRequire("8nu6j");
var $1DXK0 = parcelRequire("1DXK0");

var $fVPN0 = parcelRequire("fVPN0");

var $6XJko = parcelRequire("6XJko");
const $c36e74a942f9c7e3$var$styles = {
    root: "_1e0c1txw _1bah1h6o _ca0q1b66 _u5f31b66 _n3td1b66 _19bv1b66"
};
function $c36e74a942f9c7e3$export$7e4dcb8ef4c4afcd(props) {
    return (0, $6XJko.isVisualRefreshEnabled)() ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
        xcss: $c36e74a942f9c7e3$var$rootStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $fVPN0.default), props)) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("div", {
        className: (0, $hcewu.default)([
            $c36e74a942f9c7e3$var$styles.root
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $fVPN0.default), props));
}
$c36e74a942f9c7e3$export$7e4dcb8ef4c4afcd.defaultProps = {
    isFavorite: undefined
};
const $c36e74a942f9c7e3$var$rootStyles = (0, $1DXK0.xcss)({
    display: 'flex',
    justifyContent: 'center',
    paddingInline: 'space.050',
    paddingBlock: 'space.100',
    alignItems: 'center',
    height: '40px',
    width: '32px'
});

});
parcelRegister("fVPN0", function(module, exports) {
$parcel$export(module.exports, "FavoriteButtonWrapper", () => $c7558d16e1b4ddea$export$bb1478fee6cd5f0c);
$parcel$export(module.exports, "default", () => $c7558d16e1b4ddea$export$2e2bcd8739ae039);
/* view.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $eq3Hf = parcelRequire("eq3Hf");

var $12DRg = parcelRequire("12DRg");

var $goZPP = parcelRequire("goZPP");

var $gGgaG = parcelRequire("gGgaG");

var $aaIe7 = parcelRequire("aaIe7");

var $dLR8J = parcelRequire("dLR8J");

var $k71qx = parcelRequire("k71qx");

var $6sjW5 = parcelRequire("6sjW5");

var $f2JN3 = parcelRequire("f2JN3");

var $6YFG2 = parcelRequire("6YFG2");

var $6XJko = parcelRequire("6XJko");

var $6urTU = parcelRequire("6urTU");
const $c7558d16e1b4ddea$var$SKELETON_TEST_ID = 'favouriting.favorite-button-stateless.skeleton';
const $c7558d16e1b4ddea$var$ICON_WRAPPER_TEST_ID_PREFIX = 'favouriting.favorite-button-stateless.icon-wrapper';
class $c7558d16e1b4ddea$export$f8ad2acf0ec4860f extends (0, $eJOHy.Component) {
    static{
        this.defaultProps = {
            isFavorite: undefined,
            favoriteItemName: undefined,
            isShownInList: false,
            isSmall: false,
            hideTooltip: false,
            onClick: (0, (/*@__PURE__*/$parcel$interopDefault($12DRg))),
            tooltipPosition: 'bottom',
            skipAnimation: false
        };
    }
    componentDidUpdate(prevProps) {
        if (!this.props.skipAnimation && (!prevProps.pending && this.props.pending || !prevProps.isFavorite && this.props.isFavorite)) {
            this.onAnimationStart();
            this.onSettingAnimationEnd();
        }
    }
    onAnimationStart() {
        this.setState({
            isAnimating: !this.state.isAnimating
        });
    }
    onSettingAnimationEnd() {
        setTimeout(()=>{
            this.setState({
                isAnimating: false
            });
        }, $c7558d16e1b4ddea$var$animationTime * 2);
    }
    render() {
        const { isFavorite: isFavorite, favoriteItemName: favoriteItemName, isShownInList: isShownInList, isSmall: isSmall, hideTooltip: hideTooltip, tooltipPosition: tooltipPosition, pending: pending, intl: { formatMessage: formatMessage } } = this.props;
        const { isAnimating: isAnimating } = this.state;
        if (isFavorite === undefined) // show skeleton as a space placeholder (to avoid layout recalculations in browser and visible "jump" when we got data)
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $dLR8J.default), {
            name: "favourite-button"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($c7558d16e1b4ddea$export$db65185b5889c83, {
            "data-testid": $c7558d16e1b4ddea$var$SKELETON_TEST_ID,
            isSmall: isSmall
        }));
        const iconWrapperTestId = isShownInList ? `${$c7558d16e1b4ddea$var$ICON_WRAPPER_TEST_ID_PREFIX}-list` : $c7558d16e1b4ddea$var$ICON_WRAPPER_TEST_ID_PREFIX;
        const buttonContentOld = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($c7558d16e1b4ddea$var$FavIconWrapper, {
            isFavorite: isFavorite,
            isAnimating: isAnimating,
            "data-testid": iconWrapperTestId,
            isSmall: isSmall
        }, isFavorite ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($gGgaG))), {
            LEGACY_size: isSmall ? 'small' : undefined,
            color: "currentColor",
            label: formatMessage((0, $6urTU.default).removeFromStarred)
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($aaIe7))), {
            LEGACY_size: isSmall ? 'small' : undefined,
            color: "currentColor",
            label: formatMessage((0, $6urTU.default).addToStarred)
        }));
        const renderIcon = ()=>{
            const label = isFavorite ? formatMessage((0, $6urTU.default).removeFromStarred) : formatMessage((0, $6urTU.default).addToStarred);
            const StarIconComponent = isFavorite ? (0, (/*@__PURE__*/$parcel$interopDefault($gGgaG))) : (0, (/*@__PURE__*/$parcel$interopDefault($aaIe7)));
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(StarIconComponent, {
                color: "currentColor",
                label: label,
                size: isSmall ? 'small' : 'medium'
            });
        };
        const buttonContent = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($c7558d16e1b4ddea$var$FavIconWrapper, {
            isFavorite: isFavorite,
            isAnimating: isAnimating,
            "data-testid": iconWrapperTestId,
            isSmall: isSmall
        }, renderIcon());
        const tooltipContent = isFavorite ? formatMessage((0, $6urTU.default).removeFromStarred) : formatMessage((0, $6urTU.default).addToStarred);
        const ariaLabel = favoriteItemName ? formatMessage((0, $6urTU.default).toggleStarredWithItemName, {
            itemName: favoriteItemName
        }) : formatMessage((0, $6urTU.default).toggleStarred);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($c7558d16e1b4ddea$export$bb1478fee6cd5f0c, {
            role: "presentation",
            onClick: this.onBtnClickWrapper,
            onKeyPress: this.onBtnClickWrapper,
            "data-is-favorite": isFavorite
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $k71qx.default), {
            content: !hideTooltip && tooltipContent,
            hideTooltipOnClick: true,
            position: tooltipPosition
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $goZPP.default), {
            appearance: isShownInList ? 'subtle-link' : 'subtle',
            spacing: "none",
            "aria-label": ariaLabel,
            "aria-pressed": isFavorite,
            onClick: !pending ? this.onClick : (0, (/*@__PURE__*/$parcel$interopDefault($12DRg)))
        }, (0, $6XJko.isVisualRefreshEnabled)() ? buttonContent : buttonContentOld)));
    }
    constructor(...args){
        super(...args), this.state = {
            isAnimating: false
        }, this.onBtnClickWrapper = (e)=>{
            e.stopPropagation(); // should not let this event get outside of the component, to prevent issue when, for example, star button is clicked in an item or row, which goes somewhere else on onClick handler. Cannot put it in onBtnClick, otherwise hideTooltipOnClick in <Tooltip> will not work
            e.preventDefault(); // same for cases when btn is inside a link - not to go to that link (e.g. in Star Drawer)
        }, this.onClick = (_, analyticsEvent)=>{
            this.props.onClick(analyticsEvent);
        };
    }
}
var $c7558d16e1b4ddea$export$2e2bcd8739ae039 = (0, (/*@__PURE__*/$parcel$interopDefault($eq3Hf)))((0, $6sjW5.default)({
    onClick: ()=>({
            name: 'star'
        })
}), (0, $6YFG2.default))($c7558d16e1b4ddea$export$f8ad2acf0ec4860f);
const $c7558d16e1b4ddea$var$animationTime = 500; // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
const $c7558d16e1b4ddea$export$bb1478fee6cd5f0c = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_1e0c1o8l",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $c7558d16e1b4ddea$var$FavoriteIconWrapperBaseOld = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { isSmall: isSmall, isAnimating: isAnimating, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_1e0c1txw _4cvr1h6o _1bah1h6o",
            __cmplp.isSmall ? "_1bsb1tcg" : "_1bsbzwfg",
            __cmplp.isSmall ? "_4t3i1tcg" : "_4t3izwfg",
            __cmplp.isAnimating && "_11vn1rr0 _1px1fmmq _48hmq7pw _1uvf1e03",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $c7558d16e1b4ddea$var$FavoriteIconWrapperBaseNew = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { isSmall: isSmall, isAnimating: isAnimating, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_1e0c1txw _4cvr1h6o _1bah1h6o",
            __cmplp.isSmall ? "_1bsb1tcg" : "_1bsbzwfg",
            __cmplp.isSmall ? "_4t3i1tcg" : "_4t3izwfg",
            __cmplp.isAnimating && "_1px1fmmq _48hmq7pw _1uvf1e03",
            __cmplp.className
        ])
    });
});
const $c7558d16e1b4ddea$var$FavoriteIconWrapperBase = (0, $f2JN3.componentWithCondition)((0, $6XJko.isVisualRefreshEnabled), $c7558d16e1b4ddea$var$FavoriteIconWrapperBaseNew, $c7558d16e1b4ddea$var$FavoriteIconWrapperBaseOld); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $c7558d16e1b4ddea$var$FavIconWrapper = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = $c7558d16e1b4ddea$var$FavoriteIconWrapperBase, style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "",
            __cmplp.isFavorite ? "_syaz1oqg" : "_syaz1oju",
            __cmplp.isFavorite ? "_30l31vop" : "_30l3wdcn",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
const $c7558d16e1b4ddea$export$db65185b5889c83 = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { isSmall: isSmall, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_1e0c1txw",
            __cmplp.isSmall ? "_1bsb1tcg" : "_1bsbzwfg",
            __cmplp.isSmall ? "_4t3i1tcg" : "_4t3izwfg",
            __cmplp.className
        ])
    });
});

});
parcelRegister("6urTU", function(module, exports) {
$parcel$export(module.exports, "default", () => $708ae8e1a771b9ca$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
const $708ae8e1a771b9ca$var$messages = (0, $7qGN1.defineMessages)({
    addToStarred: {
        "id": "platform.ui.favouriting.favourite-button-stateless.add-to-starred",
        "defaultMessage": "Add to Starred"
    },
    removeFromStarred: {
        "id": "platform.ui.favouriting.favourite-button-stateless.remove-from-starred",
        "defaultMessage": "Remove from Starred"
    },
    toggleStarred: {
        "id": "platform.ui.favouriting.favourite-button-stateless.toggle-starred",
        "defaultMessage": "Star"
    },
    toggleStarredWithItemName: {
        "id": "platform.ui.favouriting.favourite-button-stateless.toggle-starred-with-item-name",
        "defaultMessage": "Star {itemName}"
    }
});
var $708ae8e1a771b9ca$export$2e2bcd8739ae039 = $708ae8e1a771b9ca$var$messages;

});




parcelRegister("flgeI", function(module, exports) {
$parcel$export(module.exports, "default", () => $c610cc5af025dbec$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $rIjzv = parcelRequire("rIjzv");

var $gnQAk = parcelRequire("gnQAk");

var $cK5WJ = parcelRequire("cK5WJ");
const $c610cc5af025dbec$var$mapStateToProps = (state, ownProps)=>({
        user: (0, $cK5WJ.getOwner)(state, ownProps.id)
    });
const $c610cc5af025dbec$var$UserCell = (props)=>{
    const { user: user } = props;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $rIjzv.default), {
        user: user
    });
};
$c610cc5af025dbec$var$UserCell.defaultProps = {
    onClick: null
};
var // @ts-expect-error - TS2345 - Argument of type '{ (props: UserCellProps): JSX.Element; defaultProps: { onClick: null; }; }' is not assignable to parameter of type 'Component<EntityCellProps & Props>'.
$c610cc5af025dbec$export$2e2bcd8739ae039 = (0, $gnQAk.connect)($c610cc5af025dbec$var$mapStateToProps, {})($c610cc5af025dbec$var$UserCell);

});
parcelRegister("rIjzv", function(module, exports) {
$parcel$export(module.exports, "default", () => $4786212b595d5412$export$2e2bcd8739ae039);

var $6sjW5 = parcelRequire("6sjW5");

var $hJq8V = parcelRequire("hJq8V");
var $4786212b595d5412$export$2e2bcd8739ae039 = (0, $6sjW5.default)({
    onClick: 'userProfile'
})((0, $hJq8V.default));

});
parcelRegister("hJq8V", function(module, exports) {
$parcel$export(module.exports, "default", () => $3a0cbec7d37711e3$export$2e2bcd8739ae039);
/* view.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $eJOHy = parcelRequire("eJOHy");

var $faIE0 = parcelRequire("faIE0");

var $98kYt = parcelRequire("98kYt");
function $3a0cbec7d37711e3$export$2e2bcd8739ae039(props) {
    const { user: user, isDeleting: isDeleting } = props;
    if (!user) return null;
    const { accountId: accountId, displayName: displayName, avatarUrl: avatarUrl } = user;
    const content = /*#__PURE__*/ $eJOHy.createElement((0, $98kYt.default), {
        displayName: displayName,
        avatarUrl: avatarUrl,
        isDeleting: isDeleting
    });
    return /*#__PURE__*/ $eJOHy.createElement((0, $faIE0.default), {
        accountId: accountId,
        prepopulatedData: {
            fullName: displayName
        }
    }, content);
}

});
parcelRegister("faIE0", function(module, exports) {
$parcel$export(module.exports, "default", () => $147e70feef199e30$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");


const $147e70feef199e30$var$ConditionalProfileCard = (parcelRequire("h0jdL")).default;
function $147e70feef199e30$export$2e2bcd8739ae039(props) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($147e70feef199e30$var$ConditionalProfileCard, props);
}

});
parcelRegister("h0jdL", function(module, exports) {


module.exports = (parcelRequire("g81qY"))('empanada_profilecard_sync_trigger_import_final', function() {
    return parcelRequire('kaujN');
}, function() {
    return parcelRequire('bMaIs');
}, {
    l: (parcelRequire("bbrhz")),
    i: [
        "4yYgJ",
        "6Z32B"
    ]
});

});
parcelRegister("g81qY", function(module, exports) {
"use strict";

var $9VDxJ = parcelRequire("9VDxJ");
var $bbde81794392820b$require$getBundleURL = $9VDxJ.getBundleURL;

var $iTG8W = parcelRequire("iTG8W");
var $bbde81794392820b$require$resolve = $iTG8W.resolve;
module.exports = function loadCond(cond, ifTrue, ifFalse, fallback) {
    let result = globalThis.__MCOND(cond);
    try {
        return result ? ifTrue() : ifFalse();
    } catch (err) {
        if (fallback) {
            globalThis.__ATLASPACK_ERRORS = globalThis.__ATLASPACK_ERRORS || [];
            globalThis.__ATLASPACK_ERRORS.push(new Error(`Sync dependency fallback triggered for condition "${cond}": ${err.message}`));
            for (const id of fallback.i)fallback.l(new URL($bbde81794392820b$require$resolve(id), $bbde81794392820b$require$getBundleURL(id)).toString());
            return result ? ifTrue() : ifFalse();
        } else throw err;
    }
};

});
parcelRegister("9VDxJ", function(module, exports) {
$parcel$export(module.exports, "getBundleURL", () => $73a81c5f1e1fde26$export$bdfd709ae4826697, (v) => $73a81c5f1e1fde26$export$bdfd709ae4826697 = v);
// TODO: convert this file to ESM once HMR issues are resolved
var $73a81c5f1e1fde26$export$5a759dc7a1cfb72a;
var $73a81c5f1e1fde26$export$bdfd709ae4826697;
var $73a81c5f1e1fde26$export$c9e73fbda7da57b6;
"use strict";
const $73a81c5f1e1fde26$var$stackTraceUrlRegexp = /(https?|file|ftp|(chrome|moz|safari-web)-extension):\/\/[^)\n]+/g;
const $73a81c5f1e1fde26$var$bundleURL = {};
/**
 * Retrieves the cached bundle URL for a given identifier.
 * If the URL is not cached, it computes and stores it in the cache.
 *
 * @param {string} id - The identifier for the bundle.
 * @param {Error?} inputError - An error object to extract the stack trace from
 * (for testing purposes).
 * @returns {string} The URL of the bundle, without file name.
 */ function $73a81c5f1e1fde26$var$getBundleURLCached(id, inputError) {
    let value = $73a81c5f1e1fde26$var$bundleURL[id];
    if (!value) {
        value = $73a81c5f1e1fde26$var$getBundleURL(inputError);
        $73a81c5f1e1fde26$var$bundleURL[id] = value;
    }
    return value;
}
/** Get the URL without the filename (last / segment)
 *
 * @param {string} url
 * @returns {string} The URL with the file name removed
 */ function $73a81c5f1e1fde26$var$getBaseURL(url) {
    return url.slice(0, url.lastIndexOf('/')) + '/';
}
function $73a81c5f1e1fde26$var$getBundleURL(inputError) {
    try {
        throw inputError ?? new Error();
    } catch (err) {
        var matches = ('' + err.stack).match($73a81c5f1e1fde26$var$stackTraceUrlRegexp);
        if (matches) // The first two stack frames will be this function and getBundleURLCached.
        // Use the 3rd one, which will be a runtime in the original bundle.
        return $73a81c5f1e1fde26$var$getBaseURL(matches[2]);
    }
    return '/';
}
/**
 * @param {string} url
 * @returns {string}
 */ function $73a81c5f1e1fde26$var$getOrigin(url) {
    return new URL(url).origin;
}
$73a81c5f1e1fde26$export$5a759dc7a1cfb72a = $73a81c5f1e1fde26$var$getOrigin;
$73a81c5f1e1fde26$export$bdfd709ae4826697 = $73a81c5f1e1fde26$var$getBundleURLCached;
$73a81c5f1e1fde26$export$c9e73fbda7da57b6 = $73a81c5f1e1fde26$var$getBaseURL;

});


parcelRegister("bbrhz", function(module, exports) {
"use strict";
module.exports = function loadJSBundle(bundle) {
    // Don't insert the same script twice (e.g. if it was already in the HTML)
    let existingScripts = document.getElementsByTagName('script');
    let isCurrentBundle = function(script) {
        return script.src === bundle;
    };
    if ([].concat(existingScripts).some(isCurrentBundle)) return;
    // Request using XHR because it's synchronous and we can't use promises here
    // This has extremely poor performance because we're idle during this fetch, so we only use this so that the app won't crash
    const xhr = new XMLHttpRequest();
    xhr.open('GET', bundle, false);
    try {
        xhr.send();
        if (xhr.status === 200) {
            const script = document.createElement('script');
            script.type = 'text/javascript';
            script.text = xhr.responseText;
            // Execute the script synchronously
            document.head.appendChild(script);
        } else throw new TypeError(`Failed to fetch dynamically imported module: ${bundle}. Status: ${xhr.status}`);
    } catch (e) {
        throw new TypeError(`Failed to fetch dynamically imported module: ${bundle}. Error: ${e.message}`);
    }
};

});



parcelRegister("98kYt", function(module, exports) {
$parcel$export(module.exports, "default", () => $b36214b33d25bdee$export$2e2bcd8739ae039);
/* view.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $gYvT9 = parcelRequire("gYvT9");

var $5DgXR = parcelRequire("5DgXR");

var $8nu6j = parcelRequire("8nu6j");
var $lmgo6 = parcelRequire("lmgo6");
var $3Wh6p = parcelRequire("3Wh6p");
var $1DXK0 = parcelRequire("1DXK0");

var $k71qx = parcelRequire("k71qx");

var $4cTDP = parcelRequire("4cTDP");

var $6XJko = parcelRequire("6XJko");

var $2wTQj = parcelRequire("2wTQj");
const $b36214b33d25bdee$var$styles = {
    avatarContainer: "_16jlidpf _1o9zidpf _i0dl1wug _u5f3u2gc _vwz4idpf",
    avatarContainerNew: "_4cvr1h6o",
    container: "_16jlkb7n _1o9zkb7n _i0dl1wug _ca0q12x7 _n3td12x7 _1e0c1txw",
    contentContainer: "_16jlkb7n _1o9zkb7n _i0dl1wug _1reo15vq _18m915vq _1e0c1txw _4cvr1h6o _1bsb1osq",
    contentContainerOld: "_16jlkb7n _1o9zkb7n _i0dl1wug _1e0c1txw _4cvr1h6o _1bsb1osq",
    accessibleContentContainer: "_16jlkb7n _1o9zkb7n _i0dl1wug _ca0qu2gc _n3tdu2gc _1e0c1txw _4cvr1h6o _1bsb1osq",
    link: "_1bsb1osq",
    textContainer: "_1reo15vq _18m915vq _slp31hna _o5721q9c _1bto1l2s"
};
function $b36214b33d25bdee$export$2e2bcd8739ae039(props) {
    const { avatarUrl: avatarUrl, displayName: displayName, href: href, appearance: appearance, isDeleting: isDeleting, onClick: onClick } = props;
    // To vertically align the avatar with the text and also change the height of the cell from 44px to 40px -  BLU-7380
    const applyVisualRefreshStyles = (0, $6XJko.isVisualRefreshEnabled)();
    const content = !href ? /*#__PURE__*/ $eJOHy.createElement((0, $lmgo6.default), {
        alignItems: applyVisualRefreshStyles ? 'center' : 'start',
        xcss: applyVisualRefreshStyles ? $b36214b33d25bdee$var$contentWrapperStyles : $b36214b33d25bdee$var$contentWrapperStylesOld
    }, /*#__PURE__*/ $eJOHy.createElement("div", {
        className: (0, $hcewu.default)([
            $b36214b33d25bdee$var$styles.avatarContainer,
            applyVisualRefreshStyles && $b36214b33d25bdee$var$styles.avatarContainerNew
        ])
    }, /*#__PURE__*/ $eJOHy.createElement((0, $5DgXR.default), {
        src: avatarUrl,
        size: "small",
        appearance: appearance
    })), /*#__PURE__*/ $eJOHy.createElement((0, $3Wh6p.default), {
        xcss: !applyVisualRefreshStyles ? $b36214b33d25bdee$var$inlineTextStyles : undefined
    }, isDeleting && (0, $4cTDP.fg)('hix-6302_project_delete_improvements') ? /*#__PURE__*/ $eJOHy.createElement((0, $2wTQj.default), null, displayName) : displayName)) : /*#__PURE__*/ $eJOHy.createElement($b36214b33d25bdee$var$Content, null, /*#__PURE__*/ $eJOHy.createElement("div", {
        className: (0, $hcewu.default)([
            $b36214b33d25bdee$var$styles.avatarContainer,
            applyVisualRefreshStyles && $b36214b33d25bdee$var$styles.avatarContainerNew
        ])
    }, /*#__PURE__*/ $eJOHy.createElement((0, $5DgXR.default), {
        src: avatarUrl,
        size: "small",
        appearance: appearance
    })), /*#__PURE__*/ $eJOHy.createElement("div", {
        className: (0, $hcewu.default)([
            $b36214b33d25bdee$var$styles.textContainer
        ])
    }, isDeleting && (0, $4cTDP.fg)('hix-6302_project_delete_improvements') ? /*#__PURE__*/ $eJOHy.createElement((0, $2wTQj.default), null, displayName, " ") : displayName));
    if (href) return /*#__PURE__*/ $eJOHy.createElement("div", {
        className: (0, $hcewu.default)([
            $b36214b33d25bdee$var$styles.container
        ])
    }, isDeleting && (0, $4cTDP.fg)('hix-6302_project_delete_improvements') ? content : /*#__PURE__*/ $eJOHy.createElement("div", {
        className: (0, $hcewu.default)([
            $b36214b33d25bdee$var$styles.link
        ])
    }, /*#__PURE__*/ $eJOHy.createElement((0, $8nu6j.default), {
        xcss: applyVisualRefreshStyles ? $b36214b33d25bdee$var$contentWrapperStyles : $b36214b33d25bdee$var$contentWrapperStylesOld
    }, /*#__PURE__*/ $eJOHy.createElement((0, $k71qx.default), {
        content: displayName,
        isScreenReaderAnnouncementDisabled: true,
        delay: 1000,
        position: "bottom-start"
    }, /*#__PURE__*/ $eJOHy.createElement((0, $gYvT9.default), {
        href: href,
        onClick: onClick
    }, content)))));
    return /*#__PURE__*/ $eJOHy.createElement("div", {
        className: (0, $hcewu.default)([
            (0, $6XJko.isVisualRefreshEnabled)() ? $b36214b33d25bdee$var$styles.contentContainer : $b36214b33d25bdee$var$styles.contentContainerOld
        ])
    }, content);
}
$b36214b33d25bdee$export$2e2bcd8739ae039.defaultProps = {
    avatarUrl: undefined,
    href: undefined,
    appearance: 'circle',
    onClick: undefined
};
const $b36214b33d25bdee$var$Content = (props)=>{
    return (0, $6XJko.isVisualRefreshEnabled)() ? /*#__PURE__*/ $eJOHy.createElement((0, $8nu6j.default), {
        xcss: $b36214b33d25bdee$var$accessibleContentContainerStyles
    }, props.children) : /*#__PURE__*/ $eJOHy.createElement("div", {
        className: (0, $hcewu.default)([
            $b36214b33d25bdee$var$styles.accessibleContentContainer
        ])
    }, props.children);
};
const $b36214b33d25bdee$var$contentWrapperStyles = (0, $1DXK0.xcss)({
    maxWidth: '100%',
    paddingBlock: 'space.075'
});
const $b36214b33d25bdee$var$contentWrapperStylesOld = (0, $1DXK0.xcss)({
    maxWidth: '100%',
    paddingBlock: 'space.100'
});
const $b36214b33d25bdee$var$inlineTextStyles = (0, $1DXK0.xcss)({
    paddingBlockStart: 'space.025'
});
const $b36214b33d25bdee$var$accessibleContentContainerStyles = (0, $1DXK0.xcss)({
    paddingTop: 'space.100',
    paddingBottom: 'space.100',
    display: 'flex',
    alignItems: 'center',
    flex: '1 1 auto',
    width: '100%',
    height: '40px'
});

});
parcelRegister("2wTQj", function(module, exports) {
$parcel$export(module.exports, "default", () => $1a72e7a385cd217c$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $eJOHy = parcelRequire("eJOHy");

var $8nu6j = parcelRequire("8nu6j");
var $1DXK0 = parcelRequire("1DXK0");
function $1a72e7a385cd217c$export$2e2bcd8739ae039({ children: children }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
        xcss: $1a72e7a385cd217c$var$disabledBoxStyles
    }, children);
}
const $1a72e7a385cd217c$var$disabledBoxStyles = (0, $1DXK0.xcss)({
    display: 'contents',
    color: 'color.text.disabled',
    ':hover': {
        cursor: 'default'
    }
});

});





parcelRegister("8dY5q", function(module, exports) {
$parcel$export(module.exports, "default", () => $0c0ab4c62d336b81$export$2e2bcd8739ae039);

var $eq3Hf = parcelRequire("eq3Hf");

var $LFmXM = parcelRequire("LFmXM");

var $6sjW5 = parcelRequire("6sjW5");


var $gnQAk = parcelRequire("gnQAk");

var $bpMvQ = parcelRequire("bpMvQ");

var $cK5WJ = parcelRequire("cK5WJ");

var $2ukd2 = parcelRequire("2ukd2");
const $0c0ab4c62d336b81$var$mapStateToPropsFactory = ()=>{
    const onCopyFactory = (0, $LFmXM.default)((onOperationRequested)=>()=>// @ts-expect-error - TS2554 - Expected 2 arguments, but got 1.
            onOperationRequested((0, $85bfce414eef38c7$export$92f9e1ed9114d3a6)));
    const onEditFactory = (0, $LFmXM.default)((onOperationRequested)=>()=>// @ts-expect-error - TS2554 - Expected 2 arguments, but got 1.
            onOperationRequested((0, $85bfce414eef38c7$export$250171a898bf7ef)));
    const onChangeOwnerFactory = (0, $LFmXM.default)((onOperationRequested)=>()=>// @ts-expect-error - TS2554 - Expected 2 arguments, but got 1.
            onOperationRequested((0, $85bfce414eef38c7$export$39d2a7fb21967424)));
    const onDeleteFactory = (0, $LFmXM.default)((onOperationRequested)=>()=>// @ts-expect-error - TS2554 - Expected 2 arguments, but got 1.
            onOperationRequested((0, $85bfce414eef38c7$export$4bd2facc4a3e6aa1)));
    return (state, ownProps)=>({
            owner: (0, $cK5WJ.getOwner)(state, ownProps.id),
            caption: (0, $cK5WJ.getName)(state, ownProps.id),
            loggedInUserAccountId: (0, $bpMvQ.getLoggedInUserAccountId)(state),
            isWritable: (0, $cK5WJ.getIsWritable)(state, ownProps.id),
            systemDashboard: (0, $cK5WJ.getSystemDashboard)(state, ownProps.id),
            showSpinner: ownProps.isOperationInProgress,
            onCopy: onCopyFactory(ownProps.onOperationRequested),
            onEdit: onEditFactory(ownProps.onOperationRequested),
            onChangeOwner: onChangeOwnerFactory(ownProps.onOperationRequested),
            onDelete: onDeleteFactory(ownProps.onOperationRequested),
            popularity: (0, $cK5WJ.getPopularity)(state, ownProps.id)
        });
};
var $0c0ab4c62d336b81$export$2e2bcd8739ae039 = (0, (/*@__PURE__*/$parcel$interopDefault($eq3Hf)))((0, $6sjW5.default)({
    onCopyDashboardClick: 'copy',
    onEditDashboardClick: 'edit',
    onDeleteDashboardClick: 'delete',
    onChangeOwnerClick: 'changeOwner'
}), (0, $gnQAk.connect)($0c0ab4c62d336b81$var$mapStateToPropsFactory, {}))((0, $2ukd2.default));

});
parcelRegister("2ukd2", function(module, exports) {
$parcel$export(module.exports, "default", () => $5ffe381d9fc9a348$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $2sLVw = parcelRequire("2sLVw");

var $5PT6a = parcelRequire("5PT6a");

var $lpXRH = parcelRequire("lpXRH");
function $5ffe381d9fc9a348$export$2e2bcd8739ae039(props) {
    const { popularity: popularity } = props;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $2sLVw.default), {
        alignItems: "center",
        justifyContent: "space-between"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $5PT6a.default), {
        popularity: popularity
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $lpXRH.default), props));
}

});
parcelRegister("5PT6a", function(module, exports) {
$parcel$export(module.exports, "default", () => $b6d6a62711aa9407$export$2e2bcd8739ae039);
/* view.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $lRq8t = parcelRequire("lRq8t");

var $6XJko = parcelRequire("6XJko");

var $iXUYb = parcelRequire("iXUYb");
function $b6d6a62711aa9407$var$Popularity(props) {
    const { popularity: popularity } = props;
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    if ((0, $6XJko.isVisualRefreshEnabled)()) return /*#__PURE__*/ $eJOHy.createElement("div", {
        className: (0, $hcewu.default)([
            "_1e0c1txw _2lx2vrvc _4cvr1h6o _1tke1jfw _1ul91ejb"
        ])
    }, /*#__PURE__*/ $eJOHy.createElement("div", {
        className: (0, $hcewu.default)([
            "_1reo15vq _18m915vq _slp31hna"
        ])
    }, formatMessage((0, $iXUYb.default).popularity, {
        popularity: popularity
    })));
    return /*#__PURE__*/ $eJOHy.createElement("div", {
        className: (0, $hcewu.default)([
            "_16jlkb7n _1o9zkb7n _i0dl1wug _1reo15vq _18m915vq _1e0c1txw _2lx2vrvc _1bsb1osq _o5721q9c _1bto1l2s _ca0qutpp _n3tdutpp"
        ])
    }, formatMessage((0, $iXUYb.default).popularity, {
        popularity: popularity
    }));
}
var $b6d6a62711aa9407$export$2e2bcd8739ae039 = $b6d6a62711aa9407$var$Popularity;
const $b6d6a62711aa9407$var$containerStyles = null;
const $b6d6a62711aa9407$var$textContainerStyles = null;
const $b6d6a62711aa9407$var$containerStylesOld = null;

});
parcelRegister("iXUYb", function(module, exports) {
$parcel$export(module.exports, "default", () => $3dafa938a0b26392$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
const $3dafa938a0b26392$var$messages = (0, $7qGN1.defineMessages)({
    popularity: {
        "id": "directories.common.components.popularity-cell.popularity",
        "defaultMessage": "{popularity, plural, one {{popularity} person} other {{popularity} people}}"
    }
});
var $3dafa938a0b26392$export$2e2bcd8739ae039 = $3dafa938a0b26392$var$messages;

});


parcelRegister("lpXRH", function(module, exports) {
$parcel$export(module.exports, "default", () => $a3dd3cf894a6a6d4$export$2e2bcd8739ae039);
/* view.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $eJOHy = parcelRequire("eJOHy");

var $12DRg = parcelRequire("12DRg");

var $Ay1uj = parcelRequire("Ay1uj");

var $7rjYb = parcelRequire("7rjYb");
var $jYYbf = parcelRequire("jYYbf");
var $aLJ1L = parcelRequire("aLJ1L");

var $NByNW = parcelRequire("NByNW");

var $2sLVw = parcelRequire("2sLVw");

var $as6H2 = parcelRequire("as6H2");

var $lRq8t = parcelRequire("lRq8t");

var $bzbsd = parcelRequire("bzbsd");

var $4aSRi = parcelRequire("4aSRi");

var $4cTDP = parcelRequire("4cTDP");

var $cewKx = parcelRequire("cewKx");
const $a3dd3cf894a6a6d4$var$DropdownMenuWithAnalytics = (0, $as6H2.default)('dropdownMenu', {
    onOpenChange: 'open'
})((0, $7rjYb.default));
const $a3dd3cf894a6a6d4$var$DropdownItemWithAnalytics = (0, $as6H2.default)('dropdownItem', {
    onClick: 'clicked'
})((0, $jYYbf.default));
function $a3dd3cf894a6a6d4$export$2e2bcd8739ae039(props) {
    const { isWritable: isWritable = false, systemDashboard: systemDashboard = false, defaultOpen: defaultOpen = false, showSpinner: showSpinner = false, loggedInUserAccountId: loggedInUserAccountId = '', owner: owner = null, caption: caption = '', onChangeOwner: onChangeOwner = (0, (/*@__PURE__*/$parcel$interopDefault($12DRg))), onCopy: onCopy = (0, (/*@__PURE__*/$parcel$interopDefault($12DRg))), onEdit: onEdit = (0, (/*@__PURE__*/$parcel$interopDefault($12DRg))), onDelete: onDelete = (0, (/*@__PURE__*/$parcel$interopDefault($12DRg))), onCopyDashboardClick: onCopyDashboardClick = (0, (/*@__PURE__*/$parcel$interopDefault($12DRg))), onEditDashboardClick: onEditDashboardClick = (0, (/*@__PURE__*/$parcel$interopDefault($12DRg))), onChangeOwnerClick: onChangeOwnerClick = (0, (/*@__PURE__*/$parcel$interopDefault($12DRg))), onDeleteDashboardClick: onDeleteDashboardClick = (0, (/*@__PURE__*/$parcel$interopDefault($12DRg))) } = props;
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const { setReturnFocusTo: setReturnFocusTo } = (0, $4aSRi.useModalDialogActions)();
    const [isDropdownOpen, setIsDropdownOpen] = (0, $eJOHy.useState)(defaultOpen);
    const triggerButtonRef = (0, $eJOHy.useRef)(null);
    const onOpenChange = (0, $eJOHy.useCallback)(({ isOpen: isOpen })=>{
        setIsDropdownOpen(isOpen);
    }, []); // /**
    //  * Close the menu with a minimal delay so the inner handlers are able to react on keypress properly.
    //  * In its current implementation if we close the menu right away it won't open the focused `href`.
    //  * Ideally we have to get right of this and few more methods when the bug linked below is fixed.
    //  * @see https://ecosystem.atlassian.net/browse/AK-4467
    //  */
    // const delayedClose = useCallback(() => {
    // 	setTimeout(() => setIsDropdownOpen(false));
    // }, []);
    const handleCopy = (0, $eJOHy.useCallback)((e, analytics)=>{
        onCopyDashboardClick(analytics);
        onCopy();
        if ((0, $4cTDP.fg)('jfp_a11y_fix_dashboard_actions_modal_accessibility')) triggerButtonRef.current && setReturnFocusTo(triggerButtonRef);
    }, [
        setReturnFocusTo,
        onCopy,
        onCopyDashboardClick
    ]);
    const handleEdit = (0, $eJOHy.useCallback)((e, analytics)=>{
        onEditDashboardClick(analytics);
        onEdit();
        if ((0, $4cTDP.fg)('jfp_a11y_fix_dashboard_actions_modal_accessibility')) triggerButtonRef.current && setReturnFocusTo(triggerButtonRef);
    }, [
        setReturnFocusTo,
        onEdit,
        onEditDashboardClick
    ]);
    const handleChangeOwner = (0, $eJOHy.useCallback)((e, analytics)=>{
        onChangeOwnerClick(analytics);
        onChangeOwner();
        if ((0, $4cTDP.fg)('jfp_a11y_fix_dashboard_actions_modal_accessibility')) triggerButtonRef.current && setReturnFocusTo(triggerButtonRef);
    }, [
        setReturnFocusTo,
        onChangeOwner,
        onChangeOwnerClick
    ]);
    const handleDelete = (0, $eJOHy.useCallback)((e, analytics)=>{
        onDeleteDashboardClick(analytics);
        onDelete();
        if ((0, $4cTDP.fg)('jfp_a11y_fix_dashboard_actions_modal_accessibility')) triggerButtonRef.current && setReturnFocusTo(triggerButtonRef);
    }, [
        setReturnFocusTo,
        onDelete,
        onDeleteDashboardClick
    ]); // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const triggerFunction = ({ triggerRef: triggerRef, ...buttonProps })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $Ay1uj.default), {
            ...buttonProps,
            testId: "dashboards-main.content.cells.actions.button",
            appearance: "subtle",
            icon: (0, (/*@__PURE__*/$parcel$interopDefault($NByNW))),
            spacing: "compact",
            ref: (0, $bzbsd.mergeRefs)(triggerRef, triggerButtonRef),
            label: formatMessage((0, $cewKx.default).moreActions, {
                dashboardName: caption
            }),
            isLoading: showSpinner
        });
    const renderEditAction = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($a3dd3cf894a6a6d4$var$DropdownItemWithAnalytics, {
            onClick: handleEdit
        }, formatMessage(systemDashboard ? (0, $cewKx.default).shareAction : (0, $cewKx.default).renameOrShareAction));
    const renderCopyAction = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($a3dd3cf894a6a6d4$var$DropdownItemWithAnalytics, {
            onClick: handleCopy
        }, formatMessage((0, $cewKx.default).copyAction));
    const renderChangeOwnerAction = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($a3dd3cf894a6a6d4$var$DropdownItemWithAnalytics, {
            onClick: handleChangeOwner
        }, formatMessage((0, $cewKx.default).changeOwner));
    const renderDeleteAction = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($a3dd3cf894a6a6d4$var$DropdownItemWithAnalytics, {
            onClick: handleDelete
        }, formatMessage((0, $cewKx.default).moveToTrashAction));
    const isOwnedByCurrentUser = owner && owner.accountId === loggedInUserAccountId;
    const copyItem = renderCopyAction();
    let editItem = null;
    let changeOwnerItem = null;
    let deleteItem = null;
    if (isWritable) editItem = renderEditAction();
    if (isOwnedByCurrentUser) {
        changeOwnerItem = renderChangeOwnerAction();
        deleteItem = renderDeleteAction();
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($a3dd3cf894a6a6d4$var$Container, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($a3dd3cf894a6a6d4$var$DropdownMenuWithAnalytics, {
        placement: "bottom-end",
        isOpen: isDropdownOpen,
        onOpenChange: onOpenChange,
        trigger: triggerFunction,
        shouldRenderToParent: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $aLJ1L.default), null, copyItem, editItem, changeOwnerItem, deleteItem)));
}
const $a3dd3cf894a6a6d4$var$Container = ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $2sLVw.default), {
        xcss: $a3dd3cf894a6a6d4$var$styles.container
    }, children);
const $a3dd3cf894a6a6d4$var$styles = {
    container: "_1rjcu2gc _19bvu2gc _u5f3utpp"
};

});



parcelRegister("e63eo", function(module, exports) {
$parcel$export(module.exports, "default", () => $37ed8f1842440a05$export$2e2bcd8739ae039);

var $5PT6a = parcelRequire("5PT6a");

var $gnQAk = parcelRequire("gnQAk");

var $cK5WJ = parcelRequire("cK5WJ");
const $37ed8f1842440a05$var$mapStateToProps = ()=>(state, ownProps)=>({
            popularity: (0, $cK5WJ.getPopularity)(state, ownProps.id)
        });
var $37ed8f1842440a05$export$2e2bcd8739ae039 = (0, $gnQAk.connect)($37ed8f1842440a05$var$mapStateToProps, {})((0, $5PT6a.default));

});

parcelRegister("c5o1z", function(module, exports) {
$parcel$export(module.exports, "default", () => $9e14c884872e7c6c$export$2e2bcd8739ae039);

var $eq3Hf = parcelRequire("eq3Hf");

var $6sjW5 = parcelRequire("6sjW5");

var $gnQAk = parcelRequire("gnQAk");

var $cK5WJ = parcelRequire("cK5WJ");

var $iZ6hX = parcelRequire("iZ6hX");
const $9e14c884872e7c6c$var$mapStateToProps = ()=>(state, ownProps)=>({
            caption: (0, $cK5WJ.getName)(state, ownProps.id),
            href: (0, $cK5WJ.getViewUrl)(state, ownProps.id)
        });
var $9e14c884872e7c6c$export$2e2bcd8739ae039 = (0, (/*@__PURE__*/$parcel$interopDefault($eq3Hf)))((0, $6sjW5.default)({
    onClick: 'dashboard'
}), (0, $gnQAk.connect)($9e14c884872e7c6c$var$mapStateToProps, {}))((0, $iZ6hX.default));

});
parcelRegister("iZ6hX", function(module, exports) {
$parcel$export(module.exports, "default", () => $714529fe6cfbfe77$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $bTsWb = parcelRequire("bTsWb");

var $9M9Yb = parcelRequire("9M9Yb");
function $714529fe6cfbfe77$export$2e2bcd8739ae039({ onClick: onClick, href: href, caption: caption }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $9M9Yb.TransitionComponent), {
        href: href,
        onClick: onClick
    }, (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $bTsWb.default), {
            ...props,
            caption: caption
        }));
}

});
parcelRegister("bTsWb", function(module, exports) {
$parcel$export(module.exports, "default", () => $ff8fef4b8456318c$export$2e2bcd8739ae039);
/* view.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $gYvT9 = parcelRequire("gYvT9");

var $8nu6j = parcelRequire("8nu6j");
var $1DXK0 = parcelRequire("1DXK0");

var $k71qx = parcelRequire("k71qx");

var $6XJko = parcelRequire("6XJko");
function $ff8fef4b8456318c$export$2e2bcd8739ae039({ caption: caption, href: href, onClick: onClick, ...props }) {
    const content = (0, $eJOHy.useMemo)(()=>{
        const innerContent = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
            paddingInline: "space.050"
        }, href ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $gYvT9.default), {
            href: href,
            onClick: onClick
        }, caption) : caption);
        if ((0, $6XJko.isVisualRefreshEnabled)()) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
            xcss: $ff8fef4b8456318c$var$containerStyles
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
            xcss: $ff8fef4b8456318c$var$wrapperStyles
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $k71qx.default), {
            content: caption,
            isScreenReaderAnnouncementDisabled: true,
            delay: 1000,
            position: "bottom-start"
        }, innerContent)));
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($ff8fef4b8456318c$var$Container, props, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $k71qx.default), {
            content: caption,
            isScreenReaderAnnouncementDisabled: true,
            delay: 1000,
            position: "bottom-start"
        }, innerContent));
    }, [
        caption,
        href,
        onClick,
        props
    ]);
    return content;
}
const $ff8fef4b8456318c$var$containerStyles = (0, $1DXK0.xcss)({
    width: '100%',
    paddingBlock: 'space.100',
    flex: '1 1 auto',
    flexDirection: 'row',
    display: 'flex',
    height: '40px'
});
const $ff8fef4b8456318c$var$wrapperStyles = (0, $1DXK0.xcss)({
    paddingBlock: 'space.025',
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis'
});
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- Ignored via go/DSP-18766
const $ff8fef4b8456318c$var$Container = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_16jlkb7n _1o9zkb7n _i0dl1wug _1reo15vq _18m915vq _1e0c1txw _2lx2vrvc _1bsb1osq _o5721q9c _1bto1l2s _ca0qutpp _n3tdutpp",
            __cmplp.className
        ])
    });
});

});

parcelRegister("9M9Yb", function(module, exports) {
$parcel$export(module.exports, "TransitionComponent", () => $c8a405d1bfe18777$export$3c61ec5cd62a42f9);

var $eJOHy = parcelRequire("eJOHy");

var $lcB5K = parcelRequire("lcB5K");
const $c8a405d1bfe18777$export$3c61ec5cd62a42f9 = ({ children: children, onClick: onClick, href: href })=>__SPA__ ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $lcB5K.RouterActions), null, ({ push: push })=>{
        const clickHandler = (e, analyticsEvent)=>{
            if (e.metaKey || e.ctrlKey || e.altKey || e.shiftKey || e.button === 1) return;
            e.preventDefault();
            onClick && onClick(e, analyticsEvent);
            push(href);
        };
        return children({
            href: href,
            onClick: clickHandler
        });
    }) : children({
        href: href,
        onClick: onClick
    });

});



parcelRegister("5J9oH", function(module, exports) {
$parcel$export(module.exports, "default", () => $32ed4db478190114$export$2e2bcd8739ae039);

var $LFmXM = parcelRequire("LFmXM");

var $ifeBU = parcelRequire("ifeBU");

var $gnQAk = parcelRequire("gnQAk");
const $32ed4db478190114$var$mapStateToPropsFactory = ()=>{
    const onCancelFactory = (0, $LFmXM.default)((onCancel)=>onCancel);
    const onSuccessFactory = (0, $LFmXM.default)((onSuccess)=>onSuccess);
    const onInitiateSuccessFactory = (0, $LFmXM.default)((onDialogShown)=>onDialogShown);
    const onInitiateFailedFactory = (0, $LFmXM.default)((onDataRetrieveFailed)=>onDataRetrieveFailed);
    return (state, ownProps)=>({
            id: ownProps.entityId,
            onCancel: onCancelFactory(ownProps.onCancel),
            onSuccess: onSuccessFactory(ownProps.onUpdated),
            onInitiateSuccess: onInitiateSuccessFactory(ownProps.onDialogShown),
            onInitiateFailed: onInitiateFailedFactory(ownProps.onDataRetrieveFailed)
        });
};
var $32ed4db478190114$export$2e2bcd8739ae039 = (0, $gnQAk.connect)($32ed4db478190114$var$mapStateToPropsFactory, {})((0, $ifeBU.default));

});
parcelRegister("ifeBU", function(module, exports) {
$parcel$export(module.exports, "default", () => $0e2efe8ee8bc9973$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $5Lo0w = parcelRequire("5Lo0w");

var $5vQ2T = parcelRequire("5vQ2T");

var $2imLM = parcelRequire("2imLM");

var $bQWwW = parcelRequire("bQWwW");

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $0e2efe8ee8bc9973$var$NoLazyAsyncChangeOwnerDashboardModal = (0, $bQWwW.lazy)(()=>(parcelRequire("9WKXs")), {
    moduleId: "./src/packages/global-pages/directories/dashboards-directory-v2/change-owner-dashboard-modal/src/index.tsx"
});
const $0e2efe8ee8bc9973$var$AsyncChangeOwnerDashboardModal = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $5vQ2T.JSErrorBoundary), {
        id: "configure-owner-modal",
        packageName: "dashboard",
        fallback: "flag",
        teamName: "endeavour"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $2imLM.default), {
        name: "change-owner-modal",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $5Lo0w.default), null)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($0e2efe8ee8bc9973$var$NoLazyAsyncChangeOwnerDashboardModal, props)));
var $0e2efe8ee8bc9973$export$2e2bcd8739ae039 = $0e2efe8ee8bc9973$var$AsyncChangeOwnerDashboardModal;

});
parcelRegister("9WKXs", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("5wWZN").then(()=>parcelRequire('athk0'));

});



parcelRegister("9eKBp", function(module, exports) {
$parcel$export(module.exports, "default", () => $9f0a70ce5c304ba3$export$2e2bcd8739ae039);

var $ahm5r = parcelRequire("ahm5r");

var $g0RcK = parcelRequire("g0RcK");

var $gnQAk = parcelRequire("gnQAk");

var $jJaSe = parcelRequire("jJaSe");
const $9f0a70ce5c304ba3$var$selectOwnProps = (_, ownProps)=>ownProps;
const $9f0a70ce5c304ba3$var$navigateToDashboard = (id, push)=>{
    push(`/jira/dashboards/${id}`);
};
const $9f0a70ce5c304ba3$var$makeMapStateToProps = ()=>(0, $ahm5r.createSelector)([
        $9f0a70ce5c304ba3$var$selectOwnProps
    ], (ownProps)=>({
            id: ownProps.entityId,
            onCancel: ownProps.onCancel,
            onSuccess: (_, { id: id })=>{
                $9f0a70ce5c304ba3$var$navigateToDashboard(id, ownProps.push);
                // @ts-expect-error - TS2554 - Expected 1 arguments, but got 0.
                ownProps.onUpdated();
            },
            onInitiateSuccess: ownProps.onDialogShown,
            onInitiateFailed: ownProps.onDataRetrieveFailed
        }));
const $9f0a70ce5c304ba3$var$ConnectedModal = (0, $gnQAk.connect)($9f0a70ce5c304ba3$var$makeMapStateToProps, null, (stateProps)=>stateProps)((0, $g0RcK.default));
var $9f0a70ce5c304ba3$export$2e2bcd8739ae039 = (0, $jJaSe.withRouter)($9f0a70ce5c304ba3$var$ConnectedModal);

});
parcelRegister("g0RcK", function(module, exports) {
$parcel$export(module.exports, "default", () => $b6e476e52ea9d78f$export$2e2bcd8739ae039);
// eslint-disable-next-line jira/restricted/react-component-props

var $eJOHy = parcelRequire("eJOHy");

var $2imLM = parcelRequire("2imLM");

var $bQWwW = parcelRequire("bQWwW");

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $b6e476e52ea9d78f$var$AsyncCopyDashboardModal = (0, $bQWwW.lazyForPaint)(()=>(parcelRequire("4Q4ZZ")), {
    ssr: false,
    moduleId: "./src/packages/global-pages/directories/dashboards-directory-v2/copy-dashboard-modal/src/index.tsx"
});
const $b6e476e52ea9d78f$var$AsyncCopyDashboardModalContainer = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $2imLM.default), {
        name: "dashboard-modal",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($b6e476e52ea9d78f$var$AsyncCopyDashboardModal, props));
var $b6e476e52ea9d78f$export$2e2bcd8739ae039 = $b6e476e52ea9d78f$var$AsyncCopyDashboardModalContainer;

});
parcelRegister("4Q4ZZ", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("ejKF4").then(()=>parcelRequire('9PYsD'));

});



parcelRegister("kAUoD", function(module, exports) {
$parcel$export(module.exports, "default", () => $7b1def028705e661$export$2e2bcd8739ae039);

var $e9v7k = parcelRequire("e9v7k");

var $gnQAk = parcelRequire("gnQAk");
var $7b1def028705e661$export$2e2bcd8739ae039 = (0, $gnQAk.connect)(// eslint-disable-next-line @typescript-eslint/no-explicit-any
(state, ownProps)=>({
        id: ownProps.entityId,
        onCancel: ownProps.onCancel,
        onSuccess: ownProps.onUpdated,
        onInitiateSuccess: ownProps.onDialogShown,
        onInitiateFailed: ownProps.onDataRetrieveFailed
    }), {})((0, $e9v7k.default));

});
parcelRegister("e9v7k", function(module, exports) {
$parcel$export(module.exports, "default", () => $1de0821762343ce9$export$2e2bcd8739ae039);
// eslint-disable-next-line jira/restricted/react-component-props

var $eJOHy = parcelRequire("eJOHy");

var $2imLM = parcelRequire("2imLM");

var $bQWwW = parcelRequire("bQWwW");

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $1de0821762343ce9$var$RLLAsyncDeleteDashboardModal = (0, $bQWwW.lazyForPaint)(()=>(parcelRequire("4rTeb")), {
    ssr: false,
    moduleId: "./src/packages/global-pages/directories/dashboards-directory-v2/delete-dashboard-modal/src/index.tsx"
});
const $1de0821762343ce9$var$RLLAsyncDeleteDashboardModalContainer = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $2imLM.default), {
        name: "delete-dashboard-modal",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($1de0821762343ce9$var$RLLAsyncDeleteDashboardModal, props));
var $1de0821762343ce9$export$2e2bcd8739ae039 = $1de0821762343ce9$var$RLLAsyncDeleteDashboardModalContainer;

});
parcelRegister("4rTeb", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("7VPUr").then(()=>parcelRequire('1ZA37'));

});



parcelRegister("h38eJ", function(module, exports) {
$parcel$export(module.exports, "default", () => $abc3dabb009c45a1$export$2e2bcd8739ae039);

var $dYuAp = parcelRequire("dYuAp");

var $gnQAk = parcelRequire("gnQAk");
const $abc3dabb009c45a1$var$ConnectedModal = (0, $gnQAk.connect)(// eslint-disable-next-line @typescript-eslint/no-explicit-any
(state, ownProps)=>({
        id: ownProps.entityId,
        onCancel: ownProps.onCancel,
        onSuccess: ownProps.onUpdated,
        onInitiateSuccess: ownProps.onDialogShown,
        onInitiateFailed: ownProps.onDataRetrieveFailed
    }), {})((0, $dYuAp.default));
var $abc3dabb009c45a1$export$2e2bcd8739ae039 = $abc3dabb009c45a1$var$ConnectedModal;

});
parcelRegister("dYuAp", function(module, exports) {
$parcel$export(module.exports, "default", () => $fac19b7b1a12e0c5$export$2e2bcd8739ae039);
// eslint-disable-next-line jira/restricted/react-component-props

var $eJOHy = parcelRequire("eJOHy");

var $2imLM = parcelRequire("2imLM");

var $bQWwW = parcelRequire("bQWwW");

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $fac19b7b1a12e0c5$var$AsyncEditDashboardModal = (0, $bQWwW.lazyForPaint)(()=>(parcelRequire("5tiBh")), {
    ssr: false,
    moduleId: "./src/packages/global-pages/directories/dashboards-directory-v2/edit-dashboard-modal/src/index.tsx"
});
const $fac19b7b1a12e0c5$var$AsyncEditDashboardModalContainer = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $2imLM.default), {
        name: "edit-dashboard-modal",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($fac19b7b1a12e0c5$var$AsyncEditDashboardModal, props));
var $fac19b7b1a12e0c5$export$2e2bcd8739ae039 = $fac19b7b1a12e0c5$var$AsyncEditDashboardModalContainer;

});
parcelRegister("5tiBh", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("5rTzj").then(()=>parcelRequire('5TnZb'));

});



parcelRegister("ghyjR", function(module, exports) {
$parcel$export(module.exports, "default", () => $8eaadbab6543f173$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
const $8eaadbab6543f173$var$messages = (0, $7qGN1.defineMessages)({
    name: {
        "id": "directories.dashboards-v2.main.name",
        "defaultMessage": "Name"
    },
    popularity: {
        "id": "directories.dashboards-v2.main.popularity",
        "defaultMessage": "Starred by"
    },
    owner: {
        "id": "directories.dashboards-v2.main.owner",
        "defaultMessage": "Owner"
    },
    access: {
        "id": "directories.dashboards-v2.main.access",
        "defaultMessage": "Access"
    },
    viewers: {
        "id": "directories.dashboards-v2.main.viewers",
        "defaultMessage": "Viewers"
    },
    editors: {
        "id": "directories.dashboards-v2.main.editors",
        "defaultMessage": "Editors"
    },
    emptyFilterResultMessage: {
        "id": "directories.dashboards-v2.main.empty-filter-result-message",
        "defaultMessage": "No dashboards were found that match your search"
    },
    tableAriaLabel: {
        "id": "directories.dashboards-v2.main.table-aria-label",
        "defaultMessage": "Dashboards details"
    },
    filterResultsAnnouncement: {
        "id": "directories.dashboards-v2.main.filter-results-announcement",
        "defaultMessage": "{itemCount, plural, =0 {No dashboards were found that match your search} one {{itemCount} dashboard found} other {{itemCount} dashboards found}}"
    },
    moreActions: {
        "id": "directories.dashboards-v2.main.more-actions",
        "defaultMessage": "More actions"
    },
    aToZOrder: {
        "id": "directories.dashboards-v2.main.a-to-z-order",
        "defaultMessage": "Sort A to Z"
    },
    zToAOrder: {
        "id": "directories.dashboards-v2.main.z-to-a-order",
        "defaultMessage": "Sort Z to A"
    },
    starredToUnstarredOrder: {
        "id": "directories.dashboards-v2.main.starred-to-unstarred-order",
        "defaultMessage": "Sort starred to unstarred"
    },
    unstarredToStarredOrder: {
        "id": "directories.dashboards-v2.main.unstarred-to-starred-order",
        "defaultMessage": "Sort unstarred to starred"
    },
    lowestToHighestOrder: {
        "id": "directories.dashboards-v2.main.lowest-to-highest-order",
        "defaultMessage": "Sort lowest to highest"
    },
    highestToLowestOrder: {
        "id": "directories.dashboards-v2.main.highest-to-lowest-order",
        "defaultMessage": "Sort highest to lowest"
    }
});
var $8eaadbab6543f173$export$2e2bcd8739ae039 = $8eaadbab6543f173$var$messages;

});




parcelRegister("8UrZS", function(module, exports) {
$parcel$export(module.exports, "default", () => $0bc45abae5c1a50e$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $gHI4w = parcelRequire("gHI4w");

var $3nL89 = parcelRequire("3nL89");

var $lTWOb = parcelRequire("lTWOb");
const $0bc45abae5c1a50e$var$DashboardsPage = (props)=>{
    const { CreateButton: CreateButton, DashboardsDirectory: DashboardsDirectory, intl: { formatMessage: formatMessage }, ...directoryProps } = props;
    const actions = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(CreateButton, null);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $3nL89.DocumentTitle), {
        title: formatMessage((0, $lTWOb.default).pageTitle)
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $gHI4w.default), {
        truncateTitle: true,
        actions: actions
    }, formatMessage((0, $lTWOb.default).pageTitle)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(DashboardsDirectory, directoryProps));
};
var $0bc45abae5c1a50e$export$2e2bcd8739ae039 = $0bc45abae5c1a50e$var$DashboardsPage;

});
parcelRegister("3nL89", function(module, exports) {
$parcel$export(module.exports, "DocumentTitle", () => $8eb9deaadd9d6be8$export$dd5ad0b65cf665da);

var $19u1t = parcelRequire("19u1t");
const $8eb9deaadd9d6be8$export$dd5ad0b65cf665da = (0, $19u1t.DocumentTitleHelper);

});

parcelRegister("lTWOb", function(module, exports) {
$parcel$export(module.exports, "default", () => $4672cf408dff0771$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
const $4672cf408dff0771$var$messages = (0, $7qGN1.defineMessages)({
    pageTitle: {
        "id": "directories.dashboards-v2.page.page-title",
        "defaultMessage": "Dashboards"
    }
});
var $4672cf408dff0771$export$2e2bcd8739ae039 = $4672cf408dff0771$var$messages;

});



parcelRegister("jUHqr", function(module, exports) {
$parcel$export(module.exports, "checkAndEmitApdexSignal", () => $0aba41a6ca8ce346$export$3082c88b693a5230);
$parcel$export(module.exports, "default", () => $0aba41a6ca8ce346$export$2e2bcd8739ae039);
$parcel$export(module.exports, "baseDefaultProps", () => $0aba41a6ca8ce346$export$9b3029ee6188a41f);

var $eJOHy = parcelRequire("eJOHy");

var $2gvG4 = parcelRequire("2gvG4");

var $6whQo = parcelRequire("6whQo");

var $kVpZx = parcelRequire("kVpZx");

var $ioEQd = parcelRequire("ioEQd");

var $fRC66 = parcelRequire("fRC66");

var $CkF8u = parcelRequire("CkF8u");

var $iAPDN = parcelRequire("iAPDN");

var $4WwFo = parcelRequire("4WwFo");

var $cllya = parcelRequire("cllya");
const $0aba41a6ca8ce346$export$3082c88b693a5230 = (appName, metricKey)=>{
    var emitSignal;
};
class $0aba41a6ca8ce346$export$2e2bcd8739ae039 extends (0, $eJOHy.Component) {
    static{
        this.defaultProps = {
            isExpectedToHaveSsr: false,
            withMarks: [],
            extra: {},
            emitOnAnimationFrame: false
        };
    }
    render() {
        const { appName: appName, metricKey: metricKey, extra: extra, metric: metric, emitOnAnimationFrame: emitOnAnimationFrame } = this.props;
        $0aba41a6ca8ce346$export$3082c88b693a5230(appName, metricKey);
        const isUFODefined = (0, $ioEQd.GlobalPageLoadExperience).loadingPageLoadId !== 'UNKNOWN';
        if (isUFODefined) (0, $4WwFo.addUFOSSRDoneAsFMPToInteraction)();
        if (metric) {
            // https://product-fabric.atlassian.net/browse/UFO-323
            (0, $iAPDN.addBM3SSRDoneAsFMPToInteraction)(metric);
            (0, $cllya.trackBM3FeatureFlagsAccessed)(metric);
        }
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $2gvG4.default), {
            data: extra
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $6whQo.UFOBM3TimingsToUFO), {
            marks: metric?.getData()?.marks,
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            timings: metric?.getData()?.config?.timings
        }), isUFODefined ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $CkF8u.StopUfo), {
            appName: appName,
            customData: extra,
            key: (0, $kVpZx.getInteractionId)().current
        }) : metric && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $fRC66.StopBrowserMetrics3), {
            metric: metric,
            customData: extra,
            emitOnAnimationFrame: emitOnAnimationFrame
        }));
    }
}
const $0aba41a6ca8ce346$export$9b3029ee6188a41f = $0aba41a6ca8ce346$export$2e2bcd8739ae039.defaultProps;

});
parcelRegister("6whQo", function(module, exports) {
$parcel$export(module.exports, "getBm3Timings", () => $3708d872c36dd1bb$export$f02972da195a43bb);
$parcel$export(module.exports, "UFOBM3TimingsToUFO", () => $3708d872c36dd1bb$export$30f0b5e5acd268bf);
$parcel$export(module.exports, "addBM3TimingsToUFO", () => $3708d872c36dd1bb$export$d93d677ef2f33c5c);

var $eJOHy = parcelRequire("eJOHy");

var $7aoMz = parcelRequire("7aoMz");

var $kVpZx = parcelRequire("kVpZx");

var $2QO3b = parcelRequire("2QO3b");
function $3708d872c36dd1bb$export$f02972da195a43bb(marks, timingConfigs) {
    const bm3Timings = {};
    if (!marks || !timingConfigs) return bm3Timings;
    timingConfigs.forEach((item)=>{
        if (!item.startMark || !item.endMark) return;
        const startTime = marks[item.startMark];
        if (!startTime) return;
        const endTime = marks[item.endMark];
        if (!endTime) return;
        bm3Timings[item.key] = {
            startTime: startTime,
            endTime: endTime
        };
    });
    return bm3Timings;
}
function $3708d872c36dd1bb$export$30f0b5e5acd268bf({ marks: marks, timings: timings }) {
    const interactionContext = (0, $eJOHy.useContext)((0, $7aoMz.default));
    const interactionId = (0, $kVpZx.getInteractionId)().current;
    (0, $eJOHy.useMemo)(()=>{
        if (interactionContext != null && interactionId != null && marks != null && timings != null) {
            const interactionType = (0, $2QO3b.getCurrentInteractionType)(interactionId);
            if (interactionType === 'press') return;
            const bm3Timings = $3708d872c36dd1bb$export$f02972da195a43bb(marks, timings);
            interactionContext.addCustomTimings(bm3Timings);
        }
    }, [
        interactionContext,
        interactionId,
        marks,
        timings
    ]);
    return null;
}
function $3708d872c36dd1bb$export$d93d677ef2f33c5c(marks, timingsConfig) {
    const interactionId = (0, $kVpZx.getInteractionId)().current;
    if (interactionId) {
        const interactionType = (0, $2QO3b.getCurrentInteractionType)(interactionId);
        if (interactionType === 'press') return;
        const bm3Timings = $3708d872c36dd1bb$export$f02972da195a43bb(marks, timingsConfig);
        (0, $2QO3b.addCustomTiming)(interactionId, [], bm3Timings);
    }
}

});

parcelRegister("fRC66", function(module, exports) {
$parcel$export(module.exports, "StopBrowserMetrics3", () => $7986e193b27b5912$export$575e93c0f9905999);

var $eJOHy = parcelRequire("eJOHy");

var $7aoMz = parcelRequire("7aoMz");

var $k04JP = parcelRequire("k04JP");

var $6uWhG = parcelRequire("6uWhG");

var $2HxHL = parcelRequire("2HxHL");

var $iEXnd = parcelRequire("iEXnd");

var $lOI8W = parcelRequire("lOI8W");

var $9DwQv = parcelRequire("9DwQv");

const $7986e193b27b5912$var$emitMetrics = (metric, customData, stopTime)=>{
    (0, $lOI8W.setInitialPageLoadTimingFromPerformanceMarks)('batch-js-heritage.eval', 'jira.heritage_batch_file_eval:start', 'jira.heritage_batch_file_eval:end');
    if (stopTime !== undefined) metric.stop({
        customData: customData,
        stopTime: stopTime
    });
    else metric.stop({
        customData: customData
    });
    if ((0, $9DwQv.isAutomaticExposureCollectionEnabled)()) (0, $2HxHL.stopLowPriorityEventDelay)();
};
class $7986e193b27b5912$export$575e93c0f9905999 extends (0, $eJOHy.Component) {
    componentDidMount() {
        const { metric: metric, customData: customData, emitOnAnimationFrame: emitOnAnimationFrame } = this.props;
        if (!metric) return;
        const start = (0, $k04JP.browserMetrics).getPageLoadMetric()?.getData()?.start || 0;
        (0, $6uWhG.setMark)('BROWSER_METRICS_TTI_START', {
            startTime: start
        });
        (0, $6uWhG.setMark)('BROWSER_METRICS_TTI_END');
        (0, $6uWhG.setMeasure)('BROWSER_METRICS_TTI', 'BROWSER_METRICS_TTI_START', 'BROWSER_METRICS_TTI_END');
        const bm3Data = metric.getData();
        if (emitOnAnimationFrame) {
            const stopTime = performance.now();
            (0, $lOI8W.stopInitialPageLoadTimingFromPerformanceMarkStart)('product', (0, $iEXnd.PRODUCT_START_MARK), true);
            if (bm3Data) this.context?.addApdex({
                key: bm3Data.key,
                startTime: bm3Data.start,
                stopTime: stopTime
            });
            if (typeof queueMicrotask !== 'undefined') queueMicrotask(()=>{
                (0, $6uWhG.setMark)('BROWSER_METRICS_TTI_TASK_END');
                (0, $6uWhG.setMeasure)('BROWSER_METRICS_TTI_TASK', 'BROWSER_METRICS_TTI_START', 'BROWSER_METRICS_TTI_TASK_END');
            });
            requestAnimationFrame(()=>{
                metric.mark((0, $fcc2379b1f384e36$export$99c08ec92759c71c));
                (0, $6uWhG.setMark)((0, $fcc2379b1f384e36$export$99c08ec92759c71c));
                (0, $6uWhG.setMeasure)('BROWSER_METRICS_TTI_RAF', 'BROWSER_METRICS_TTI_START', (0, $fcc2379b1f384e36$export$99c08ec92759c71c));
                setTimeout(()=>{
                    $7986e193b27b5912$var$emitMetrics(metric, customData, stopTime);
                }, 500);
            });
        } else {
            if (bm3Data) this.context?.addApdex({
                key: bm3Data.key,
                startTime: bm3Data.start,
                stopTime: performance.now()
            });
            (0, $lOI8W.stopInitialPageLoadTimingFromPerformanceMarkStart)('product', (0, $iEXnd.PRODUCT_START_MARK), true);
            $7986e193b27b5912$var$emitMetrics(metric, customData);
        }
    }
    static{
        this.contextType = (0, $7aoMz.default);
    }
    render() {
        return null;
    }
}

});
const $fcc2379b1f384e36$export$56940a9488e85199 = 'jira.fe.spa-';
const $fcc2379b1f384e36$export$45c4b6bf7935c69a = `${$fcc2379b1f384e36$export$56940a9488e85199}start`;
const $fcc2379b1f384e36$export$135c96ab5afee429 = 'ssr.spa.rendered';
const $fcc2379b1f384e36$export$ff834eccc35b9089 = 'appBundleReady';
const $fcc2379b1f384e36$export$86b05e34d462ead8 = 'prefetchApiReady';
const $fcc2379b1f384e36$export$d6a604a7d9a390fb = 'prefetchApiStart';
const $fcc2379b1f384e36$export$3ae43cc1782d058f = 'jswRenderStart';
const $fcc2379b1f384e36$export$363f6703ffa600be = 'jswCreateReduxStoreStart';
const $fcc2379b1f384e36$export$e87b74567b79c8 = 'jswCreateReduxStoreEnd';
const $fcc2379b1f384e36$export$99fe642459a8b02 = 'jswTransformCriticalDataStart';
const $fcc2379b1f384e36$export$ab1f5705fc8e0571 = 'jswTransformCriticalDataEnd';
const $fcc2379b1f384e36$export$8c3a9046da692c35 = 'jswReduxSoftwareAppLoadedStart';
const $fcc2379b1f384e36$export$5aa497d1efdcc5bf = 'jswReduxSoftwareAppLoadedEnd';
const $fcc2379b1f384e36$export$99c08ec92759c71c = 'tti-raf-mark';
const $fcc2379b1f384e36$export$48552baa9db8ce1d = 'tti-raf';


parcelRegister("CkF8u", function(module, exports) {
$parcel$export(module.exports, "StopUfo", () => $f04c01c7c6bf4310$export$d91154f099475c5);

var $eJOHy = parcelRequire("eJOHy");

var $7aoMz = parcelRequire("7aoMz");

var $ioEQd = parcelRequire("ioEQd");
class $f04c01c7c6bf4310$export$d91154f099475c5 extends (0, $eJOHy.Component) {
    componentDidMount() {
        const { customData: customData, appName: appName } = this.props;
        (0, $ioEQd.GlobalPageLoadExperience).success({
            force: true,
            metadata: customData
        });
        const name = appName || (0, $ioEQd.GlobalPageLoadExperience).loadingPageLoadId;
        if (name) this.context?.addApdex({
            key: name,
            stopTime: performance.now()
        });
    }
    static{
        this.contextType = (0, $7aoMz.default);
    }
    render() {
        return null;
    }
}

});

parcelRegister("iAPDN", function(module, exports) {
$parcel$export(module.exports, "addBM3SSRDoneAsFMPToInteraction", () => $4d28fc5eaea80e10$export$bf239ac2bfb04967);

var $kVpZx = parcelRequire("kVpZx");

var $2QO3b = parcelRequire("2QO3b");
function $4d28fc5eaea80e10$export$bf239ac2bfb04967(metric) {
    const interactionId = (0, $kVpZx.getInteractionId)();
    const currentInteractionId = interactionId.current;
    if (!currentInteractionId) return;
    const data = metric.getData();
    // Use BM3 SSR mark as FMP config for UFO if it exists, temporarily.
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    const config = data?.config;
    if (config && data?.isInitial) (0, $2QO3b.addMetadata)(currentInteractionId, {
        __legacy__bm3ConfigSSRDoneAsFmp: config.ssr?.doneAsFmp || false
    });
}

});

parcelRegister("4WwFo", function(module, exports) {
$parcel$export(module.exports, "addUFOSSRDoneAsFMPToInteraction", () => $3d02e80116d345ab$export$e63862cd888fe05a);

var $kVpZx = parcelRequire("kVpZx");

var $2QO3b = parcelRequire("2QO3b");

var $ioEQd = parcelRequire("ioEQd");
var $8tVkR = parcelRequire("8tVkR");
async function $3d02e80116d345ab$export$e63862cd888fe05a() {
    const interactionId = (0, $kVpZx.getInteractionId)();
    const currentInteractionId = interactionId.current;
    if (!currentInteractionId) return;
    // Use UFO SSR mark as FMP config for rUFO if it exists, temporarily.
    const data = await (0, $ioEQd.GlobalPageLoadExperience).exportData();
    const fmpMark = data.metrics.marks.find((mark)=>mark.name === 'fmp') || (0, $8tVkR.payloadPublisher).ssr?.getDoneMark();
    if (data.initial && fmpMark) (0, $2QO3b.addMetadata)(currentInteractionId, {
        __legacy__ufoConfigSSRDoneAsFmp: true
    });
}

});

parcelRegister("cllya", function(module, exports) {
$parcel$export(module.exports, "trackBM3FeatureFlagsAccessed", () => $eaa2e9e24133f900$export$f00f1e874ce869e9);

var $kVpZx = parcelRequire("kVpZx");

var $j500r = parcelRequire("j500r");
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $eaa2e9e24133f900$var$startsAsObject = (value)=>{
    try {
        if (value.charAt(0) === '{') return true;
    } catch (e) {
        return false;
    }
    return false;
};
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $eaa2e9e24133f900$var$isObject = (value)=>value && typeof value === 'object' && value.constructor === Object;
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $eaa2e9e24133f900$var$isString = (input)=>{
    let result;
    try {
        result = typeof input === 'string' || input instanceof String;
    } catch (err) {
        // swallow any errors
        result = false;
    }
    return result;
};
const $eaa2e9e24133f900$export$7b4abba432e57989 = (value)=>$eaa2e9e24133f900$var$isString(value) && $eaa2e9e24133f900$var$startsAsObject(value) || $eaa2e9e24133f900$var$isObject(value);
const $eaa2e9e24133f900$export$fcc03ee4c944962f = (featureFlagValue)=>$eaa2e9e24133f900$export$7b4abba432e57989(featureFlagValue) ? 'non_boolean' : featureFlagValue;
const $eaa2e9e24133f900$export$d2818866b4acbea4 = new Map();
const $eaa2e9e24133f900$export$f00f1e874ce869e9 = (metric)=>{
    const interactionId = (0, $kVpZx.getInteractionId)();
    const currentInteractionId = interactionId.current;
    if (!currentInteractionId) return;
    const data = metric.getData();
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    const config = data?.config;
    if (config && config?.featureFlags?.length) {
        const allFeatureFlags = (0, $j500r.default)();
        config.featureFlags.forEach((featureFlagName)=>{
            const value = allFeatureFlags[featureFlagName];
            if (value === undefined) return;
            const featureFlagValue = $eaa2e9e24133f900$export$fcc03ee4c944962f(value);
            $eaa2e9e24133f900$export$d2818866b4acbea4.set(featureFlagName, featureFlagValue);
        });
    }
};

});


parcelRegister("gWu57", function(module, exports) {
$parcel$export(module.exports, "ScrollablePage", () => $3970ca9ce19c6445$export$8d7a30196b47fe34);
$parcel$export(module.exports, "PageLayout", () => $3970ca9ce19c6445$export$6d1402fb58384e4f);

var $eJOHy = parcelRequire("eJOHy");

var $8nu6j = parcelRequire("8nu6j");
var $1DXK0 = parcelRequire("1DXK0");

var $4cTDP = parcelRequire("4cTDP");
const $3970ca9ce19c6445$export$8d7a30196b47fe34 = ({ children: children, ...rest })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
        testId: rest['data-testid'] || 'spa-apps-page-layout.page.scrollable-page',
        xcss: $3970ca9ce19c6445$var$scrollablePageStyles,
        paddingBlock: "space.0",
        paddingInline: "space.300"
    }, children);
const $3970ca9ce19c6445$export$6d1402fb58384e4f = ({ children: children, hideMargin: hideMargin, ...rest })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
        testId: rest['data-testid'] || 'spa-apps-page-layout.page.page-layout',
        xcss: [
            hideMargin ? $3970ca9ce19c6445$var$pageLayoutWithoutMarginStyles : $3970ca9ce19c6445$var$pageLayoutWithMarginStyles,
            (0, $4cTDP.fg)('global_rovo_button_in_jira') && $3970ca9ce19c6445$var$additionalPaddingForGlobalRovoButtonStyles
        ]
    }, children);
};
const $3970ca9ce19c6445$var$scrollablePageStyles = (0, $1DXK0.xcss)({
    minWidth: '800px',
    margin: 'space.0'
});
const $3970ca9ce19c6445$var$pageLayoutWithoutMarginStyles = (0, $1DXK0.xcss)({
    margin: 'space.0'
});
const $3970ca9ce19c6445$var$pageLayoutWithMarginStyles = (0, $1DXK0.xcss)({
    marginBlock: '0',
    marginInline: 'space.300'
});
const $3970ca9ce19c6445$var$additionalPaddingForGlobalRovoButtonStyles = (0, $1DXK0.xcss)({
    paddingBottom: 'space.500'
});

});

parcelRegister("6fgqt", function(module, exports) {
$parcel$export(module.exports, "dashboardsDirectoryPageLoad", () => $8c93886c3e1a3224$export$91799dd22df54613);

var $hqYEY = parcelRequire("hqYEY");
const $8c93886c3e1a3224$export$91799dd22df54613 = (0, $hqYEY.metrics).pageLoad({
    key: 'dashboards-directory',
    ssr: {
        doneAsFmp: true
    }
});

});





//# sourceMappingURL=async-dashboards-directory.a1305fc9.js.map
